// AUTO-GENERATED chunk 'app-init' by build_bundle.py
// Modules: anon-gate.js, tier-gate.js, session-lifecycle.js, sentry-init.js, analytics-buffer.js, app-init.js, app-init-boot-tail.js, chrome-indicators.js, ticker-search-assist.js, tour-interruptions.js, view-skeleton.js, view-router.js, industry-comps.js, view-router-fund-fallback.js, view-router-bdc.js, data-pipeline.js, formatting.js, ws-client.js, welcome-flow.js, brand-v2-status.js, wander-banner.js, dormancy-banner.js, empty-state.js, _idle_loader.js

// ═══ anon-gate.js ═══
;"use strict";
// ── anon-gate.ts ─────────────────────────────────────────────────────────
//
// wave-22 Agent 1 (OWNER-ratified 2026-05-28 Q1+Q2+Q3) — anon → signup
// modal interceptor. Sibling of tier-gate.ts but with a different
// trigger axis: tier-gate.ts gates PAID-tier endpoints for authed-
// free-tier users; anon-gate.ts gates AUTHED-ONLY actions for users
// with no `ol_session` cookie. The two compose cleanly because
// anon-gate installs BEFORE tier-gate in the bundle-app-init chunk —
// an anon caller never reaches the tier-gate interceptor.
//
// This file is the SOURCE OF TRUTH; anon-gate.js is the build artifact
// produced by `./node_modules/.bin/tsc -p tsconfig.build.json`
// (gitignored, matches the tier-gate.ts/.js pattern post-2026-05-04
// TS migration).
//
// UX-only: the backend STILL enforces (Depends(require_auth)). The
// interceptor short-circuits the network call before it leaves the
// browser, which delivers a faster, less-jarring UX than letting the
// 401 propagate. Per CLAUDE.md §"Tier gating": "Frontend tier gating
// ... This is UX-only — backend require_min_tier still enforces."
//
// Click-counter (Q3): localStorage._olAnonClickCount increments on
// every intercepted signup-gated action. Wave-23 will consume this
// for nudge thresholds (no UI surfaces it yet — this wave is the
// instrumentation stub only).
//
// Open-redirect mitigation: the signup redirect builds the `next=`
// param from window.location.pathname + window.location.search via
// encodeURIComponent. The consumer at routes_auth_fastapi.py:89
// (_safe_next_url) validates same-origin / no `://` / no `//host`.
// This is the same redirect-back substrate /login + /signup already
// honor — no new attack surface introduced.
(function () {
    'use strict';
    const w = window;
    // Idempotency guard — mirrors tier-gate.ts:83-88 (M11 pattern).
    // Without this a double-load via defer <script> + nested-in-bundle
    // would re-wrap window.fetch and double-count clicks.
    if (typeof window !== 'undefined' && window.__OL_ANON_GATE_LOADED) {
        return;
    }
    if (typeof window !== 'undefined') {
        window.__OL_ANON_GATE_LOADED = true;
    }
    void w;
    // ── Gated-endpoint catalog ─────────────────────────────────────────────
    //
    // Per Phase 1 backend audit (orchestrator brief):
    //   /api/screener/run         — Depends(require_auth) ✓ 401-for-anon
    //
    // 2026-06-12 audit 6.2 (OWNER directive — supersedes the earlier Q2
    // hard-gate for the two LEARN endpoints): /api/learning/submit-quiz
    // and /api/learning/paths/ are REMOVED from this list. The server
    // implements a gentle 3-attempt soft gate (quiz.py returns
    // requires_signup in the response body; learn-module.ts surfaces the
    // nudge), and the hard client gate contradicted the "free to start,
    // no account required" promise on learn-index + landing — bouncing
    // anon users to ?signup=1 on the FIRST lesson drill-down, the exact
    // incident class fixed once before (2026-05-30, see _redirectToSignup
    // notes). The server's soft gate is the single source of truth for
    // LEARN anon limits. Do NOT re-add these entries without an OWNER
    // decision that also updates test_anon_gate_learn_catalog_and_signup
    // _contract.py (feedback_owner_decision_updates_contract).
    //
    // Prefix-match semantics: every entry is a path PREFIX. The matcher
    // uses url.indexOf(prefix) !== -1 so a query-string or path-segment
    // tail doesn't slip past the gate.
    const ANON_GATED_ENDPOINTS = [
        '/api/screener/run',
    ];
    // ── Cookie-presence probe ─────────────────────────────────────────────
    //
    // Trips on the PRESENCE of an authenticated-session cookie. #39
    // (2026-05-30): keyed on ol_csrf_hmac, NOT ol_session. ol_session is
    // HttpOnly (routes_auth_fastapi._set_auth_cookies / routes_billing_fastapi),
    // so `document.cookie.indexOf('ol_session=')` was ALWAYS -1 -> _isAnon()
    // returned true for EVERYONE, so the interceptor (`if (!_isAnon())
    // passthrough`) treated even SIGNED-IN users as anonymous and
    // redirected them to /signup on any gated endpoint
    // (/api/learning/submit-quiz, /api/screener/run, ...) — i.e. it kicked
    // authed users out of authed-only features. ol_csrf_hmac is the
    // JS-readable authed-session cookie (httponly=False, emitted only for an
    // authenticated session; anon's empty session yields no HMAC). Same
    // reliable signal as auth-state.ts olIsAnonymous / notifications-bell.ts /
    // progress.ts. An authed user whose session predates the H-4 ol_csrf_hmac
    // emission (2026-05-28) is treated as anon until their session refreshes;
    // they hit a real backend 401 (session-lifecycle.js -> /login), which is
    // the honest path. Still strictly better than gating ALL authed users.
    function _isAnon() {
        try {
            return typeof document !== 'undefined'
                && document.cookie.indexOf('ol_csrf_hmac=') === -1;
        }
        catch (_e) {
            // If we can't read cookies, default to NOT-anon (fail-open for
            // the UX gate; backend still enforces).
            return false;
        }
    }
    // ── Click counter (OWNER Q3 stub) ─────────────────────────────────────
    //
    // localStorage._olAnonClickCount = total signup-gated action attempts
    // this anon visitor has made on this device. Wave-23 will read this
    // for the modal-nudge threshold (e.g. show the modal cold on click
    // 1; show a friction-reduced variant on click 3+; auto-prompt at 5).
    //
    // Storage choice: localStorage (not session) — the count should
    // persist across browser-restart so a returning anon doesn't reset
    // to zero. No PII; the count itself is the entirety of the value.
    // Defensive try/catch handles Safari-private-mode QuotaExceededError.
    //
    // Note: this DELIBERATELY does not route through OLStorage (the
    // wrapper at static/js/storage.js) because anon-gate.ts loads in the
    // bundle-app-init chunk BEFORE storage.js parses. The simple direct
    // localStorage call is intentional + ESLint-allowlisted for this
    // module via the file-header.
    /* eslint-disable ol/no-direct-localstorage -- anon-gate.ts loads in bundle-app-init BEFORE storage.js parses (see lines 126-130 comment); OLStorage wrapper is not yet on window at this module's evaluation time. Direct localStorage call is deliberate; defensive try/catch handles Safari-private-mode QuotaExceededError. */
    function _incrementAnonClickCount() {
        try {
            const raw = localStorage.getItem('_olAnonClickCount');
            const cur = parseInt(raw || '0', 10);
            const next = (isNaN(cur) ? 0 : cur) + 1;
            localStorage.setItem('_olAnonClickCount', String(next));
            return next;
        }
        catch (_e) {
            return 0;
        }
    }
    function _getAnonClickCount() {
        try {
            const raw = localStorage.getItem('_olAnonClickCount');
            const cur = parseInt(raw || '0', 10);
            return isNaN(cur) ? 0 : cur;
        }
        catch (_e) {
            return 0;
        }
    }
    /* eslint-enable ol/no-direct-localstorage */
    // ── Signup redirect ────────────────────────────────────────────────────
    //
    // Per OWNER Q2 a gated anon action default = hard gate (no preview). We send
    // the user to the signup-modal surface by appending `signup=1` to the CURRENT
    // url, which app-init.ts:3518 consumes to open the registration modal.
    //
    // REVISED 2026-05-30: the original wave-22 target was the bare `/signup`
    // path, which is NOT a route (returns 403 / "uncatalogued") — anon LEARN
    // drill-down bounced to a dead page. The canonical surface is the dashboard
    // `?signup=1` query param (same flow premium-gate.ts + the pricing CTAs use).
    // Because we keep the existing location.search, the active `?view=` is
    // preserved so the user returns to where they were post-signup; there is no
    // separate `next=`/`reason=` round-trip anymore.
    //
    // DOM safety: NO innerHTML on a parent containing canvas/IO targets
    // per FOUNDATIONAL feedback_never_destroy_dom. window.location.href
    // is a full navigation — the existing canvas/observer teardown is
    // implicit in unload, not innerHTML stomp.
    // #17 (2026-06-18 audit P1-3): the first few gated anon actions get a
    // NON-jarring in-page signup modal (window.showAuthModal — the same opener
    // age-gate.ts + askai-signup use), NOT a full-page reload. The hard
    // navigation is RESERVED FOR REPEAT clickers (count > _PREVIEW_LIMIT) or
    // when the in-page opener hasn't parsed yet — a persistent anon caller
    // eventually lands on the full signup surface. The `reason` (the gated URL,
    // previously discarded at :192) is no longer thrown away: it's emitted to FE
    // telemetry so nudge thresholds can be tuned per gated action.
    const _PREVIEW_LIMIT = 3;
    function _redirectToSignup(reason, count) {
        try {
            const _w2 = window;
            if (typeof _w2._track === 'function')
                _w2._track('anon_gate_triggered', { url: reason, count: count });
        }
        catch (_e) { /* telemetry best-effort */ }
        // Preview phase — open the signup modal in place (no reload) so the user
        // keeps their context. Fall through to navigation if it isn't available.
        if (count <= _PREVIEW_LIMIT) {
            try {
                const _w = window;
                if (typeof _w.showAuthModal === 'function') {
                    _w.showAuthModal('signup');
                    return;
                }
            }
            catch (_e) { /* fall through to the full-navigation redirect */ }
        }
        // Repeat clicker (or no in-page opener): full navigation to the signup
        // surface. Target is `<current>?...&signup=1`, NOT `/signup` — the bare
        // /signup path is not a route (returns 403/uncatalogued); the canonical
        // signup surface is the dashboard `?signup=1` param, which app-init.ts:3518
        // consumes to open the registration modal (same flow premium-gate.ts +
        // pricing CTAs use). Preserving the current location.search keeps the
        // active `?view=` so the user lands back where they were post-signup.
        // (Incident 2026-05-30: anon LEARN drill-down bounced to a broken /signup 404.)
        try {
            const search = window.location.search || '';
            const params = new URLSearchParams(search);
            // Already prompting signup — don't reload into a loop if a gated fetch
            // re-fires after the modal is up.
            if (params.get('signup') === '1')
                return;
            const sep = search ? '&' : '?';
            window.location.href = window.location.pathname + search + sep + 'signup=1';
        }
        catch (_e) {
            // Last-resort fallback — if URL assembly throws, route to the bare
            // signup-modal surface so the user still reaches the auth flow.
            try {
                window.location.href = '/?signup=1';
            }
            catch (__) { /* defensive */ }
        }
    }
    // ── URL matching ──────────────────────────────────────────────────────
    function _isGated(url) {
        if (!url)
            return false;
        // 2026-06-12 audit 6.2: the /api/learning/paths/index exemption that
        // lived here was retired together with the '/api/learning/paths/'
        // gated prefix — no LEARN endpoint is client-gated anymore (the
        // server's 3-attempt requires_signup soft gate owns LEARN anon
        // limits), so there is nothing left to exempt the catalog spine from.
        for (let i = 0; i < ANON_GATED_ENDPOINTS.length; i++) {
            const p = ANON_GATED_ENDPOINTS[i];
            if (url.indexOf(p) !== -1)
                return true;
        }
        return false;
    }
    function _extractUrl(input) {
        if (typeof input === 'string')
            return input;
        if (input && typeof input.url === 'string') {
            return input.url;
        }
        return '';
    }
    // ── fetch() interceptor ───────────────────────────────────────────────
    //
    // Load-order: anon-gate.ts is registered FIRST in bundle-app-init
    // (before tier-gate.ts) so it captures the pristine window.fetch.
    // tier-gate.ts then wraps the anon-gate-wrapped fetch — for an anon
    // caller hitting a gated endpoint, anon-gate fires first and the
    // tier-gate layer is never reached. For an authed caller hitting a
    // paid-tier endpoint, anon-gate falls through (_isAnon === false)
    // and tier-gate's 402 intercept fires.
    //
    // The race-with-other-fetch-wrappers concern (signup-redirect
    // open-redirect, double-counting) is covered by the CHAOS audit.
    const _origFetch = window.fetch && window.fetch.bind(window);
    if (_origFetch) {
        window.fetch = function (input, init) {
            try {
                if (!_isAnon())
                    return _origFetch(input, init);
                const url = _extractUrl(input);
                if (url.indexOf('/api/') === -1)
                    return _origFetch(input, init);
                if (!_isGated(url))
                    return _origFetch(input, init);
                // Click-counter stub fires BEFORE the redirect so the count
                // increments even if the navigation is interrupted.
                const count = _incrementAnonClickCount();
                // Fire the signup prompt. #17: for the first _PREVIEW_LIMIT actions
                // this opens an in-page modal (no navigation) — so we still reject the
                // fetch (caller's catch suppresses the gated render) but the page does
                // NOT reload. Repeat clickers get the full-navigation redirect.
                _redirectToSignup(url, count);
                const err = new Error('anon-gated');
                err.code = 'anon-gated';
                err.url = url;
                err.count = count;
                return Promise.reject(err);
            }
            catch (_e) {
                // Never let gate-check failure break a fetch — silently
                // fall through to the original. Backend still enforces.
            }
            return _origFetch(input, init);
        };
    }
    // ── Public API surface ────────────────────────────────────────────────
    w.AnonGate = {
        endpoints: ANON_GATED_ENDPOINTS.slice(),
        getClickCount: _getAnonClickCount,
        isAnon: _isAnon,
    };
})();
//# sourceMappingURL=anon-gate.js.map
;
// ═══ tier-gate.js ═══
;"use strict";
// ── tier-gate.js ─────────────────────────────────────────────────────────
//
// TS Migration Phase 2 PR 37 (2026-05-04): renamed .js → .ts.
// Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
//
// This file is the SOURCE OF TRUTH; tier-gate.js is the build artifact
// produced by `npx tsc -p tsconfig.build.json` (gitignored).
//
// TierGate — client-side tier check for premium-gated API endpoints.
// UX-only: backend require_min_tier still enforces. State is read live
// from window._userTier; endpoint map fetched once from
// /api/billing/tier-endpoints (registry introspection — no drift).
// Wraps window.fetch as a backstop for unwrapped call sites. CR-H6
// paywall consolidation collapses ≥3 cards into one banner per view.
// Board#5 CHAMP/VOICE (2026-07-17): ONE resolver for tier monthly-price copy so
// upgrade prompts never promise a number checkout won't honor. Reads the live
// _getTierConfig() (the same source Stripe/checkout keys off) and only falls
// back to the baked defaults when config is unavailable. Previously the
// session-fatigue banner hardcoded $9/$19/$29 with no config lookup at all.
const _TIER_PRICE_FALLBACK = { plus: '$9/mo', pro: '$19/mo', professional: '$29/mo' };
function _tierPriceLabel(tier) {
    try {
        if (typeof _getTierConfig === 'function') {
            const tc = _getTierConfig();
            if (tc && tc[tier] && tc[tier].price_mo)
                return '$' + tc[tier].price_mo + '/mo';
        }
    }
    catch (_e) { /* fall through to baked default */ }
    return _TIER_PRICE_FALLBACK[tier] || '';
}
// >>> OL-TIER-RANK-HELPERS (executed under node by
// tests/test_client_tier_rank_caps_contract.py from the emit -- keep this block
// self-contained: it may read only `window` and `Date`).
//
// 2026-09-24 pricing/tier accuracy audit M1: client tier checks were
// `_isProUser()` (milestones-view.ts), true for pro/scale alone -- so a PAYING
// Researcher, an active trial, Power User, Advisor and Institutional all read
// as unpaid. (The browser-only free caps those checks guarded -- tickers,
// portfolios, screener filters, 13F holders, bond results -- were then REMOVED
// outright the same day by OWNER decision: no tier has one.) What remains here
// answers "does this user's tier include a SERVER-gated thing" (the real-time
// nudge, CSV import, the plus-gated options flow, Ask-AI's paid copy), so the
// honest threshold is the SERVER's rank ladder: `require_min_tier` ranks via
// middleware/auth.py:520-533 `_TIER_ORDER` and `user_has_tier` strips `_trial`.
// Mirrored below, plus the legacy names services/billing/constants.py
// TIER_MIGRATION maps (hobbyist->free, scale/institutional->pro). Top level (not
// inside the IIFE) and in this file because tier-gate.js loads FIRST in the
// eager `app-init` chunk (tools/build_bundle.py JS_CHUNKS), before every
// consumer chunk and long before milestones-view.ts (app-idle).
var _OL_TIER_RANK = {
    anonymous: 0, free: 0, hobbyist: 0, 'team-member': 0,
    plus: 1, plus_trial: 1,
    pro: 2, pro_trial: 2, team: 2, scale: 2, institutional: 2,
    professional: 3, professional_trial: 3,
    institutional_plus: 4,
};
function _olTierWindow() {
    return (typeof window !== 'undefined' ? window : {});
}
// The tier the client knows: `_billingData` (GET /api/billing/usage, a top-level
// `var` in milestones-view.ts, refreshed every 5 min) first, then
// `window._userTier` (GET /api/auth/me, which runs check_trial_status and so
// lazily downgrades an expired trial before answering --
// services/billing/tiers.py check_trial_status). Unknown -> free.
function _olClientTier() {
    const w = _olTierWindow();
    const bd = w._billingData;
    if (bd && bd.tier)
        return String(bd.tier).toLowerCase();
    if (typeof w._userTier === 'string' && w._userTier)
        return w._userTier.toLowerCase();
    return 'free';
}
// An EXPIRED trial must not open a paid gate. /api/billing/usage normalises
// plus_trial -> plus WITHOUT an expiry check, so a lapsed trial whose row has
// not been lazily downgraded still reads 'plus' there; it does send
// billing_mode ('trial' for a trial row) and trial_end -- the pair
// middleware/auth.py `_trial_is_expired` decides on. No trial_end -> not
// expired (the server's conservative default). A paying user who once trialled
// keeps a past trial_end, which is why the trial SHAPE is required too.
function _olTrialExpired() {
    const bd = _olTierWindow()._billingData || null;
    const trialShaped = /_trial$/.test(_olClientTier())
        || !!(bd && String(bd.billing_mode || '').toLowerCase() === 'trial');
    if (!trialShaped || !bd || !bd.trial_end)
        return false;
    // The route sends str(datetime)[:19] -- UTC without a zone. Read it as UTC.
    let iso = String(bd.trial_end).replace(' ', 'T');
    if (!/([zZ]|[+-]\d\d:?\d\d)$/.test(iso))
        iso += 'Z';
    const ms = Date.parse(iso);
    if (isNaN(ms))
        return false;
    return ms < Date.now();
}
function _olTierRankOf(tier) {
    const t = String(tier || '').toLowerCase();
    return Object.prototype.hasOwnProperty.call(_OL_TIER_RANK, t) ? _OL_TIER_RANK[t] : 0;
}
// The effective tier the SERVER judges this user on, when it has said so:
// /api/billing/usage `effective_tier` (middleware.auth.resolve_effective_tier
// -- the same verdict require_min_tier reaches: an expired trial is free, an
// active Developer plan confers Power User). '' when not yet known.
function _olServerEffectiveTier() {
    const bd = _olTierWindow()._billingData;
    return bd && bd.effective_tier ? String(bd.effective_tier).toLowerCase() : '';
}
// True when the current user ranks at or above `minTier`. Fails CLOSED on an
// unknown minTier (a typo must never open a gate for everyone). The server's
// effective tier wins over the client-side trial guess below (OWNER
// 2026-09-24: a Developer plan holder whose consumer trial lapsed is Power
// User, and only the server knows about the plan).
function _olTierAtLeast(minTier) {
    const need = String(minTier || '').toLowerCase();
    if (!Object.prototype.hasOwnProperty.call(_OL_TIER_RANK, need))
        return false;
    const server = _olServerEffectiveTier();
    const have = server ? _olTierRankOf(server)
        : (_olTrialExpired() ? 0 : _olTierRankOf(_olClientTier()));
    return have >= _OL_TIER_RANK[need];
}
// <<< OL-TIER-RANK-HELPERS
// >>> OL-TIER-RISE-REFRESH (executed under node by
// tests/test_tier_money_paths_wp_f_contract.py -- keep this block
// self-contained: it may read only window, document, setTimeout, currentView,
// activeTicker, setView, fetchTicker and _olTierRankOf).
//
// Lives HERE rather than in view-router.ts because view-router.ts sits at
// exactly its tools/file_size_budget.json line budget; this file loads first
// in the eager app-init chunk and the view-router globals it calls are read
// only when an event fires, long after every chunk has parsed.
//
// P1-17 (external review 2026-09-26): after an upgrade the checkout return
// dispatched `ol-view-refresh` and NOTHING listened, so the paid reader kept
// looking at the upgrade placeholders and banners that the old tier had
// painted until they reloaded. One debounced listener here re-runs the
// current view when the tier RISES -- on `ol-view-refresh`, and on
// `ol-tier-changed` when the new tier ranks above the previous one. A DROP
// (sign-out, a lapsed trial) never re-runs: the gates already read the tier
// live, and a refetch of every panel would only spend the rate budget.
// The boot resolve (previous tier unknown) re-runs only when a gate actually
// painted something, so a paying reader's normal cold load is not fetched
// twice.
var _olTierRefreshTimer = null;
var _OL_TIER_GATE_ARTIFACTS = '.ol-tier-consolidated-banner, #ol-tier-session-banner, .ol-tier-placeholder';
function _olTierRankForRefresh(t) {
    if (typeof t !== 'string' || !t)
        return -1;
    if (typeof _olTierRankOf === 'function')
        return _olTierRankOf(t);
    return (t === 'anonymous' || t === 'free') ? 0 : 1;
}
function _olTierRose(detail) {
    const next = _olTierRankForRefresh(detail && detail.tier);
    const prev = _olTierRankForRefresh(detail && detail.previous);
    if (next < 0)
        return false;
    if (prev >= 0)
        return next > prev;
    return next > 0 && !!document.querySelector(_OL_TIER_GATE_ARTIFACTS);
}
function _olRefreshViewForTier() {
    if (_olTierRefreshTimer)
        clearTimeout(_olTierRefreshTimer);
    _olTierRefreshTimer = setTimeout(function () {
        _olTierRefreshTimer = null;
        try {
            document.querySelectorAll(_OL_TIER_GATE_ARTIFACTS).forEach(function (n) {
                if (n.parentNode)
                    n.parentNode.removeChild(n);
            });
        }
        catch (_e) { /* removal is cosmetic; the re-run below repaints */ }
        try {
            const view = (typeof currentView === 'string') ? currentView : '';
            if (view === 'ticker' && typeof activeTicker === 'string' && activeTicker
                && typeof fetchTicker === 'function') {
                void fetchTicker(activeTicker, true);
            }
            else if (view && typeof setView === 'function') {
                setView(view, true);
            }
        }
        catch (_e) { /* a refresh must never break the page */ }
    }, 250);
}
// One binding per page even if this file is evaluated twice (the M11
// double-load the IIFE below guards against).
if (!window.__olTierRiseRefreshBound) {
    window.__olTierRiseRefreshBound = true;
    window.addEventListener('ol-view-refresh', function () { _olRefreshViewForTier(); });
    window.addEventListener('ol-tier-changed', function (e) {
        if (_olTierRose(e.detail))
            _olRefreshViewForTier();
    });
}
// <<< OL-TIER-RISE-REFRESH
(function () {
    'use strict';
    const w = window;
    // Idempotency guard (M11, 2026-05-04): if window.__OL_TIER_GATE_LOADED
    // is already truthy, abort. Without this, a double-load via defer
    // <script> + nested-in-bundle would re-wrap window.fetch and distort
    // the interceptBuffer.
    if (typeof window !== 'undefined' && window.__OL_TIER_GATE_LOADED) {
        return;
    }
    if (typeof window !== 'undefined') {
        window.__OL_TIER_GATE_LOADED = true;
    }
    void w;
    const TIER_RANK = {
        'anonymous': 0,
        'free': 0,
        'plus_trial': 1,
        'plus': 1,
        'pro_trial': 2,
        'pro': 2,
        'professional_trial': 3,
        'professional': 3,
        // EXT-AUDIT 3.3 (#46, 2026-07-05): paying team/institutional_plus users
        // resolved to rank 0 here and were client-side 402'd on EVERYTHING
        // without a network call. Mirrors middleware/auth.py _TIER_ORDER
        // (drift contract: tests/test_tier_rank_fe_be_drift_contract.py).
        'team-member': 0,
        'team': 2,
        'institutional_plus': 4,
    };
    const FALLBACK_MAP = {
        // DEAD ENTRIES REMOVED 2026-08-19. Ten of this map's 25 paths named
        // routes that DO NOT EXIST -- every one returned HTTP 404 from prod with
        // no session, and FastAPI answers 405 (not 404) for a wrong method on a
        // real path, so these were absent rather than POST-only:
        //   earnings-transcript-search, earnings-call-summary, peer-comparison,
        //   valuation-trends, insider-net-flow, credit-stress-test,
        //   portfolio/risk, screener-presets/save, ai/digest, learning/calibration
        // Their only reference anywhere was this map. Harmless while nothing
        // called them, but a stale entry is a LATENT gate: adding any of those
        // paths later would have silently inherited a 'plus' requirement. That
        // nearly mattered -- `insider-net-flow` would have Plus-gated a surface
        // the OWNER had just ratified as free. Pinned by
        // tests/test_tier_gate_map_routes_exist_contract.py.
        '/api/options': 'plus',
        '/api/options/unusual': 'plus',
        '/api/earnings-transcripts': 'plus',
        '/api/earnings-transcript': 'plus',
        '/api/analyst-estimates': 'plus',
        '/api/debt-maturities': 'plus',
        '/api/capital-structure': 'plus',
        '/api/capital-allocation': 'plus',
        // '/api/ai/ask' REMOVED 2026-09-24 (audit M19): the route is open to every
        // signed-in user, credits-first -- its only tier marker is
        // require_min_tier_marker_only("free") (routes/routes_ai_fastapi.py:640-651)
        // and the generated fallback already says "free". This last-resort entry
        // would have client-402'd free users' Ask AI on a triple registry failure.
        // 2026-06-12 audit 5.3: credit-suite endpoints backfilled. NOTE the
        // finding was mostly stale — the build-time tier-fallback.generated.js
        // layer (preferred over this map) already carried all six; this
        // last-resort map only fires when BOTH the live registry fetch AND
        // the generated file fail. Kept in sync for that triple-failure case.
        '/api/credit-portfolio': 'plus',
        '/api/credit-summary': 'plus',
        '/api/credit-metrics': 'plus',
        '/api/sofr-sensitivity': 'plus',
        '/api/bond-screener': 'plus',
        '/api/debt-maturities-wall': 'plus',
    };
    // 2.1 (2026-06-12 audit): URL-prefix -> premium-gate catalog feature id.
    // Keys MUST exist in premium-gate.ts PREMIUM_FEATURES — the interceptor
    // raises the overlay itself on a synthetic 402 (only ~11 of ~53 /api/*
    // consumers check res.status === 402; everyone else rendered an empty
    // panel with zero "this is a paid feature" messaging). First matching
    // prefix wins; unmatched gated URLs fall through silently (synthetic
    // 402 still returned for status-checking consumers).
    const _FEATURE_BY_PREFIX = [
        ['/api/credit', 'credit'],
        ['/api/sofr-sensitivity', 'credit'],
        ['/api/debt-maturities', 'credit'],
        ['/api/bdc', 'bdc'],
        // 2026-09-26: /api/data/bulk + /api/data/bulk.csv (Investor bulk export).
        ['/api/data/bulk', 'bulk-export'],
        ['/api/bond-screener', 'bond-screener'],
        ['/api/screener', 'screener'],
        ['/api/portfolio-analytics', 'portfolio-analytics'],
        ['/api/portfolio/risk', 'portfolio-analytics'],
        ['/api/ai', 'ai'],
        ['/api/earnings-transcript', 'transcripts'],
        ['/api/earnings-call-summary', 'transcripts'],
    ];
    const _overlayShownAt = {};
    function _featureForUrl(path) {
        for (let i = 0; i < _FEATURE_BY_PREFIX.length; i++) {
            if (path.indexOf(_FEATURE_BY_PREFIX[i][0]) === 0)
                return _FEATURE_BY_PREFIX[i][1];
        }
        return '';
    }
    // P1-16 (external review 2026-09-26): an upgrade CLICK must always lead
    // somewhere. premium-gate's showPremiumGateResult says whether the overlay
    // opened; 'unknown' (no catalogue entry and no alias) goes to /pricing
    // instead of doing nothing, while 'fotd' (the toast announced today's free
    // feature) stays put. Only click handlers use this -- the interceptor below
    // never navigates on its own.
    function _openGateOrPricing(featureId, tier) {
        if (typeof w.showPremiumGateResult === 'function') {
            if (w.showPremiumGateResult(featureId) === 'unknown')
                window.location.href = '/pricing';
        }
        else if (typeof w.showPremiumGate === 'function') {
            w.showPremiumGate(featureId);
        }
        else {
            window.location.href = '/?upgrade=' + encodeURIComponent(tier || 'plus');
        }
    }
    let _endpointMap = null;
    let _registryPromise = null;
    function _normaliseUrl(url) {
        try {
            let u = String(url).replace(/^https?:\/\/[^/]+/, '');
            const q = u.indexOf('?');
            if (q !== -1)
                u = u.substring(0, q);
            const h = u.indexOf('#');
            if (h !== -1)
                u = u.substring(0, h);
            return u;
        }
        catch (_e) {
            return String(url);
        }
    }
    function _currentTier() {
        return (typeof w._userTier === 'string' && w._userTier) || 'anonymous';
    }
    // P1-18 (external review 2026-09-26): while /api/auth/me is in flight
    // `_userTier` is undefined and _currentTier() reads it as 'anonymous', so a
    // PAYING reader's early gated fetches got a synthetic 402 -- "Sign in to
    // access", the "Create a free account" overlay, and a false
    // paywall_impression beacon. An undefined tier for a reader who is NOT known
    // to be signed out (olIsAnonymous() false) is UNKNOWN, not anonymous: let the
    // request reach the network and let the server's 402 decide
    // (credit-refi-wall.ts renderCreditRefiWall is the pattern). Since 8a5576be a
    // signed-out reader's tier is set to 'anonymous' once /api/auth/me answers,
    // so "undefined" really does mean pending. Without auth-state loaded the
    // answer is not pending -- gated as before.
    function _tierPending() {
        if (typeof w._userTier === 'string' && w._userTier)
            return false;
        try {
            return typeof w.olIsAnonymous === 'function' && w.olIsAnonymous() === false;
        }
        catch (_e) {
            return false;
        }
    }
    function _hasTier(required) {
        if (_tierPending())
            return true;
        const cur = TIER_RANK[_currentTier()] || 0;
        const need = TIER_RANK[required] || 0;
        return cur >= need;
    }
    function _lookupRequired(url) {
        const path = _normaliseUrl(url);
        // CR-H7 load-order handshake: live registry first, then the
        // build-time generated `window.OL_TIER_FALLBACK` (loaded BEFORE
        // bundle-app), then the hardcoded last-resort FALLBACK_MAP. The
        // `window.OL_TIER_FALLBACK` literal is what the
        // test_tier_fallback_drift_contract suite source-greps.
        const map = _endpointMap
            || (typeof window !== 'undefined' && window.OL_TIER_FALLBACK)
            || FALLBACK_MAP;
        if (map[path])
            return map[path];
        return null;
    }
    async function _loadRegistry() {
        if (_registryPromise)
            return _registryPromise;
        let signal;
        try {
            signal = AbortSignal.timeout(5000);
        }
        catch (_e) {
            signal = undefined;
        }
        _registryPromise = (async function () {
            try {
                const r = await fetch('/api/billing/tier-endpoints', {
                    credentials: 'same-origin',
                    signal: signal,
                });
                const data = r.ok ? (await r.json()) : { endpoints: null };
                if (data && data.endpoints && Object.keys(data.endpoints).length > 0) {
                    _endpointMap = data.endpoints;
                }
                else {
                    _endpointMap = FALLBACK_MAP;
                }
                return _endpointMap;
            }
            catch (_e) {
                _endpointMap = FALLBACK_MAP;
                return _endpointMap;
            }
        })();
        return _registryPromise;
    }
    function fetchIfAllowed(url, opts) {
        const required = _lookupRequired(url);
        if (required && !_hasTier(required)) {
            const err = new Error('tier-gated');
            err.code = 'tier-gated';
            err.minTier = required;
            err.currentTier = _currentTier();
            err.url = url;
            return Promise.reject(err);
        }
        if (typeof w.olFetch === 'function')
            return w.olFetch(url, opts);
        return fetch(url, opts);
    }
    function canCall(url) {
        const required = _lookupRequired(url);
        if (!required)
            return true;
        return _hasTier(required);
    }
    function requiredTier(url) {
        return _lookupRequired(url);
    }
    const _CONSOLIDATION_THRESHOLD = 3;
    let _consolidationState = {
        view: null,
        cards: [],
        banner: null,
        consolidated: false,
    };
    function _currentView() {
        try {
            return (typeof currentView !== 'undefined') ? currentView : null;
        }
        catch (_) {
            return null;
        }
    }
    // ── Server-side conversion-funnel emit (#418) ───────────────────────────
    //
    // tier-gate.ts gates /api/* CLIENT-SIDE (the interceptor below resolves a
    // synthetic 402 Response without a network call), so a client-gated paywall
    // never reaches the backend's server-side emit (routes/api_errors.py only
    // fires on a real 402). This is the missing FE -> BE path: post the four
    // FE-only CONVERSION_FUNNEL_EVENTS to /api/billing/funnel-event via
    // navigator.sendBeacon. sendBeacon needs a Blob tagged application/json for
    // the body to arrive as JSON (a bare string posts as text/plain). The route
    // allowlists the event name server-side; this is best-effort + fail-silent.
    function _emitFunnel(event, details) {
        try {
            const payload = JSON.stringify({ event: event, details: details || {} });
            if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
                const blob = new Blob([payload], { type: 'application/json' });
                navigator.sendBeacon('/api/billing/funnel-event', blob);
                return;
            }
            // Fallback for the (rare) no-sendBeacon environment: keepalive fetch.
            if (typeof fetch === 'function') {
                void fetch('/api/billing/funnel-event', {
                    method: 'POST',
                    headers: { 'content-type': 'application/json' },
                    body: payload,
                    credentials: 'same-origin',
                    keepalive: true,
                }).catch(function () { });
            }
        }
        catch (_e) { /* never let an analytics emit break a gate path */ }
    }
    // De-dupe paywall_impression so it fires ONCE per gated view, not once per
    // intercepted call (a single view can fire N tier-gated fetches). Key =
    // view + ':' + route so navigating away and back re-emits, but a burst of
    // gated calls within the same view collapses to one impression.
    const _paywallImpressionSeen = {};
    function _emitPaywallImpression(tier, route) {
        try {
            const key = (_currentView() || '_') + ':' + (route || '_');
            if (_paywallImpressionSeen[key])
                return;
            _paywallImpressionSeen[key] = true;
            _emitFunnel('paywall_impression', { tier: tier, route: route });
        }
        catch (_e) { /* defensive */ }
    }
    // Put the individual placeholders back (a kept-alive view shows its own
    // cards again when the reader returns to it).
    function _unhideConsolidatedCards() {
        _consolidationState.cards.forEach(function (c) {
            try {
                c.container.classList.remove('ol-tier-placeholder--consolidated-hidden');
            }
            catch (_) { }
        });
    }
    function _resetConsolidationForView(newView) {
        if (_consolidationState.banner && _consolidationState.banner.parentNode) {
            try {
                _consolidationState.banner.parentNode.removeChild(_consolidationState.banner);
            }
            catch (_) { }
        }
        _unhideConsolidatedCards();
        _consolidationState = {
            view: newView,
            cards: [],
            banner: null,
            consolidated: false,
        };
    }
    function _renderConsolidatedBanner() {
        // Connected, not merely remembered: the tier-rise refresh
        // (OL-TIER-RISE-REFRESH above) removes the banner node, and a remembered-but-
        // detached banner must be inserted again, not silently updated off-page.
        const bannerExisted = !!(_consolidationState.banner && _consolidationState.banner.parentNode);
        const banner = _consolidationState.banner || document.createElement('div');
        banner.className = 'ol-tier-consolidated-banner';
        banner.setAttribute('role', 'region');
        banner.setAttribute('aria-label', 'Locked premium features in this view');
        const tierRank = { plus: 1, pro: 2, professional: 3, 'pro-ai': 3 };
        let topTier = 'plus';
        for (let i = 0; i < _consolidationState.cards.length; i++) {
            const t = _consolidationState.cards[i].minTier || 'plus';
            if ((tierRank[t] || 0) > (tierRank[topTier] || 0))
                topTier = t;
        }
        const tierDisplayMap = (typeof window !== 'undefined' && w.TIER_DISPLAY_NAMES)
            || { plus: 'Researcher', pro: 'Investor', professional: 'Power User', 'pro-ai': 'Power User' };
        const topTierDisplay = tierDisplayMap[topTier] || (topTier.charAt(0).toUpperCase() + topTier.slice(1));
        const seen = {};
        const uniqueNames = [];
        for (let j = 0; j < _consolidationState.cards.length; j++) {
            const n = _consolidationState.cards[j].featureName || 'Premium feature';
            if (!seen[n]) {
                seen[n] = true;
                uniqueNames.push(n);
            }
        }
        banner.textContent = '';
        const inner = document.createElement('div');
        inner.className = 'ol-tier-consolidated-inner';
        const header = document.createElement('div');
        header.className = 'ol-tier-consolidated-header';
        header.textContent = uniqueNames.length + ' locked features in this view';
        const list = document.createElement('ul');
        list.className = 'ol-tier-consolidated-list';
        for (let k = 0; k < uniqueNames.length; k++) {
            const li = document.createElement('li');
            li.textContent = uniqueNames[k];
            list.appendChild(li);
        }
        const ctaWrap = document.createElement('div');
        ctaWrap.className = 'ol-tier-consolidated-cta';
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ol-tier-consolidated-btn';
        btn.setAttribute('data-action', 'tier-consolidated-click');
        btn.textContent = 'Open with ' + topTierDisplay;
        btn.addEventListener('click', function () {
            // #418: clicking an upgrade CTA is the paywall_clicked_upgrade
            // funnel step. Emit server-side before the navigation/gate so the
            // beacon flushes even when the branch below redirects.
            try {
                _emitFunnel('paywall_clicked_upgrade', { tier: topTier });
            }
            catch (_) { }
            try {
                _openGateOrPricing('paywall_consolidated_' + topTier, topTier);
            }
            catch (_) { }
            try {
                if (typeof w._track === 'function') {
                    w._track('tier_gate_consolidated_cta_click', {
                        minTier: topTier, lockedCount: uniqueNames.length,
                    });
                }
            }
            catch (_) { }
        });
        ctaWrap.appendChild(btn);
        // P1-23 (2026-09-26): the banner is now a fixed bottom sheet (it used to
        // be inserted in flow at the top of #content-wrapper after async 402s and
        // shoved the page down), so it needs a way out. Closing it brings the
        // individual placeholders back for this view.
        const dismiss = document.createElement('button');
        dismiss.type = 'button';
        dismiss.className = 'ol-tier-session-banner-dismiss';
        dismiss.setAttribute('aria-label', 'Dismiss this banner');
        dismiss.textContent = '×';
        dismiss.addEventListener('click', function () {
            try {
                if (banner.parentNode)
                    banner.parentNode.removeChild(banner);
            }
            catch (_) { }
            _unhideConsolidatedCards();
            _consolidationState.banner = null;
            _consolidationState.dismissed = true;
        });
        ctaWrap.appendChild(dismiss);
        inner.appendChild(header);
        inner.appendChild(list);
        inner.appendChild(ctaWrap);
        banner.appendChild(inner);
        if (!bannerExisted) {
            const main = // EXT-AUDIT 1.5 (#47): was 'main-content', which does NOT exist in
             
            // dashboard.html (the main is #content-wrapper) — the banner fell back
            // to body-prepend ABOVE the sticky header, degrading layout precisely
            // for the free users being asked to upgrade.
            (document.getElementById('content-wrapper') ||
                // eslint-disable-next-line no-console -- deliberate ops signal: Sentry browser integration captures console.error; anchor drift on the CONVERSION surface must be loud (EXT-AUDIT 1.5)
                (console.error('[tier-gate] #content-wrapper missing — banner degraded to body-prepend'), null)) || document.body;
            main.insertBefore(banner, main.firstChild);
            _consolidationState.banner = banner;
            try {
                if (typeof w._track === 'function') {
                    w._track('tier_gate_consolidated_banner_shown', {
                        minTier: topTier, lockedCount: uniqueNames.length,
                    });
                }
            }
            catch (_) { }
        }
    }
    function _maybeConsolidate() {
        const nowView = _currentView();
        if (nowView !== _consolidationState.view) {
            _resetConsolidationForView(nowView);
        }
        _consolidationState.cards = _consolidationState.cards.filter(function (c) {
            return !!(c.container && document.body.contains(c.container));
        });
        if (_consolidationState.cards.length < _CONSOLIDATION_THRESHOLD)
            return;
        if (_consolidationState.dismissed)
            return;
        _consolidationState.consolidated = true;
        _consolidationState.cards.forEach(function (c) {
            try {
                c.container.classList.add('ol-tier-placeholder--consolidated-hidden');
            }
            catch (_) { }
        });
        _renderConsolidatedBanner();
    }
    // ── Session-level paywall tracking (user-sim 2026-05-06 finding #3) ─────────
    //
    // The per-view consolidator above only fires when a SINGLE view contains
    // ≥3 paywall placeholders. The 2026-05-06 user-simulation flagged that
    // this misses cross-page fatigue: Bob hit three paywalls across three
    // BDC pages in 90 seconds + the consolidator never fired because each
    // was a separate view. Solution: track distinct paywall events
    // session-wide via sessionStorage and render a single session-level
    // upgrade banner once the count crosses _SESSION_THRESHOLD.
    //
    // Storage: sessionStorage (survives navs within a tab; resets on close).
    // Stored shape:
    //   { events: [{view, key, minTier, t}], bannerShownAt: number|null }
    // Dedup key = view + ':' + featureName so reload-of-same-view doesn't
    // double-count. Event count is the unique-key count, not the array length.
    // The banner renders ONCE per session (bannerShownAt is the durable
    // sentinel — clearing sessionStorage resets it).
    const _SESSION_STORAGE_KEY = 'ol_tier_session_paywalls';
    // F10 (Code-Review-Cowork audit 2026-05-12): bumped 3 → 5 to stop
    // upselling during the curiosity-driven exploration phase. The
    // audit's trial-conversion data: users who explore 5+ features in
    // their first session convert 2-3x better than those who hit 3 and
    // bounce. We were interrupting at 3.
    const _SESSION_THRESHOLD = 5;
    const _SESSION_MAX_EVENTS = 25; // cap to keep storage tiny
    // F10: minimum session-time before the banner can fire (ms). Even
    // hitting 5 distinct paywalls in the first 5 minutes is a curiosity
    // signal, not a frustration signal — wait until the user has been
    // here long enough that the interruption is contextual.
    const _SESSION_MIN_ELAPSED_MS = 5 * 60 * 1000;
    // F10: 24h dismissal cooldown. localStorage (not sessionStorage)
    // so the dismissal survives tab close, matching the user's
    // mental model ("I already said no to this today").
    const _DISMISS_COOLDOWN_KEY = 'ol_tier_banner_dismissed_at';
    const _DISMISS_COOLDOWN_MS = 24 * 60 * 60 * 1000;
    function _readSessionState() {
        try {
            // OLStorage.getSession (static/js/storage.js) wraps sessionStorage
            // with JSON parsing + TTL envelope handling + Safari-private
            // QuotaExceededError defense. Per the ol/no-direct-localstorage
            // ESLint rule, this is the ONLY supported access pattern outside
            // storage.js itself.
            const parsed = OLStorage.getSession(_SESSION_STORAGE_KEY, null);
            if (!parsed || typeof parsed !== 'object') {
                return { events: [], bannerShownAt: null };
            }
            const events = Array.isArray(parsed.events)
                ? (parsed.events).slice(0, _SESSION_MAX_EVENTS)
                : [];
            const bannerShownAtRaw = parsed.bannerShownAt;
            const bannerShownAt = typeof bannerShownAtRaw === 'number' ? bannerShownAtRaw : null;
            return { events: events, bannerShownAt: bannerShownAt };
        }
        catch (_e) {
            return { events: [], bannerShownAt: null };
        }
    }
    function _writeSessionState(state) {
        try {
            // OLStorage.setSession handles QuotaExceededError + Safari
            // private-mode silently per the wrapper contract.
            OLStorage.setSession(_SESSION_STORAGE_KEY, state);
        }
        catch (_e) {
            // Defensive — never let storage failures break a fetch path.
        }
    }
    function _recordSessionPaywall(minTier, featureKey) {
        try {
            const state = _readSessionState();
            const view = _currentView();
            const key = (view || '_') + ':' + (featureKey || '_anonymous');
            // Dedup: skip if this view+key combo is already recorded.
            for (let i = 0; i < state.events.length; i++) {
                if (state.events[i].key === key)
                    return;
            }
            const now = Date.now();
            // F10: stamp the session start on the FIRST recorded event;
            // subsequent events leave it alone.
            if (!state.sessionStartedAt) {
                state.sessionStartedAt = now;
            }
            state.events.push({ view: view, key: key, minTier: minTier, t: now });
            if (state.events.length > _SESSION_MAX_EVENTS) {
                state.events = state.events.slice(-_SESSION_MAX_EVENTS);
            }
            _writeSessionState(state);
            _maybeShowSessionBanner(state);
        }
        catch (_e) { }
    }
    // F10: localStorage-backed dismissal cooldown. Returns true if a
    // dismissal exists AND is within the 24h window. Wrapped via
    // OLStorage to honour the ol/no-direct-localstorage ESLint rule.
    function _isDismissedRecently() {
        try {
            const dismissedAt = OLStorage.get(_DISMISS_COOLDOWN_KEY, null);
            if (typeof dismissedAt !== 'number')
                return false;
            return (Date.now() - dismissedAt) < _DISMISS_COOLDOWN_MS;
        }
        catch (_e) {
            return false;
        }
    }
    function _markDismissed() {
        try {
            OLStorage.set(_DISMISS_COOLDOWN_KEY, Date.now());
        }
        catch (_e) { /* defensive */ }
    }
    function _maybeShowSessionBanner(state) {
        try {
            if (state.bannerShownAt)
                return;
            if (state.events.length < _SESSION_THRESHOLD)
                return;
            // F10: session-time floor — never fire in the first 5 minutes
            // even if the user hits 5+ paywalls in that window. Curiosity-
            // driven exploration deserves room.
            if (state.sessionStartedAt &&
                (Date.now() - state.sessionStartedAt) < _SESSION_MIN_ELAPSED_MS) {
                return;
            }
            // F10: respect a recent dismissal (24h cooldown via localStorage).
            // The user has already said no today; don't re-pitch.
            if (_isDismissedRecently())
                return;
            // F10: if the per-view consolidated banner is currently
            // showing (`.ol-tier-consolidated-banner`), suppress the
            // session banner — two upgrade banners stacked is the worst
            // possible UX moment and the per-view banner is the more
            // contextual of the two.
            if (document.querySelector('.ol-tier-consolidated-banner'))
                return;
            // Already-rendered guard: if the DOM has the banner already
            // (e.g. a user navigated from a view that just rendered it),
            // don't double-render.
            if (document.getElementById('ol-tier-session-banner'))
                return;
            _renderSessionBanner(state);
            state.bannerShownAt = Date.now();
            _writeSessionState(state);
        }
        catch (_e) { }
    }
    function _renderSessionBanner(state) {
        const tierRank = { plus: 1, pro: 2, professional: 3, 'pro-ai': 3 };
        const tierDisplayMap = (typeof window !== 'undefined' && w.TIER_DISPLAY_NAMES)
            || { plus: 'Researcher', pro: 'Investor', professional: 'Power User', 'pro-ai': 'Power User' };
        // Pick the LOWEST tier that unlocks every recorded event — the
        // cheapest banner CTA that satisfies the user's locked surfaces.
        // (Higher tiers always include lower ones, so the highest-required
        // tier IS the cheapest single-tier solution.)
        let topTier = 'plus';
        for (let i = 0; i < state.events.length; i++) {
            const t = state.events[i].minTier || 'plus';
            if ((tierRank[t] || 0) > (tierRank[topTier] || 0))
                topTier = t;
        }
        const topTierDisplay = tierDisplayMap[topTier] || (topTier.charAt(0).toUpperCase() + topTier.slice(1));
        const priceTxt = _tierPriceLabel(topTier);
        const lockedCount = state.events.length;
        const banner = document.createElement('div');
        banner.id = 'ol-tier-session-banner';
        banner.className = 'ol-tier-session-banner';
        banner.setAttribute('role', 'region');
        banner.setAttribute('aria-label', 'Locked premium features this visit');
        const inner = document.createElement('div');
        inner.className = 'ol-tier-session-banner-inner';
        const headline = document.createElement('div');
        headline.className = 'ol-tier-session-banner-headline';
        // Mobile audit 2026-09-25 wave 2 (voice): a calm statement of fact, not
        // "You've hit N paid features ... unlocks all of them".
        headline.textContent = lockedCount + (lockedCount === 1 ? ' feature' : ' features')
            + ' you opened this visit ' + (lockedCount === 1 ? 'is' : 'are')
            + ' part of the ' + topTierDisplay + ' plan (' + priceTxt + ').';
        const ctaWrap = document.createElement('div');
        ctaWrap.className = 'ol-tier-session-banner-cta';
        const upgradeBtn = document.createElement('button');
        upgradeBtn.type = 'button';
        upgradeBtn.className = 'ol-tier-session-banner-upgrade';
        upgradeBtn.setAttribute('data-action', 'tier-session-banner-click');
        upgradeBtn.textContent = 'Upgrade';
        upgradeBtn.addEventListener('click', function () {
            // #418: paywall_clicked_upgrade funnel step (session-banner CTA).
            try {
                _emitFunnel('paywall_clicked_upgrade', { tier: topTier });
            }
            catch (_) { }
            try {
                _openGateOrPricing('paywall_session_' + topTier, topTier);
            }
            catch (_) { }
            try {
                if (typeof w._track === 'function') {
                    w._track('tier_gate_session_banner_cta_click', {
                        minTier: topTier, lockedCount: lockedCount,
                    });
                }
            }
            catch (_) { }
        });
        // F10: secondary "See what's free" CTA. Opens the feature-
        // discovery overlay (templates/feat-disc-overlay.html) so the
        // upsell moment doubles as orientation — what's already free,
        // what's locked behind which tier. The audit framing: stop
        // treating the banner as a pure upgrade pitch; treat it as a
        // tier-tour entry point.
        const freeBtn = document.createElement('button');
        freeBtn.type = 'button';
        freeBtn.className = 'ol-tier-session-banner-secondary';
        freeBtn.setAttribute('data-action', 'tier-session-banner-see-free');
        freeBtn.textContent = "See what's free";
        freeBtn.addEventListener('click', function () {
            try {
                // Prefer the canonical feature-discovery opener if loaded,
                // else fall through to the pricing comparison anchor.
                if (typeof w.openFeatureDiscovery === 'function') {
                    w.openFeatureDiscovery();
                }
                else {
                    window.location.href = '/pricing#compare';
                }
            }
            catch (_) { }
            try {
                if (typeof w._track === 'function') {
                    w._track('tier_gate_session_banner_see_free_click', {
                        minTier: topTier, lockedCount: lockedCount,
                    });
                }
            }
            catch (_) { }
        });
        const dismissBtn = document.createElement('button');
        dismissBtn.type = 'button';
        dismissBtn.className = 'ol-tier-session-banner-dismiss';
        dismissBtn.setAttribute('aria-label', 'Dismiss this banner — not now');
        dismissBtn.textContent = '×';
        dismissBtn.addEventListener('click', function () {
            try {
                const b = document.getElementById('ol-tier-session-banner');
                if (b && b.parentNode)
                    b.parentNode.removeChild(b);
            }
            catch (_) { }
            // F10: persist the dismissal so we don't re-pitch within 24h.
            _markDismissed();
            try {
                if (typeof w._track === 'function') {
                    w._track('tier_gate_session_banner_dismissed', {
                        minTier: topTier, lockedCount: lockedCount,
                    });
                }
            }
            catch (_) { }
        });
        ctaWrap.appendChild(upgradeBtn);
        ctaWrap.appendChild(freeBtn);
        ctaWrap.appendChild(dismissBtn);
        inner.appendChild(headline);
        inner.appendChild(ctaWrap);
        banner.appendChild(inner);
        const main = (document.getElementById('content-wrapper') ||
            // eslint-disable-next-line no-console -- deliberate ops signal: Sentry browser integration captures console.error; anchor drift on the CONVERSION surface must be loud (EXT-AUDIT 1.5)
            (console.error('[tier-gate] #content-wrapper missing — banner degraded to body-prepend'), null)) /* EXT-AUDIT 1.5: see :400 */ || document.body;
        main.insertBefore(banner, main.firstChild);
        try {
            if (typeof w._track === 'function') {
                w._track('tier_gate_session_banner_shown', {
                    minTier: topTier, lockedCount: lockedCount,
                });
            }
        }
        catch (_) { }
    }
    function renderInlineUpgrade(container, opts) {
        if (!container)
            return;
        opts = opts || {};
        const featureId = opts.featureId || '';
        const featureName = opts.featureName || 'Premium feature';
        const description = opts.description || '';
        const minTier = opts.minTier || 'plus';
        const tierDisplayMap = (typeof window !== 'undefined' && w.TIER_DISPLAY_NAMES)
            || { plus: 'Researcher', pro: 'Investor', professional: 'Power User', 'pro-ai': 'Power User' };
        const tierDisplay = tierDisplayMap[minTier] || (minTier.charAt(0).toUpperCase() + minTier.slice(1));
        const price = _tierPriceLabel(minTier);
        const wrap = document.createElement('div');
        wrap.className = 'ol-tier-placeholder';
        const html = '<div class="ol-tier-placeholder-inner">'
            + '<div class="ol-tier-placeholder-title"></div>'
            + '<div class="ol-tier-placeholder-desc"></div>'
            + '<div class="ol-tier-placeholder-cta">'
            + '  <button type="button" class="ol-tier-placeholder-btn" data-action="tier-placeholder-click">See what\u2019s included <span aria-hidden="true">→</span></button>'
            + '  <span class="ol-tier-placeholder-price"></span>'
            + '</div>'
            + '</div>';
        wrap.innerHTML = html;
        const titleEl = wrap.querySelector('.ol-tier-placeholder-title');
        const descEl = wrap.querySelector('.ol-tier-placeholder-desc');
        const priceEl = wrap.querySelector('.ol-tier-placeholder-price');
        if (titleEl)
            titleEl.textContent = featureName;
        if (descEl)
            descEl.textContent = (description ? description + ' ' : '') + 'Available on ' + tierDisplay + '.';
        if (priceEl)
            priceEl.textContent = price;
        const btn = wrap.querySelector('.ol-tier-placeholder-btn');
        if (btn)
            btn.addEventListener('click', function () {
                // #418: paywall_clicked_upgrade funnel step (inline placeholder CTA).
                try {
                    _emitFunnel('paywall_clicked_upgrade', { tier: minTier || 'plus' });
                }
                catch (_) { }
                if (featureId) {
                    _openGateOrPricing(featureId, minTier || 'plus');
                }
                else {
                    window.location.href = '/?upgrade=' + encodeURIComponent(minTier || 'plus');
                }
                try {
                    if (typeof w._track === 'function') {
                        w._track('tier_gate_cta_click', { featureId: featureId, minTier: minTier });
                    }
                }
                catch (_) { }
            });
        container.textContent = '';
        container.appendChild(wrap);
        try {
            if (typeof w._track === 'function') {
                w._track('tier_gate_cta_render', { featureId: featureId, minTier: minTier });
            }
        }
        catch (_) { }
        try {
            _maybeConsolidate();
            _consolidationState.cards.push({
                container: wrap,
                featureName: featureName,
                minTier: minTier,
            });
            _maybeConsolidate();
        }
        catch (_) { }
        // Session-wide tracker: count this paywall placeholder against the
        // session-level threshold so cross-view fatigue triggers the
        // session banner. The dedup key includes the current view, so a
        // re-render of the same placeholder under the same view doesn't
        // double-count.
        try {
            _recordSessionPaywall(minTier, featureName || featureId || 'paywall');
        }
        catch (_) { }
    }
    function explain(url) {
        const required = _lookupRequired(url);
        const cur = _currentTier();
        if (!required)
            return { url: url, gated: false, currentTier: cur, reason: 'not in registry' };
        const allowed = _hasTier(required);
        return {
            url: url,
            gated: !allowed,
            minTier: required,
            currentTier: cur,
            reason: allowed ? 'tier OK' : 'insufficient tier',
        };
    }
    window.addEventListener('ol-tier-changed', function () { });
    // P1-23 (external review 2026-09-26): the consolidated banner used to
    // survive into the NEXT view with the old view's count, because the reset in
    // _maybeConsolidate only runs when a new placeholder renders. setView writes
    // body[data-view] synchronously as its first act (view-router.ts #124B), so a
    // change there is the view change -- drop the banner the moment it happens.
    function _onViewAttr() {
        try {
            const v = document.body ? document.body.getAttribute('data-view') : null;
            if (v && v !== _consolidationState.view && (_consolidationState.banner || _consolidationState.cards.length)) {
                _resetConsolidationForView(v);
            }
        }
        catch (_) { /* a banner reset must never break navigation */ }
    }
    try {
        if (typeof MutationObserver === 'function' && document.body) {
            new MutationObserver(_onViewAttr).observe(document.body, { attributes: true, attributeFilter: ['data-view'] });
        }
    }
    catch (_) { /* defensive */ }
    // ── User-gesture window (BOARD ticker cycle Q1, OWNER decision 2a, 2026-09-28) ──
    // The overlay below opens only for a gated fetch that FOLLOWS a user gesture.
    // 702fb284 / audit 2.1 made the interceptor raise it for every intercepted
    // fetch because "a blocked click must SHOW something" -- ~42 consumers never
    // check res.status === 402, so without it a click on a paid feature did
    // nothing. That reason is about clicks; it never covered fetches nobody
    // asked for, and the ticker view's lazy credit panels opened the full-screen
    // plan overlay on every cold visit (the 8.5s-dwell view).
    //
    // Mechanism: a capture-phase listener stamps the time of the last click /
    // form submit / Enter key, and the interceptor treats a gated fetch within
    // _GESTURE_WINDOW_MS of it as user-initiated. Capture phase runs BEFORE the
    // handler that issues the fetch, so a synchronous fetch in a click handler
    // is always inside the window; the window covers a handler that awaits a
    // little first. Chosen over navigator.userActivation: its transient window
    // is browser-defined (about 5s in Chromium, absent on older Safari), long
    // enough that a lazy panel loading a few seconds after an in-app navigation
    // click would still raise the overlay. A fixed, short window we stamp
    // ourselves is the same on every browser and is testable. Auto-loaded
    // panels should still pre-flight with canCall and render an inline card
    // (debt-panels.ts) -- this gate is the backstop, not the pattern.
    const _GESTURE_WINDOW_MS = 1500;
    let _lastGestureAt = 0;
    function _stampGesture(ev) {
        if (ev.type === 'keydown' && ev.key !== 'Enter')
            return;
        _lastGestureAt = Date.now();
    }
    try {
        // F3 (CHAOS 2026-09-28): `change` too -- a select/checkbox that loads a paid view is a request.
        ['click', 'submit', 'keydown', 'change'].forEach(function (t) {
            document.addEventListener(t, _stampGesture, true);
        });
    }
    catch (_) { /* no gesture stamp -> overlays stay off; inline cards remain */ }
    function _followsUserGesture(now) {
        return _lastGestureAt > 0 && (now - _lastGestureAt) <= _GESTURE_WINDOW_MS;
    }
    const _origFetch = window.fetch && window.fetch.bind(window);
    const _interceptBuffer = [];
    const MAX_INTERCEPT_BUFFER = 50;
    function _isDisabled() {
        try {
            return OLStorage.getString('ol_tier_gate_disable', null) === '1';
        }
        catch (_e) {
            return false;
        }
    }
    function _extractUrl(input) {
        if (typeof input === 'string')
            return input;
        if (input && typeof input.url === 'string')
            return input.url;
        return '';
    }
    if (_origFetch) {
        window.fetch = function (input, init) {
            try {
                if (_isDisabled())
                    return _origFetch(input, init);
                const url = _extractUrl(input);
                if (url.indexOf('/api/') === -1)
                    return _origFetch(input, init);
                const required = _lookupRequired(url);
                if (required && !_hasTier(required)) {
                    const _now = Date.now();
                    const _DEDUP_WINDOW_MS = 60000;
                    let _isDuplicate = false;
                    for (let _i = _interceptBuffer.length - 1; _i >= 0; _i--) {
                        const _prev = _interceptBuffer[_i];
                        if (_now - _prev.t > _DEDUP_WINDOW_MS)
                            break;
                        if (_prev.url === url) {
                            _isDuplicate = true;
                            break;
                        }
                    }
                    const _userInitiated = _followsUserGesture(_now);
                    if (!_isDuplicate) {
                        // `user` records whether the overlay was eligible (Q1), so the
                        // telemetry can tell a blocked click from an auto-load.
                        _interceptBuffer.push({ url: url, required: required, current: _currentTier(), t: _now, user: _userInitiated });
                        if (_interceptBuffer.length > MAX_INTERCEPT_BUFFER)
                            _interceptBuffer.shift();
                    }
                    // Session-wide tracker: a 402 from a fetch interceptor is
                    // also a paywall encounter. Use the URL path as the feature
                    // key (already deduped per view+key in _recordSessionPaywall).
                    try {
                        _recordSessionPaywall(required, url);
                    }
                    catch (_) { }
                    // #418: this client-side short-circuit is the paywall impression
                    // that NEVER reaches the backend (no 402 over the wire). Emit it
                    // server-side via sendBeacon, deduped once per gated view.
                    try {
                        _emitPaywallImpression(required, _normaliseUrl(url));
                    }
                    catch (_) { }
                    // 2.1 (2026-06-12 audit): a blocked click must SHOW something —
                    // raise the premium-gate overlay (tier + price + trial + free
                    // alternatives) from the interceptor itself instead of trusting
                    // 53 call sites to check res.status === 402. Cross-chunk:
                    // premium-gate lives in bundle-core-utils, tier-gate in
                    // bundle-app-init — window + typeof guard per the chunk rules.
                    // Throttled per feature so parallel gated fetches on one view
                    // render one overlay, and an overlay failure never breaks fetch.
                    try {
                        // FE-STORM P2-B (2026-07-04): a matched prefix raises its SPECIFIC overlay; an
                        // UNMATCHED gated URL used to fall through silently (empty panel, zero "this is a
                        // paid feature" messaging on the ~42 consumers that don't check res.status === 402).
                        // Fall back to the generic tier-keyed paywall (same id shape as the consolidated/
                        // session overlays above) so EVERY gated 402 shows something, not nothing.
                        const _fid = _featureForUrl(_normaliseUrl(url)) || ('paywall_consolidated_' + required);
                        const _wpg = window;
                        // Q1: only a fetch that follows a user gesture raises the overlay.
                        if (_userInitiated && _fid && typeof _wpg.showPremiumGate === 'function') {
                            const _lastShown = _overlayShownAt[_fid] || 0;
                            if (_now - _lastShown > _DEDUP_WINDOW_MS) {
                                _overlayShownAt[_fid] = _now;
                                _wpg.showPremiumGate(_fid);
                            }
                        }
                    }
                    catch (_) { /* overlay must never break the fetch */ }
                    // F-04 (external code review 2026-05-21): resolve with a
                    // synthetic 402 Response instead of rejecting with a bare
                    // Error. The backend's real tier-gate exception handler
                    // (routes/api_errors.py::tier_gate_exception_handler) returns
                    // the same shape (status 402, body with requiredTier +
                    // currentTier + url), so every existing 402 handler in the
                    // app now "just works" without modification — including
                    // data-pipeline.ts:292 which already parses _402body.
                    // Migrated alongside: 3 consumers (screener-options.ts × 2,
                    // ticker-renderer.ts × 1) that previously caught the bare
                    // Error and called renderInlineUpgrade in catch; they now
                    // check `res.status === 402` inline. See same-PR commits.
                    const _curTier = _currentTier();
                    const _body = JSON.stringify({
                        error: 'tier-gated',
                        requiredTier: required,
                        currentTier: _curTier,
                        url: url,
                        // 2.2 (2026-06-12 audit): the server's 402 handler returns
                        // upgrade_url (routes/api_errors.py); consumers reading it
                        // got undefined on client-gated 402s. `url` (the blocked
                        // endpoint) stays for back-compat — different semantic.
                        upgrade_url: '/pricing',
                        reason: 'tier-gate-intercept',
                    });
                    const _resp = new Response(_body, {
                        status: 402,
                        statusText: 'Payment Required',
                        headers: { 'content-type': 'application/json' },
                    });
                    // Tag the Response so consumers that want to special-case
                    // the intercept (vs a real server-side 402) can introspect.
                    try {
                        _resp
                            ._tierGateIntercept = true;
                    }
                    catch (_) { /* defensive */ }
                    return Promise.resolve(_resp);
                }
            }
            catch (_e) {
                // Never let gate-check failure break a fetch — silently fall through.
            }
            return _origFetch(input, init);
        };
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', _loadRegistry);
    }
    else {
        void _loadRegistry();
    }
    w.TierGate = {
        fetchIfAllowed: fetchIfAllowed,
        canCall: canCall,
        requiredTier: requiredTier,
        renderInlineUpgrade: renderInlineUpgrade,
        explain: explain,
        _loadRegistry: _loadRegistry,
        _getMap: function () { return _endpointMap || {}; },
        _intercepts: function () { return _interceptBuffer.slice(); },
        _isDisabled: _isDisabled,
    };
})();
//# sourceMappingURL=tier-gate.js.map
;
// ═══ session-lifecycle.js ═══
;"use strict";
/**
 * session-lifecycle.js — Global 401 session-expiry handler (CR-C4)
 *
 * TS Migration Phase 2 PR 9 (2026-05-04): renamed .js → .ts.
 * Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
 *
 * This file is now the SOURCE OF TRUTH; the sibling session-lifecycle.js
 * is the build artifact produced by `npx tsc -p tsconfig.build.json`
 * (gitignored).
 *
 * Problem: tier-gate.js intercepts 402s with an upgrade card, but there was
 * no equivalent for 401 (expired session). A user typing in a scratchpad note
 * or screener filter hit the auth wall mid-submit and got a silent fetch
 * failure — no toast, no "your session expired" banner, no input preserved.
 *
 * Fix:
 *   1. Global fetch wrapper that checks every /api/* response for 401.
 *   2. Dispatches ol-session-expired CustomEvent (idempotent, 30s guard).
 *   3. Toast listener renders "Your session expired — sign in to continue"
 *      with a Sign In button that opens the auth modal.
 *   4. Draft preservation: scans data-ol-draft-key elements and saves to
 *      sessionStorage before the toast renders.
 *   5. Draft restoration: on ol-user-signed-in, reads saved drafts back.
 *
 * Coexistence with tier-gate.js:
 *   tier-gate.js wraps window.fetch to short-circuit 402s BEFORE the network
 *   call. This module wraps the already-wrapped window.fetch (whichever is
 *   the live reference at load time) to inspect ACTUAL responses — it does
 *   not double-gate 402s. Load order: tier-gate.js first, then this module.
 *
 * CSP compliance: NO inline styles, NO cssText. All classes are defined in
 * dashboard-styles.css under the ol-session-toast-* namespace.
 */
(function () {
    'use strict';
    // ── Idempotency guard ─────────────────────────────────────────────────────
    // Suppresses further dispatches if ol-session-expired fired within 30s.
    // Prevents toast spam when several in-flight fetches all hit the 401 wall
    // at once (e.g. page load with 5 parallel data fetches on a stale session).
    let _lastSessionExpiredAt = 0;
    const SESSION_EXPIRED_DEBOUNCE_MS = 30000; // 30 seconds
    // URLs where 401 is expected / handled by a dedicated flow — skip them.
    const _SKIP_URLS = [
        '/api/auth/me', // canonical "am I logged in" probe — 401 = anonymous, normal
        '/api/auth/refresh', // token refresh endpoint — 401 handled by its own caller
        '/api/auth/login', // login attempt — 401 is the "wrong password" response
        // Curated bond catalogue (2026-08-07 P0, COUNSEL ruling §1D / C4a). The
        // loader in credit-sample-cusips.ts fires this eagerly on every nav to
        // ?view=credit / ?view=screener, so for an ANONYMOUS visitor the 401 is
        // the normal steady state — not an expired session. Without this entry a
        // logged-out user browsing the credit view would be shown a "session
        // expired" toast and bounced to /login, which is worse than the anonymous
        // bulk download the P0 removed. The loader treats 401 as a silent no-op
        // and degrades to the empty "0 curated bonds" state.
        '/api/credit/sample-cusips',
    ];
    function _shouldSkip(url) {
        if (typeof url !== 'string')
            return true;
        for (let i = 0; i < _SKIP_URLS.length; i++) {
            if (url.indexOf(_SKIP_URLS[i]) !== -1)
                return true;
        }
        return false;
    }
    function _isApiUrl(url) {
        if (typeof url !== 'string')
            return false;
        return url.indexOf('/api/') !== -1;
    }
    function _extractUrl(input) {
        if (typeof input === 'string')
            return input;
        if (input instanceof URL)
            return input.toString();
        if (input && typeof input.url === 'string') {
            return input.url;
        }
        return '';
    }
    // ── Draft preservation ────────────────────────────────────────────────────
    // Convention: any input/textarea that carries data-ol-draft-key="<key>"
    // will have its value saved to sessionStorage under "ol_draft:<key>" before
    // the session-expired toast renders.
    const DRAFT_PREFIX = 'ol_draft:';
    function _saveDrafts() {
        try {
            const elements = document.querySelectorAll('[data-ol-draft-key]');
            for (let i = 0; i < elements.length; i++) {
                const el = elements[i];
                const key = el.dataset && el.dataset.olDraftKey;
                if (!key)
                    continue;
                const val = el.value;
                if (val) {
                    // eslint-disable-next-line ol/no-direct-localstorage -- sessionStorage has no OLStorage wrapper; draft preservation is intentionally session-scoped per CR-C4
                    try {
                        sessionStorage.setItem(DRAFT_PREFIX + key, val);
                    }
                    catch (_e) { }
                }
            }
        }
        catch (_e) { }
    }
    function _restoreDrafts() {
        try {
            const elements = document.querySelectorAll('[data-ol-draft-key]');
            for (let i = 0; i < elements.length; i++) {
                const el = elements[i];
                const key = el.dataset && el.dataset.olDraftKey;
                if (!key)
                    continue;
                try {
                    // eslint-disable-next-line ol/no-direct-localstorage -- sessionStorage has no OLStorage wrapper; draft restoration sibling to _saveDrafts above
                    const saved = sessionStorage.getItem(DRAFT_PREFIX + key);
                    if (saved !== null && saved !== undefined) {
                        el.value = saved;
                        // eslint-disable-next-line ol/no-direct-localstorage -- sessionStorage has no OLStorage wrapper; one-shot drain after restore
                        sessionStorage.removeItem(DRAFT_PREFIX + key);
                    }
                }
                catch (_e) { }
            }
        }
        catch (_e) { }
    }
    // ── Toast UI ───────────────────────────────────────────────────────────────
    // Renders a non-blocking session-expired banner at the top-right of the
    // viewport. All styling via CSS classes — no inline styles (CSP).
    let _activeToastEl = null;
    let _autoExpireTimer = null;
    function _dismissToast() {
        if (_activeToastEl) {
            try {
                _activeToastEl.classList.add('ol-session-toast-exiting');
                const el = _activeToastEl;
                setTimeout(function () { if (el && el.parentNode)
                    el.parentNode.removeChild(el); }, 300);
                _activeToastEl = null;
            }
            catch (_e) { }
        }
        if (_autoExpireTimer) {
            clearTimeout(_autoExpireTimer);
            _autoExpireTimer = null;
        }
    }
    function _renderSessionExpiredToast() {
        // Idempotent — replace any existing session toast rather than stacking.
        _dismissToast();
        const toast = document.createElement('div');
        toast.className = 'ol-session-toast';
        toast.setAttribute('role', 'alert');
        toast.setAttribute('aria-live', 'assertive');
        toast.id = 'ol-session-expired-toast';
        const msgSpan = document.createElement('span');
        msgSpan.className = 'ol-session-toast-msg';
        msgSpan.textContent = 'Your session expired — sign in to continue';
        const signinBtn = document.createElement('button');
        signinBtn.type = 'button';
        signinBtn.className = 'ol-session-toast-signin-btn';
        signinBtn.textContent = 'Sign in';
        signinBtn.addEventListener('click', function () {
            _dismissToast();
            // Dispatch the canonical event; session-lifecycle.js listens for it too.
            try {
                window.dispatchEvent(new CustomEvent('ol-open-signin-modal', {
                    detail: { reason: 'session-expired' },
                }));
            }
            catch (_e) { }
            // Defensive direct call in case the event listener isn't wired yet.
            try {
                if (typeof authOpenModal === 'function')
                    authOpenModal('signin');
            }
            catch (_e) { }
        });
        const dismissBtn = document.createElement('button');
        dismissBtn.type = 'button';
        dismissBtn.className = 'ol-session-toast-dismiss-btn';
        dismissBtn.setAttribute('aria-label', 'Dismiss');
        dismissBtn.textContent = '×';
        dismissBtn.addEventListener('click', _dismissToast);
        toast.appendChild(msgSpan);
        toast.appendChild(signinBtn);
        toast.appendChild(dismissBtn);
        // Insert into #toast-container if available (matches app.js showToast pattern),
        // otherwise append to body as fallback.
        const container = document.getElementById('toast-container') || document.body;
        container.appendChild(toast);
        _activeToastEl = toast;
        // Auto-dismiss after 30 seconds.
        _autoExpireTimer = setTimeout(_dismissToast, 30000);
    }
    // ── Core event dispatch ───────────────────────────────────────────────────
    function _onSession401(url, method) {
        // 2026-09-26 anon audit: a reader who never signed in cannot have an
        // expired session. Without this, every anon 401 (watchlist, calendar,
        // settings, invoices, streak...) raised "Your session expired -- sign in
        // to continue", visible on every view once #toast-container stopped being
        // nested in the hidden ticker pane (09daf3d5). A real expiry keeps its
        // ol_csrf_hmac cookie, so olIsAnonymous() is false and the toast still shows.
        const _anonFn = window.olIsAnonymous;
        if (typeof _anonFn === 'function' && _anonFn())
            return;
        const now = Date.now();
        if (now - _lastSessionExpiredAt < SESSION_EXPIRED_DEBOUNCE_MS) {
            // Still within debounce window — suppress duplicate dispatch.
            return;
        }
        _lastSessionExpiredAt = now;
        // Save any in-progress drafts before showing the toast.
        _saveDrafts();
        // Dispatch the canonical event so other modules can react.
        try {
            window.dispatchEvent(new CustomEvent('ol-session-expired', {
                detail: { url: url, method: method || 'GET' },
            }));
        }
        catch (_e) { }
        // Render the toast (the primary UX response).
        _renderSessionExpiredToast();
    }
    // ── M9: Age-verification 403 handler ──────────────────────────────────────
    // New OAuth signups land with oauth_age_pending=TRUE + date_of_birth=NULL
    // (COPPA gap fix v34). Backend require_auth raises 403 with detail
    // "age_verification_required" on protected routes for these users.
    // Pre-fix: silent fetch failure, no modal, no completion path — user
    // sees broken pages and can't continue. Fix: force-mount a DOB modal
    // when this 403 is observed; on submit POST to
    // /api/auth/complete-age-verification then reload.
    //
    // Idempotency: a single 403 modal at a time. Once mounted, subsequent
    // 403s are absorbed silently until the modal is dismissed (or auth
    // completion succeeds and triggers a reload).
    let _ageVerifyModalEl = null;
    const _AGE_VERIFY_DETAIL_LITERALS = ['age_verification_required'];
    function _isAgeVerifyResponse(parsedBody) {
        if (!parsedBody || typeof parsedBody !== 'object')
            return false;
        // P0 2026-07-10: the unified error envelope (routes/api_errors.py
        // http_exception_handler) re-keys HTTPException bodies to
        // {error, message, status} — the raw FastAPI `detail` key this check
        // originally matched NEVER reached the browser, so the DOB modal never
        // mounted and age-pending OAuth users saw silently broken pages. The
        // envelope now passes the sentinel through on all three keys; check all
        // three so neither side can silently break the other again.
        const b = parsedBody;
        const candidates = [b.detail, b.error, b.message];
        for (let c = 0; c < candidates.length; c++) {
            const v = candidates[c];
            if (typeof v !== 'string')
                continue;
            for (let i = 0; i < _AGE_VERIFY_DETAIL_LITERALS.length; i++) {
                if (v === _AGE_VERIFY_DETAIL_LITERALS[i])
                    return true;
            }
        }
        return false;
    }
    function _renderAgeVerificationModal() {
        // Idempotent: if a modal is already mounted, no-op.
        if (_ageVerifyModalEl && _ageVerifyModalEl.parentNode)
            return;
        try {
            const overlay = document.createElement('div');
            overlay.className = 'ol-age-verify-overlay';
            overlay.id = 'ol-age-verify-modal-overlay';
            overlay.setAttribute('role', 'dialog');
            overlay.setAttribute('aria-modal', 'true');
            overlay.setAttribute('aria-labelledby', 'ol-age-verify-title');
            const modal = document.createElement('div');
            modal.className = 'ol-age-verify-modal';
            const title = document.createElement('h2');
            title.id = 'ol-age-verify-title';
            title.className = 'ol-age-verify-title';
            title.textContent = 'One more step';
            const body = document.createElement('p');
            body.className = 'ol-age-verify-body';
            body.textContent = 'Please confirm your date of birth to continue. We use this to comply with COPPA + your jurisdiction\'s age-of-majority rules. Required once per account.';
            const label = document.createElement('label');
            label.className = 'ol-age-verify-label';
            label.htmlFor = 'ol-age-verify-dob-input';
            label.textContent = 'Date of birth';
            const input = document.createElement('input');
            input.type = 'date';
            input.className = 'ol-age-verify-input';
            input.id = 'ol-age-verify-dob-input';
            input.required = true;
            // Sane bounds: today as max (no future dates), 120yr ago as min.
            const _now = new Date();
            const _maxDate = _now.toISOString().slice(0, 10);
            const _minYear = _now.getFullYear() - 120;
            input.max = _maxDate;
            input.min = _minYear + '-01-01';
            // CHAOS F2 (2026-10-04): a 13-17 OAuth account needs a parent or
            // guardian address to finish (the server refuses a minor without one),
            // so the field appears once the date of birth reads 13-17. It sits in a
            // plain wrapper toggled by `hidden`: the label/input classes set
            // display:block, which would override the attribute on the field itself.
            const parentWrap = document.createElement('div');
            parentWrap.className = 'ol-age-verify-parent';
            parentWrap.id = 'ol-age-verify-parent';
            parentWrap.hidden = true;
            const parentLabel = document.createElement('label');
            parentLabel.className = 'ol-age-verify-label';
            parentLabel.htmlFor = 'ol-age-verify-parent-input';
            parentLabel.textContent = 'Parent or guardian email';
            const parentInput = document.createElement('input');
            parentInput.type = 'email';
            parentInput.className = 'ol-age-verify-input';
            parentInput.id = 'ol-age-verify-parent-input';
            parentInput.autocomplete = 'off';
            const parentNote = document.createElement('p');
            parentNote.className = 'ol-age-verify-body';
            parentNote.textContent = 'You are under 18, so we email your parent or guardian to approve your account.';
            parentWrap.appendChild(parentLabel);
            parentWrap.appendChild(parentInput);
            parentWrap.appendChild(parentNote);
            function _ageFromDob(v) {
                const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v || '');
                if (!m)
                    return null;
                const t = new Date();
                let a = t.getFullYear() - Number(m[1]);
                const mo = t.getMonth() + 1, d = t.getDate();
                if (mo < Number(m[2]) || (mo === Number(m[2]) && d < Number(m[3])))
                    a -= 1;
                return a;
            }
            function _syncParentField() {
                const a = _ageFromDob(input.value);
                parentWrap.hidden = !(a !== null && a >= 13 && a < 18);
            }
            input.addEventListener('change', _syncParentField);
            input.addEventListener('input', _syncParentField);
            const errEl = document.createElement('div');
            errEl.className = 'ol-age-verify-error';
            errEl.id = 'ol-age-verify-error';
            errEl.setAttribute('role', 'alert');
            const btnRow = document.createElement('div');
            btnRow.className = 'ol-age-verify-btn-row';
            const submitBtn = document.createElement('button');
            submitBtn.type = 'button';
            submitBtn.className = 'ol-age-verify-submit-btn';
            submitBtn.textContent = 'Confirm';
            const signOutBtn = document.createElement('button');
            signOutBtn.type = 'button';
            signOutBtn.className = 'ol-age-verify-signout-btn';
            signOutBtn.textContent = 'Sign out';
            signOutBtn.addEventListener('click', function () {
                try {
                    if (_prevFetch) {
                        _prevFetch('/api/auth/logout', { method: 'POST', credentials: 'same-origin',
                            headers: { 'X-CSRF-Token': (typeof _getCsrfToken === 'function' ? _getCsrfToken() : '') } })
                            .then(function () { window.location.href = '/'; })
                            .catch(function () { window.location.href = '/'; });
                    }
                    else {
                        window.location.href = '/';
                    }
                }
                catch (_e) {
                    window.location.href = '/';
                }
            });
            submitBtn.addEventListener('click', function () {
                const dob = input.value;
                errEl.textContent = '';
                if (!dob) {
                    errEl.textContent = 'Please enter your date of birth.';
                    return;
                }
                _syncParentField();
                const parentEmail = parentWrap.hidden ? '' : (parentInput.value || '').trim();
                if (!parentWrap.hidden && !parentEmail) {
                    errEl.textContent = 'Please enter your parent or guardian’s email.';
                    return;
                }
                submitBtn.disabled = true;
                submitBtn.textContent = 'Confirming…';
                // CSRF cookie is sent automatically via same-origin credentials.
                // The /api/auth/complete-age-verification route requires CSRF
                // (validate_csrf dependency); the X-CSRF-Token header is read
                // from a cookie by the canonical helper, but we shortcut by
                // re-reading the cookie inline (auth-handlers may not be loaded
                // before session-lifecycle in all bundle orderings).
                //
                // HMAC-first (2026-07-29): /api/auth/complete-age-verification is
                // `require_auth`, so it always carries ol_session and validate_csrf
                // takes path (b) — which requires HMAC(OL_CSRF_SECRET, ol_session)
                // and, since SEC-2 (2026-06-14), rejects a mismatch outright with no
                // fallthrough. The legacy `ol_csrf` cookie is a different random
                // token, kept last as the anonymous path-(a) fallback. Pinned by
                // tests/test_client_csrf_hmac_first_contract.py.
                let csrfToken = '';
                try {
                    const hmacMatch = document.cookie.match(/(?:^|;\s*)ol_csrf_hmac=([^;]+)/);
                    const match = document.cookie.match(/(?:^|;\s*)ol_csrf=([^;]+)/);
                    if (hmacMatch && hmacMatch[1])
                        csrfToken = decodeURIComponent(hmacMatch[1]);
                    else if (match)
                        csrfToken = decodeURIComponent(match[1]);
                }
                catch (_e) { }
                const headers = { 'Content-Type': 'application/json' };
                if (csrfToken)
                    headers['X-CSRF-Token'] = csrfToken;
                if (!_prevFetch) {
                    errEl.textContent = 'Browser fetch unavailable — please reload.';
                    submitBtn.disabled = false;
                    submitBtn.textContent = 'Confirm';
                    return;
                }
                _prevFetch('/api/auth/complete-age-verification', {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: headers,
                    body: JSON.stringify(parentEmail
                        ? { date_of_birth: dob, parental_consent_email: parentEmail }
                        : { date_of_birth: dob }),
                }).then(function (res) {
                    if (res.ok) {
                        // Success — reload to re-fetch protected resources with the
                        // newly cleared age-pending flag.
                        window.location.reload();
                        return;
                    }
                    return res.json().catch(function () { return null; }).then(function (data) {
                        // CHAOS F2 (2026-10-04): an under-13 answer deleted the account
                        // server-side. Mark this browser (the OL-UNDER13-GUARD reads the
                        // same key) and show the 13+ statement -- no retry, no form.
                        if (res.status === 403 && data && data.under_13) {
                            try {
                                OLStorage.setString('ol_age_verified', 'under_13');
                            }
                            catch (_e) { }
                            try {
                                const g = window.olInstallUnder13Guard;
                                if (typeof g === 'function')
                                    g();
                            }
                            catch (_e) { }
                            body.textContent = 'Oxford Ledge is for people 13 and older.';
                            title.textContent = 'Oxford Ledge is for people 13 and older';
                            // Removed, not hidden: their classes set display, which would
                            // override the `hidden` attribute.
                            [label, input, parentWrap, submitBtn].forEach(function (n) {
                                if (n.parentNode)
                                    n.parentNode.removeChild(n);
                            });
                            errEl.textContent = '';
                            signOutBtn.textContent = 'Close';
                            return;
                        }
                        // api_error sends {error, message}: read those (CHAOS F2 -- the
                        // prior read of `detail` always fell through to the generic line).
                        const raw = data ? (data.error || data.message) : '';
                        const msg = (typeof raw === 'string' && raw) ? raw : 'Verification failed. Please try again.';
                        errEl.textContent = msg;
                        submitBtn.disabled = false;
                        submitBtn.textContent = 'Confirm';
                    });
                }).catch(function () {
                    errEl.textContent = 'Network error — please try again.';
                    submitBtn.disabled = false;
                    submitBtn.textContent = 'Confirm';
                });
            });
            btnRow.appendChild(submitBtn);
            btnRow.appendChild(signOutBtn);
            modal.appendChild(title);
            modal.appendChild(body);
            modal.appendChild(label);
            modal.appendChild(input);
            modal.appendChild(parentWrap);
            modal.appendChild(errEl);
            modal.appendChild(btnRow);
            overlay.appendChild(modal);
            document.body.appendChild(overlay);
            _ageVerifyModalEl = overlay;
            // Focus the DOB input for keyboard users.
            try {
                input.focus();
            }
            catch (_e) { }
        }
        catch (_e) {
            // Modal mount failed — fall back to a full-page reload so at
            // minimum the user isn't left on a 403-throwing page silently.
            // /complete-verification doesn't exist as a route, so reload is
            // the safest fallback. ONE-SHOT guarded (FE-AUDIT #106): if the
            // mount throws BEFORE _ageVerifyModalEl is set, an unguarded reload
            // loops reload -> protected fetch re-403s (age_verification_required)
            // -> re-mount -> throw -> reload forever. Mirror ol_chunk_stale_reload
            // / ol_ticker_stuck_reload: a missing/unwritable sessionStorage means
            // we cannot prove loop-safety, so we do NOT reload.
            try {
                var _ss = window.sessionStorage;
                if (_ss && !_ss.getItem('ol_age_verify_reload')) {
                    _ss.setItem('ol_age_verify_reload', String(Date.now()));
                    window.location.reload();
                }
            }
            catch (__e) { }
        }
    }
    // Fire-and-forget: parse a Response clone for the age-verification
    // detail literal, then trigger the modal. Uses .clone() so the
    // original response stream stays intact for the caller.
    function _maybeHandleAgeVerify(response) {
        if (!response || response.status !== 403)
            return;
        try {
            const cloned = response.clone();
            cloned.json().then(function (body) {
                if (_isAgeVerifyResponse(body)) {
                    try {
                        _renderAgeVerificationModal();
                    }
                    catch (_e) { }
                }
            }).catch(function () {
                // Body wasn't JSON — not our 403, ignore.
            });
        }
        catch (_e) { }
    }
    // ── Fetch interceptor ─────────────────────────────────────────────────────
    // Wraps the CURRENT window.fetch at load time. tier-gate.js may already
    // have wrapped the native fetch; we compose on top of whatever is live.
    // This module ONLY intercepts ACTUAL 401 responses from the network —
    // it does not pre-flight or short-circuit any call.
    const _prevFetch = (typeof window !== 'undefined' && window.fetch)
        ? window.fetch.bind(window)
        : null;
    if (_prevFetch) {
        window.fetch = function (input, init) {
            const url = _extractUrl(input);
            // Fast path: skip non-API URLs and excluded endpoints.
            if (!_isApiUrl(url) || _shouldSkip(url)) {
                return _prevFetch(input, init);
            }
            const method = (init && init.method) || 'GET';
            return _prevFetch(input, init).then(function (response) {
                if (response && response.status === 401) {
                    try {
                        _onSession401(url, method);
                    }
                    catch (_e) { }
                }
                else if (response && response.status === 403) {
                    // M9: detect age_verification_required + force-mount modal.
                    try {
                        _maybeHandleAgeVerify(response);
                    }
                    catch (_e) { }
                }
                // Always return the original response — callers must not be disrupted.
                return response;
            });
            // NB: we intentionally do NOT catch() here — network errors (offline,
            // CORS, etc.) are not 401s; let callers handle them with their own
            // .catch() chains.
        };
    }
    // ── Event: ol-open-signin-modal ───────────────────────────────────────────
    // Listens for the canonical modal-open event dispatched by the Sign In
    // button inside the toast (and by other modules). Falls through to
    // authOpenModal() which lives in milestones-view.js.
    window.addEventListener('ol-open-signin-modal', function () {
        try {
            if (typeof authOpenModal === 'function')
                authOpenModal('signin');
        }
        catch (_e) { }
    });
    // ── Event: ol-user-signed-in ───────────────────────────────────────────────
    // Dispatched by milestones-view.js authUpdateUI() when _authUser becomes
    // truthy (i.e. user successfully signed in). Restores saved drafts.
    window.addEventListener('ol-user-signed-in', function () {
        try {
            _restoreDrafts();
        }
        catch (_e) { }
        // Also dismiss any lingering session-expired toast.
        _dismissToast();
        _lastSessionExpiredAt = 0; // Reset guard so a future real expiry shows the toast.
    });
    // ── Auto-dismiss on 200 ───────────────────────────────────────────────────
    // If the toast is showing and a subsequent /api/* call succeeds (200 OK),
    // that means auth was somehow re-established (e.g. cookie refreshed
    // server-side) — dismiss the toast proactively.
    // Re-wrap only if we successfully wrapped above.
    if (_prevFetch) {
        const _toastAwareFetch = window.fetch;
        window.fetch = function (input, init) {
            const url = _extractUrl(input);
            if (!_activeToastEl || !_isApiUrl(url))
                return _toastAwareFetch(input, init);
            return _toastAwareFetch(input, init).then(function (response) {
                if (response && response.status === 200 && _activeToastEl) {
                    try {
                        _dismissToast();
                    }
                    catch (_e) { }
                }
                return response;
            });
        };
    }
    // ── Info toast helper ─────────────────────────────────────────────────────
    // Lightweight "activating…" banner for the post-Checkout waiting state.
    // Uses the same #toast-container / body-append fallback as the expired toast.
    // Class `ol-session-toast-info` is a sibling variant in dashboard-styles.css.
    let _activeInfoToastEl = null;
    function _showInfoToast(text) {
        // Remove any prior info toast first (idempotent on repeated calls).
        if (_activeInfoToastEl) {
            try {
                if (_activeInfoToastEl.parentNode) {
                    _activeInfoToastEl.parentNode.removeChild(_activeInfoToastEl);
                }
            }
            catch (_e) { }
            _activeInfoToastEl = null;
        }
        const toast = document.createElement('div');
        toast.className = 'ol-session-toast ol-session-toast-info';
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');
        toast.id = 'ol-tier-refresh-toast';
        const msgSpan = document.createElement('span');
        msgSpan.className = 'ol-session-toast-msg';
        msgSpan.textContent = text;
        toast.appendChild(msgSpan);
        const container = document.getElementById('toast-container') || document.body;
        container.appendChild(toast);
        _activeInfoToastEl = toast;
    }
    function _hideInfoToast() {
        if (_activeInfoToastEl) {
            try {
                _activeInfoToastEl.classList.add('ol-session-toast-exiting');
                const el = _activeInfoToastEl;
                setTimeout(function () { if (el && el.parentNode)
                    el.parentNode.removeChild(el); }, 300);
            }
            catch (_e) { }
            _activeInfoToastEl = null;
        }
    }
    // ── Tier refresh poller (CR-H5) ───────────────────────────────────────────
    // Polls /api/auth/refresh-tier until the tier changes from `priorTier` OR
    // maxAttempts is exhausted. Returns a Promise:
    //   resolve({oldTier, newTier})  — tier changed within maxAttempts
    //   reject({reason, attempts})   — timed out
    //
    // Dispatches `ol-tier-refreshed` CustomEvent on the window so TierGate
    // and other listeners can re-evaluate gates without a page reload.
    //
    // Uses direct fetch with an eslint-disable comment below because this module
    // predates the OLApi typed-client and lives at the infrastructure layer
    // (below the SPA data layer). Wrapping via window.OLApi.getRefreshTier
    // would create a circular dependency (session-lifecycle loads before
    // api-client in the bundle order). The direct fetch is intentional and
    // documented — it hits the same CORS/cookie path as all /api/* calls.
    function pollTierRefresh(opts) {
        const maxAttempts = (opts && opts.maxAttempts) || 10;
        const intervalMs = (opts && opts.intervalMs) || 1000;
        const sessionWin = window;
        const priorTier = (opts && opts.priorTier) || (typeof sessionWin._userTier === 'string' ? sessionWin._userTier : 'free');
        return new Promise(function (resolve, reject) {
            let attempt = 0;
            function _poll() {
                attempt += 1;
                let req;
                if (typeof window !== 'undefined' && window.fetch) {
                    // window.fetch member-access form (not bare `fetch`) so the
                    // ol/prefer-typed-api-client rule doesn't fire here. session-
                    // lifecycle is infrastructure-layer, loaded before api-client
                    // in bundle order; OLApi wrapper would create circular dep.
                    req = window.fetch('/api/auth/refresh-tier', { credentials: 'same-origin' });
                }
                else {
                    req = Promise.reject(new Error('fetch unavailable'));
                }
                req.then(function (res) {
                    if (!res.ok) {
                        // 401 = session expired mid-poll (unusual but possible); stop.
                        reject({ reason: 'http_error', status: res.status, attempts: attempt });
                        return null;
                    }
                    return res.json();
                }).then(function (data) {
                    if (!data)
                        return; // already rejected above
                    const newTier = data.tier || 'free';
                    if (newTier !== priorTier) {
                        // Tier changed — success path.
                        try {
                            window.dispatchEvent(new CustomEvent('ol-tier-refreshed', {
                                detail: { oldTier: priorTier, newTier: newTier },
                            }));
                        }
                        catch (_e) { }
                        resolve({ oldTier: priorTier, newTier: newTier });
                    }
                    else if (attempt >= maxAttempts) {
                        reject({ reason: 'timeout', attempts: attempt });
                    }
                    else {
                        setTimeout(_poll, intervalMs);
                    }
                }).catch(function (err) {
                    if (attempt >= maxAttempts) {
                        reject({ reason: 'network_error', error: err, attempts: attempt });
                    }
                    else {
                        setTimeout(_poll, intervalMs);
                    }
                });
            }
            _poll();
        });
    }
    // ── Public API (for tests / debugging) ────────────────────────────────────
    const api = {
        // Fire the 401 handler programmatically (test / dev use only).
        _trigger: function (url, method) { _onSession401(url || '/api/test', method || 'GET'); },
        _getLastExpiredAt: function () { return _lastSessionExpiredAt; },
        _resetGuard: function () { _lastSessionExpiredAt = 0; },
        _dismissToast: _dismissToast,
        _saveDrafts: _saveDrafts,
        _restoreDrafts: _restoreDrafts,
        SKIP_URLS: _SKIP_URLS,
        DRAFT_PREFIX: DRAFT_PREFIX,
        // CR-H5: post-Checkout tier-refresh poller.
        pollTierRefresh: pollTierRefresh,
        _showInfoToast: _showInfoToast,
        _hideInfoToast: _hideInfoToast,
        // M9: age-verification 403 handler.
        _renderAgeVerificationModal: _renderAgeVerificationModal,
        _isAgeVerifyResponse: _isAgeVerifyResponse,
        _dismissAgeVerifyModal: function () {
            if (_ageVerifyModalEl && _ageVerifyModalEl.parentNode) {
                try {
                    _ageVerifyModalEl.parentNode.removeChild(_ageVerifyModalEl);
                }
                catch (_e) { }
            }
            _ageVerifyModalEl = null;
        },
    };
    window.OLSessionLifecycle = api;
})();
//# sourceMappingURL=session-lifecycle.js.map
;
// ═══ sentry-init.js ═══
;"use strict";
/**
 * Browser Sentry loader (Phase 1b, 2026-04-16).
 *
 * TS Migration Phase 2 PR 21 (2026-05-04): renamed .js → .ts.
 * Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
 *
 * This file is now the SOURCE OF TRUTH; the sibling sentry-init.js
 * is the build artifact produced by `npx tsc -p tsconfig.build.json`
 * (gitignored).
 *
 * Reads config from CSP-safe <meta> tags injected by serve_dashboard when
 * SENTRY_DSN_BROWSER env var is set:
 *   <meta name="ol-sentry-dsn" content="...">
 *   <meta name="ol-sentry-env" content="production|development">
 *   <meta name="ol-sentry-release" content="oxford-ledge-frontend@<sha>">
 * No-op if the meta tags are absent.
 *
 * Lazy-loads the Sentry CDN bundle so users without Sentry configured
 * don't pay a ~50KB network cost on page load. Once loaded, Sentry
 * automatically captures unhandled exceptions + rejected promises +
 * console.error calls.
 *
 * Privacy:
 *   - sendDefaultPii: false
 *   - beforeSend hook strips URL query strings (might contain email on
 *     signup paths)
 *   - No replay / session recording (keeps free-tier quota + privacy)
 *
 * Security note: the DSN is by design a public value — Sentry DSNs are
 * meant to be embedded in client code. They let the browser POST events
 * to a specific project but are not a secret. Rate-limiting + event
 * filtering happen on the Sentry side. The server-side CSP already
 * allow-lists browser.sentry-cdn.com + *.ingest.sentry.io conditionally
 * when the DSN is configured.
 */
(function () {
    'use strict';
    function _olUnder13() {
        try {
            const w = window;
            return typeof w.olIsUnder13Browser === 'function' && w.olIsUnder13Browser() === true;
        }
        catch (_e) {
            return false;
        }
    }
    function _meta(name) {
        const el = document.querySelector('meta[name="' + name + '"]');
        return el ? (el.getAttribute('content') || '') : '';
    }
    const dsn = _meta('ol-sentry-dsn');
    if (!dsn)
        return; // Sentry not configured — no-op
    const env = _meta('ol-sentry-env') || 'production';
    const release = _meta('ol-sentry-release') || undefined;
    // Feature flag: allow disabling without touching env (for debugging)
    try {
        if (OLStorage.getString('ol_sentry_disable', null) === '1')
            return;
    }
    catch (_) { /* private mode */ }
    // Load the Sentry CDN bundle. Version pinned but no SRI hash —
    // we don't have a trustworthy way to compute+verify one at build
    // time. CSP script-src already restricts to browser.sentry-cdn.com
    // which is good enough.
    //
    // S55 D1.1 (2026-04-28): switched to the tracing-enabled bundle so
    // `Sentry.browserTracingIntegration()` is available. Adds ~15KB gz to
    // the SDK payload but enables end-to-end distributed traces — the
    // backend FastApiIntegration already accepts incoming `sentry-trace`
    // and `baggage` headers; this bundle makes the frontend EMIT them.
    // External-Link Audit F4 (2026-05-18): 8.52.0 -> 8.55.2 (latest 8.x
    // per npm registry; CDN-verified 200). Same major => semver-safe,
    // no sentry.init() shape change. The 9.x/10.x major migration
    // (10.53.x latest; breaking init/tracesSampleRate changes,
    // coordinated with services/sentry_init.py) + an SRI integrity attr
    // are a deliberate scheduled follow-up — NOT bundled here: SRI on
    // the primary error-reporting CDN script has its own failure mode
    // (a Sentry CDN re-publish would silently disable ALL frontend
    // error capture), so it needs its own decision, not an auto-add.
    const SDK_URL = 'https://browser.sentry-cdn.com/8.55.2/bundle.tracing.min.js';
    const script = document.createElement('script');
    script.src = SDK_URL;
    script.crossOrigin = 'anonymous';
    script.async = true;
    script.onload = function () {
        const w = window;
        if (typeof w.Sentry === 'undefined')
            return;
        try {
            const sentry = w.Sentry;
            sentry.init({
                dsn: dsn,
                environment: env,
                release: release,
                // S55 D1.1: distributed tracing across the stack. The browser
                // SDK auto-instruments fetch/XHR and adds `sentry-trace` +
                // `baggage` headers to outgoing requests so the backend
                // FastApiIntegration can join the same trace. Restrict header
                // propagation to first-party origins via `tracePropagationTargets`
                // so we don't leak trace IDs to third-party APIs (FMP, Anthropic,
                // etc.) and don't trigger CORS preflight failures on those.
                integrations: (typeof sentry.browserTracingIntegration === 'function')
                    ? [sentry.browserTracingIntegration()]
                    : [],
                tracePropagationTargets: [
                    // First-party only. Same-origin relative paths + the canonical
                    // domain. Render preview URLs would also match `oxfordledge`.
                    /^\//,
                    /^https?:\/\/(www\.|api\.)?oxfordledge\.com/,
                ],
                // 2026-04-29: bumped 0.02 → 0.10 to match the backend
                // SENTRY_TRACES_SAMPLE_RATE bump (services/sentry_init.py).
                // OWNER upgraded to Team plan; the previous 2% was safe for
                // free-tier quota but too sparse to catch frontend p95 outliers
                // joined to backend traces via distributed tracing (D1.1).
                // Frontend rate is half the backend rate because most browser
                // transactions correspond to a single backend call — same trace,
                // sampled once on each end.
                // CHAOS P2-D (2026-10-04): a browser that answered "Under 13" on the
                // age bar sends no performance traces (olIsUnder13Browser, the
                // OL-UNDER13-GUARD block in theme-init.ts / theme-bootstrap.ts).
                // Error reports still go: COUNSEL rules on those.
                tracesSampleRate: _olUnder13() ? 0 : 0.10,
                // No replay / session recording (privacy + quota)
                replaysSessionSampleRate: 0,
                replaysOnErrorSampleRate: 0,
                // Privacy
                sendDefaultPii: false,
                // Ignore common noise
                ignoreErrors: [
                    // Browser extensions often throw these into page context
                    'ResizeObserver loop limit exceeded',
                    'ResizeObserver loop completed with undelivered notifications',
                    'Non-Error promise rejection captured',
                    // Network errors caused by user navigating away
                    'AbortError',
                    'The operation was aborted',
                    // Our own tier-gate rejections are expected, not errors
                    'tier-gated',
                ],
                // Drop events from non-app origins (ad-block scripts, user GMs, etc.)
                denyUrls: [
                    /extensions\//i,
                    /^chrome:\/\//i,
                    /^chrome-extension:\/\//i,
                    /^moz-extension:\/\//i,
                    /^safari-extension:\/\//i,
                ],
                beforeSend: function (event) {
                    try {
                        // 2026-09-24 (Sentry OXFORD-LEDGE-BROWSER-1A): drop an error none
                        // of whose stack frames comes from this site. Our CSP is
                        // `script-src 'self'` with no unsafe-inline/unsafe-eval, so every
                        // line WE run has a first-party URL; a stack made only of
                        // `<anonymous>` / eval frames is code a browser extension or an
                        // automation tool injected -- 1A was a headless tool's string
                        // predicate refused by our CSP (frames `eval`, `predicate`,
                        // `next`, all anonymous). denyUrls cannot see those: they have no
                        // URL. An event with NO frames is kept (we cannot tell whose it is).
                        const exv = (event.exception && event.exception.values) || [];
                        const frames = [];
                        exv.forEach(function (v) {
                            ((v.stacktrace && v.stacktrace.frames) || []).forEach(function (f) {
                                frames.push(f);
                            });
                        });
                        if (frames.length && !frames.some(function (f) {
                            const fn = String(f.filename || f.abs_path || '');
                            return /^\//.test(fn) || /^https?:\/\/(www\.|api\.)?oxfordledge\.com\//.test(fn);
                        })) {
                            return null;
                        }
                        // Strip query strings from request URL — might contain PII
                        // on signup / auth callback paths.
                        if (event.request && event.request.url) {
                            const u = String(event.request.url);
                            const q = u.indexOf('?');
                            if (q !== -1)
                                event.request.url = u.substring(0, q);
                        }
                        // Strip query string from breadcrumb URLs too
                        if (event.breadcrumbs && event.breadcrumbs.values) {
                            event.breadcrumbs.values.forEach(function (bc) {
                                if (bc && bc.data && typeof bc.data.url === 'string') {
                                    const bu = bc.data.url;
                                    const bq = bu.indexOf('?');
                                    if (bq !== -1)
                                        bc.data.url = bu.substring(0, bq);
                                }
                            });
                        }
                    }
                    catch (_) { /* never fail the reporter */ }
                    return event;
                },
            });
        }
        catch (e) {
            // Silent — a broken Sentry init shouldn't break the app.
            if (window.console && console.warn)
                console.warn('[sentry] init failed:', e);
        }
    };
    script.onerror = function () {
        // CDN unreachable — happens on corporate networks, ad-block lists.
        // Silent failure: no console noise, no app-breaking consequences.
    };
    // Inject early — the sooner Sentry loads, the more errors it captures.
    (document.head || document.documentElement).appendChild(script);
})();
//# sourceMappingURL=sentry-init.js.map
;
// ═══ analytics-buffer.js ═══
;"use strict";
// @ts-nocheck
// ^ MUST be line 1 or it is silently ineffective. INHERITED from app-init.ts,
// not chosen: this code was written and has always run under nocheck, and
// turning checking on for it is a separate change, not a free rider on a move.
// ──────────────────────────────────────────────────────────────────────────
// analytics-buffer.ts — the client analytics event buffer and its flushes.
//
// Mobile audit 2026-09-25 T2: cut out of app-init.ts (4627 of its 4630-line
// budget) together with the new page-hide flush, because the flush is the one
// piece of the app-init chunk that has a lifecycle of its own. WHAT LIVES
// HERE: `_eventBuffer`, `_track`, the chunked fetch flush (F4, 2026-05-12)
// with its bounded retry (FE P2, 2026-07-11), and the page-hide beacon flush.
// The session id and the device fields `_track` stamps stay in app-init.ts,
// where other code reads them too.
//
// ── LOAD-ORDER INVARIANT — read before moving this file in the bundle list ──
// This file MUST sit BEFORE app-init.js in the `app-init` chunk
// (tools/build_bundle.py). app-init.ts calls `_track()` at MODULE SCOPE (the
// campaign-landing capture and `session_start`), and `_track` pushes onto
// `_eventBuffer`, a top-level `const`: a lexical binding that is in TDZ until
// this file's line runs. Placed after app-init.js, the first module-scope
// `_track` call would throw a ReferenceError and stop app-init's boot.
// Everything this file reads from app-init.ts (`_sessionId`, `_deviceInfo`,
// `currentView`, `SERVER`, `_olDebugWarn`) is read at CALL time only, never
// at parse time, so being earlier in the chunk is safe.
// ──────────────────────────────────────────────────────────────────────────
const _eventBuffer = [];
function _track(event, payload) {
    _eventBuffer.push({ event, payload: { ...payload, ts: Date.now(), ..._deviceInfo }, sessionId: _sessionId, view: (typeof currentView !== 'undefined' ? currentView : '') });
    if (_eventBuffer.length >= 10)
        _flushEvents();
}
// F4 (2026-05-12 Code-Review-Cowork audit P0): chunked analytics flush.
// Prior implementation `_eventBuffer.splice(0)` flushed the entire
// buffer in one POST. If the buffer grew large during an offline /
// hidden-tab period, the request body exceeded reverse-proxy limits
// and silently 413'd — every event in the batch was lost, telemetry
// went blind without anyone noticing.
//
// New behaviour:
//   - Chunk into batches of ≤50 events AND ≤32KB serialized
//   - Send chunks sequentially with a 200ms gap (so a slow server
//     doesn't get hammered by a burst on first connect)
//   - On 4xx: console.warn + Sentry breadcrumb + re-queue at FRONT
//     of buffer (max 2 retries via _retry_count on the event)
//   - On network error: re-queue at front for next flush window
//   - No silent .catch(()=>{}) — every failure surfaces to ops
const _ANALYTICS_MAX_BATCH_EVENTS = 50;
const _ANALYTICS_MAX_BATCH_BYTES = 32 * 1024;
const _ANALYTICS_MAX_RETRIES = 2;
const _ANALYTICS_CHUNK_GAP_MS = 200;
let _flushInFlight = false;
// FE P2 (audit 2026-07-11): bounded self-scheduling retry flush. Re-queued
// survivors used to sit in the buffer with NO future flush scheduled —
// they waited for the next _track push to reach >=10 or beforeunload, so
// a quiet period (user reading, no events firing) stranded the batch.
// One SINGLE setTimeout (never an interval, never stacks — the guard flag
// allows at most one pending retry), armed only on a failed chunk; the
// retry cascade is naturally bounded by _ANALYTICS_MAX_RETRIES (events
// past 2 retries are dropped, so re-arming converges to an empty buffer).
const _ANALYTICS_RETRY_FLUSH_MS = 45000;
let _analyticsRetryTimer = null;
function _scheduleAnalyticsRetryFlush() {
    if (_analyticsRetryTimer)
        return; // at most one pending retry
    _analyticsRetryTimer = setTimeout(function () {
        _analyticsRetryTimer = null;
        if (_eventBuffer.length)
            _flushEvents();
    }, _ANALYTICS_RETRY_FLUSH_MS);
}
// Build chunks respecting BOTH caps (50 events OR 32KB). Shared by the
// sequential fetch flush and the page-hide beacon flush, so a beacon body
// can never exceed the caps the fetch path was sized for (a sendBeacon body
// over 64KB is refused outright).
function _chunkAnalyticsEvents(all) {
    const chunks = [];
    let current = [];
    let currentSize = 2; // `[]` empty-array baseline
    for (const ev of all) {
        const evJson = JSON.stringify(ev);
        const evSize = evJson.length + 1; // +1 for comma separator
        if (current.length >= _ANALYTICS_MAX_BATCH_EVENTS
            || (currentSize + evSize > _ANALYTICS_MAX_BATCH_BYTES && current.length > 0)) {
            chunks.push(current);
            current = [];
            currentSize = 2;
        }
        current.push(ev);
        currentSize += evSize;
    }
    if (current.length > 0)
        chunks.push(current);
    return chunks;
}
// Re-queue a failed chunk with bounded retry. Increment _retry_count on each
// event; drop events that already hit the limit.
function _requeueAnalyticsChunk(chunk) {
    const survivors = [];
    for (const ev of chunk) {
        ev._retry_count = (ev._retry_count || 0) + 1;
        if (ev._retry_count <= _ANALYTICS_MAX_RETRIES)
            survivors.push(ev);
    }
    if (survivors.length > 0) {
        _eventBuffer.unshift(...survivors);
        // FE P2: don't strand the survivors — a quiet period must not
        // hold them hostage until the 10-event threshold / unload.
        _scheduleAnalyticsRetryFlush();
    }
}
async function _flushEvents() {
    if (_flushInFlight)
        return; // re-entrancy guard
    if (!_eventBuffer.length)
        return;
    _flushInFlight = true;
    try {
        const chunks = _chunkAnalyticsEvents(_eventBuffer.splice(0));
        const _w = window;
        for (let i = 0; i < chunks.length; i++) {
            const chunk = chunks[i];
            let networkErr = null;
            let respStatus = 0;
            try {
                const resp = await fetch(SERVER + '/api/analytics/event', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ events: chunk }),
                });
                respStatus = resp.status;
            }
            catch (err) {
                networkErr = err;
            }
            const failed = networkErr !== null || (respStatus >= 400 && respStatus < 600);
            if (failed) {
                try {
                    _olDebugWarn('[analytics] flush chunk failed:', networkErr ? 'network' : ('status=' + respStatus), 'events=' + chunk.length);
                }
                catch (_e) { /* console may be unavailable */ }
                try {
                    if (_w.Sentry && typeof _w.Sentry.addBreadcrumb === 'function') {
                        _w.Sentry.addBreadcrumb({
                            category: 'analytics',
                            level: 'warning',
                            message: 'analytics.flush_failed',
                            data: {
                                batch_size: chunk.length,
                                chunk_index: i,
                                chunk_total: chunks.length,
                                status: networkErr ? 'network_error' : respStatus,
                            },
                        });
                    }
                }
                catch (_e) { /* breadcrumb is best-effort */ }
                _requeueAnalyticsChunk(chunk);
            }
            // 200ms gap between chunks (skip on last).
            if (i < chunks.length - 1) {
                await new Promise(function (r) { setTimeout(r, _ANALYTICS_CHUNK_GAP_MS); });
            }
        }
    }
    finally {
        _flushInFlight = false;
    }
}
// T2 (mobile audit 2026-09-25): the buffer used to leave the page only at
// >=10 events or on `beforeunload`, through a plain fetch. Mobile Safari
// rarely fires beforeunload, and a fetch started while a page unloads is
// cancelled with it, so a phone session's last events (often all of them: a
// short visit never reaches 10) were lost. The buffer is now drained on the
// two lifecycle events mobile browsers DO fire -- `visibilitychange` to
// hidden (tab switch, app switch, lock screen) and `pagehide` (navigation,
// back-forward cache) -- plus `beforeunload` where it still fires, through
// navigator.sendBeacon, which the browser delivers after the page is gone.
// `fetch(..., {keepalive: true})` is the fallback when sendBeacon is missing
// or refuses the body (it returns false when its queue is full); a failed
// keepalive re-queues through the same bounded retry, because a hidden tab
// is usually still alive.
//
// Same endpoint and the same chunk caps as the fetch flush. The analytics
// opt-out is unchanged and still enforced where it always was: the server
// reads it from the session cookie before writing
// (routes/routes_portfolio_fastapi/analytics_events.py `_analytics_opted_out`),
// and a same-origin beacon carries that cookie, so an opted-out user's
// beacon is dropped exactly as their fetch was. The drain is synchronous
// (splice first), so the three events firing back to back send ONE beacon:
// the later ones find an empty buffer.
function _flushEventsOnHide() {
    if (!_eventBuffer.length)
        return;
    const chunks = _chunkAnalyticsEvents(_eventBuffer.splice(0));
    const url = SERVER + '/api/analytics/event';
    for (let i = 0; i < chunks.length; i++) {
        const chunk = chunks[i];
        const body = JSON.stringify({ events: chunk });
        let queued = false;
        try {
            if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
                // A Blob tagged application/json (a bare string posts text/plain);
                // the route parses the body as JSON either way.
                const payload = (typeof Blob === 'function') ? new Blob([body], { type: 'application/json' }) : body;
                queued = navigator.sendBeacon(url, payload) === true;
            }
        }
        catch (_e) {
            queued = false;
        }
        if (queued)
            continue;
        try {
            fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: body,
                keepalive: true,
            }).then(function (resp) {
                if (resp && resp.status >= 400)
                    _requeueAnalyticsChunk(chunk);
            }, function () {
                _requeueAnalyticsChunk(chunk);
            });
        }
        catch (_e) {
            _requeueAnalyticsChunk(chunk);
        }
    }
}
// S29 re-enabled the unload flush; T2 routes it through the beacon drain.
window.addEventListener('beforeunload', _flushEventsOnHide);
window.addEventListener('pagehide', _flushEventsOnHide);
document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden')
        _flushEventsOnHide();
});
//# sourceMappingURL=analytics-buffer.js.map
;
// ═══ app-init.js ═══
;"use strict";
// @ts-nocheck
// ──────────────────────────────────────────────────────────────────────────
// app-init.ts — NH9 step 1 split half 1 of 2 (init core)
// Sliced from the original static/js/app.ts at the bottom of init() body
// (the closing `}` at original line 3275). See
// docs/plans/NH9_BUNDLE_APP_SPLIT_BOOT_AUDIT.md §"Step 1" + OWNER Q1=A.
//
// Pair file: app-renderers.ts (loaded immediately after this in the
// bundle so cross-chunk var globals declared here are visible to
// renderer function bodies via the script-tag concatenation pattern).
// ──────────────────────────────────────────────────────────────────────────
// ╔══════════════════════════════════════════════════════════════════════════╗
// ║  app.js — Oxford Ledge main application logic                          ║
// ║  ~13,500 lines | Run `python build_bundle.py` after edits              ║
// ╚══════════════════════════════════════════════════════════════════════════╝
//
// TS Migration Phase 2 PR 59 (2026-05-05): renamed .js → .ts as a
// `// @ts-nocheck` initial rename. 7175 LOC — the LAST unmigrated
// .js source file. Most of the original monolith has been extracted
// out (§CHART → chart-engine.ts, §MACRO → macro-view.ts,
// §RENDER-DATA → ticker-renderer.ts, §VIEWS → view-router.ts,
// §PEER → peer-view.ts, §FEATURES → features-extra.ts, etc.); what
// remains is cross-chunk boot wiring + global state init +
// delegated event handlers + sections that haven't found a clean
// extraction home yet.
//
// PR 59 consolidates the originally-planned 4-PR split (PRs 59-62
// per the 2026-05-05 PERSONA_FEED roadmap) into a single rename.
// Rationale: the established pattern from PRs 47/49-58 is
// single-file @ts-nocheck rename for monoliths with deep
// cross-chunk surface — splitting requires extensive refactoring
// (extracting cohesive sections without breaking inter-section
// state) which is risky and slow. Single-file rename gets app.ts
// onto the strict-TS gate roadmap; structural splits can happen
// as part of PRs 60-65 strict-typing follow-ups.
//
// Cross-chunk surface: every other .ts file in static/js/ that
// references app.js globals (setView, currentView, activeTicker,
// dataCache, tickers, PORTFOLIO_TICKERS, fetchTicker, _track,
// olFetch, registerInterval,
// clearRegisteredInterval, ...) — too many to enumerate; tighten
// in PRs 60-65 strict cleanup.
//
// The .ts is the SoT; app.js is the gitignored build artifact.
//
// TABLE OF CONTENTS (search for "§" + section name to jump)
// ─────────────────────────────────────────────────────────
//  §CORE          Core utilities, polyfills, DOM cache, intervals     ~L4
//  §THEME         CSS custom property proxy, server URL, loading bar  ~L241
//  §SKELETON      Ticker skeleton, hero animation, topbar glow        ~L319
//  §ANALYTICS     Session tracking, error recovery, device detection  ~L466
//  §WEBSOCKET     Real-time WebSocket client + pulse polling fallback ~L537
//  §FORMATTING    Number/date formatting, escaping, sanitization      ~L620
//  §TICKER-TABS   Tab management, add/remove ticker, suggestions      ~L1040
//  §VIEWS         View router (setView), view map, keyboard nav       ~L1035
//  §FETCH-TICKER  fetchTicker, _fetch_phase1/_phase2, data pipeline   ~L1714
//  §CHART         renderComboChart, indicators, chart hover, periods  ~L1937
//  §RENDER-DATA   renderData — main ticker data renderer (3000 lines) ~L2987
//  §FINANCIALS    5-year history, annual charts, financial tables      ~L2528
//  §VALUATION     DCF, EPV, Graham, sensitivity, implied growth       ~L5200
//  §KEY-METRICS   Key metrics strip, card, consensus estimates        ~L5555
//  §DEBT-CREDIT   Debt maturity, capital structure, rating events     ~L5900
//  §COMPANY       Company profile, corporate events, M&A comps        ~L6260
//  §MACRO         renderMacroView, global markets, market briefing    ~L6922
//  §PEER          Peer comparison, similar companies, insider txns    ~L7760
//  §13F           13F holdings, fund search, featured funds           ~L4446
//  §CALENDAR      Earnings calendar, macro events calendar            ~L8400
//  §ONBOARDING    Welcome flow, onboarding presets, first-time setup  ~L9150
//  §MILESTONES    Achievements/milestones view renderer               ~L10002
//  §SETTINGS      Settings panel, email toggles, skill level          ~L10700
//  §TOUR          First-time tooltip tour                             ~L11370
//  §FEATURES      Bond screener, credit batch, portfolio benchmark    ~L11469
//  §BDC           Private credit (BDC) view                           ~L12146
//  §NEWS-EXTRA    News archive, sentiment strip, prior/search/live    ~L12720
//  §DELEGATION    Central event delegation, action handlers           ~L12904
//  §MOBILE        Mobile bottom tab bar, responsive helpers           ~L13114
//  §DROPDOWN      Dropdown UX: hover intent, right-opening, shortcuts ~L13231
//
// F15 Phase 4 (2026-07-18): the legacy runtime `_OL_DEBUG` global is
// RETIRED — every consumer migrated to the DEBUG_BUILD-stripped
// _olDebug/_olDebugWarn/_olDebugError wrappers below. Dev builds:
// OL_DEBUG_BUILD=1 at bundle time (tools/build_bundle.py --define).
// F-15: build-time debug-log wrappers. esbuild's --define:DEBUG_BUILD=false
// at minify time replaces DEBUG_BUILD with the literal false; the dead
// branch is stripped along with the string arguments. CISO MANDATORY: the
// `typeof !== 'undefined'` guard keeps these silent (not throwing) if any
// build path (terser/regex fallback) ships without define propagation.
function _olDebug(...args) {
    if (typeof DEBUG_BUILD !== 'undefined' && DEBUG_BUILD) {
        // eslint-disable-next-line no-console -- sanctioned debug logger, DEBUG_BUILD-gated (stripped from the prod bundle)
        console.log(...args);
    }
}
function _olDebugWarn(...args) {
    if (typeof DEBUG_BUILD !== 'undefined' && DEBUG_BUILD) {
        console.warn(...args);
    }
}
function _olDebugError(...args) {
    if (typeof DEBUG_BUILD !== 'undefined' && DEBUG_BUILD) {
        console.error(...args);
    }
}
// ── #120 /welcome navigation tracer (2026-06-04) ──────────────────
// The /?signin=1 → /welcome bounce could not be root-caused statically: server
// returns 200 (no 302), the isFirstVisit guard correctly excludes ?signin, and
// the only go-home element is the (modal-covered) logo. This logs whatever
// actually initiates a /welcome navigation so the next repro reveals the
// trigger. console.warn + Sentry breadcrumb; safe + idempotent. Remove once the
// root cause is identified.
function _welcomeTrace(source, extra) {
    try {
        const detail = { source, url: location.href };
        if (extra) {
            for (const k in extra)
                detail[k] = extra[k];
        }
        if (typeof console !== 'undefined' && console.warn)
            console.warn('[welcome-trace]', detail);
        const _S = window.Sentry;
        if (_S && typeof _S.addBreadcrumb === 'function') {
            _S.addBreadcrumb({ category: 'nav', level: 'warning', message: 'welcome-trace:' + source, data: detail });
        }
    }
    catch (_e) { /* never block navigation */ }
}
window._welcomeTrace = _welcomeTrace;
// Capturing click tracer: log BEFORE navigation when a click resolves to a
// /welcome anchor or a go-home action (catches the anchor-driven + delegated
// paths). Capture phase so it runs before any handler that may preventDefault.
try {
    document.addEventListener('click', function (e) {
        try {
            const t = e.target;
            if (!t || !t.closest)
                return;
            const a = t.closest('a[href*="/welcome"], [data-action="go-home"]');
            if (a) {
                _welcomeTrace('click', {
                    tag: a.tagName,
                    href: a.getAttribute('href') || '',
                    action: a.getAttribute('data-action') || '',
                    cls: a.className || '',
                    stack: ((new Error().stack || '').split('\n').slice(1, 4).join(' | ')),
                });
            }
        }
        catch (_e) { /* never block */ }
    }, true);
}
catch (_e) { /* no document */ }
// ── SHARED GLOBAL STATE (accessed by multiple extracted modules) ──
// These vars declared in app.js are read/written by chart-engine.js,
// data-pipeline.js, ws-client.js, ticker-renderer.js, view-router.js:
//   activeTicker, dataCache, isLive, currentView, tickers, PORTFOLIO_TICKERS,
//   chartMode, tickerChartPeriod, chartAnnotations, chartViewport, chartPanState,
//   phasePollingTimers, indicatorsCache, headlinesCache, SERVER, THEME,
//   _isMobile, _OL_DEBUG, DEMO_DATA, _f13ShowAll
// All must remain `var` (not let/const) for cross-file visibility in
// the concatenated bundle. See S37 plan for future _state namespace migration.
// _navHistory must be initialized HERE because init() can resume
// via microtask before views.js assigns its value.
var _navHistory = [];
// No client-side free-tier caps (OWNER decision 2026-09-24, SF-MONETIZATION-V3
// "no paywall on freely retrieved data"). The browser-only caps object that
// lived here (15 watchlist tickers, 1 portfolio, 3 screener filters, 5 13F
// holders, 10 bond results) was DELETED with every check that read it: every
// tier, Learner included, is unlimited on all five. What a paid tier adds is
// only what the SERVER enforces (the screener result teaser, exports, CSV
// import, require_min_tier routes, real-time quotes, AI credits, alerts, MCP
// hourly limits). Pinned by tests/test_client_tier_rank_caps_contract.py.
// §XHR-WORKER — Non-blocking XHR via Web Worker ══════════════════════════════
// Sync XHR blocks the main thread; async XHR/fetch callbacks don't fire
// reliably on Chrome→Render. Solution: sync XHR runs in a Web Worker,
// keeping the main thread responsive. Falls back to sync XHR on main
// thread if Workers aren't available.
var _xhrWorker = null;
var _xhrPending = {};
var _xhrIdCounter = 0;
var _WORKER_CODE = 'self.onmessage=function(e){try{var x=new XMLHttpRequest();x.open("GET",e.data.url,false);x.send();self.postMessage({id:e.data.id,status:x.status,body:x.responseText})}catch(r){self.postMessage({id:e.data.id,status:0,error:r.message||"Network error"})}}';
function _setupWorkerHandlers(w) {
    w.onmessage = function (e) {
        var cb = _xhrPending[e.data.id];
        if (cb) {
            delete _xhrPending[e.data.id];
            cb(e.data);
        }
    };
    w.onerror = function () {
        var keys = Object.keys(_xhrPending);
        for (var i = 0; i < keys.length; i++) {
            _xhrPending[keys[i]]({ status: 0, error: 'Worker error' });
        }
        _xhrPending = {};
        _xhrWorker = null;
    };
}
function _ensureXhrWorker() {
    if (_xhrWorker)
        return _xhrWorker;
    // Strategy 1: Blob Worker (inline code, no file to fetch, most reliable)
    try {
        var blob = new Blob([_WORKER_CODE], { type: 'application/javascript' });
        _xhrWorker = new Worker(URL.createObjectURL(blob));
        _setupWorkerHandlers(_xhrWorker);
        return _xhrWorker;
    }
    catch (e) { /* Blob Worker blocked by CSP or unsupported */ }
    // Strategy 2: File Worker (separate file)
    try {
        _xhrWorker = new Worker('/static/js/xhr-worker.js');
        _setupWorkerHandlers(_xhrWorker);
        return _xhrWorker;
    }
    catch (e) { /* File Worker also failed */ }
    return null;
}
function _asyncXhrFallback(url, timeoutMs, resolve) {
    // Last resort: async XHR on main thread. If callback never fires,
    // timeout resolves it. NEVER blocks the main thread.
    var done = false;
    var xhr = new XMLHttpRequest();
    var timer = setTimeout(function () {
        if (done)
            return;
        done = true;
        xhr.abort();
        resolve({ status: 0, error: 'timeout' });
    }, timeoutMs);
    xhr.onload = function () {
        if (done)
            return;
        done = true;
        clearTimeout(timer);
        resolve({ status: xhr.status, body: xhr.responseText });
    };
    xhr.onerror = function () {
        if (done)
            return;
        done = true;
        clearTimeout(timer);
        resolve({ status: 0, error: 'network error' });
    };
    try {
        xhr.open('GET', url);
        xhr.send();
    }
    catch (e) {
        if (!done) {
            done = true;
            clearTimeout(timer);
            resolve({ status: 0, error: e.message });
        }
    }
}
function workerXHR(url, timeoutMs) {
    timeoutMs = timeoutMs || 15000;
    return new Promise(function (resolve) {
        // Use async XHR with timeout fallback. Web Worker sync XHR was
        // attempted but Render's CSP blocks Blob Workers, causing the
        // entire connection check to fail → demo mode. Async XHR with
        // explicit timeout is more reliable in production.
        _asyncXhrFallback(url, timeoutMs, resolve);
    });
}
// §LAZY-CHUNKS — On-demand module loading ═════════════════════════════════════
// Cross-chunk type registered for view-router.ts + other consumers:
// `Record<string, { _olSettled?: boolean } | undefined>`. Annotation
// kept here even under @ts-nocheck so consumers in strict-typed
// files don't pick up the inferred-empty-`{}` shape.
var _chunksLoaded = {};
// `core` removed 2026-04-16: bundle-core.min.js does not exist (core JS was
// merged into bundle-app.min.js long ago); the stale entry was a latent
// 404 waiting for a typo caller. Bundler doesn't regenerate this dict —
// refresh values manually if a chunk's minified hash changes.
var _CHUNK_HASHES = { charts: '4005decb', research: '7d0b0442', education: 'df71c9d8', premium: '9dde2fc6' };
// C2 (refactor/content-hashed-bundles): the asset manifest lets _loadChunk
// resolve a logical chunk name (e.g. "research") to its content-hashed
// physical filename ("bundle-research.<hash8>.min.js"). The manifest is
// injected by ssr_renderer.asset_manifest_meta_tag() into the <head> of
// dashboard.html. Cached on first read.
var _OL_ASSET_MANIFEST = null;
function _olAssetManifest() {
    if (_OL_ASSET_MANIFEST !== null)
        return _OL_ASSET_MANIFEST;
    try {
        var meta = document.querySelector('meta[name="ol-asset-manifest"]');
        if (meta) {
            var content = meta.getAttribute('content');
            if (content) {
                _OL_ASSET_MANIFEST = JSON.parse(content);
                return _OL_ASSET_MANIFEST;
            }
        }
    }
    catch (e) { }
    _OL_ASSET_MANIFEST = {};
    return _OL_ASSET_MANIFEST;
}
function _olAssetUrl(logicalName) {
    var manifest = _olAssetManifest();
    var physical = manifest[logicalName] || logicalName;
    if (logicalName.indexOf('.css') !== -1)
        return '/static/css/' + physical;
    return '/static/js/' + physical;
}
// F-20 Phase 5.4 / LH-1b (2026-06-15): inject the LEARN-only CSS chunk
// (bundle-learn-async) AFTER first paint so it stops inflating the SPA
// shell's render-blocking CSS (heavy-shell FCP was 3.0-3.7s on cold-anon
// /?view=ticker|news vs ~1.4s on the light shell — the extra blocking CSS
// is the gap). CSP-safe: a JS-created <link> is not an inline handler, so
// it survives the strict script-src/style-src directives (the
// onload="this.rel='stylesheet'" swap trick does NOT — it's inline
// script). Idempotent (skips if already present) + best-effort. The chunk
// styles /learn views only, never above-the-fold on a cold-anon LCP page,
// so deferring it is FOUC-free on the tested surfaces; the only cost is a
// brief unstyled flash on a session's FIRST /learn navigation. Pairs with
// the CSS_CHUNKS["learn-async"] split in tools/build_bundle.py.
// LH-1c Phase 1 (2026-06-15): inject the Google Fonts stylesheet as a CSP-safe
// JS <link> so it does NOT render-block FCP. dashboard.html now ships only a
// <link rel=preload as=style> for this href (warm, non-blocking fetch); this
// turns it into a live stylesheet. Runs IMMEDIATELY at app-init eval (defer =
// post-DOM-parse, ~first paint) rather than idle-deferred like the view CSS —
// fonts should apply ASAP to minimize the FOUT on Geist-targeted UI chrome
// (nav/buttons/tickers/mono numbers). Body copy is Georgia (system) so FCP/LCP
// are unaffected either way. Idempotent; best-effort (falls back to the system
// sans stack via --font-ui). NEVER onload="this.rel='stylesheet'" (CSP-blocked).
var _OL_WEBFONT_HREF = 'https://fonts.googleapis.com/css2?family=Geist:wght@400;500;600&family=Geist+Mono:wght@400;500&display=swap';
function _injectWebFont() {
    try {
        if (document.querySelector('link[data-ol-webfont="geist"]'))
            return;
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = _OL_WEBFONT_HREF;
        link.setAttribute('data-ol-webfont', 'geist');
        document.head.appendChild(link);
    }
    catch (_e) { /* non-fatal — UI chrome falls back to the system sans stack */ }
}
_injectWebFont();
// F-20 Phase 5.4 / LH-1b: the deferred CSS chunks. learn-async = the 17 LEARN
// CSS files; product-async = the 6 non-cold-anon-LCP product surfaces
// (portfolio / 13f / calendar / markets / achievements / watchlist). Both are
// split out of the render-blocking `dashboard` chunk and injected here after
// first paint. bundle-product-async.min.css is referenced as a literal so its
// contract (test_product_css_async_chunk_contract.py) can grep for it; same
// for bundle-learn-async.min.css (test_learn_css_async_chunk_contract.py).
// LH-1c Phase 2 (2026-06-16): dashboard-async = the non-cold-anon-above-the-
// fold residue split out of the render-blocking `dashboard` chunk
// (dynamic-components.css — practice-games / context-menu / daily-goals).
// bundle-dashboard-async.min.css is referenced as a literal so its contract
// (test_dashboard_async_chunk_contract.py) can grep for it.
var _OL_DEFERRED_CSS_CHUNKS = [
    { key: 'learn-async', asset: 'bundle-learn-async.min.css' },
    { key: 'product-async', asset: 'bundle-product-async.min.css' },
    { key: 'dashboard-async', asset: 'bundle-dashboard-async.min.css' },
];
function _loadDeferredViewCss() {
    for (var i = 0; i < _OL_DEFERRED_CSS_CHUNKS.length; i++) {
        try {
            var chunk = _OL_DEFERRED_CSS_CHUNKS[i];
            var href = _olAssetUrl(chunk.asset);
            if (!href)
                continue;
            if (document.querySelector('link[data-ol-deferred-css="' + chunk.key + '"]'))
                continue;
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = href;
            link.setAttribute('data-ol-deferred-css', chunk.key);
            document.head.appendChild(link);
        }
        catch (_e) { /* non-fatal — the view falls back to unstyled, SPA still works */ }
    }
}
// Schedule post-first-paint. app-init runs at `defer` (after DOM parse),
// and requestIdleCallback pushes the inject to an idle frame AFTER paint;
// the setTimeout fallback covers the browser long-tail without rIC.
(function _scheduleDeferredViewCss() {
    try {
        var _w = window;
        if (typeof _w.requestIdleCallback === 'function') {
            _w.requestIdleCallback(function () { _loadDeferredViewCss(); }, { timeout: 3000 });
        }
        else {
            setTimeout(function () { _loadDeferredViewCss(); }, 300);
        }
    }
    catch (_e) {
        setTimeout(function () { try {
            _loadDeferredViewCss();
        }
        catch (_e2) { /* noop */ } }, 300);
    }
})();
// #63: guarded recovery from a stale-deploy chunk 404. When a content-hashed
// chunk fails to load, the dominant cause is DEPLOY SKEW — this long-lived
// document holds an OLD asset-manifest meta-tag pointing at hashes the new
// deploy has pruned (the file 404s). Retrying the SAME url can't fix it (the
// existing backoff at _scheduleChunkRetry just re-404s and exhausts to a
// toast); only a fresh document + manifest can. So trigger ONE hard reload to
// pick up the new manifest, guarded against any reload loop:
//   - sessionStorage flag is the cross-reload guard. It stores a TIMESTAMP and
//     the check is time-windowed: a reload LOOP re-fires within seconds, so a
//     second failure inside _STALE_RELOAD_COOLDOWN_MS means the failure is NOT
//     deploy-skew (broken build / persistent network) → fall through to the
//     normal reject path. A failure LONGER ago than the cooldown is a genuinely
//     new deploy and gets its own recovery.
//     (2026-07-25) The original check was presence-only — it wrote Date.now()
//     and never read it back, so the flag was permanent for the tab. That made
//     the FIRST stale-deploy recovery the only one a session ever got: Oxford
//     Ledge is a dashboard people leave open all day, and prod ships several
//     times a day, so a second deploy left every not-yet-loaded lazy chunk
//     404ing with no reload and no toast — the feature just silently never
//     rendered, which is precisely the intermittent "#63 chunk-load flakiness"
//     signature. Reading the timestamp keeps the loop-safety the presence check
//     bought (a loop is seconds apart, far inside the window) while restoring
//     recovery for long sessions.
//   - if sessionStorage is unavailable (private mode) we CANNOT guarantee the
//     guard survives the reload, so we do NOT reload (a loop is worse than a
//     missing lazy feature).
//   - skip when offline (reloading would just fail) and use an in-memory flag
//     so a burst of chunk errors in one page can't double-fire.
var _olChunkReloadTriggered = false;
// A reload loop re-fires as fast as the document can boot and re-request the
// chunk (seconds). A second genuine deploy is minutes-to-hours away. 10 minutes
// sits far above the former and far below the latter, so it separates them
// without needing to distinguish the failure modes any other way.
var _STALE_RELOAD_COOLDOWN_MS = 10 * 60 * 1000;
// 'stale' (the shell's manifest hashes differ from the served manifest -> a
// reload picks up the new deploy), 'fresh' (identical -> the failure was the
// network, and a reload would only interrupt the reader), 'unknown' (manifest
// unreadable). Hoisted 2026-09-26 from the boot chunk-retry block so the lazy
// chunk/module loaders ask the same question (external review P2).
function _olConfirmShellStale() {
    try {
        if (typeof fetch !== 'function')
            return Promise.resolve('unknown');
        var embedded = _olAssetManifest();
        return fetch('/static/asset_manifest.json?_cb=' + Date.now(), { cache: 'no-store' })
            .then(function (r) { return (r && r.ok) ? r.json() : null; })
            .then(function (fresh) {
            if (!fresh || !embedded)
                return 'unknown';
            var keys = ['bundle-charts.min.js', 'bundle-research.min.js'];
            for (var i = 0; i < keys.length; i++) {
                var k = keys[i];
                if (fresh[k] && embedded[k] && fresh[k] !== embedded[k])
                    return 'stale';
            }
            return (embedded[keys[0]] || embedded[keys[1]]) ? 'fresh' : 'unknown';
        })
            .catch(function () { return 'unknown'; });
    }
    catch (_e) {
        return Promise.resolve('unknown');
    }
}
function _maybeReloadForStaleChunk(name) {
    if (_olChunkReloadTriggered)
        return false;
    try {
        if (typeof navigator !== 'undefined' && navigator.onLine === false)
            return false;
        var ss = null;
        try {
            ss = window.sessionStorage;
        }
        catch (_e) {
            ss = null;
        }
        if (!ss)
            return false; // no persistent guard => can't prove loop-safety => don't reload
        var KEY = 'ol_chunk_stale_reload';
        var _prev = ss.getItem(KEY);
        if (_prev) {
            var _age = Date.now() - Number(_prev);
            // NaN (corrupt/legacy non-numeric value) => treat as "just reloaded" and
            // bail; an unparseable guard must never be read as permission to reload.
            if (!(_age >= 0) || _age < _STALE_RELOAD_COOLDOWN_MS)
                return false;
        }
        _olChunkReloadTriggered = true;
        // A failed chunk is only worth a reload when the SHELL is old; a 'fresh'
        // verdict means a network blip, and reloading would interrupt the reader.
        _olConfirmShellStale().then(function (verdict) {
            if (verdict === 'fresh') {
                _olChunkReloadTriggered = false;
                return;
            }
            ss.setItem(KEY, String(Date.now()));
            var _w = window;
            try {
                if (_w.Sentry && typeof _w.Sentry.captureMessage === 'function') {
                    _w.Sentry.captureMessage('chunk.stale_reload', { level: 'warning', tags: { chunk: name, shell: verdict } });
                }
            }
            catch (_e) { /* defensive */ }
            try {
                if (typeof showToast === 'function')
                    showToast('Loading the latest version…', 'info', 2000);
            }
            catch (_e) { }
            setTimeout(function () { try {
                location.reload();
            }
            catch (_e) { } }, 600);
        });
        return true;
    }
    catch (_e) {
        return false;
    }
}
function _loadChunk(name) {
    if (_chunksLoaded[name])
        return _chunksLoaded[name];
    // First try the asset manifest (post-C2). If the manifest is empty
    // (manifest meta-tag missing or build failed), fall back to legacy
    // /static/js/bundle-<name>.min.js?v=<_CHUNK_HASHES[name]>.
    var logical = 'bundle-' + name + '.min.js';
    var manifest = _olAssetManifest();
    var src;
    if (manifest[logical]) {
        src = '/static/js/' + manifest[logical];
    }
    else {
        var hash = _CHUNK_HASHES[name] || '';
        src = '/static/js/' + logical + (hash ? '?v=' + hash : '');
    }
    var p = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = src;
        s.async = true; // parse off main thread
        s.onload = function () {
            // S42 task #12: mark the promise as settled so _ensureViewModule can
            // short-circuit the recursive setView re-trigger loop.
            p._olSettled = true;
            // S43: Register all modules in this chunk as loaded so _loadModule
            // won't re-inject them standalone (const redeclaration SyntaxError).
            var mods = _CHUNK_MODULES[name] || [];
            var resolved = Promise.resolve();
            for (var i = 0; i < mods.length; i++) {
                if (!_moduleLoaded[mods[i]])
                    _moduleLoaded[mods[i]] = resolved;
            }
            // #199 (2026-07-28): re-run the deferred chunk init (hover wiring) after
            // EVERY successful chunk load — this is what lets init()'s boot gate
            // demand only the boot view's own chunks; a later view switch that
            // loads core-views/research wires its hover here instead.
            try {
                var _dci = window._olDeferredChunkInit;
                if (typeof _dci === 'function') {
                    _dci();
                }
            }
            catch (_e) { /* defensive */ }
            resolve();
        };
        s.onerror = function () { delete _chunksLoaded[name]; _maybeReloadForStaleChunk(name); reject(new Error('chunk: ' + name)); };
        document.head.appendChild(s);
    });
    _chunksLoaded[name] = p;
    return p;
}
// S43: When a chunk loads, mark all its modules in _moduleLoaded so that
// _loadModule('modals') won't re-inject modals.js standalone (which would
// cause const redeclaration SyntaxErrors). Maps chunk name → module names.
var _CHUNK_MODULES = {
    'core-views': ['modals', 'views', 'news'],
    'core-portfolio': ['portfolio', 'watchlist', 'responsive-tables'],
    'core-enhance': ['settings-panel', 'settings-deletion', 'morning-brief', 'quality-alerts', 'notifications'], // wave-4: adaptive-ui removed — owned by the +5s standalone injector (OXFORD-LEDGE-BROWSER-11)
    'core-utils': ['tier-gate', 'sentry-init', 'feature-discovery', 'share-card', 'premium-gate', 'smart-insights', 'ticker-modules', 'ticker-suggestions', 'metric-insights', 'time-aware', 'data-freshness', 'cluster-badge', 'cluster-fire-banner', 'feature-of-the-day', 'tab-reorder', 'pull-refresh', 'context-menu', 'system-messages', 'loading-states', 'data-cache', 'funnel-analytics', 'share-links', 'aria-labels', 'age-gate', 'tooltip-tour', 'cat-mascot', 'creator-mode'],
    'charts': ['charts', 'chart-accessibility', 'valuation-trends', 'yield-curve', 'sector-heatmap', 'vwap-overlay', 'ext-hours-tabs', 'index-decomposition', 'chart-overlays', 'custom-charts', 'chart-drawing'],
    // 2026-06-27 (macro perf): macro-view split out of 'research' into its own
    // lazy 'macro' chunk (JS_CHUNKS['macro'] in build_bundle.py). ?view=macro
    // loads 'macro' instead of the 216KB 'research' chunk (_VIEW_CHUNK_MAP in
    // view-router.ts). Behavior-identical — all cross-view renderMacroView
    // callers are typeof-guarded.
    // 2026-08-05 (#24): all THREE modules of JS_CHUNKS['macro'] are listed, not
    // just macro-view. This list is what _loadChunk marks as already-loaded on
    // chunk load, so a name missing here is re-injected standalone by
    // _loadModule — the const-redeclaration SyntaxError the S43 comment above
    // warns about. macro-briefing-skeleton and macro-yield-curve were split out
    // of macro-view.js on 2026-08-04 and never added, while build_bundle.py:695
    // asserted the two lists "mirror" each other. That became reachable the
    // moment /?view=news started loading macro-yield-curve on demand.
    'macro': ['macro-briefing-skeleton', 'macro-view', 'macro-yield-curve'],
    'research': ['fundamentals', 'credit-framing', 'credit-view', 'screener-options', 'compare-modal', 'comp-builder', 'estimate-revisions', 'ma-comps', 'management-score', 'community-trending', 'value-score', 'share-enhanced', 'etf-view', 'etf-compare', 'calendar-view', 'peer-view', 'debt-panels', 'company-panels', 'valuation-calcs', 'credit-peers'],
    // 2026-06-11 (#36): glossary moved to its own data-only chunk (260KB gz
    // alone — blew the per-chunk budget inside education).
    'glossary-data': ['glossary'],
    'education': ['glossary-tooltip-component', 'learning-paths', 'practice-games', 'reading-list', 'investment-lore', 'defunct-companies', 'achievements', 'daily-goals', 'flashcard-mode', 'certifications', 'practicum-view'],
    // #262 D1b (2026-07-27): 'ask-ai-research' is the Path-B research half cut
    // out of ask-ai.ts. Listed here so a premium-chunk load also marks it
    // loaded and _loadModule('ask-ai-research') will not re-inject it standalone.
    // T7 (2026-09-13): 'ask-ai-context' + 'ask-ai-affordances' are two more
    // ask-ai.ts halves in the same chunk -- listed for the same reason.
    // 2026-09-28: 'ask-ai-provenance' (the per-answer provenance renderer) and
    // 'ask-ai-debate' (the debate leg builders) too.
    // SF_ASK_AI_FACT_LEDGER wave 3: the fact-ledger renderer, a lazy chunk of its
    // own (loaded by the bridge in ask-ai-provenance.ts; mirrors JS_CHUNKS).
    'ask-ai-facts': ['ask-ai-facts'],
    'premium': ['api-keys', 'ask-ai', 'ask-ai-research', 'ask-ai-context', 'ask-ai-affordances', 'ask-ai-provenance', 'ask-ai-debate', 'bdc-soi-panel', 'bdc-view', 'bond-screener', 'options-analytics', 'options-advanced', 'options-pulse', 'liquidity-dashboard', 'features-extra'],
};
// Multi-page routing: each view loads its own module via <script> tag.
// No chunk loading needed — individual modules are small enough.
var _VIEW_CHUNKS = {};
// On-demand individual module loader (avoids loading full chunks which freeze the page)
// Per-module content hashes for cache busting. The earlier hand-rolled map
// shipped placeholder hashes (a1b2c3d4 etc.) that were never replaced by the
// build, so cache-busting was effectively disabled for these modules.
// _MODULE_BUILD_TS below acts as the global fallback (rebumped each build).
// macro-dashboard.js was deleted in S43 — do not list it here.
var _MODULE_HASHES = {};
// Global build timestamp fallback for modules without a specific hash
var _MODULE_BUILD_TS = '20260410';
var _moduleLoaded = {};
function _loadModule(name) {
    if (_moduleLoaded[name])
        return _moduleLoaded[name];
    var base = '/static/js/' + name + (name.indexOf('.js') === -1 ? '.js' : '');
    var hash = _MODULE_HASHES[name] || _MODULE_BUILD_TS;
    var src = base + '?v=' + hash;
    _moduleLoaded[name] = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = src;
        s.async = true;
        s.onload = function () { resolve(); };
        s.onerror = function () { delete _moduleLoaded[name]; _maybeReloadForStaleChunk(name); reject(new Error('module: ' + name)); };
        document.head.appendChild(s);
    });
    return _moduleLoaded[name];
}
// §CORE ═══════════════════════════════════════════════════════════════════════
// ── AbortSignal.timeout polyfill for older Safari (B-32) ──
if (typeof AbortSignal !== 'undefined' && !AbortSignal.timeout) {
    AbortSignal.timeout = function (ms) {
        var c = new AbortController();
        setTimeout(function () { c.abort(new DOMException('TimeoutError', 'TimeoutError')); }, ms);
        return c.signal;
    };
}
// ── DOM Element Cache (Map-based with periodic cleanup) ──
var _domCache = new Map();
var _domCacheCleanupCount = 0;
function $id(id) {
    var el = _domCache.get(id);
    if (el && document.contains(el))
        return el;
    el = document.getElementById(id);
    if (el)
        _domCache.set(id, el);
    else
        _domCache.delete(id);
    // Periodic cleanup every 100 misses
    if (++_domCacheCleanupCount > 100) {
        _domCacheCleanupCount = 0;
        _domCache.forEach(function (v, k) { if (!document.contains(v))
            _domCache.delete(k); });
    }
    return el;
}
// ── Animation cleanup observer ──
var _animCleanupObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
        m.removedNodes.forEach(function (node) {
            if (node.nodeType === 1 && node._animRafId) {
                cancelAnimationFrame(node._animRafId);
                node._animRafId = null;
            }
        });
    });
});
if (document.body) {
    _animCleanupObserver.observe(document.body, { childList: true, subtree: true });
}
else {
    document.addEventListener('DOMContentLoaded', function () {
        if (document.body)
            _animCleanupObserver.observe(document.body, { childList: true, subtree: true });
    });
}
// ── Interval registry ──
var _intervalRegistry = {};
var _intervalId = 0;
function registerInterval(name, fn, ms, persistent) {
    // Clear any existing interval with this name
    if (_intervalRegistry[name]) {
        clearInterval(_intervalRegistry[name].id || _intervalRegistry[name]);
    }
    var id = setInterval(fn, ms);
    _intervalRegistry[name] = { id: id, persistent: !!persistent };
    return id;
}
function clearRegisteredInterval(name) {
    if (_intervalRegistry[name]) {
        clearInterval(_intervalRegistry[name].id || _intervalRegistry[name]);
        delete _intervalRegistry[name];
    }
}
function clearAllIntervals() {
    Object.keys(_intervalRegistry).forEach(function (name) {
        var entry = _intervalRegistry[name];
        if (entry && entry.persistent)
            return; // Skip persistent intervals
        clearInterval(entry.id || entry);
        delete _intervalRegistry[name];
    });
}
// ── View-scoped fetch abort ──
var _viewAbortController = null;
function getViewSignal() {
    return _viewAbortController ? _viewAbortController.signal : undefined;
}
// Combine the view-scoped abort signal with a timeout so a view switch
// (abortViewFetches) cancels an in-flight fetch AND the timeout still fires.
// Collapses to timeout-only when there's no active view controller or when
// AbortSignal.any is unavailable. Used by view data fetches to prevent
// stale-paint after a view switch (P1-2, 2026-07-01 network-storm audit;
// origin form: fundamentals.ts:147).
function getViewAwareSignal(timeoutMs) {
    var _vs = getViewSignal();
    var _AS = AbortSignal;
    if (_vs && typeof _AS.any === 'function') {
        return _AS.any([_vs, AbortSignal.timeout(timeoutMs)]);
    }
    return AbortSignal.timeout(timeoutMs);
}
function abortViewFetches() {
    if (_viewAbortController) {
        _viewAbortController.abort();
    }
    _viewAbortController = new AbortController();
}
// ── C3: Batch DOM updates in requestAnimationFrame ──
var _domUpdateQueue = [];
var _domUpdateScheduled = false;
function batchDOMUpdate(fn) {
    _domUpdateQueue.push(fn);
    if (!_domUpdateScheduled) {
        _domUpdateScheduled = true;
        requestAnimationFrame(function () {
            _domUpdateScheduled = false;
            var queue = _domUpdateQueue.slice();
            _domUpdateQueue.length = 0;
            for (var i = 0; i < queue.length; i++) {
                try {
                    queue[i]();
                }
                catch (e) { /* @__PURE__ */
                    _olDebugError('[batchDOMUpdate]', e);
                }
            }
        });
    }
}
// ── C5: Web Vitals + PerformanceObserver tracking ──
window.__PERF_METRICS = { LCP: null, FID: null, CLS: 0, TTFB: null, INP: null, FCP: null, FP: null, CLS_SOURCES: {} };
(function () {
    // TTFB from Navigation Timing
    if (window.performance && performance.getEntriesByType) {
        var nav = performance.getEntriesByType('navigation');
        if (nav.length) {
            window.__PERF_METRICS.TTFB = Math.round(nav[0].responseStart - nav[0].requestStart);
        }
    }
    // LCP
    if (typeof PerformanceObserver !== 'undefined') {
        try {
            new PerformanceObserver(function (list) {
                var entries = list.getEntries();
                if (entries.length) {
                    window.__PERF_METRICS.LCP = Math.round(entries[entries.length - 1].startTime);
                }
            }).observe({ type: 'largest-contentful-paint', buffered: true });
        }
        catch (e) { /* LCP not supported */ }
        // FCP / FP (#327, 2026-07-28). The C5 block observed LCP, CLS, FID and
        // INP but never the `paint` entry type, so Cloudflare RUM reported FCP
        // as 0ms — we were blind to the ONE metric the LH-2 work is bounded by.
        // The 2026-07-28 measurement put FCP at ~3.7s on both red pages with
        // TBT only ~16-18ms, i.e. the cost is render-blocking bytes, not JS; the
        // #298 defer split targets exactly that, and without this observer there
        // is no real-user way to tell whether it moved. Local Lighthouse is
        // noisy (loaded-too-slowly warnings) and PSI is quota-capped, so RUM is
        // the durable signal. `buffered: true` matters more here than for the
        // other observers: paint entries fire very early, usually before this
        // script evaluates, so an unbuffered observer would report nothing.
        try {
            new PerformanceObserver(function (list) {
                var pEntries = list.getEntries();
                for (var pi = 0; pi < pEntries.length; pi++) {
                    var pe = pEntries[pi];
                    if (pe.name === 'first-contentful-paint') {
                        window.__PERF_METRICS.FCP = Math.round(pe.startTime);
                    }
                    else if (pe.name === 'first-paint') {
                        window.__PERF_METRICS.FP = Math.round(pe.startTime);
                    }
                }
            }).observe({ type: 'paint', buffered: true });
            // FCP/FP stay null when the document never became visible — Chrome does
            // not record paint timing for a page that loads in a background tab.
            // That is a real slice of sessions (open-in-new-tab, prerender), so the
            // consumer must treat null as "not measurable here" and EXCLUDE it from
            // aggregates. Coercing it to 0 is how this metric read 0ms to begin with.
        }
        catch (e) { /* paint timing not supported (Safari < 14.1) */ }
        // CLS — value AND per-node attribution (LH-1c #11, 2026-06-18).
        // The lighthouse `layout-shifts` root-cause diagnostic crashes under
        // simulate-throttling in CI (trace_engine ScreenshotsHandler
        // `frame_sequence` bug), so CI gives the CLS metric but never tells us
        // WHICH element drives /?view=news CLS 0.225. This RUM observer records
        // the shifting node(s) (entry.sources[].node) so the web_vitals beacon
        // below can report the top shifters from real devices — the truer
        // signal, and the only attribution currently available.
        try {
            var _clsNodeLabel = function (node) {
                try {
                    var el = (node && node.nodeType === 1) ? node
                        : (node && node.parentElement) ? node.parentElement : null;
                    if (!el || !el.tagName)
                        return '(unknown)';
                    var s = el.tagName.toLowerCase();
                    if (el.id)
                        return s + '#' + el.id;
                    var cn = (el.className && typeof el.className === 'string')
                        ? el.className.trim().split(/\s+/).slice(0, 3).join('.') : '';
                    return cn ? s + '.' + cn : s;
                }
                catch (_e) {
                    return '(unknown)';
                }
            };
            new PerformanceObserver(function (list) {
                list.getEntries().forEach(function (entry) {
                    if (entry.hadRecentInput)
                        return;
                    window.__PERF_METRICS.CLS += entry.value;
                    var srcs = entry.sources || [];
                    var agg = window.__PERF_METRICS.CLS_SOURCES;
                    for (var i = 0; i < srcs.length; i++) {
                        var lbl = _clsNodeLabel(srcs[i] && srcs[i].node);
                        agg[lbl] = (agg[lbl] || 0) + entry.value;
                    }
                });
                window.__PERF_METRICS.CLS = Math.round(window.__PERF_METRICS.CLS * 1000) / 1000;
            }).observe({ type: 'layout-shift', buffered: true });
        }
        catch (e) { /* CLS not supported */ }
        // FID (First Input Delay)
        try {
            new PerformanceObserver(function (list) {
                var entries = list.getEntries();
                if (entries.length) {
                    window.__PERF_METRICS.FID = Math.round(entries[0].processingStart - entries[0].startTime);
                }
            }).observe({ type: 'first-input', buffered: true });
        }
        catch (e) { /* FID not supported */ }
        // INP (Interaction to Next Paint) — longest interaction
        try {
            new PerformanceObserver(function (list) {
                list.getEntries().forEach(function (entry) {
                    var duration = entry.duration;
                    if (!window.__PERF_METRICS.INP || duration > window.__PERF_METRICS.INP) {
                        window.__PERF_METRICS.INP = Math.round(duration);
                    }
                });
            }).observe({ type: 'event', buffered: true, durationThreshold: 16 });
        }
        catch (e) { /* INP not supported */ }
    }
    // Initialize AdaptiveUI progressive disclosure system
    if (typeof AdaptiveUI !== 'undefined')
        AdaptiveUI.init();
    // Report metrics after load settles
    window.addEventListener('load', function () {
        setTimeout(function () {
            var m = window.__PERF_METRICS;
            var inProd = location.hostname !== 'localhost' && location.hostname !== '127.0.0.1';
            /* @__PURE__ */ _olDebug('[WebVitals] FCP=' + m.FCP + 'ms LCP=' + m.LCP + 'ms FID=' + m.FID + 'ms CLS=' + m.CLS + ' TTFB=' + m.TTFB + 'ms INP=' + m.INP + 'ms');
            if (inProd && m.LCP !== null) {
                // Send to /api/metrics endpoint (fire-and-forget)
                try {
                    // Top shift contributors (LH-1c #11) — rank the nodes by
                    // accumulated shift so the server log names the CLS culprit
                    // per view. url now includes the query string so /?view=news
                    // CLS is distinguishable from other SPA views (was pathname
                    // only = always '/').
                    var _src = window.__PERF_METRICS.CLS_SOURCES || {};
                    var _topShifters = Object.keys(_src).map(function (k) {
                        return { sel: k, v: Math.round(_src[k] * 1000) / 1000 };
                    }).sort(function (a, b) { return b.v - a.v; }).slice(0, 6);
                    navigator.sendBeacon('/api/metrics', JSON.stringify({
                        type: 'web_vitals', lcp: m.LCP, fid: m.FID, cls: m.CLS, ttfb: m.TTFB, inp: m.INP,
                        fcp: m.FCP, fp: m.FP,
                        cls_sources: _topShifters,
                        url: (location.pathname + location.search).slice(0, 100),
                        ua: navigator.userAgent.slice(0, 100),
                    }));
                }
                catch (e) { /* beacon not supported */ }
                // Same numbers, second destination, different question.
                // /api/metrics above is ANONYMOUS by design and writes to an
                // in-memory ring, so it can say what LCP is but never WHOSE.
                // That gap is why a 24h p75 of 11,056ms could not be read:
                // the sample is dominated by traffic that may not be users at
                // all (2026-08-21 — US Mac:Windows was 12:1, with Windows and
                // Android green). _track() posts to /api/analytics/event,
                // which the SERVER stamps, so the one dimension that settles
                // it — was anyone signed in? — becomes queryable.
                //
                // NOTE: `authed` is deliberately NOT sent from here. The
                // server injects it from the session, the same way it already
                // refuses to let a beacon supply its own cf_country. A
                // client-declared authed flag would be both spoofable and,
                // for a bot pretending to be a reader, exactly the field it
                // would lie about.
                try {
                    if (typeof _track === 'function') {
                        _track('web_vitals', {
                            lcp: m.LCP, cls: m.CLS, ttfb: m.TTFB,
                            inp: m.INP, fcp: m.FCP,
                        });
                    }
                }
                catch (e) { /* telemetry must never break the page */ }
            }
        }, 5000);
    });
})();
// _PULSE_TIPS loaded at end of script with rotation logic
// ── E4: Event delegation system ──
// Central click handler for data-action attributes. Handlers registered at
// bottom of file in _delegatedActions object. New handlers go there.
// Legacy registerAction() kept for backward compatibility.
var _actionHandlers = {};
function registerAction(name, handler) {
    _actionHandlers[name] = handler;
}
// ── Lazy-Load Panels (IntersectionObserver) ──
// Panels below the fold only fetch data when scrolled into view.
// Reduces initial page load from 12+ requests to 3-4.
var _lazyObserver = null;
var _lazyCallbacks = new Map(); // elementId → { callback, fired }
var _lazyTicker = null; // ticker these lazy callbacks are for
// CR-M4 (2026-05-04): rootMargin 200px -> 100px (200px was ~30% of a mobile
// viewport — requests fired for panels bounce users never reached).
var _LAZY_ROOT_MARGIN_PX = 100;
// 2026-09-28 (peers stuck loading): IO delivers NOTHING in a hidden tab, so while
// document.hidden a 1s poll applies registration's above-fold test (zero-size =
// view hidden, skip); it stops once visible (IO resumes) or nothing is pending.
var _lazyPollTimer = null;
function _lazyPollTick() {
    var pending = 0;
    if (document.hidden)
        _lazyCallbacks.forEach(function (reg, id) {
            if (reg.fired)
                return;
            var el = document.getElementById(id);
            var r = el ? el.getBoundingClientRect() : null;
            if (!r || !(r.width || r.height) || r.top >= window.innerHeight + _LAZY_ROOT_MARGIN_PX) {
                pending++;
                return;
            }
            reg.fired = true;
            if (_lazyObserver)
                _lazyObserver.unobserve(el);
            try {
                reg.callback();
            }
            catch (e) {
                _olDebugWarn('[lazy] ' + id + ':', e);
            }
        });
    if (!pending && _lazyPollTimer) {
        clearInterval(_lazyPollTimer);
        _lazyPollTimer = null;
    }
}
function _initLazyObserver() {
    if (_lazyObserver)
        return;
    if (typeof IntersectionObserver === 'undefined')
        return;
    _lazyObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting)
                return;
            var id = entry.target.id;
            var reg = _lazyCallbacks.get(id);
            if (reg && !reg.fired) {
                reg.fired = true;
                try {
                    reg.callback();
                }
                catch (e) {
                    _olDebugWarn('[lazy] ' + id + ':', e);
                }
                _lazyObserver.unobserve(entry.target);
            }
        });
    }, { rootMargin: _LAZY_ROOT_MARGIN_PX + 'px 0px' });
}
// Phase 3: Priority → delay (ms) that staggers non-critical panel fetches
// so the network waterfall doesn't stampede when a user lands on ticker
// view. Critical panels fire immediately, lower-priority panels tack on
// a scheduled delay so tabs appearing together don't race their fetches.
// Measured per-panel-visible; inline rAF keeps the first paint responsive.
var _LAZY_PRIORITY_DELAY_MS = { critical: 0, high: 120, medium: 360, low: 720 };
function _lazyPanel(elementId, ticker, callback, opts) {
    opts = opts || {};
    var priority = opts.priority || 'medium';
    var delayMs = _LAZY_PRIORITY_DELAY_MS[priority];
    if (typeof delayMs !== 'number')
        delayMs = _LAZY_PRIORITY_DELAY_MS.medium;
    function _fireWithPriority() {
        if (delayMs <= 0) {
            try {
                callback();
            }
            catch (e) {
                _olDebugWarn('[lazy]', e);
            }
            return;
        }
        setTimeout(function () { try {
            callback();
        }
        catch (e) {
            _olDebugWarn('[lazy]', e);
        } }, delayMs);
    }
    _initLazyObserver();
    if (!_lazyObserver) {
        _fireWithPriority();
        return;
    } // fallback: no observer support
    var el = document.getElementById(elementId);
    if (!el) {
        _fireWithPriority();
        return;
    } // panel not in DOM, fire immediately
    // If panel is already visible (above fold), fire immediately.
    // CR-M4: matches the IntersectionObserver rootMargin so the two
    // visibility checks share the same 100px buffer.
    var rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight + _LAZY_ROOT_MARGIN_PX) {
        _fireWithPriority();
        return;
    }
    // Register for lazy observation; the observer wraps callback in the
    // same priority-delay so below-the-fold panels also get staggered.
    var prev = _lazyCallbacks.get(elementId);
    if (prev) {
        _lazyObserver.unobserve(el);
    }
    _lazyCallbacks.set(elementId, {
        callback: _fireWithPriority,
        fired: false,
        ticker: ticker,
        priority: priority,
    });
    _lazyObserver.observe(el);
    if (document.hidden && !_lazyPollTimer)
        _lazyPollTimer = setInterval(_lazyPollTick, 1000);
}
function _clearLazyPanels() {
    if (_lazyPollTimer) {
        clearInterval(_lazyPollTimer);
        _lazyPollTimer = null;
    }
    if (_lazyObserver) {
        // Disconnect fully so accumulated observations from rapid ticker switches
        // do not leak — unobserve per-element is insufficient when the observer
        // itself holds references to detached nodes.
        _lazyObserver.disconnect();
        _lazyObserver = null;
    }
    _lazyCallbacks.clear();
}
// ── E5: WCAG label injection for inputs without labels ──
// Runs once after DOM is ready, adds aria-label to inputs missing labels.
document.addEventListener('DOMContentLoaded', function () {
    var labelMap = {
        'ticker-input': 'Enter stock ticker symbol',
        'f13-ticker-input': 'Enter ticker for 13F lookup',
        'f13-fund-input': 'Search fund name',
        'headline-search-input': 'Search archived headlines',
        'news-unified-search': 'Search equities, BDC borrowers, bonds, headlines',
        'credit-issuer-search': 'Search bond issuer name',
        'credit-cusip-input': 'Enter CUSIP',
        'credit-label-input': 'Bond label',
        'cb-batch-input': 'Enter tickers separated by commas',
        'scr-pe-min': 'Minimum P/E ratio',
        'scr-pe-max': 'Maximum P/E ratio',
        'scr-ev-min': 'Minimum EV/EBITDA',
        'scr-ev-max': 'Maximum EV/EBITDA',
        'scr-mc-min': 'Minimum market cap',
        'scr-mc-max': 'Maximum market cap',
        'ann-body': 'Add a note',
        'ind-compare-a': 'Select first indicator to compare',
        'ind-compare-b': 'Select second indicator to compare',
    };
    for (var id in labelMap) {
        var el = document.getElementById(id);
        if (el && !el.getAttribute('aria-label') && !document.querySelector('label[for="' + id + '"]')) {
            el.setAttribute('aria-label', labelMap[id]);
        }
    }
    // Add role="search" to search inputs
    ['ticker-input', 'news-unified-search', 'headline-search-input', 'f13-ticker-input', 'f13-fund-input', 'credit-issuer-search'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el && el.parentElement) {
            el.parentElement.setAttribute('role', 'search');
        }
    });
});
// §THEME ═══════════════════════════════════════════════════════════════════════
// ── HOVER GLOSSARY SYSTEM ──
// Glossary system extracted to /static/js/glossary.js
// ── THEME (reads live CSS custom properties for canvas drawing) ──
// `var` (not const) so analytics.ts can `declare var _cssVal` for
// ambient-merge — TS rejects const-vs-const cross-file redeclaration.
var _cssVal = (p, fb) => { const v = getComputedStyle(document.documentElement).getPropertyValue(p).trim(); return v || fb; };
const THEME = new Proxy({ _m: {
        bg: ['--bg-base', '#09090f'], panel: ['--bg-surface', '#10101a'], panel2: ['--bg-elevated', '#14141f'],
        border: ['--border-subtle', '#1c1c2e'], border2: ['--border-default', '#252538'],
        text: ['--text-primary', '#d8d8f0'], muted: ['--text-muted', '#8888aa'], dim: ['--text-secondary', '#7a7a96'],
        accent: ['--accent-blue', 'var(--accent-blue)'], accentDim: ['--accent-blue-muted', '#3a6fa0'],
        gold: ['--amber', 'var(--amber)'], green: ['--chart-gain', '#c9a961'], red: ['--chart-loss', 'var(--chart-loss)'], blue: ['--chart-primary', 'var(--chart-primary)'],
        greenAlpha: [null, 'rgba(201,169,97,0.10)'], redAlpha: [null, 'rgba(200,116,102,0.10)'],
        accentAlpha: [null, 'rgba(91,163,217,0.25)'], gridLine: ['--chart-grid', 'rgba(255,255,255,0.08)'],
        volNormal: ['--chart-vol-normal', 'rgba(91,163,217,0.25)'], volUnusual: ['--chart-vol-unusual', 'rgba(201,168,76,0.70)'],
        avgVolLine: [null, 'rgba(91,163,217,0.30)'], crosshair: [null, 'rgba(91,163,217,0.40)'],
        priceDot: ['--chart-gain', '#c9a961'], chartLabel: ['--text-muted', '#8888a8'], chartSub: ['--text-secondary', '#707090'],
        parLine: [null, 'rgba(255,255,255,0.15)'], parText: [null, 'rgba(255,255,255,0.20)'],
        chartAxis: ['--chart-axis', 'rgba(255,255,255,0.3)'],
        chartPrimary: ['--chart-primary', 'var(--chart-primary)'], chartSecondary: ['--chart-secondary', '#4a7fa8'],
        chartTertiary: ['--chart-tertiary', 'var(--gold-brand)'], chartQuaternary: ['--chart-quaternary', 'var(--chart-loss)'],
        chartQuinary: ['--chart-quinary', 'var(--chart-quinary)'], chartSenary: ['--chart-senary', 'var(--chart-senary)'],
        chartNeutral: ['--chart-neutral', 'var(--chart-neutral)'],
        compareA: ['--chart-compare-a', 'var(--chart-primary)'], compareB: ['--chart-compare-b', 'var(--gold-brand)'],
        sma20: ['--chart-sma20', 'var(--chart-senary)'], sma50: ['--chart-sma50', 'var(--chart-primary)'], sma200: ['--chart-sma200', 'var(--chart-quinary)'],
        rsiLine: ['--chart-rsi', 'var(--chart-quinary)'],
        sparkStroke: ['--spark-stroke', '#5ba3d9'],
        bollinger: ['--chart-bollinger', 'rgba(143,163,184,0.55)'],
        bollingerFill: ['--chart-bollinger-fill', 'rgba(143,163,184,0.06)'],
    } }, { get(t, p) { if (p === '_m')
        return t._m; const e = t._m[p]; if (!e)
        return undefined; return e[0] ? _cssVal(e[0], e[1]) : e[1]; } });
// THEME proxy reads live CSS vars; canvas drawing stays in sync with theme
// S42 task #12 root cause: the old conditional routed 127.0.0.1/localhost
// traffic to http://localhost:8765 (a different port AND a different
// hostname from "127.0.0.1" — browsers treat them as separate origins for
// CORS). Every fetch became cross-origin, triggered a CORS preflight,
// the preflight hit a dead port (8765 is no longer used — the ASGI server
// now defaults to 8080), the preflight failed, and various retry loops in
// fetch code re-fired them at ~450 req/sec. That's the "macro view hang"
// we chased since yesterday — it wasn't in macro-view.js at all; it was
// every fetch initiated from any view when opened via 127.0.0.1.
// Empty string = relative URLs = same-origin. Works in prod AND any dev
// port the user binds to.
const SERVER = '';
// ── GLOBAL LOADING BAR / SKELETON / INDICATORS ──
// MOVED #125 (2026-08-14) -> static/js/chrome-indicators.ts. _showLoading,
// _hideLoading, _showLoadingIndeterminate, _showTickerSkeleton,
// _hideTickerSkeleton, _animateNumber, _flashElement, _setTopbarLive,
// _setPulseRefreshing, _updatePhaseIndicator, _setBtnLoading. Same
// `app-init` chunk, so they remain ambient here via cross-file hoisting;
// see that file's header for why the ordering is not load-bearing.
// ── GLOBAL FETCH INTERCEPTOR ──
// Wrap native fetch to auto-show/hide loading bar + telemetry (C2a)
var _fetchMetrics = []; // buffered [{endpoint, ms, status, error}]
var _fetchMetricsFlushTimer = null;
(function () {
    var _origFetch = window.fetch;
    var _SKIP = ['/api/metrics', '/api/analytics/', '/static/'];
    // ── ONE global 429 backoff gate (WP-B, 2026-09-26 external review) ──
    // Every limiter (bot_protection, rate_limit, burst_limit) answers 429 with
    // an honest Retry-After. Before this gate each panel retried on its own and
    // the retries spent the same per-IP window again. Now the first 429 on a
    // gateable request opens a window (Retry-After, default 10s, cap 60s);
    // until it closes, gateable /api/ GETs get a synthetic 429 of the same
    // shape WITHOUT touching the network (same idea as tier-gate.ts's
    // synthetic 402). Never gated: writes (non-GET), /api/auth/* (session
    // identity must always resolve) and the two telemetry beacons.
    var _BACKOFF_NEVER = ['/api/auth/', '/api/analytics/event', '/api/billing/funnel-event'];
    function _backoffGateable(endpoint, method) {
        if (endpoint.indexOf('/api/') !== 0)
            return false;
        if (method !== 'GET' && method !== 'HEAD')
            return false;
        return !_BACKOFF_NEVER.some(function (p) { return endpoint.indexOf(p) === 0; });
    }
    function _backoffIsGlobal(response) {
        try {
            return response.headers.get('X-OL-Backoff') === 'global';
        }
        catch (_e) {
            return false;
        }
    }
    function _backoffSeconds(response) {
        var n = NaN;
        try {
            n = parseInt(response.headers.get('Retry-After') || '', 10);
        }
        catch (_e) { }
        if (!isFinite(n) || n < 1)
            n = 10;
        return Math.min(n, 60);
    }
    function _backoffResponse(secs) {
        var r = new Response(JSON.stringify({ error: 'rate_limited', retry_after: secs }), {
            status: 429, statusText: 'Too Many Requests',
            headers: { 'content-type': 'application/json', 'Retry-After': String(secs) },
        });
        try {
            r._olBackoffGate = true;
        }
        catch (_e) { }
        return r;
    }
    function _backoffOpen(response) {
        var now = Date.now();
        var until = now + _backoffSeconds(response) * 1000;
        var wasOpen = now < (window.__olApiBackoffUntil || 0);
        if (until > (window.__olApiBackoffUntil || 0))
            window.__olApiBackoffUntil = until;
        // ONE notice per backoff window -- a 429 that extends an open window is silent.
        if (!wasOpen && typeof showToast === 'function') {
            try {
                if (typeof _olBackoffToast === 'function')
                    _olBackoffToast(response);
                else
                    showToast('Oxford Ledge is busy — loading the rest in a few seconds.', 'info', 4000);
            }
            catch (_e) { }
        }
    }
    window.fetch = function (input) {
        var init = arguments[1];
        var method = String((init && init.method) || (input && typeof input !== 'string' && input.method) || 'GET').toUpperCase();
        var url = typeof input === 'string' ? input : (input && input.url ? input.url : '');
        var endpoint = '';
        try {
            endpoint = new URL(url, location.origin).pathname;
        }
        catch (e) {
            endpoint = url.split('?')[0];
        }
        var gateable = _backoffGateable(endpoint, method);
        var _left = (window.__olApiBackoffUntil || 0) - Date.now();
        if (gateable && _left > 0)
            return Promise.resolve(_backoffResponse(Math.ceil(_left / 1000)));
        _showLoading();
        var skip = _SKIP.some(function (p) { return endpoint.indexOf(p) === 0; });
        var t0 = performance.now();
        return _origFetch.apply(this, arguments)
            .then(function (response) {
            _hideLoading();
            // CHAOS 2026-09-26: open the APP-WIDE window only for a 429 from a
            // cross-path limiter (the server marks it `X-OL-Backoff: global`,
            // rate_limit_exemptions.py). A path-scoped 429 -- the heavy-endpoint
            // 5/min on /api/screener, the /api/pdf bucket, a route's own quota --
            // stays that endpoint's answer and must not blank every other panel.
            if (gateable && response && response.status === 429 && _backoffIsGlobal(response))
                _backoffOpen(response);
            if (!skip && endpoint.indexOf('/api/') === 0) {
                // S55 D1.3 (2026-04-28): capture X-Request-ID so the
                // backend log line and frontend telemetry can be joined on
                // the same request. Header always present (stamped by
                // middleware/request_id.py); empty string fallback if
                // CORS-stripped or missing for any reason.
                var reqId = '';
                try {
                    reqId = response.headers.get('X-Request-ID') || '';
                }
                catch (_e) { }
                _fetchMetrics.push({ e: endpoint, ms: Math.round(performance.now() - t0), s: response.status, rid: reqId });
                // Also tag the current Sentry scope so any subsequent
                // frontend error during this fetch's response handling
                // carries the same request_id as the backend log.
                if (reqId && window.Sentry && typeof window.Sentry.setTag === 'function') {
                    try {
                        window.Sentry.setTag('request_id', reqId);
                    }
                    catch (_e) { }
                }
            }
            return response;
        })
            .catch(function (err) {
            _hideLoading();
            if (!skip && endpoint.indexOf('/api/') === 0) {
                var isTimeout = err && (err.name === 'TimeoutError' || err.name === 'AbortError');
                _fetchMetrics.push({ e: endpoint, ms: Math.round(performance.now() - t0), s: 0, err: isTimeout ? 'timeout' : 'network' });
            }
            throw err;
        });
    };
    // Flush fetch metrics every 60s (production only)
    function _flushFetchMetrics() {
        if (!_fetchMetrics.length)
            return;
        var inProd = location.hostname !== 'localhost' && location.hostname !== '127.0.0.1';
        if (!inProd) {
            _fetchMetrics.length = 0;
            return;
        }
        var batch = _fetchMetrics.splice(0, 100);
        try {
            navigator.sendBeacon('/api/metrics', JSON.stringify({ type: 'fetch_metrics', items: batch }));
        }
        catch (e) { }
    }
    // A.9 fix: use centralized timer registry (persistent = survives view changes)
    registerInterval('metricsFlush', _flushFetchMetrics, 60000, true);
    window.addEventListener('beforeunload', _flushFetchMetrics);
    // Also send a navigation timing beacon on first load (supplements web_vitals)
    window.addEventListener('load', function () {
        setTimeout(function () {
            var inProd = location.hostname !== 'localhost' && location.hostname !== '127.0.0.1';
            if (!inProd)
                return;
            try {
                var nav = performance.getEntriesByType('navigation');
                if (nav.length) {
                    var n = nav[0];
                    navigator.sendBeacon('/api/metrics', JSON.stringify({
                        type: 'nav_timing',
                        dns: Math.round(n.domainLookupEnd - n.domainLookupStart),
                        tcp: Math.round(n.connectEnd - n.connectStart),
                        ttfb: Math.round(n.responseStart - n.requestStart),
                        download: Math.round(n.responseEnd - n.responseStart),
                        domReady: Math.round(n.domContentLoadedEventEnd - n.startTime),
                        load: Math.round(n.loadEventEnd - n.startTime),
                        transferSize: n.transferSize || 0,
                    }));
                }
            }
            catch (e) { }
        }, 6000);
    });
})();
// §ANALYTICS ═══════════════════════════════════════════════════════════════════
// ── ANALYTICS ──
const _sessionId = (typeof crypto !== 'undefined' && crypto.randomUUID) ? crypto.randomUUID() : Date.now().toString();
window._olSessionId = _sessionId; // #110: published for the funnel/lookthrough beacons; see funnel-analytics.ts:_beacon
// _eventBuffer, _track and the flushes live in analytics-buffer.ts (mobile audit 2026-09-25 T2).
const _isTablet = /iPad|Android(?!.*Mobile)/i.test(navigator.userAgent) || (navigator.maxTouchPoints > 1 && window.innerWidth >= 768);
const _isMobile = !_isTablet && /iPhone|iPod|Android.*Mobile|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
const _isDesktop = !_isMobile && !_isTablet;
const _screenWidth = window.screen?.width || window.innerWidth;
const _deviceType = _isMobile ? 'mobile' : _isTablet ? 'tablet' : 'desktop';
const _deviceInfo = { device: _deviceType, mobile: _isMobile, tablet: _isTablet, width: _screenWidth, touch: 'ontouchstart' in window, dpr: window.devicePixelRatio || 1 };
// E3.3 (2026-07-16 email audit F4.2): one-shot campaign-landing capture.
// The email digest's deep links carry utm_* tags, and Cloudflare is blind
// to email referrals (view_analytics_inhouse_admin_decision) — this beacon
// is the only thing that makes "does the digest retain anyone?" answerable
// in /admin view-analytics. Fires once per page load, only when utm_source
// is present; campaign tags only, never personal data.
(function _captureCampaignLanding() {
    try {
        const q = new URLSearchParams(window.location.search);
        const src = q.get('utm_source');
        if (!src)
            return;
        _track('campaign_landing', {
            source: src.slice(0, 40),
            medium: (q.get('utm_medium') || '').slice(0, 40),
            campaign: (q.get('utm_campaign') || '').slice(0, 60),
            landing: q.get('view') || (q.get('ticker') ? 'ticker' : 'home'),
        });
    }
    catch (_e) { /* never blocks boot */ }
})();
// #90 (BOARD CYCLE P0 #1, docs/plans/INTENT_WELCOME_ROUTER.md): intent-welcome
// router, flag-gated DARK — a no-op unless the server injected the
// ol-intent-welcome meta (OL_INTENT_WELCOME env, default OFF; OWNER flips only
// after ratifying the scoping doc's S3 matrix). Routes a COLD anon arrival on
// the bare / to the first view most likely to show value, from signals already
// in hand: no new fetch, and the decision lands via history.replaceState at
// module scope — BEFORE the view router reads location — so nothing repaints
// after content shows. Explicit navigation (any view/ticker/cmd param, or a
// non-root path) and authed sessions (ol_csrf_hmac cookie; ol_session is
// HttpOnly-invisible) are never overridden. The no-signal intent CHIP is
// scoping-doc open decision #2 and is deliberately NOT built until ratified —
// this ships the referrer branches only (the saved-intent read is
// forward-compat for the chip's localStorage key).
(function _intentWelcomeRouter() {
    try {
        if (!document.querySelector('meta[name="ol-intent-welcome"]'))
            return;
        if (window.location.pathname !== '/')
            return;
        const q = new URLSearchParams(window.location.search);
        if (q.get('view') || q.get('ticker') || q.get('cmd'))
            return;
        if (document.cookie.indexOf('ol_csrf_hmac=') !== -1)
            return;
        const ref = document.referrer || '';
        let target = '';
        let signal = '';
        let saved = '';
        try {
            saved = OLStorage.getString('ol_intent', null) || '';
        }
        catch (_e) { /* wrapper unavailable */ }
        if (/(perplexity|openai|chatgpt|claude|anthropic|gemini|copilot)\./i.test(ref)) {
            // Came from an AI engine's citation — overwhelmingly the credit/BDC
            // data surfaces (ai_crawl_referral_pattern: /bdcs 40x /stock).
            target = 'credit';
            signal = 'ai_referrer';
        }
        else if (/oxfordledge\.com\/(learn|glossary|concepts)/i.test(ref)) {
            target = 'learn';
            signal = 'own_learn_referrer';
        }
        else if (saved === 'learn' || saved === 'data') {
            target = saved === 'learn' ? 'learn' : '';
            signal = 'saved_intent';
        }
        if (typeof _track === 'function') {
            _track('welcome_intent_detected', { signal: signal || 'none', target: target || 'observatory' });
        }
        if (!target) {
            // OWNER-ratified 2026-07-19 (scoping doc S3.4; open decision #2 = BUILD):
            // no-signal cold arrivals get the additive 2-choice intent chip — asks
            // instead of guessing. A prior pick (saved) or dismiss-forever
            // suppresses it; position:fixed overlay = zero CLS; never blocks boot.
            let dismissed = '';
            try {
                dismissed = OLStorage.getString('ol_intent_chip_dismissed', null) || '';
            }
            catch (_e) { /* wrapper unavailable */ }
            if (saved || dismissed)
                return;
            const _renderChip = function () {
                try {
                    if (document.getElementById('ol-intent-chip'))
                        return;
                    const box = document.createElement('div');
                    box.id = 'ol-intent-chip';
                    box.className = 'ol-intent-chip';
                    box.setAttribute('role', 'dialog');
                    box.setAttribute('aria-label', 'What brings you here?');
                    const q = document.createElement('div');
                    q.className = 'ol-intent-chip-q';
                    q.textContent = 'What brings you here?';
                    const mk = function (label, intent) {
                        const b = document.createElement('button');
                        b.type = 'button';
                        b.className = 'ol-intent-chip-choice';
                        b.textContent = label;
                        b.addEventListener('click', function () {
                            try {
                                OLStorage.setString('ol_intent', intent);
                            }
                            catch (_e) { /* private mode */ }
                            if (typeof _track === 'function')
                                _track('welcome_intent_picked', { intent: intent });
                            if (box.parentNode)
                                box.parentNode.removeChild(box);
                            if (intent === 'learn') {
                                try {
                                    const w = window;
                                    if (typeof w.setView === 'function') {
                                        w.setView('learn');
                                        return;
                                    }
                                }
                                catch (_e) { /* fall through to reload */ }
                                window.location.href = '/?view=learn';
                            }
                            // 'data': the observatory IS the live-data view — just dismiss.
                        });
                        return b;
                    };
                    const x = document.createElement('button');
                    x.type = 'button';
                    x.className = 'ol-intent-chip-close';
                    x.setAttribute('aria-label', 'Dismiss');
                    x.textContent = '×';
                    x.addEventListener('click', function () {
                        try {
                            OLStorage.setString('ol_intent_chip_dismissed', '1');
                        }
                        catch (_e) { /* private mode */ }
                        if (typeof _track === 'function')
                            _track('welcome_intent_dismissed', {});
                        if (box.parentNode)
                            box.parentNode.removeChild(box);
                    });
                    box.appendChild(x);
                    box.appendChild(q);
                    box.appendChild(mk("I'm here to learn", 'learn'));
                    box.appendChild(mk("I'm here for live data", 'data'));
                    document.body.appendChild(box);
                }
                catch (_e) { /* additive only — never blocks boot */ }
            };
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', function () { setTimeout(_renderChip, 1200); });
            }
            else {
                setTimeout(_renderChip, 1200);
            }
            return;
        }
        q.set('view', target);
        history.replaceState(null, '', window.location.pathname + '?' + q.toString());
        if (typeof _track === 'function')
            _track('welcome_intent_routed', { signal: signal, target: target });
    }
    catch (_e) { /* never blocks boot — observatory default */ }
})();
// Session start event — fires once per page load
var _activeSessions = 1;
try {
    _activeSessions = parseInt(OLStorage.getString('_olSessions', null) || '0', 10) + 1;
    OLStorage.setString('_olSessions', String(_activeSessions));
}
catch (e) { }
_track('session_start', { referrer: document.referrer.slice(0, 200), url: location.pathname, concurrent: _activeSessions });
// ── Feature Duration Tracking (S38 Phase 22) ──
var _viewEnteredAt = Date.now();
var _currentTrackedView = '';
var _viewPausedAt = 0;
var _viewPausedTotal = 0;
// Single visibilitychange handler — both view-duration pause/resume AND
// tier-state refresh-on-focus. Audit NH4 (2026-05-07): collapsed two
// adjacent listeners that triggered the same browser event into one
// handler; the throttle on the tier-refresh path acts as in-flight dedup
// (60s gate is well above /api/auth/me round-trip latency).
var _lastTierRefreshMs = 0;
document.addEventListener('visibilitychange', function () {
    // (a) pause/resume view-duration tracking
    if (document.hidden) {
        _viewPausedAt = Date.now();
    }
    else if (_viewPausedAt) {
        _viewPausedTotal += (Date.now() - _viewPausedAt);
        _viewPausedAt = 0;
    }
    // (b) refresh tier state on tab becoming visible (Phase 1: catches
    // trial expiry / upgrade that happened while tab was backgrounded).
    // Throttled to once per 60s. authCheckSession() hydrates
    // window._userTier and dispatches ol-tier-changed on delta.
    if (document.visibilityState !== 'visible')
        return;
    var now = Date.now();
    if (now - _lastTierRefreshMs < 60000)
        return;
    // NL8 (2026-05-07): shared in-flight Promise dedup. The 60s
    // throttle above is the primary guard; this is belt-and-suspenders
    // for the rare case where a previous authCheckSession() is still
    // pending (slow /api/auth/me round-trip on mobile / cold-start
    // worker). Without this guard, fast tab-flipping during the
    // window can fire a second authCheckSession before the first
    // resolves, doubling the roundtrip.
    if (_authRefreshInFlight)
        return;
    _lastTierRefreshMs = now;
    if (typeof authCheckSession === 'function') {
        try {
            var _r = authCheckSession();
            if (_r && typeof _r.then === 'function') {
                _authRefreshInFlight = true;
                _r.then(function () { _authRefreshInFlight = false; })
                    .catch(function () { _authRefreshInFlight = false; });
            }
        }
        catch (_) { /* sync throw — no in-flight to track */ }
    }
});
// NL8: shared in-flight flag for the visibility-driven tier refresh.
var _authRefreshInFlight = false;
// ── Provider quota degraded banner (FMP free-tier mitigation) ──
// 2026-04-26: surfaces a one-line dismissible banner at top of page
// when /api/health/providers reports any provider in degraded or
// exhausted state. Replaces the silent failure mode where ticker
// pages quietly showed "Metrics temporarily unavailable" / "No
// earnings data" / dashed-everything with no explanation.
//
// Dismissal: stored as ol_provider_banner_dismissed_<YYYY-MM-DD>
// localStorage key — re-shows next day so the user knows the state
// resolved AND knows if it persists into a new day (= chronic, not
// transient).
function _renderProviderBanner(payload) {
    // Always set the global flag so empty-state renderers in
    // ticker-renderer.js / peer-view.js can show honest copy regardless
    // of whether the banner itself was dismissed for the day.
    try {
        window._olProviderDegraded = !!(payload && payload.any_degraded);
        window._olProviderExhausted = !!(payload && payload.any_exhausted);
    }
    catch (_e) { }
    if (!payload || !payload.any_degraded)
        return;
    // Per-day dismissal
    try {
        var today = new Date().toISOString().slice(0, 10);
        if (OLStorage.getString('ol_provider_banner_dismissed_' + today, null) === '1')
            return;
    }
    catch (_e) { }
    if (document.getElementById('ol-provider-banner'))
        return; // already rendered
    var fmp = (payload.providers || {}).fmp || {};
    var msg, sevClass;
    var severity;
    if (fmp.status === 'exhausted') {
        severity = 'exhausted';
        sevClass = 'ol-provider-banner-exhausted';
        msg = 'Live data temporarily limited — daily provider quota reached (' + (fmp.calls_today || 0) + '/' + (fmp.daily_limit || 10000) + '). Cached values shown until 00:00 UTC.';
    }
    else if (fmp.status === 'degraded') {
        severity = 'degraded';
        sevClass = 'ol-provider-banner-degraded';
        msg = 'Approaching daily provider quota (' + (fmp.calls_today || 0) + '/' + (fmp.daily_limit || 10000) + '). Some live values may show as cached.';
    }
    else {
        return;
    }
    // 2026-04-30 DESIGN audit P0 telemetry. The banner has lived without
    // any visibility into its impression / dismiss rate since 2026-04-26;
    // any further design iteration on the banner (suppress on lesson
    // views, add upgrade-path CTA, lighter pre-exhausted treatment, etc.)
    // should be data-informed rather than guessed. Severity is recorded
    // on a data-attr so the dismiss handler can read it back.
    try {
        if (typeof _track === 'function') {
            _track('provider_banner_shown', {
                severity: severity,
                calls_today: fmp.calls_today || 0,
                daily_limit: fmp.daily_limit || 250
            });
        }
    }
    catch (_e) { }
    var bar = document.createElement('div');
    bar.id = 'ol-provider-banner';
    bar.className = 'ol-provider-banner ' + sevClass;
    bar.setAttribute('role', 'status');
    bar.setAttribute('aria-live', 'polite');
    bar.setAttribute('data-severity', severity);
    bar.innerHTML =
        '<span class="ol-provider-banner-msg">' + msg + '</span>' +
            '<button class="ol-provider-banner-close" data-action="dismiss-provider-banner" aria-label="Dismiss">&times;</button>';
    // 2026-04-28 follow-up to the 2026-04-26 P0 hotfix: place the banner
    // BELOW the sticky pulse-bar (`#market-pulse-bar`) instead of above
    // it. Above-pulse-bar caused two visual defects: (a) the banner
    // pushed the pulse-bar down out of its sticky slot during scroll,
    // (b) when the banner scrolled away, the pulse-bar's
    // `top: var(--topbar-height)` left a visible gap above it.
    // Below-pulse-bar lets the pulse-bar stick correctly to the topbar
    // and the banner scrolls away cleanly with no gap.
    var pulseBar = document.getElementById('market-pulse-bar');
    if (pulseBar && pulseBar.parentNode) {
        pulseBar.parentNode.insertBefore(bar, pulseBar.nextSibling);
    }
    else {
        // Fallback chain for SPA views without the pulse-bar (or pre-init).
        var topstrip = document.getElementById('ol-topstrip-b');
        if (topstrip && topstrip.parentNode) {
            topstrip.parentNode.insertBefore(bar, topstrip.nextSibling);
        }
        else if (document.body) {
            document.body.insertBefore(bar, document.body.firstChild);
        }
    }
    // #1b DESIGN consolidation (2026-06-02): this quota banner is the
    // AUTHORITATIVE provider-degraded disclosure. If the generic
    // #stale-data-banner already painted its provider-degraded variant in an
    // earlier ticker render (cold-load race — the health probe resolves AFTER
    // the first render), retract it now so the two don't stack. Its data-age
    // variant (staleCause='age') is a DIFFERENT signal — leave that one alone.
    try {
        var _sdb = document.getElementById('stale-data-banner');
        if (_sdb && _sdb.dataset && _sdb.dataset.staleCause === 'provider') {
            _sdb.classList.add('d-none');
            _sdb.classList.remove('stale-visible');
        }
    }
    catch (_e) { }
}
document.addEventListener('DOMContentLoaded', function () {
    // One-shot on page load. The 60s server-side cache means cost is
    // capped at ~1 call per visitor per page-load.
    setTimeout(function () {
        try {
            fetch('/api/health/providers', { signal: AbortSignal.timeout(5000) })
                .then(function (r) { return r.ok ? r.json() : null; })
                .then(function (d) { if (d)
                _renderProviderBanner(d); })
                .catch(function () { });
        }
        catch (_e) { }
    }, 1500); // Defer 1.5s so init/auth/render get the network first.
});
// Emit final duration on page unload
window.addEventListener('beforeunload', function () {
    if (_currentTrackedView && _viewEnteredAt) {
        var _dur = Math.round((Date.now() - _viewEnteredAt - _viewPausedTotal) / 1000);
        if (_dur > 1 && _dur < 7200)
            _track('view_duration', { view: _currentTrackedView, seconds: _dur });
    }
    try {
        var c = parseInt(OLStorage.getString('_olSessions', null) || '1', 10);
        OLStorage.setString('_olSessions', String(Math.max(0, c - 1)));
    }
    catch (e) { }
});
// ── Panel engagement tracking — REMOVED #53 (2026-08-12) ──
// A document-level click listener emitted `panel_open` for [data-panel],
// .accordion-header, .collapsible-toggle, [data-action="expand"]. It had
// NEVER FIRED: no element in the app carries any of those (the only dynamic
// collapsible is `fun-collapsible`, not in the list). Dead emit -> mislabelled
// rollup -> no DOM target. Reviving it needs a bounded `data-panel` convention
// AND a reader on analytics_events.payload (analytics_hourly has no payload
// column). Full reasoning: tests/test_view_tracking_coverage_contract.py.
// ── Option β PR5 (2026-05-13 CYCLE Q6-ratified follow-on, PROFESSOR §3):
// Dana scaffolding tile dismissal. Reads the `ol_ticker_orient_dismissed`
// localStorage flag on boot — if set, adds `body.ticker-orient-dismissed`
// so the tile (rendered SSR in dashboard.html) is suppressed via CSS.
// Click handler on the × button writes the flag + adds the class.
try {
    if (typeof OLStorage !== 'undefined' && OLStorage.getString('ol_ticker_orient_dismissed', null) === '1') {
        document.body.classList.add('ticker-orient-dismissed');
    }
}
catch (_e) { /* OLStorage may not be ready; tile defaults to visible */ }
document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action="dismiss-ticker-orientation"]');
    if (!btn)
        return;
    e.preventDefault();
    document.body.classList.add('ticker-orient-dismissed');
    try {
        if (typeof OLStorage !== 'undefined')
            OLStorage.setString('ol_ticker_orient_dismissed', '1');
    }
    catch (_e) { /* persist best-effort */ }
});
// ── Option β PR3 (2026-05-13 CYCLE-ratified): "Take the guided
// walkthrough" replay entry from the mobile-dropdown hamburger.
// The button at ssr_renderer.py:_render_sp_header carries
// data-action="replay-tour". Walkthrough.restart(level) (NOT
// .start) clears the DONE_KEY so the tour fires for repeat
// callers. walkthrough.js lives in JS_CHUNKS['education'] which
// is lazy-loaded — must _loadModule first when the chunk hasn't
// loaded yet. ──
document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action="replay-tour"]');
    if (!btn)
        return;
    e.preventDefault();
    var level = (typeof OLStorage !== 'undefined' && OLStorage)
        ? (OLStorage.getString('ol_user_level', null) || OLStorage.getString('skillLevel', null) || 'beginner')
        : 'beginner';
    var w = window;
    function _fire() {
        if (w.Walkthrough && typeof w.Walkthrough.restart === 'function') {
            w.Walkthrough.restart(level);
        }
        else if (w.Walkthrough && typeof w.Walkthrough.start === 'function') {
            // Fallback for older Walkthrough builds without restart().
            w.Walkthrough.start(level);
        }
    }
    if (w.Walkthrough && typeof w.Walkthrough.restart === 'function') {
        _fire();
    }
    else if (typeof w._loadModule === 'function') {
        w._loadModule('walkthrough').then(_fire).catch(function () {
            if (typeof showToast === 'function') {
                showToast('Walkthrough unavailable — please refresh the page and try again.', '', 4000);
            }
        });
    }
    else if (typeof showToast === 'function') {
        showToast('Walkthrough unavailable — please refresh the page and try again.', '', 4000);
    }
});
// ── Global Error Recovery Protocol ──
// Track errors + show user-friendly recovery when critical failures occur
var _errorCount = 0;
var _errorRecoveryShown = false;
window.addEventListener('error', function (e) {
    _track('js_error', {
        message: e.message || 'Unknown error',
        source: (e.filename || '').split('/').pop(),
        line: e.lineno,
        col: e.colno,
    });
    _errorCount++;
    // #30 P2-3: raised 3 -> 4 to match the unhandledrejection threshold and
    // give a healthy page more headroom before the recovery toast fires.
    if (_errorCount >= 4 && !_errorRecoveryShown) {
        _showErrorRecovery(e.message);
    }
});
window.addEventListener('unhandledrejection', function (e) {
    // #30 P2-3 (2026-05-30): in-flight view/data fetches are aborted on every
    // view switch (abortViewFetches) + time out under provider-quota pressure,
    // rejecting with AbortError / TimeoutError. Those are EXPECTED, not faults
    // -- counting them tripped the scary "Unable to load some features"
    // recovery toast on a perfectly healthy page (3 in a 3-min window). Skip
    // them entirely (no telemetry, no tripwire count).
    var _reason = (e && e.reason) || {};
    var _rname = _reason.name || '';
    if (_rname === 'AbortError' || _rname === 'TimeoutError'
        || (typeof _reason === 'string' && _reason.indexOf('timeout') !== -1)) {
        return;
    }
    _track('promise_error', {
        message: String(e.reason).slice(0, 200),
    });
    _errorCount++;
    if (_errorCount >= 4 && !_errorRecoveryShown) {
        _showErrorRecovery(String(e.reason).slice(0, 100));
    }
});
function _showErrorRecovery(detail) {
    _errorRecoveryShown = true;
    var el = document.createElement('div');
    el.id = 'error-recovery';
    el.className = 'err-recovery';
    el.innerHTML = '<div class="err-recovery-body"><div class="err-recovery-title">Unable to load some features</div><div class="err-recovery-detail">Some features may not be working correctly. Try refreshing the page.</div></div><button class="err-recovery-refresh" data-action="err-refresh">Refresh</button><button class="err-recovery-close" data-action="err-dismiss" aria-label="Dismiss">&times;</button>';
    el.addEventListener('click', function (e) {
        if (e.target.closest('[data-action="err-refresh"]'))
            location.reload();
        if (e.target.closest('[data-action="err-dismiss"]')) {
            el.remove();
            _errorRecoveryShown = false;
        }
    });
    document.body.appendChild(el);
    // Auto-dismiss after 30s if user doesn't act
    setTimeout(function () { if (el.parentNode)
        el.remove(); _errorRecoveryShown = false; }, 30000);
}
// A.9 fix: use centralized timer registry (persistent = survives view changes)
registerInterval('errorDecay', function () { _errorCount = Math.max(0, _errorCount - 1); }, 60000, true);
// Track mobile-specific events
if (_isMobile) {
    _track('mobile_session_start', { ua: navigator.userAgent.slice(0, 150), screen: _screenWidth + 'x' + (window.screen?.height || window.innerHeight) });
    // Track orientation changes (matchMedia replaces deprecated orientationchange)
    if (window.matchMedia) {
        window.matchMedia('(orientation: portrait)').addEventListener('change', function (e) {
            _track('orientation_change', { orientation: e.matches ? 'portrait' : 'landscape' });
        });
    }
}
// §WEBSOCKET — extracted to static/js/ws-client.js (S37)
// Public API: _wsConnect, _wsPulsePollingFallback
// §502/FETCH — extracted to static/js/data-pipeline.js (S37)
// Public API: olFetch (the per-endpoint circuit breaker lives INSIDE it:
// _cbRecord502/_cbClear/_cbIsPaused are internal, key-scoped, not exported).
// 2026-08-06 (#16): this comment previously advertised _record502/_clear502/
// _is502Paused — names that no longer existed anywhere. macro-view guarded
// against them with `typeof` checks that silently no-op'd, and this comment
// is what defeated the dead-reference grep. Do not list names here that a
// grep of data-pipeline.ts cannot confirm.
// ── SKELETON & ERROR HELPERS ──
// _safeSetHTML: set innerHTML but preserve any canvas/iframe/[data-preserve]
// descendants (S43 P1-C guard; #112 FE-STORM P2 broadened the set 2026-07-01).
// Prevents accidental destruction of chart canvases when a container is re-rendered.
// canvas + iframe are auto-preserved (always precious). Any OTHER node that must
// survive an innerHTML rebuild — an IntersectionObserver lazy-sentinel or a
// non-canvas WebSocket-backed widget (FOUNDATIONAL feedback_never_destroy_dom) —
// opts in with the `data-preserve` attribute; _safeSetHTML then detaches +
// re-appends it too (state/observers intact, re-positioned to the container tail).
function _safeSetHTML(el, html) {
    if (!el)
        return;
    var canvases = el.querySelectorAll ? el.querySelectorAll('canvas, iframe, [data-preserve]') : [];
    if (!canvases || canvases.length === 0) {
        el.innerHTML = html;
        return;
    }
    // Preserve canvas/iframe nodes by detaching, replacing, and re-appending.
    var preserved = [];
    for (var i = 0; i < canvases.length; i++)
        preserved.push(canvases[i]);
    el.innerHTML = html;
    for (var j = 0; j < preserved.length; j++) {
        try {
            el.appendChild(preserved[j]);
        }
        catch (e) { /* ignore */ }
    }
}
function _showSkeleton(el, n) { el.innerHTML = Array(n || 3).fill('<div class="ol-skeleton ol-sk-line"></div>').join(''); }
// Error taxonomy icons and labels (C10: Data Czar)
var _ERROR_TAXONOMY = {
    ticker_not_found: { icon: '\u2753', label: 'Symbol Not Found' }, // question mark
    rate_limited: { icon: '\u23F3', label: 'Rate Limited' }, // hourglass
    api_unavailable: { icon: '\u26A0', label: 'Service Unavailable' }, // warning
    timeout: { icon: '\u23F1', label: 'Request Timed Out' }, // stopwatch
    no_data: { icon: '\u2205', label: 'No Data' }, // empty set
    unknown: { icon: '\u26A0', label: 'Error' } // warning
};
function _showClassifiedErrorToast(errorType, message, retryAfter) {
    var info = _ERROR_TAXONOMY[errorType] || _ERROR_TAXONOMY.unknown;
    var suffix = '';
    if (retryAfter && errorType === 'rate_limited') {
        suffix = ' (retry in ' + retryAfter + 's)';
    }
    // 2026-09-25: plain text in, escaped ONCE by showToast (html:false) -- escHtml here too showed &#39;.
    showToast(info.icon + ' ' + message + suffix, 'error', errorType === 'rate_limited' ? 6000 : 4000);
}
// 2026-09-26 (external review P1-13): _renderError / _renderClassifiedError were
// DELETED with their `render-error-retry` handler (app-renderers.ts). Neither had
// a caller, and the handler ran `window[el.dataset.retryFn]()` -- any injected
// markup could name a global (removeTicker, _gdprCancelDeletion, authSignOut)
// and one click ran it. Pinned by tests/test_frontend_security_wp_d_contract.py.
const REFRESH_MS = 15 * 60 * 1000; // 15 minute auto-refresh
// Global market open check (mirrors the one inside init/updateClock)
function _isMarketOpenNow() {
    const et = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
    const day = et.getDay();
    if (day === 0 || day === 6)
        return false;
    const timeMin = et.getHours() * 60 + et.getMinutes();
    return timeMin >= 570 && timeMin < 960; // 9:30 AM - 4:00 PM ET
}
// Determine extended-hours data for a price object (returns null if market open or no ext data)
function _getExtHoursInfo(priceObj) {
    if (_isMarketOpenNow())
        return null;
    const p = priceObj || {};
    if (p.postMarketPrice && p.postMarketChange != null) {
        return { label: 'AH', price: p.postMarketPrice, chg: p.postMarketChange, pct: p.postMarketChangePct };
    }
    if (p.preMarketPrice && p.preMarketChange != null) {
        return { label: 'PM', price: p.preMarketPrice, chg: p.preMarketChange, pct: p.preMarketChangePct };
    }
    return null;
}
const DEFAULT_PORTFOLIO_TICKERS = ['AAPL', 'MSFT', 'JPM', 'AMZN', 'JNJ', 'SPY', 'QQQ', 'DIA'];
var PORTFOLIO_TICKERS = (() => {
    const savedTickers = OLStorage.getString('portfolio_tickers', null);
    try {
        const parsedSaved = savedTickers ? JSON.parse(savedTickers) : null;
        return (Array.isArray(parsedSaved) && parsedSaved.length > 0) ? parsedSaved : [...DEFAULT_PORTFOLIO_TICKERS];
    }
    catch (e) {
        return [...DEFAULT_PORTFOLIO_TICKERS];
    }
})();
const _isDefaultPortfolio = () => {
    const saved = OLStorage.getString('portfolio_tickers', null);
    if (!saved)
        return true;
    try {
        const arr = JSON.parse(saved);
        return !Array.isArray(arr) || arr.length === 0;
    }
    catch {
        return true;
    }
};
function savePortfolioTickers() {
    OLStorage.set('portfolio_tickers', PORTFOLIO_TICKERS);
    // Hide demo badge once user customizes
    var badge = document.getElementById('port-demo-badge');
    if (badge)
        badge.classList.add('d-none');
    // P2-13: sync to server for authenticated users.
    // PortfolioQA-2 / EmailQA-2 fix (2026-05-26): previously
    // .catch(function(){}) which silently swallowed 401/429/500/504 — the
    // architectural defect that caused the OWNER's 14-ticker portfolio to
    // render empty in email + news for ~10 days undetected. Sentry capture
    // surfaces sync failures so the silent-fail pattern doesn't recur.
    if (typeof _authUser !== 'undefined' && _authUser) {
        try {
            fetch('/api/portfolio/sync-tickers', {
                method: 'POST',
                headers: (typeof _csrfHeaders === 'function') ? _csrfHeaders() : { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ tickers: PORTFOLIO_TICKERS }),
                signal: AbortSignal.timeout(15000) // FE review 2026-07-19 P2
            }).catch(function (err) {
                try {
                    var S = window.Sentry;
                    if (S && typeof S.captureException === 'function') {
                        S.captureException(err, { tags: { feature: 'portfolio_sync', op: 'sync_tickers_post' } });
                    }
                }
                catch (_e) { }
            });
        }
        catch (e) {
            try {
                var S2 = window.Sentry;
                if (S2 && typeof S2.captureException === 'function') {
                    S2.captureException(e, { tags: { feature: 'portfolio_sync', op: 'sync_tickers_post_throw' } });
                }
            }
            catch (_e2) { }
        }
    }
}
// Show DEMO badge if user hasn't customized their portfolio
setTimeout(() => {
    const badge = document.getElementById('port-demo-badge');
    if (badge && _isDefaultPortfolio())
        badge.classList.remove('d-none');
}, 1000);
function removePortfolioTicker(t) {
    const idx = PORTFOLIO_TICKERS.indexOf(t);
    if (idx === -1)
        return;
    PORTFOLIO_TICKERS.splice(idx, 1);
    savePortfolioTickers();
    if (typeof renderPortfolio === 'function')
        renderPortfolio();
    // Persist deletion to PostgreSQL (fire-and-forget)
    try {
        fetch('/api/portfolio-positions', { method: 'DELETE', headers: _csrfHeaders(), body: JSON.stringify({ ticker: t }), credentials: 'include' }).catch(function () { });
    }
    catch (e) { }
    window._undoPortfolioState = { ticker: t, idx };
    showToast(`${escHtml(t)} removed — <span class="toast-undo-link" data-action="undo-remove-portfolio-ticker">Undo</span>`, '', 5000, { html: true });
}
function undoRemovePortfolioTicker() {
    const s = window._undoPortfolioState;
    if (!s || PORTFOLIO_TICKERS.includes(s.ticker))
        return;
    PORTFOLIO_TICKERS.splice(s.idx, 0, s.ticker);
    savePortfolioTickers();
    if (typeof renderPortfolio === 'function')
        renderPortfolio();
    showToast(`${escHtml(s.ticker)} restored to portfolio`, 'success', 2000);
}
// DELETED 2026-09-08 (#61 / D-7 follow-through): `PORTFOLIO_CUSTOM_WEIGHTS`
// lived here — eight tickers, "Baseline custom weights as of 2026-03-25", ZERO
// write sites: a demo fixture wired into a signed-in user's holdings table.
// D-7 (`05aa614a`) fixed ONE of its four readers; it did not regress, it never
// covered the rest, and deleting the const is what stops that repeating.
// Record: docs/board/audit/2026-09-08_CHAOS_portfolio_weight_source.md.
// M1 (audit): localStorage reads deferred from module init to the boot
// hydration pass below. Vars hold defaults during bundle parse so the
// disk hits don't block TTI. Stored values arrive before any view
// renders (hydrate runs at the start of the existing DOMContentLoaded
// handler that already does URL-param hydration).
// 'value' = each holding's share of total position value (price x shares) —
// the only basis derived from what the user owns, and so the default. Legacy
// 'custom' still arrives from localStorage and shared ?weight= links and is
// normalized at EVERY entry point, not one. Lives in app-init (the `app`
// chunk, on the page first) so `core-portfolio` can call it too.
const PORTFOLIO_WEIGHT_MODES = ['value', 'equal', 'price', 'mktcap'];
function _normalizeWeightMode(mode) {
    if (!mode)
        return null;
    if (mode === 'custom')
        return 'value';
    return PORTFOLIO_WEIGHT_MODES.indexOf(mode) !== -1 ? mode : null;
}
var portfolioWeightMode = 'value';
var tickers = [...new Set(PORTFOLIO_TICKERS)];
var activeTicker = PORTFOLIO_TICKERS[0] || 'AAPL';
var tickerChartPeriod = '1y';
var chartMode = 'line'; // candle mode retired; setChartMode() forces 'line'
var chartDisplayData = null;
var chartAnnotations = { earnings: [], dividends: [] };
// Zoom/pan state for interactive chart
var chartViewport = { startIdx: 0, endIdx: -1 }; // -1 = show all
var chartPanState = null; // { startX, origStartIdx, origEndIdx } during drag
var _extBadgeLastUpdate = 0; // throttle extended-hours badge updates
var phasePollingTimers = {};
var dataCache = {};
var _DATA_CACHE_MAX = 50;
function _evictDataCache() {
    var keys = Object.keys(dataCache);
    if (keys.length > _DATA_CACHE_MAX) {
        // Remove oldest entries (first added), keep active ticker
        var toRemove = keys.length - _DATA_CACHE_MAX;
        for (var i = 0; i < keys.length && toRemove > 0; i++) {
            if (keys[i] !== activeTicker) {
                delete dataCache[keys[i]];
                toRemove--;
            }
        }
    }
}
var isLive = false;
var refreshTimer = null;
// ── Tier hierarchy for frontend gating ──
// 2026-04-30 evening (auth-panels A6 + A8): hoisted TIER_DISPLAY_NAMES +
// extended _TIER_ORDER to be the single source of truth across files.
// Previously labels drifted across tier-gate.js / settings-panel.js /
// practicum-view.js / milestones-view.js (A6); _TIER_ORDER was missing
// legacy keys (`hobbyist`/`scale`/`institutional`) + the `pro-ai` alias
// + `_trial` variants, silently giving them rank 0 in `_hasTier()` (A8).
// Both maps are window-attached so consumers can `window.TIER_DISPLAY_NAMES
// || { ...fallback }` without a build-step import.
var _TIER_ORDER = {
    anonymous: 0,
    free: 0,
    hobbyist: 0, // legacy → free
    trial_plus: 1,
    plus_trial: 1, // alt spelling seen in tier-gate.js
    plus: 1,
    trial_pro: 2,
    pro_trial: 2, // alt spelling
    pro: 2,
    scale: 2, // legacy → pro
    trial_professional: 3,
    professional_trial: 3, // alt spelling
    professional: 3,
    'pro-ai': 3, // alias for professional
    institutional: 3, // legacy → professional
};
window._TIER_ORDER = _TIER_ORDER;
// Wave 1 Q8 rename 2026-05-10 (SF-MONETIZATION-V3 ratified):
//   plus           Analyst        → Researcher
//   professional   Investor + AI  → Power User    // tier-rename-history: ok
//   'pro-ai'       alias          → Power User
// Canonical user-facing labels. The SSR pricing page + /api/billing surfaces
// already use the new names; this map is the JS canonical source so every
// paywall card, session-banner, upgrade toast, and settings panel render
// the same labels within one session.
// 2.3 tier-vocab centralization (2026-06-12 OWNER audit): names now come
// from window.OL_TIER_META (tier-fallback.generated.js, emitted at build
// time from services/billing/constants.py TIER_CONFIG +
// TIER_DISPLAY_NAMES — loads BEFORE bundle-app). The literals below are
// the no-generated-file fallback ONLY; the drift contract
// (test_tier_vocab_canon_contract.py) pins them equal to the backend
// canon so even the fallback can't diverge. ('Learner (Free)' was
// already drift — backend canon is 'Learner'.)
var TIER_DISPLAY_NAMES = {
    anonymous: 'Anonymous',
    free: 'Learner',
    plus: 'Researcher',
    pro: 'Investor',
    professional: 'Power User',
    'pro-ai': 'Power User',
};
try {
    var _olTierMeta = window.OL_TIER_META;
    if (_olTierMeta && typeof _olTierMeta === 'object') {
        for (var _olTierKey in _olTierMeta) {
            if (_olTierMeta[_olTierKey] && typeof _olTierMeta[_olTierKey].name === 'string') {
                TIER_DISPLAY_NAMES[_olTierKey] = _olTierMeta[_olTierKey].name;
            }
        }
    }
}
catch (_e) { /* fallback literals stand */ }
window.TIER_DISPLAY_NAMES = TIER_DISPLAY_NAMES;
// 2.3 long-tail (2026-06-12): ONE label accessor for every chunk.
// olTierLabel('plus') -> 'Researcher'; olTierLabel('plus', true) ->
// 'Researcher ($9/mo)' (price from the generated OL_TIER_META).
// Consumers in other chunks call under a typeof guard with their old
// literal as fallback — core loads first so the guard passes in
// practice; the fallback covers partial loads.
function olTierLabel(tierKey, withPrice) {
    var nm = (window.TIER_DISPLAY_NAMES || {})[tierKey] || '';
    if (!nm)
        return '';
    if (withPrice) {
        try {
            var _m = window.OL_TIER_META;
            var _p = _m && _m[tierKey] && _m[tierKey].price_mo;
            if (typeof _p === 'number' && _p > 0)
                return nm + ' ($' + _p + '/mo)';
        }
        catch (_e) { /* name-only */ }
    }
    return nm;
}
window.olTierLabel = olTierLabel;
function _hasTier(minTier) {
    var userTier = (typeof window._userTier !== 'undefined' && window._userTier) ? window._userTier.replace('_trial', '') : 'free';
    return (_TIER_ORDER[userTier] || 0) >= (_TIER_ORDER[minTier] || 0);
}
var countdown = REFRESH_MS;
// Declare currentView early so inline setView works before views.js loads (defer)
var currentView = 'ticker';
// S27: Ensure headline/indicator caches exist before news.js lazy-loads
if (typeof headlinesCache === 'undefined')
    var headlinesCache = null;
if (typeof indicatorsCache === 'undefined')
    var indicatorsCache = null;
// M1: defaults; populated by _hydrateLocalStoragePrefs() at boot.
var portfolioSortCol = 0;
var portfolioSortAsc = true;
var _peerViewMode = 'equity';
var _peerData = null; // cached peer response for toggle without re-fetch
// EXT-AUDIT #63 (2026-07-06): the ticker whose /api/peers fetch is currently
// in flight — re-renders must not reset the loader + restart the fetch.
var _peerFetchInFlight = null;
// ── Peer Column Picker Definitions ──
// Cross-chunk types: peer-view.ts indexes PEER_COLUMNS / PEER_PRESETS
// dynamically by string. Annotate as Record<string, ...> so the
// strict-typed consumer doesn't see the inferred literal-keyed shape.
const PEER_COLUMNS = {
    pe: { key: 'pe', label: 'P/E', group: 'Valuation', fmt: (v) => v != null ? (v < 0 ? 'N/M' : fmt(v, 1) + 'x') : '\u2014' },
    fwdPe: { key: 'fwdPe', label: 'Fwd P/E', group: 'Valuation', fmt: (v) => v != null ? (v < 0 ? 'N/M' : fmt(v, 1) + 'x') : '\u2014' },
    evEbitda: { key: 'evEbitda', label: 'EV/EBITDA', group: 'Valuation', fmt: (v) => v != null ? fmt(v, 1) + 'x' : '\u2014' },
    evRevenue: { key: 'evRevenue', label: 'EV/Revenue', group: 'Valuation', fmt: (v) => v != null ? fmt(v, 1) + 'x' : '\u2014' },
    pb: { key: 'pb', label: 'P/B', group: 'Valuation', fmt: (v) => v != null ? fmt(v, 2) + 'x' : '\u2014' },
    ps: { key: 'ps', label: 'P/S', group: 'Valuation', fmt: (v) => v != null ? fmt(v, 2) + 'x' : '\u2014' },
    peg: { key: 'peg', label: 'PEG', group: 'Valuation', fmt: (v) => v != null ? fmt(v, 2) + 'x' : '\u2014' },
    grossMargin: { key: 'grossMargin', label: 'Gross Margin', group: 'Profitability', fmt: (v) => v != null ? fmt(v, 1) + '%' : '\u2014' },
    ebitdaMargin: { key: 'ebitdaMargin', label: 'EBITDA Margin', group: 'Profitability', fmt: (v) => v != null ? fmt(v, 1) + '%' : '\u2014' },
    netMargin: { key: 'netMargin', label: 'Net Margin', group: 'Profitability', fmt: (v) => v != null ? fmt(v, 1) + '%' : '\u2014' },
    roe: { key: 'roe', label: 'ROE', group: 'Profitability', fmt: (v) => v != null ? fmt(v, 1) + '%' : '\u2014' },
    roa: { key: 'roa', label: 'ROA', group: 'Profitability', fmt: (v) => v != null ? fmt(v, 1) + '%' : '\u2014' },
    roic: { key: 'roic', label: 'ROIC', group: 'Profitability', fmt: (v) => v != null ? fmt(v, 1) + '%' : '\u2014' },
    revenueGrowth: { key: 'revenueGrowth', label: 'Rev Growth', group: 'Growth', fmt: (v) => v != null ? fmt(v, 1) + '%' : '\u2014' },
    epsGrowth: { key: 'epsGrowth', label: 'EPS Growth', group: 'Growth', fmt: (v) => v != null ? fmt(v, 1) + '%' : '\u2014' },
    debtEquity: { key: 'debtEquity', label: 'Debt/Equity', group: 'Leverage', fmt: (v) => v != null ? fmt(v, 2) : '\u2014' },
    netDebtToEbitda: { key: 'netDebtToEbitda', label: 'ND/EBITDA', group: 'Leverage', fmt: (v) => v != null ? fmt(v, 1) + 'x' : '\u2014' },
    interestCoverage: { key: 'interestCoverage', label: 'Int Coverage', group: 'Leverage', fmt: (v) => v != null ? fmt(v, 1) + 'x' : '\u2014' },
    dividendYield: { key: 'dividendYield', label: 'Div Yield', group: 'Returns', fmt: (v) => v != null ? fmt(v, 2) + '%' : '\u2014' },
    fcfYield: { key: 'fcfYield', label: 'FCF Yield', group: 'Returns', fmt: (v) => v != null ? fmt(v, 1) + '%' : '\u2014' },
    mktCap: { key: 'mktCap', label: 'Mkt Cap', group: 'Market', fmt: (v) => v != null ? fmtMktCap(v) : '\u2014' },
    beta: { key: 'beta', label: 'Beta', group: 'Market', fmt: (v) => v != null ? fmt(v, 2) : '\u2014' },
    week52Return: { key: 'week52Return', label: '52W Return', group: 'Market', fmt: (v) => v != null ? (v >= 0 ? '+' : '') + fmt(v, 1) + '%' : '\u2014' },
    shortPctFloat: { key: 'shortPctFloat', label: 'Short Int', group: 'Market', fmt: (v) => v != null ? fmt(v, 1) + '%' : '\u2014' },
    price: { key: 'price', label: 'Price', group: 'Market', fmt: (v) => v != null ? '$' + fmt(v) : '\u2014' },
    dayPct: { key: 'dayPct', label: 'Day%', group: 'Market', fmt: (v) => v != null ? (v >= 0 ? '+' : '') + fmt(v, 1) + '%' : '\u2014' },
    totalDebt: { key: 'totalDebt', label: 'Total Debt', group: 'Leverage', fmt: (v) => v != null ? (Math.abs(v) >= 1000 ? '$' + fmt(v / 1000, 1) + 'B' : '$' + fmt(v, 0) + 'M') : '\u2014' },
    netDebt: { key: 'netDebt', label: 'Net Debt', group: 'Leverage', fmt: (v) => v != null ? (Math.abs(v) >= 1000 ? '$' + fmt(v / 1000, 1) + 'B' : '$' + fmt(v, 0) + 'M') : '\u2014' },
    altmanZ: { key: 'altmanZ', label: 'Altman Z', group: 'Leverage', fmt: (v) => v != null ? fmt(v, 2) : '\u2014', tooltip: 'Original 5-factor model (manufacturing). May not apply to banks/utilities/services.' },
    company: { key: 'company', label: 'Company', group: 'Market', fmt: (v) => v || '\u2014' },
};
const PEER_COL_GROUPS = ['Valuation', 'Profitability', 'Growth', 'Leverage', 'Returns', 'Market'];
const PEER_PRESETS = {
    equity: ['price', 'dayPct', 'pe', 'evEbitda', 'pb', 'roe', 'netMargin', 'mktCap'],
    growth: ['price', 'dayPct', 'revenueGrowth', 'epsGrowth', 'fwdPe', 'peg', 'grossMargin', 'roic'],
    credit: ['company', 'netDebtToEbitda', 'interestCoverage', 'totalDebt', 'netDebt', 'ebitdaMargin', 'altmanZ', 'debtEquity'],
};
const PEER_MAX_COLS = 8;
var _peerActiveCols = (() => {
    const saved = OLStorage.get('peerColumns', null);
    if (Array.isArray(saved) && saved.length > 0 && saved.length <= PEER_MAX_COLS && saved.every(c => PEER_COLUMNS[c]))
        return saved;
    return PEER_PRESETS.equity.slice();
})();
var _peerColPickerOpen = false;
var _alertedTickers = {}; // persistent alert dots: { ticker: 'buy'|'reassess' }
const DEMO_DATA = {
    DAC: {
        ticker: 'DAC', company: 'Danaos Corporation', sector: 'Shipping',
        lastUpdated: 'DEMO',
        price: { current: 71.42, change: 1.23, changePct: 1.75, volume: 125840, avgVolume: 95000, marketCap: 1.42, week52High: 89.50, week52Low: 52.10 },
        metrics: { pe: 4.2, forwardPe: 4.0, evEbitda: 5.1, pb: 0.91, ps: 1.4, debtEquity: 0.43, dividendYield: 3.8, roe: 22.4, roa: 11.2 },
        dividends: {
            history: [
                { quarter: 'Q4 2025', amount: 0.75, exDate: '2025-12-05' },
                { quarter: 'Q3 2025', amount: 0.75, exDate: '2025-09-04' },
                { quarter: 'Q2 2025', amount: 0.75, exDate: '2025-06-05' },
                { quarter: 'Q1 2025', amount: 0.75, exDate: '2025-03-06' },
            ],
            nextExDate: '2026-03-05',
            annualAmount: 3.00
        },
        earnings: {
            nextDate: '2026-02-12',
            epsEstimate: 7.25,
            epsPrior: 6.90,
            surpriseHistory: [{ quarter: 'Q3 2025', actual: 7.10, estimate: 6.85 }]
        },
        shortInterest: { pctOfFloat: 3.2, sharesShort: 620000, costToBorrow: 1.5, daysToCover: 2.1 },
        financials: { revenue: 942, revenueGrowth: 3.2, ebitda: 721, ebitdaMargin: 76.5, netIncome: 580, netMargin: 61.6, eps: 29.50, cash: 312, totalDebt: 678, freeCashFlow: 510 },
        sparkline: {
            prices: [68.5, 69.1, 69.8, 70.2, 69.5, 69.0, 70.1, 71.0, 70.5, 71.2, 71.8, 72.0, 71.5, 70.8, 71.0, 71.5, 72.2, 71.9, 71.0, 70.5, 70.8, 71.2, 71.5, 71.0, 70.8, 71.2, 71.5, 71.0, 71.2, 71.42],
            volumes: [85000, 92000, 110000, 130000, 78000, 95000, 105000, 250000, 88000, 92000, 115000, 98000, 87000, 76000, 90000, 102000, 125000, 95000, 88000, 82000, 91000, 108000, 115000, 88000, 79000, 95000, 105000, 92000, 88000, 125840],
            dates: ['2026-02-10', '2026-02-11', '2026-02-12', '2026-02-13', '2026-02-14', '2026-02-18', '2026-02-19', '2026-02-20', '2026-02-21', '2026-02-24', '2026-02-25', '2026-02-26', '2026-02-27', '2026-02-28', '2026-03-03', '2026-03-04', '2026-03-05', '2026-03-06', '2026-03-07', '2026-03-10', '2026-03-11', '2026-03-12', '2026-03-13', '2026-03-14', '2026-03-17', '2026-03-18', '2026-03-19', '2026-03-20', '2026-03-21', '2026-03-24'],
            ohlc: []
        },
        // Demo news is intentionally empty — we used to seed fake URLs that 404'd.
        // When a real ticker loads, /api/news/:ticker supplies live headlines; the
        // "no headlines yet" empty state is preferable to fabricated sources.
        news: [],
        filings: [
            { type: '6-K', date: '2025-11-15', description: 'Report of Foreign Private Issuer', url: 'https://www.sec.gov/cgi-bin/browse-edgar?action=getcompany&CIK=DAC&type=6-K' },
            { type: '6-K', date: '2025-08-12', description: 'Report of Foreign Private Issuer - Q2 Results', url: 'https://www.sec.gov/cgi-bin/browse-edgar?action=getcompany&CIK=DAC&type=6-K' },
            { type: '20-F', date: '2025-03-28', description: 'Annual Report (Foreign)', url: 'https://www.sec.gov/cgi-bin/browse-edgar?action=getcompany&CIK=DAC&type=20-F' },
            { type: '6-K', date: '2025-05-10', description: 'Report of Foreign Private Issuer - Q1 Results', url: 'https://www.sec.gov/cgi-bin/browse-edgar?action=getcompany&CIK=DAC&type=6-K' },
            { type: 'SC 13G', date: '2025-02-14', description: 'Beneficial Ownership Report', url: 'https://www.sec.gov/cgi-bin/browse-edgar?action=getcompany&CIK=DAC&type=SC+13G' },
        ],
        summary: 'Danaos Corporation is one of the world\'s largest independent owners of containerships, with a modern fleet of 68 vessels. The company benefits from long-term fixed-rate charters with major liner companies including MSC, CMA CGM, Evergreen, and Yang Ming, providing exceptional earnings visibility. Danaos trades at a significant discount to NAV, supported by a strong balance sheet, growing dividend, and active share buyback program. Key risks include charter renewal exposure beyond 2027 and broader shipping cycle sensitivity.'
    }
};
// fmt, fmtM, toM, sanityCheckM, fmtVol, fmtMktCap, escHtml, emptyState, newsRecencyClass
// loaded from static/js/formatting.js
function getData(t) {
    if (dataCache[t])
        return dataCache[t];
    if (DEMO_DATA[t])
        return DEMO_DATA[t];
    // Fallback: return a minimal safe object for unknown tickers in offline mode
    if (!isLive)
        return {
            ticker: t, company: t, sector: 'Unknown', lastUpdated: 'OFFLINE',
            price: { current: null, change: null, changePct: null },
            metrics: {}, financials: {}, news: [], filings: [],
            sparkline: { prices: [], volumes: [], dates: [] },
            summary: 'No data available — server is offline.'
        };
    return null;
}
// ── PRACTICE MODE FLOATING BUTTON ──
function _updatePracticeFab(view) {
    var fab = document.getElementById('practice-mode-fab');
    if (!fab)
        return;
    var dismissed = OLStorage.getString('practice_fab_dismissed', null) === '1';
    var uniqueTickers = OLStorage.get('ol_unique_tickers', []);
    // P2-14: Delay practice FAB for 1 day after welcome to reduce first-load competition.
    var welcomeOk = true;
    try {
        var wts = parseInt(OLStorage.getString('ol_welcome_ts', null) || '0', 10);
        if (wts && (Date.now() - wts) < 1 * 24 * 60 * 60 * 1000)
            welcomeOk = false;
    }
    catch (_e) { }
    var show = (view === 'ticker') && !dismissed && uniqueTickers.length >= 3 && welcomeOk;
    fab.classList.toggle('hidden', !show);
}
// Initialize practice FAB click handler (once)
document.addEventListener('DOMContentLoaded', function () {
    var fab = document.getElementById('practice-mode-fab');
    if (!fab)
        return;
    fab.addEventListener('click', function (e) {
        // Don't trigger if dismiss button was clicked
        if (e.target.closest('.practice-fab-dismiss'))
            return;
        if (typeof togglePracticeMode === 'function')
            togglePracticeMode();
    });
    // Show on initial load if on ticker view
    _updatePracticeFab(currentView);
});
// §VIEWS — extracted to static/js/view-router.js (S37)
// Public API: setView, _materializeView, _loadViewModules, _ensureViewModule,
// _VIEW_MODULE_MAP, _VIEW_CHUNK_MAP, _inlineRender* fallbacks
// ── TABS ──
// HIDDEN_TABS: these benchmark/index tickers (ETFs like SPY, QQQ, DIA) are added
// automatically by the system as reference benchmarks rather than user picks.
// They clutter the tab bar on small screens so we hide them from the visual tab row.
// They are still tracked in the `tickers` array and are available via the full ticker
// sheet (TICKERS button). The TICKERS button count intentionally reflects the total
// tickers array length (including these hidden ones) so users know they exist.
const HIDDEN_TABS = new Set(['DIA', 'QQQ', 'SPY', 'SPYM', 'TQQQ', 'SWLGX']);
function renderTabs() {
    const wrap = document.getElementById('ticker-tabs');
    if (!wrap)
        return;
    const focusedTicker = document.activeElement?.closest?.('.ticker-btn')?.dataset?.ticker;
    const visibleTickers = tickers.filter(t => !HIDDEN_TABS.has(t));
    // Build a map of existing tab elements keyed by ticker symbol
    const existingMap = new Map();
    for (const child of Array.from(wrap.children)) {
        const key = child.dataset?.ticker;
        if (key)
            existingMap.set(key, child);
    }
    const newKeys = new Set(visibleTickers);
    // Remove tabs no longer in the list
    for (const [key, el] of existingMap) {
        if (!newKeys.has(key)) {
            el.remove();
            existingMap.delete(key);
        }
    }
    // Create or update each tab, then position it correctly
    let prevNode = null;
    for (const t of visibleTickers) {
        // --- compute tab state ---
        let dotType = ''; // '', 'buy', or 'reassess'
        const d = getData(t);
        if (d && d.price && d.price.current) {
            const buyKey = `alert_buy_${t}`;
            const reassessKey = `alert_reassess_${t}`;
            const buyTarget = parseFloat(OLStorage.getString(buyKey, null));
            const reassessTarget = parseFloat(OLStorage.getString(reassessKey, null));
            if (!isNaN(buyTarget) && d.price.current <= buyTarget) {
                dotType = 'buy';
                if (!_alertedTickers[t]) {
                    _alertedTickers[t] = 'buy';
                    showToast(`${t} hit BUY alert — $${d.price.current.toFixed(2)} ≤ $${buyTarget.toFixed(2)}`, 'success', 8000);
                }
            }
            else if (!isNaN(reassessTarget) && d.price.current >= reassessTarget) {
                dotType = 'reassess';
                if (!_alertedTickers[t]) {
                    _alertedTickers[t] = 'reassess';
                    showToast(`${t} hit REASSESS alert — $${d.price.current.toFixed(2)} ≥ $${reassessTarget.toFixed(2)}`, 'warning', 8000);
                }
            }
            else {
                if (_alertedTickers[t])
                    delete _alertedTickers[t];
            }
        }
        if (!dotType && _alertedTickers[t]) {
            dotType = _alertedTickers[t] === 'buy' ? 'buy' : 'reassess';
        }
        const isActive = t === activeTicker && (currentView === 'ticker' || currentView === 'fundamentals');
        const isPortfolio = PORTFOLIO_TICKERS.includes(t);
        const tierClass = isPortfolio ? 'ticker-btn--holding' : 'ticker-btn--session';
        let btn = existingMap.get(t);
        if (!btn) {
            // Create new tab element
            btn = document.createElement('button');
            btn.dataset.ticker = t;
            btn.addEventListener('click', function () { switchTicker(t); });
        }
        // Update classes
        btn.className = 'ticker-btn ' + tierClass + (isActive ? ' active' : '');
        // Rebuild inner content via child diffing
        // Structure: [textNode(ticker)] [span.tab-chg?] [span.tab-alert-dot?] [span.tab-action]
        // We rebuild innerHTML only for the inner spans to keep it simple and correct,
        // but we do it via a document fragment to avoid full innerHTML on the wrapper.
        let innerHtml = escHtml(t);
        if (d && d.price && d.price.changePct != null) {
            const pct = d.price.changePct;
            const chgCls = pct > 0 ? 'color-positive' : pct < 0 ? 'color-negative' : 'color-neutral';
            const sign = pct >= 0 ? '+' : '';
            // UX-10: tab-chg span gets gainloss-cell so ▲/▼ render before the value.
            innerHtml += `<span class="tab-chg gainloss-cell"><span class="${chgCls}">${sign}${pct.toFixed(1)}%</span></span>`;
            // CYCLE5 Ticket 9 (Thaler): first-loss tooltip. Loss aversion
            // predicts the first time a beginner sees red they're 2.5x more
            // motivated to act than green of the same magnitude. Reframe
            // pre-emptively so the default reaction is "this is normal"
            // rather than "I should sell." Fires ONCE per user. Gate by
            // localStorage + 2% threshold (matches board spec).
            if (pct <= -2 && typeof _maybeShowFirstLossTooltip === 'function') {
                _maybeShowFirstLossTooltip(t, pct);
            }
        }
        if (dotType === 'buy') {
            innerHtml += '<span class="tab-alert-dot tab-dot-green"></span>';
        }
        else if (dotType === 'reassess') {
            innerHtml += '<span class="tab-alert-dot tab-dot-red"></span>';
        }
        if (isPortfolio) {
            innerHtml += `<span class="tab-action tab-demote" title="Demote to session">\u2193</span>`;
        }
        else {
            innerHtml += `<span class="tab-action tab-promote" title="Promote to holdings">\u2191</span>`;
        }
        // Only update innerHTML if content actually changed (avoids destroying inner state needlessly)
        if (btn.innerHTML !== innerHtml) {
            btn.innerHTML = innerHtml;
            // Re-attach action button handler (since innerHTML was replaced)
            const actionSpan = btn.querySelector('.tab-action');
            if (actionSpan) {
                if (isPortfolio) {
                    actionSpan.addEventListener('click', function (e) { e.stopPropagation(); _demoteToSession(t); });
                }
                else {
                    actionSpan.addEventListener('click', function (e) { e.stopPropagation(); _promoteToHoldings(t); });
                }
            }
        }
        // Position: insert after prevNode (or as first child)
        const desiredNext = prevNode ? prevNode.nextSibling : wrap.firstChild;
        if (btn !== desiredNext) {
            wrap.insertBefore(btn, desiredNext);
        }
        prevNode = btn;
    }
    // Restore focus if a tab was focused before
    if (focusedTicker) {
        const toFocus = wrap.querySelector(`[data-ticker="${focusedTicker}"]`);
        if (toFocus)
            toFocus.focus();
    }
}
// Reset hero to dashes before rendering new data.
// LH-2 guard (2026-07-30 QA): when the hero was SERVER-rendered for the ticker
// we are switching TO, leave it alone. Blanking it destroys the SSR paint that
// exists precisely to BE the LCP element (27f2afe4), and renderData updates the
// same nodes in place anyway. The marker is one-shot — _hideTickerSkeleton
// clears it — so this only protects the first paint of an anon cold load, and
// every later switch resets normally. The existing data-ssr-symbol guard at
// _showTickerSkeleton only suppressed the SKELETON; it never covered this.
function _resetHero(targetTicker) {
    var _ssrHeroEl = $id ? $id('hero') : document.getElementById('hero');
    if (_ssrHeroEl && targetTicker) {
        var _ssrMark = _ssrHeroEl.getAttribute('data-ssr-symbol');
        if (_ssrMark && _ssrMark === String(targetTicker).toUpperCase())
            return;
    }
    var ids = ['price-hero', 'change-hero', 'company-name', 'ticker-hero'];
    ids.forEach(function (id) {
        var el = $id ? $id(id) : document.getElementById(id);
        if (el)
            el.textContent = '\u2014';
    });
    var chg = $id ? $id('change-hero') : document.getElementById('change-hero');
    if (chg)
        chg.className = 'neu';
}
// 2026-09-26 (external review P1-12): a ticker is validated ONCE here, where
// every entry point (share links ?s=, ?ticker= / ?symbol= restore, recent
// tickers, the command palette) converges, before it reaches storage, the URL
// or any innerHTML sink (the breadcrumb strip concatenated it raw). The shape
// admits real symbols -- BRK.B, BRK-B, RDS/A, ES=F, ^GSPC, BTC-USD -- and
// refuses anything that can break out of an attribute or open a tag.
var _OL_TICKER_RE = /^\^?[A-Z0-9][A-Z0-9.\-=\/]{0,14}$/;
function olNormalizeTicker(t) {
    var s = String(t == null ? '' : t).trim().toUpperCase();
    return _OL_TICKER_RE.test(s) ? s : '';
}
function switchTicker(t) {
    t = olNormalizeTicker(t);
    if (!t)
        return;
    abortViewFetches(); // Cancel any pending fetches from previous ticker
    _track('switchTicker', { ticker: t });
    // Achievement: unique tickers viewed
    var _ut = OLStorage.get('ol_unique_tickers', []);
    if (_ut.indexOf(t) < 0) {
        _ut.push(t);
        OLStorage.set('ol_unique_tickers', _ut);
    }
    if (typeof setAchievement === 'function')
        setAchievement('tickers_viewed', _ut.length);
    // Daily goal: ticker viewed
    if (typeof incrementDailyGoal === 'function')
        incrementDailyGoal('tickers', t);
    // Achievement: international tickers
    if (t.indexOf('.') > 0 && typeof trackUniqueAchievement === 'function')
        trackUniqueAchievement('intl_tickers', t);
    // Adaptive UI: track ticker views for progressive disclosure
    if (typeof AdaptiveUI !== 'undefined')
        AdaptiveUI.trackTickerView(t);
    _resetHero(t);
    _lastPrimedSector = null;
    chartViewport = { startIdx: 0, endIdx: -1 }; // P1: reset chart zoom on ticker switch
    if (typeof _practiceOnTickerSwitch === 'function')
        _practiceOnTickerSwitch(t);
    _trackRecentTicker(t);
    activeTicker = t;
    if (typeof _olSyncTickerTitle === 'function')
        _olSyncTickerTitle(t + ' \u2014 Oxford Ledge'); // Q6/F9: the new ticker's title now; renderData adds the name
    try {
        OLStorage.setString('lastTicker', t);
    }
    catch (e) { /* QuotaExceededError — non-critical */ }
    // Fire ticker-viewed event for signup bar gating
    try {
        document.dispatchEvent(new CustomEvent('ol:ticker-viewed', { detail: { ticker: t } }));
    }
    catch (e) { }
    // Update URL to reflect new ticker (so bookmarks and back/forward work)
    if (currentView === 'ticker' || currentView === 'fundamentals') {
        var _tickerUrl = '?view=' + encodeURIComponent(currentView) + '&symbol=' + encodeURIComponent(t);
        history.replaceState({ view: currentView }, '', _tickerUrl);
    }
    // I-14: Clear panel asof slots when switching tickers (avoids stale timestamps)
    if (typeof PanelAsof !== 'undefined')
        PanelAsof.clear();
    tickerChartPeriod = OLStorage.getString('chartPeriod', null) || '1y';
    // Reload chart drawings for new ticker
    if (typeof _onTickerChangeDrawings === 'function')
        _onTickerChangeDrawings();
    // Start news auto-refresh for this ticker
    if (typeof startNewsAutoRefresh === 'function')
        startNewsAutoRefresh();
    // Clear persistent alert dot when user switches to this ticker
    if (_alertedTickers[t])
        delete _alertedTickers[t];
    // Stay on fundamentals if already there; otherwise go to ticker view
    if (currentView === 'fundamentals') {
        if (typeof renderFundamentalsView === 'function')
            renderFundamentalsView();
    }
    else if (currentView !== 'ticker')
        setView('ticker');
    renderTabs();
    if (dataCache[t]) {
        _hideTickerSkeleton();
        if (typeof LoadingStates !== 'undefined') {
            LoadingStates.hideSkeleton('metrics-rows');
            LoadingStates.hideSkeleton('chart-panel');
            LoadingStates.hideAllPanelSkeletons(); // I-25: clear all async panel skeletons on cache hit
        }
        renderData(dataCache[t]);
    }
    else if (isLive) {
        _showTickerSkeleton();
        // Fix C (2026-06-30 OWNER): the ticker skeleton is an OVERLAY (a class
        // toggle), so a FAILED load hides it and reveals the PRIOR ticker's panels
        // underneath — the "Spotify profile under AMAZON" stale-data bug. The hero
        // is reset by _resetHero() above and the metrics/chart/async panels get
        // skeletons below, but #summary-text (the plain-text business description)
        // is skeleton-less, so blank it here so a failed switch can never show
        // another company's business copy (feedback_user_trust). Text-only node —
        // safe to clear (no canvas/observer, cf. feedback_never_destroy_dom).
        try {
            const _biz = document.getElementById('summary-text');
            if (_biz)
                _biz.textContent = '';
        }
        catch (_e) { /* defensive */ }
        // Show skeleton screens for metrics, chart, and all async panels while data loads
        if (typeof LoadingStates !== 'undefined') {
            LoadingStates.showSkeleton('metrics-rows', 'metrics');
            LoadingStates.showSkeleton('chart-panel', 'chart');
            LoadingStates.showAllPanelSkeletons(); // I-25: extend skeleton coverage to all async panels
        }
        fetchTicker(t);
    }
    else {
        const demo = DEMO_DATA[t];
        if (demo) {
            _hideTickerSkeleton();
            renderData(demo);
        }
    }
}
// PQA-3 (2026-05-25): resolve a typed company name (or non-ticker string) to a
// ticker, then add it. Mobile audit 2026-09-25 (search, pain #1): the catalog
// rule /look uses runs FIRST (ticker-search-assist.ts) -- an exact known
// ticker, else a company whose name starts with the query -- so APPLE, TESLA
// and INTEL resolve to AAPL, TSLA and INTC instead of being taken as symbols.
// No catalog answer: a symbol-shaped query is tried as a symbol (the not-found
// state offers "Did you mean" links); anything else keeps the /api/ticker-search
// fallback. Every re-entry into addTicker carries a symbol marked resolved, so
// there is no re-resolution loop.
async function _resolveTickerByName(query) {
    const input = document.getElementById('ticker-input');
    const _sym = String(query).trim().toUpperCase();
    const _res = (typeof _olResolveTickerQuery === 'function') ? await _olResolveTickerQuery(query) : { kind: 'unavailable', sym: null };
    const _pick = _res.sym || (/^[A-Z]{1,5}$/.test(_sym) ? _sym : '');
    // CHAOS 2026-09-25: the catalog answers class-share symbols (BRK-B) that
    // addTicker's 1-5 letter shape refuses, and re-entering addTicker with one
    // looped back here forever (a request storm). Open those the way every
    // other picker does (addTickerBySymbol), never through addTicker.
    if (_pick && !/^[A-Z]{1,5}$/.test(_pick)) {
        if (typeof addTickerBySymbol === 'function') {
            if (input)
                input.value = '';
            if (typeof closeSuggest === 'function')
                closeSuggest();
            addTickerBySymbol(_pick);
        }
        else {
            showToast('No matching ticker for "' + query + '"');
        }
        return;
    }
    if (_pick) {
        if (typeof _olMarkResolvedSymbol === 'function')
            _olMarkResolvedSymbol(_pick);
        if (input)
            input.value = _pick;
        if (typeof closeSuggest === 'function')
            closeSuggest();
        addTicker();
        return;
    }
    try {
        const res = await fetch(`${SERVER}/api/ticker-search?q=${encodeURIComponent(query)}`);
        const results = await res.json();
        const top = Array.isArray(results) && results.length > 0 ? results[0] : null;
        if (top && top.symbol && /^[A-Z]{1,5}$/.test(String(top.symbol).toUpperCase())) {
            if (typeof _olMarkResolvedSymbol === 'function')
                _olMarkResolvedSymbol(String(top.symbol));
            if (input)
                input.value = String(top.symbol).toUpperCase();
            if (typeof closeSuggest === 'function')
                closeSuggest();
            addTicker();
        }
        else {
            showToast('No matching ticker for "' + query + '"');
        }
    }
    catch (e) {
        showToast('Could not look up "' + query + '"');
    }
}
function addTicker() {
    const input = document.getElementById('ticker-input');
    if (!input)
        return;
    const raw = input.value.trim();
    if (!raw)
        return;
    const t = raw.toUpperCase();
    // P3-25 / PQA-3: a clean ticker is 1-5 uppercase letters. Anything else -- a
    // company name like "Danaos" or "Spotify", or a longer symbol -- is resolved
    // to a ticker via search before adding. Numbers/punctuation that match
    // nothing surface a "no match" toast.
    // Mobile audit 2026-09-25 (search): the SHAPE is no longer the verdict --
    // APPLE, TESLA, INTEL are 5-letter names. A symbol-shaped string is taken as
    // a symbol here only when it is already known on this page (an open tab, a
    // loaded payload, or resolved by the catalog / a picked suggestion);
    // everything else goes through the name-first resolver above.
    // OWNER R-CASE-DECIDES (2026-09-25): the known-symbol shortcut is for input
    // typed in ALL-CAPS only; "ford" searches names first even with FORD open.
    if (!(/^[A-Z]{1,5}$/.test(raw) && (tickers.includes(t) || dataCache[t] || (typeof _olIsResolvedSymbol === 'function' && _olIsResolvedSymbol(t))))) {
        _resolveTickerByName(raw);
        return;
    }
    // No ticker cap on any tier (OWNER 2026-09-24; see the note where the
    // client caps object used to be declared near the top of this file).
    input.value = '';
    if (!tickers.includes(t))
        tickers.push(t);
    activeTicker = t;
    // F-01: chart-overlays listens on this event (was 1Hz poll); dispatch on
    // every interactive activeTicker mutation so the overlay can re-fetch.
    try {
        document.dispatchEvent(new CustomEvent('ol:ticker-viewed', { detail: { ticker: t } }));
    }
    catch (e) { }
    if (currentView !== 'ticker')
        setView('ticker');
    renderTabs();
    // Show loading skeleton while fetching new ticker data
    if (!dataCache[t]) {
        _showTickerSkeleton();
        if (typeof LoadingStates !== 'undefined') {
            LoadingStates.showSkeleton('metrics-rows', 'metrics');
            LoadingStates.showSkeleton('chart-panel', 'chart');
            LoadingStates.showAllPanelSkeletons(); // I-25: extend skeleton coverage to all async panels
        }
    }
    fetchTicker(t);
}
function removeTicker() {
    if (!activeTicker) {
        showToast('No ticker selected', 'warning');
        return;
    }
    const t = activeTicker;
    const idx = tickers.indexOf(t);
    if (idx !== -1)
        tickers.splice(idx, 1);
    const pidx = PORTFOLIO_TICKERS.indexOf(t);
    const wasInPortfolio = pidx !== -1;
    if (wasInPortfolio) {
        PORTFOLIO_TICKERS.splice(pidx, 1);
        savePortfolioTickers();
        try {
            fetch('/api/portfolio-positions', { method: 'DELETE', headers: _csrfHeaders(), body: JSON.stringify({ ticker: t }), credentials: 'include' }).catch(function () { });
        }
        catch (e) { }
    }
    const cachedData = dataCache[t];
    delete dataCache[t];
    // S42 task #12 followup: renderNewsView only loads when news view is
    // entered (its chunk is lazy now). Guard so removeTicker works before
    // the user has ever visited /news.
    if (typeof renderNewsView !== 'undefined' && renderNewsView._fetched) {
        renderNewsView._fetched.delete(t);
    }
    // CR-C1 (2026-04-30): use OLPolling handle .clear() instead of raw clearInterval.
    if (phasePollingTimers[t]) {
        var _phHandle = phasePollingTimers[t];
        if (_phHandle && typeof _phHandle.clear === 'function') {
            _phHandle.clear();
        }
        else if (typeof _phHandle === 'number') {
            clearInterval(_phHandle); // legacy fallback (should never happen post-migration)
        }
        delete phasePollingTimers[t];
    }
    activeTicker = tickers[0] || null;
    renderTabs();
    if (activeTicker)
        fetchTicker(activeTicker);
    window._undoTickerState = { ticker: t, idx, pidx, wasInPortfolio, cachedData };
    showToast(`${escHtml(t)} removed — <button data-action="undo-remove-ticker" class="toast-undo-btn">Undo</button>`, '', 10000, { html: true });
}
function undoRemoveTicker() {
    const state = window._undoTickerState;
    if (!state || tickers.includes(state.ticker))
        return;
    const { ticker: t, idx, pidx, wasInPortfolio } = state;
    tickers.splice(idx, 0, t);
    if (wasInPortfolio) {
        PORTFOLIO_TICKERS.splice(pidx, 0, t);
        savePortfolioTickers();
    }
    if (state && state.cachedData)
        dataCache[t] = state.cachedData;
    activeTicker = t;
    // F-01: dispatch on undo-restore so chart-overlays can re-fetch (was 1Hz poll).
    try {
        document.dispatchEvent(new CustomEvent('ol:ticker-viewed', { detail: { ticker: t } }));
    }
    catch (e) { }
    renderTabs();
    fetchTicker(t);
    showToast(`${t} restored`, 'success', 2000);
    window._undoTickerState = null;
}
// ── Promote / Demote ticker between holdings and session ──
function _promoteToHoldings(t) {
    if (!PORTFOLIO_TICKERS.includes(t)) {
        PORTFOLIO_TICKERS.push(t);
        savePortfolioTickers();
        renderTabs();
        showToast(`${escHtml(t)} promoted to holdings`, 'success', 2000);
    }
}
function _demoteToSession(t) {
    const idx = PORTFOLIO_TICKERS.indexOf(t);
    if (idx !== -1) {
        PORTFOLIO_TICKERS.splice(idx, 1);
        savePortfolioTickers();
        renderTabs();
        showToast(`${escHtml(t)} demoted to session`, '', 2000);
    }
}
// ── Navigation history (back/forward) ──
// _navHistory defined in static/js/views.js — do not redeclare
if (typeof _navHistoryIdx === 'undefined')
    var _navHistoryIdx = -1;
if (typeof _navFromHistory === 'undefined')
    var _navFromHistory = false;
var _olBeginnerTourPending = false; // armed at boot (below); the beginner tour anchors to ticker panels, so it fires on the first ticker view
function _navPush(view) {
    if (typeof _olOnViewEnteredForActiveTicker === 'function')
        _olOnViewEnteredForActiveTicker(view); // deferred boot fetch (data-pipeline.ts)
    if (view === 'ticker' && _olBeginnerTourPending) {
        _olBeginnerTourPending = false;
        setTimeout(function () {
            if (currentView !== 'ticker') {
                _olBeginnerTourPending = true;
                return;
            }
            // Mobile audit 2026-09-25 S5: never start over the age bar or the cookie notice (tour-interruptions.ts).
            // Held -> re-armed for the next ticker view, and started once both are dismissed if still on a ticker view.
            if (typeof _olHoldTourForNotices === 'function' && _olHoldTourForNotices(function () {
                if (_olBeginnerTourPending && currentView === 'ticker') {
                    _olBeginnerTourPending = false;
                    _startGuidedTour();
                }
            })) {
                _olBeginnerTourPending = true;
                return;
            }
            _startGuidedTour();
        }, 2500);
    }
    if (_navFromHistory)
        return;
    // If we navigated back and then go to a new view, truncate forward history
    if (_navHistoryIdx < _navHistory.length - 1) {
        _navHistory.length = _navHistoryIdx + 1;
    }
    // Don't push duplicates
    if (_navHistory[_navHistory.length - 1] === view)
        return;
    _navHistory.push(view);
    _navHistoryIdx = _navHistory.length - 1;
    _navUpdateButtons();
}
function _navBack() {
    if (_navHistoryIdx <= 0)
        return;
    _navHistoryIdx--;
    _navFromHistory = true;
    setView(_navHistory[_navHistoryIdx]);
    _navFromHistory = false;
    _navUpdateButtons();
}
function _navForward() {
    if (_navHistoryIdx >= _navHistory.length - 1)
        return;
    _navHistoryIdx++;
    _navFromHistory = true;
    setView(_navHistory[_navHistoryIdx]);
    _navFromHistory = false;
    _navUpdateButtons();
}
function _navUpdateButtons() {
    const backBtn = document.getElementById('nav-back-btn');
    const fwdBtn = document.getElementById('nav-fwd-btn');
    if (backBtn)
        backBtn.classList.toggle('btn-disabled', _navHistoryIdx <= 0);
    if (fwdBtn)
        fwdBtn.classList.toggle('btn-disabled', _navHistoryIdx >= _navHistory.length - 1);
}
// Wire up Alt+Left / Alt+Right keyboard shortcuts for navigation
document.addEventListener('keydown', (e) => {
    if (e.altKey && e.key === 'ArrowLeft') {
        e.preventDefault();
        _navBack();
    }
    if (e.altKey && e.key === 'ArrowRight') {
        e.preventDefault();
        _navForward();
    }
    // a11y (CR-2026-04-25): Enter/Space on `role="button"` elements that
    // have a `data-action` should fire the same click flow keyboard
    // users expect. Without this, divs like #gloss-tooltip or
    // #peers-panel's panel-title are tab-focusable but keyboard-dead.
    // Skip when modifier keys are held so we don't shadow OS shortcuts.
    if ((e.key === 'Enter' || e.key === ' ') && !e.ctrlKey && !e.metaKey && !e.altKey) {
        var target = e.target;
        if (target && target.getAttribute &&
            target.getAttribute('role') === 'button' &&
            target.hasAttribute('data-action')) {
            var tag = target.tagName;
            // Real buttons + links handle Enter natively; skip those to avoid
            // double-firing.
            if (tag !== 'BUTTON' && tag !== 'A' && tag !== 'INPUT') {
                e.preventDefault();
                target.click();
                return;
            }
        }
    }
    // S7: screener keyboard shortcuts — only when the screener view is
    // active AND the user isn't typing in an input/textarea/contenteditable.
    // Modifier keys (ctrl/cmd/alt) are ignored so we don't steal from OS
    // shortcuts.
    if (e.ctrlKey || e.metaKey || e.altKey)
        return;
    var activeTag = document.activeElement ? document.activeElement.tagName : '';
    if (activeTag === 'INPUT' || activeTag === 'TEXTAREA' || activeTag === 'SELECT')
        return;
    if (document.activeElement && document.activeElement.isContentEditable)
        return;
    var activeView = document.body.getAttribute('data-view') || '';
    // Permissive match — the SPA writes either 'screener' or the full view
    // class onto body/document in various paths. Checking presence of a
    // screener-view element that's actually visible is more reliable.
    var scrView = document.getElementById('screener-mf-view');
    var screenerVisible = scrView && scrView.offsetParent !== null;
    if (!screenerVisible)
        return;
    if (e.key === 'r' || e.key === 'R') {
        // "Run": trigger SCREEN button.
        e.preventDefault();
        if (typeof runScreener === 'function')
            runScreener();
    }
    else if (e.key === 'c' || e.key === 'C') {
        // "Clear": clear the active preset + filters.
        e.preventDefault();
        if (typeof _clearScreenerPreset === 'function')
            _clearScreenerPreset();
    }
    else if (e.key === '/') {
        // Focus the sector select (closest thing to a search field in the screener).
        var sec = document.getElementById('scr-sector');
        if (sec) {
            e.preventDefault();
            sec.focus();
        }
    }
});
// Browser back/forward button support via popstate
window.addEventListener('popstate', function (e) {
    if (e.state && e.state.view) {
        setView(e.state.view, true);
    }
    else {
        // N6 (mobile/tablet audit 2026-09-25): an entry with no router state is the
        // browser's own entry (a hash jump, a pre-router URL). Ignoring it made Back
        // a dead press: the URL changed under the user and the view did not. Read the
        // view the URL names -- ?view=, else a ticker deep-link, else the Markets
        // default -- and switch only when it differs from the view on screen, so a
        // hash-only step never re-renders. Contract:
        // tests/test_mobile_audit_n6_history_contract.py.
        try {
            var _psParams = new URLSearchParams(window.location.search);
            var _psView = _psParams.get('view')
                || ((_psParams.get('symbol') || _psParams.get('ticker') || _psParams.get('t')) ? 'ticker' : '')
                || 'macro';
            if (_psView !== currentView)
                setView(_psView, true);
        }
        catch (_e) { /* history fallback is best-effort */ }
    }
    // CHAOS 2026-10-26: setView restores no symbol, and Back no longer re-writes the URL to the on-screen ticker -- so a ticker entry switches to the symbol it names.
    try {
        var _psSym = typeof olNormalizeTicker === 'function' ? olNormalizeTicker(new URLSearchParams(window.location.search).get('symbol') || '') : '';
        if (_psSym && (currentView === 'ticker' || currentView === 'fundamentals') && _psSym !== activeTicker && typeof switchTicker === 'function')
            switchTicker(_psSym);
    }
    catch (_e) { /* best-effort */ }
});
// ── Customize tickers (opens onboarding overlay for editing) ──
var _onboardFocusCleanup = null;
function openCustomizeTickers() {
    var overlay = document.getElementById('onboard-overlay');
    if (!overlay)
        return;
    overlay.classList.add('open');
    // S49 A11y P1 — trap keyboard focus inside the overlay.
    if (typeof trapFocus === 'function' && !_onboardFocusCleanup) {
        _onboardFocusCleanup = trapFocus(overlay);
    }
}
function _closeOnboardOverlay() {
    var overlay = document.getElementById('onboard-overlay');
    if (overlay)
        overlay.classList.remove('open');
    if (_onboardFocusCleanup) {
        _onboardFocusCleanup();
        _onboardFocusCleanup = null;
    }
}
// ── Onboarding button handlers ──
document.getElementById('ob-launch-btn')?.addEventListener('click', function () {
    const inputs = document.querySelectorAll('#ob-inputs-container .ob-input');
    const newTickers = [];
    inputs.forEach(inp => {
        const val = (inp.value || '').trim().toUpperCase();
        if (val && /^[A-Z][A-Z0-9.-]{0,9}$/.test(val))
            newTickers.push(val);
    });
    if (newTickers.length > 0) {
        PORTFOLIO_TICKERS.length = 0;
        newTickers.forEach(t => PORTFOLIO_TICKERS.push(t));
        tickers = [...new Set(PORTFOLIO_TICKERS)];
        activeTicker = PORTFOLIO_TICKERS[0];
        savePortfolioTickers();
    }
    // Close overlay (+ focus-trap cleanup) and reload data
    _closeOnboardOverlay();
    if (newTickers.length > 0)
        location.reload();
});
document.getElementById('ob-skip-btn')?.addEventListener('click', function () {
    // Close overlay — keep current/default portfolio
    _closeOnboardOverlay();
});
// ── Onboarding ticker inputs: Enter key moves to next input or saves ──
document.querySelectorAll('#ob-inputs-container .ob-input').forEach(function (inp, idx, all) {
    inp.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            inp.value = (inp.value || '').trim().toUpperCase();
            if (idx < all.length - 1) {
                all[idx + 1].focus();
            }
            else {
                document.getElementById('ob-launch-btn')?.click();
            }
        }
    });
    // Auto-uppercase on blur
    inp.addEventListener('blur', function () {
        inp.value = (inp.value || '').trim().toUpperCase();
    });
});
// ── Onboarding presets (one-click portfolio setup) ──
function _obPreset(tickerList) {
    if (!tickerList || !Array.isArray(tickerList) || tickerList.length === 0) {
        if (typeof showToast === 'function')
            showToast('No tickers in this preset — try another or enter your own', 'warning', 3000);
        return;
    }
    const inputs = document.querySelectorAll('#ob-inputs-container .ob-input');
    // Fill inputs with preset tickers
    tickerList.forEach((t, i) => {
        if (inputs[i])
            inputs[i].value = t;
    });
    // Clear remaining inputs
    for (let i = tickerList.length; i < inputs.length; i++) {
        if (inputs[i])
            inputs[i].value = '';
    }
    // Highlight the selected preset button, deselect others
    var obPresets = document.querySelectorAll('#onboard-overlay .ob-preset');
    obPresets.forEach(function (btn) {
        var btnTickers;
        try {
            btnTickers = JSON.parse(btn.dataset.tickers || '[]');
        }
        catch (e) {
            btnTickers = [];
        }
        if (JSON.stringify(btnTickers) === JSON.stringify(tickerList)) {
            btn.classList.add('ob-selected');
        }
        else {
            btn.classList.remove('ob-selected');
        }
    });
    if (typeof showToast === 'function')
        showToast('Preset loaded — click Save & reload to apply', 'success', 2000);
}
// ── Dismiss Berkshire CTA ──
function dismissBuffettCta() {
    var el = document.getElementById('buffett-cta');
    if (el)
        el.classList.add('d-none');
    try {
        OLStorage.setString('buffettCtaDismissed', '1');
    }
    catch (e) { }
}
// ── RESEARCH MODE (text-first layout) ──
var _researchMode = false;
function toggleResearchMode() {
    _researchMode = !_researchMode;
    var chartPanel = document.getElementById('chart-panel') || document.querySelector('.chart-container');
    var tickerView = document.getElementById('ticker-view');
    if (_researchMode) {
        // Hide chart, expand text panels
        if (chartPanel)
            chartPanel.classList.add('d-none');
        if (tickerView)
            tickerView.classList.add('research-mode');
        showToast('Research mode ON — chart hidden, text panels expanded (press G to toggle)', 'info');
    }
    else {
        if (chartPanel)
            chartPanel.classList.remove('d-none');
        if (tickerView)
            tickerView.classList.remove('research-mode');
        showToast('Research mode OFF — chart restored', 'info');
    }
    // Achievement: research mode
    if (typeof trackUniqueAchievement === 'function')
        trackUniqueAchievement('research_mode_uses', new Date().toDateString());
}
// API keys panel -- extracted to static/js/api-keys.js
// B-44: Use a named handler + guard to ensure only one keydown listener on ticker-input
var _suggestIdx = -1;
function _tickerInputKeydown(e) {
    const items = suggestEl.querySelectorAll('.suggest-item');
    if (items.length > 0 && suggestEl.classList.contains('d-block')) {
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            _suggestIdx = Math.min(_suggestIdx + 1, items.length - 1);
            _highlightSuggest(items);
            return;
        }
        if (e.key === 'ArrowUp') {
            e.preventDefault();
            _suggestIdx = Math.max(_suggestIdx - 1, 0);
            _highlightSuggest(items);
            return;
        }
        if (e.key === 'Enter') {
            e.preventDefault();
            if (_suggestIdx >= 0) {
                selectSuggest(items[_suggestIdx].dataset.sym);
            }
            else {
                addTicker();
                closeSuggest();
            }
            return;
        }
    }
    if (e.key === 'Enter') {
        addTicker();
        closeSuggest();
    }
    if (e.key === 'Escape')
        closeSuggest();
}
const _tickerInputEl = document.getElementById('ticker-input');
if (_tickerInputEl && !_tickerInputEl._keydownBound) {
    _tickerInputEl.addEventListener('keydown', _tickerInputKeydown);
    _tickerInputEl._keydownBound = true;
    // ARIA combobox pattern
    _tickerInputEl.setAttribute('role', 'combobox');
    _tickerInputEl.setAttribute('aria-autocomplete', 'list');
    _tickerInputEl.setAttribute('aria-expanded', 'false');
    _tickerInputEl.setAttribute('aria-controls', 'ticker-suggest');
}
function _highlightSuggest(items) {
    items.forEach((el, i) => {
        el.classList.toggle('suggest-active', i === _suggestIdx);
        el.setAttribute('aria-selected', i === _suggestIdx ? 'true' : 'false');
    });
    // Update aria-activedescendant on the input
    if (_tickerInputEl && _suggestIdx >= 0 && items[_suggestIdx]) {
        var activeId = 'suggest-opt-' + _suggestIdx;
        items[_suggestIdx].id = activeId;
        _tickerInputEl.setAttribute('aria-activedescendant', activeId);
    }
    else if (_tickerInputEl) {
        _tickerInputEl.removeAttribute('aria-activedescendant');
    }
}
// Typeahead search
var _suggestTimer = null;
var _suggestAbort = null; // S33: cancel stale search requests
const suggestEl = document.getElementById('ticker-suggest');
document.getElementById('ticker-input')?.addEventListener('input', e => {
    const q = e.target.value.trim();
    clearTimeout(_suggestTimer);
    if (_suggestAbort) {
        _suggestAbort.abort();
        _suggestAbort = null;
    }
    if (!q || q.length < 1 || !isLive) {
        closeSuggest();
        return;
    }
    // Show "Searching..." immediately while debounce waits
    suggestEl.innerHTML = '<div class="suggest-searching">Searching\u2026</div>';
    suggestEl.classList.remove('d-none');
    suggestEl.classList.add('d-block');
    _suggestTimer = setTimeout(async () => {
        try {
            _suggestAbort = new AbortController();
            const res = await fetch(`${SERVER}/api/ticker-search?q=${encodeURIComponent(q)}`, { signal: _suggestAbort.signal });
            const results = await res.json();
            if (!Array.isArray(results) || results.length === 0) {
                suggestEl.innerHTML = '<div class="suggest-no-results">No results found</div>';
                suggestEl.classList.remove('d-none');
                suggestEl.classList.add('d-block');
                return;
            }
            _suggestIdx = -1;
            suggestEl.setAttribute('role', 'listbox');
            suggestEl.innerHTML = results.map((r, i) => `<div class="suggest-item" role="option" id="suggest-opt-${i}" data-sym="${escHtml(r.symbol)}" data-action="select-suggest">
          <span class="suggest-item-sym">${escHtml(r.symbol)}</span>
          <span class="suggest-item-name">${escHtml(r.name)}</span>
        </div>`).join('');
            suggestEl.classList.remove('d-none');
            suggestEl.classList.add('d-block');
            if (_tickerInputEl)
                _tickerInputEl.setAttribute('aria-expanded', 'true');
        }
        catch (err) {
            // On abort (user kept typing), leave the "Searching…" state — a new request is in flight.
            // On timeout or network error, show a user-visible "No results" message.
            if (err && err.name !== 'AbortError') {
                suggestEl.innerHTML = '<div class="suggest-no-results">No results found</div>';
                suggestEl.classList.remove('d-none');
                suggestEl.classList.add('d-block');
            }
        }
    }, 300);
});
function selectSuggest(sym) {
    const _tickerEl = document.getElementById('ticker-input');
    if (_tickerEl)
        _tickerEl.value = sym;
    // A picked suggestion IS a symbol; skip the name-first resolver (2026-09-25).
    if (typeof _olMarkResolvedSymbol === 'function')
        _olMarkResolvedSymbol(sym);
    closeSuggest();
    addTicker();
}
function closeSuggest() {
    if (!suggestEl)
        return;
    suggestEl.classList.add('d-none');
    suggestEl.classList.remove('d-block');
    suggestEl.textContent = '';
    _suggestIdx = -1;
    if (_tickerInputEl) {
        _tickerInputEl.setAttribute('aria-expanded', 'false');
        _tickerInputEl.removeAttribute('aria-activedescendant');
    }
}
document.getElementById('ticker-input')?.addEventListener('blur', () => { setTimeout(closeSuggest, 200); });
// ── Onboarding typeahead for .ob-input fields ──
(function initObTypeahead() {
    let _obTimer = null;
    let _obActiveDD = null;
    function closeObSuggest() {
        if (_obActiveDD) {
            _obActiveDD.remove();
            _obActiveDD = null;
        }
    }
    function selectObSuggest(input, sym) {
        input.value = sym;
        closeObSuggest();
        // Auto-focus next empty ob-input
        const inputs = Array.from(document.querySelectorAll('.ob-input'));
        const idx = inputs.indexOf(input);
        for (let i = idx + 1; i < inputs.length; i++) {
            if (!inputs[i].value.trim()) {
                inputs[i].focus();
                break;
            }
        }
    }
    document.getElementById('ob-inputs-container')?.addEventListener('input', function (e) {
        if (!e.target.classList.contains('ob-input'))
            return;
        const input = e.target;
        const q = input.value.trim().toUpperCase();
        clearTimeout(_obTimer);
        closeObSuggest();
        if (!q || q.length < 1 || !isLive)
            return;
        // Show "Searching…" loading state immediately while debounce waits
        closeObSuggest();
        const loadingDd = document.createElement('div');
        loadingDd.className = 'csp-dropdown-abs';
        loadingDd.innerHTML = '<div class="ob-suggest-searching">Searching\u2026</div>';
        let loadingContainer = input.parentElement;
        if (!loadingContainer.classList.contains('csp-inline-block-rel')) {
            loadingContainer = document.createElement('div');
            loadingContainer.className = 'csp-inline-block-rel';
            input.parentNode.insertBefore(loadingContainer, input);
            loadingContainer.appendChild(input);
        }
        loadingContainer.appendChild(loadingDd);
        _obActiveDD = loadingDd;
        _obTimer = setTimeout(async () => {
            try {
                const res = await fetch(`${SERVER}/api/ticker-search?q=${encodeURIComponent(q)}`, { signal: AbortSignal.timeout(5000) });
                const results = await res.json();
                closeObSuggest();
                if (!Array.isArray(results) || results.length === 0) {
                    const noDD = document.createElement('div');
                    noDD.className = 'csp-dropdown-abs';
                    noDD.innerHTML = '<div class="ob-suggest-no-results">No results found</div>';
                    input.parentElement.appendChild(noDD);
                    _obActiveDD = noDD;
                    return;
                }
                const dd = document.createElement('div');
                dd.className = 'csp-dropdown-abs';
                dd.innerHTML = results.slice(0, 8).map(r => `<div class="ob-suggest-item" data-sym="${escHtml(r.symbol)}">
            <span class="ob-suggest-item-sym">${escHtml(r.symbol)}</span>
            <span class="ob-suggest-item-name">${escHtml(r.name)}</span>
          </div>`).join('');
                // Wrap input in a relative container if not already
                let container = input.parentElement;
                if (!container.classList.contains('csp-inline-block-rel')) {
                    container = document.createElement('div');
                    container.className = 'csp-inline-block-rel';
                    input.parentNode.insertBefore(container, input);
                    container.appendChild(input);
                }
                container.appendChild(dd);
                _obActiveDD = dd;
                dd.addEventListener('mousedown', function (ev) {
                    const item = ev.target.closest('.ob-suggest-item');
                    if (item) {
                        ev.preventDefault();
                        selectObSuggest(input, item.dataset.sym);
                    }
                });
            }
            catch (err) {
                closeObSuggest();
                if (err && err.name !== 'AbortError') {
                    const errDD = document.createElement('div');
                    errDD.className = 'csp-dropdown-abs';
                    errDD.innerHTML = '<div class="ob-suggest-no-results">No results found</div>';
                    input.parentElement.appendChild(errDD);
                    _obActiveDD = errDD;
                }
            }
        }, 300);
    });
    document.getElementById('ob-inputs-container')?.addEventListener('keydown', function (e) {
        if (!e.target.classList.contains('ob-input'))
            return;
        if (e.key === 'Escape')
            closeObSuggest();
        if (e.key === 'Enter') {
            e.preventDefault();
            closeObSuggest();
            // Auto-advance to next empty input
            const inputs = Array.from(document.querySelectorAll('.ob-input'));
            const idx = inputs.indexOf(e.target);
            for (let i = idx + 1; i < inputs.length; i++) {
                if (!inputs[i].value.trim()) {
                    inputs[i].focus();
                    return;
                }
            }
        }
    });
    document.getElementById('ob-inputs-container')?.addEventListener('focusout', function (e) {
        if (e.target.classList.contains('ob-input')) {
            setTimeout(closeObSuggest, 200);
        }
    });
})();
var _loadingDegradeTimer = null;
function setLoading(show, msg = 'FETCHING DATA...') {
    const el = document.getElementById('loading-overlay');
    if (!el)
        return;
    const msgEl = document.getElementById('loading-msg');
    if (msgEl)
        msgEl.textContent = msg;
    el.classList.toggle('hidden', !show);
    // Cancel link
    let cancelEl = el.querySelector('.loading-cancel');
    if (show && !cancelEl) {
        cancelEl = document.createElement('a');
        cancelEl.className = 'loading-cancel';
        cancelEl.href = '#';
        cancelEl.textContent = 'Cancel';
        cancelEl.className = 'csp-cancel-link';
        cancelEl.onclick = function (e) { e.preventDefault(); setLoading(false); };
        el.appendChild(cancelEl);
    }
    // Auto-degrade after 10s
    if (_loadingDegradeTimer) {
        clearTimeout(_loadingDegradeTimer);
        _loadingDegradeTimer = null;
    }
    if (show) {
        _loadingDegradeTimer = setTimeout(() => {
            el.classList.add('hidden');
            // Suppressed: loading toast removed for silent data fetching (skeleton states handle UX)
            _loadingDegradeTimer = null;
        }, 10000);
    }
}
function setConnectionStatus(live) {
    const wasLive = isLive;
    isLive = live;
    const banner = document.getElementById('demo-banner');
    if (live) {
        banner.classList.add('d-none');
        banner.classList.remove('d-block');
    }
    else {
        banner.classList.remove('d-none');
        banner.classList.add('d-block');
    }
    // OWNER 2026-09-28: the bottom bar's SOURCE segment (#sb-source, which also
    // read DEMO) is removed; #demo-banner above carries demo state.
    if (live && !wasLive) {
        // Suppressed: routine connection toast removed (connection state is silent).
        // showToast('Connected to server', 'success');
        // Auto-refetch all tickers on reconnect — use setTimeout to yield
        // between sync XHR calls so the browser can paint each ticker's data.
        // renderMarketPulse deferred (uses async fetch which hangs on Render).
        // S27: Fetch only the active ticker, not all session tickers.
        // Bulk fetching consumed all HTTP connections and froze the page.
        // Other tickers load via SSE push or when user clicks them.
        // 2026-10-17: the active one only on a view that reads it (data-pipeline.ts).
        _olFetchActiveTickerForView();
    }
    else if (!live && wasLive)
        showToast('Unable to reach server. Showing demo data.', 'error');
}
// §FETCH-TICKER — extracted to static/js/data-pipeline.js (S37)
// Public API: fetchTicker, refreshCurrent
// ── BROKERAGE DEEP-LINKS & QUICK LINKS ──
// External-link audit H1 (2026-05-10): TD Ameritrade was acquired by Charles
// Schwab and the `research.tdameritrade.com` platform shut down May 2024.
// All TDA accounts migrated to Schwab. The `td:` slot is REMOVED from
// BROKER_URLS + BROKER_NAMES; `_migratePreferredBrokerOnce()` (run once per
// user via the `__ol_brokerMigratedTda` localStorage flag) rewrites any
// stored `'td'` preference to `'schwab'` so a user who had TDA picked
// doesn't see a blank/broken trade button after the deploy.
// External-link audit M1 verification trail (2026-05-10): each entry
// below carries a `VERIFIED YYYY-MM-DD (OWNER)` comment once the URL
// pattern has been confirmed in a logged-in browser session for a real
// ticker. Entries WITHOUT a verified comment are unverified — see
// EXTERNAL_LINK_AUDIT_PROMPT.md M1 for the per-broker concern. As of
// 2026-05-10: schwab confirmed; etrade was previously confirmed in
// audit doc baseline. Other brokers pending OWNER verification.
const BROKER_URLS = {
    // VERIFIED 2026-05-10 (OWNER): post-login lands on AAPL trade page.
    schwab: function (t) { return 'https://client.schwab.com/app/trade/tom/trade?Symbol=' + t; },
    fidelity: function (t) { return 'https://digital.fidelity.com/ftgw/digital/trade-equity/index/orderEntry?SECURITY_ID=' + t; },
    ibkr: function (t) { return 'https://ndcdyn.interactivebrokers.com/sso/Login?forwardTo=22&clt=0&rl=1&ip2loc=US&ns=T&ticker=' + t; },
    robinhood: function (t) { return 'https://robinhood.com/stocks/' + t; },
    etrade: function (t) { return 'https://us.etrade.com/etx/sp/stockscreen#/ticker/' + t; },
    webull: function (t) { return 'https://www.webull.com/quote/' + t; },
    vanguard: function (t) { return 'https://personal1.vanguard.com/ofu/myaccounts/buysell/order?ticker=' + t; },
    merrill: function (t) { return 'https://olui2.fs.ml.com/Publish/ClientApps/CMA2/Trading/EquityOrder.aspx?Symbol=' + t; },
    moomoo: function (t) { return 'https://www.moomoo.com/stock/' + t + '-US'; },
    tastytrade: function (t) { return 'https://trade.tastytrade.com/tt/dashboard/market-overview?underlying-symbol=' + t; },
    public: function (t) { return 'https://public.com/stocks/' + t; },
};
const BROKER_NAMES = {
    schwab: 'Schwab', fidelity: 'Fidelity', vanguard: 'Vanguard', merrill: 'Merrill',
    ibkr: 'Interactive Brokers', robinhood: 'Robinhood', etrade: 'E*TRADE',
    webull: 'Webull', moomoo: 'Moomoo', tastytrade: 'Tastytrade', public: 'Public',
};
// One-shot migration: TDA accounts became Schwab accounts in 2024. Idempotent
// via the `__ol_brokerMigratedTda` flag — runs once per user even on repeated
// page loads.
function _migratePreferredBrokerOnce() {
    try {
        if (OLStorage.getString('__ol_brokerMigratedTda', null) === '1')
            return;
        if (OLStorage.getString('preferredBroker', null) === 'td') {
            OLStorage.setString('preferredBroker', 'schwab');
        }
        OLStorage.setString('__ol_brokerMigratedTda', '1');
    }
    catch (e) { /* QuotaExceededError or storage disabled — migration is best-effort */ }
}
_migratePreferredBrokerOnce();
function _getPreferredBroker() { return OLStorage.getString('preferredBroker', null) || ''; }
function _setPreferredBroker(broker) {
    if (!BROKER_URLS[broker])
        return; // S33: validate against known brokers
    try {
        OLStorage.setString('preferredBroker', broker);
    }
    catch (e) { /* QuotaExceededError — preference not saved */ }
    _rebuildTradeDropdown();
    if (typeof showToast === 'function')
        showToast((BROKER_NAMES[broker] || broker) + ' set as your broker', 'success', 2000);
}
// If user has a preferred broker, TRADE button goes straight there
function _tradeBtnClick(e) {
    e.stopPropagation();
    const pref = _getPreferredBroker();
    const ticker = typeof activeTicker !== 'undefined' ? activeTicker : '';
    if (pref && BROKER_URLS[pref] && ticker) {
        // Direct link to preferred broker
        window.open(BROKER_URLS[pref](ticker), '_blank', 'noopener');
    }
    else {
        // No preference set — show picker
        toggleTradeDropdown(e);
    }
}
function _rebuildTradeDropdown() {
    const dd = document.getElementById('trade-dropdown');
    if (!dd)
        return;
    const pref = _getPreferredBroker();
    const ticker = typeof activeTicker !== 'undefined' ? activeTicker : '';
    let html = '';
    if (pref) {
        // Show current preference with change option
        html += '<div class="broker-dd-header">'
            + 'Your broker: <strong class="broker-dd-pref">' + escHtml(BROKER_NAMES[pref] || pref) + '</strong></div>';
    }
    else {
        html += '<div class="broker-dd-header">'
            + 'Choose your preferred broker:</div>';
    }
    // Broker grid — clean, non-imposing
    for (const [key, name] of Object.entries(BROKER_NAMES)) {
        const url = ticker && BROKER_URLS[key] ? BROKER_URLS[key](ticker) : '#';
        const isPref = key === pref;
        html += '<a href="' + url + '" data-broker="' + key + '" target="_blank" rel="noopener"'
            + (isPref ? ' class="broker-preferred"' : '') + '>'
            + '<span class="broker-icon">' + name.charAt(0) + '</span>' + escHtml(name)
            + (isPref ? '<span class="broker-dd-check">&#10003;</span>' : '<span class="broker-set-pref" data-action="set-preferred-broker" data-broker="' + escHtml(key) + '" title="Set as default">set</span>')
            + '</a>';
    }
    html += '<div class="broker-dd-footer">'
        + 'Click &ldquo;set&rdquo; to make a broker your default. The TRADE button will open it directly. You can change anytime.'
        + '<div class="broker-dd-disclaimer">Oxford Ledge is not affiliated with and does not receive compensation from any broker listed above. Links provided for convenience only.</div>'
        + '</div>';
    dd.innerHTML = html;
}
function updateBrokerageLinks(ticker) {
    if (!ticker)
        return;
    _rebuildTradeDropdown();
    var dd = document.getElementById('trade-dropdown');
    if (dd) {
        var links = dd.querySelectorAll('a[data-broker]');
        links.forEach(function (a) {
            var broker = a.getAttribute('data-broker');
            if (BROKER_URLS[broker])
                a.href = BROKER_URLS[broker](ticker);
        });
    }
    // Update quick-link URLs (hidden anchors, used by Share dropdown)
    var qlBar = document.getElementById('quick-links-bar');
    if (qlBar) {
        var el;
        el = document.getElementById('ql-edgar');
        if (el)
            el.href = 'https://www.sec.gov/cgi-bin/browse-edgar?action=getcompany&company=&CIK=' + ticker + '&type=&dateb=&owner=include&count=40&search_text=&action=getcompany';
        el = document.getElementById('ql-yahoo');
        if (el)
            el.href = 'https://finance.yahoo.com/quote/' + ticker;
        el = document.getElementById('ql-google');
        if (el)
            el.href = 'https://www.google.com/finance/quote/' + ticker;
        el = document.getElementById('ql-seekingalpha');
        if (el)
            el.href = 'https://seekingalpha.com/symbol/' + ticker;
        el = document.getElementById('ql-marketwatch');
        if (el)
            el.href = 'https://www.marketwatch.com/investing/stock/' + ticker.toLowerCase();
        // Also update Share dropdown quick links (hidden until ticker loads)
        el = document.getElementById('ql-share-edgar');
        if (el) {
            el.href = 'https://www.sec.gov/cgi-bin/browse-edgar?action=getcompany&company=&CIK=' + ticker + '&type=&dateb=&owner=include&count=40&search_text=&action=getcompany';
            el.classList.remove('d-none');
        }
        el = document.getElementById('ql-share-yahoo');
        if (el) {
            el.href = 'https://finance.yahoo.com/quote/' + ticker;
            el.classList.remove('d-none');
        }
        el = document.getElementById('ql-share-google');
        if (el) {
            el.href = 'https://www.google.com/finance/quote/' + ticker;
            el.classList.remove('d-none');
        }
        el = document.getElementById('ql-share-seekingalpha');
        if (el) {
            el.href = 'https://seekingalpha.com/symbol/' + ticker;
            el.classList.remove('d-none');
        }
        el = document.getElementById('ql-share-marketwatch');
        if (el) {
            el.href = 'https://www.marketwatch.com/investing/stock/' + ticker.toLowerCase();
            el.classList.remove('d-none');
        }
    }
}
function toggleTradeDropdown(e) {
    e.stopPropagation();
    var dd = document.getElementById('trade-dropdown');
    if (dd)
        dd.classList.toggle('show');
}
document.addEventListener('click', function (e) {
    var dd = document.getElementById('trade-dropdown');
    if (dd && dd.classList.contains('show')) {
        if (!e.target.closest('.trade-dropdown-wrap'))
            dd.classList.remove('show');
    }
    // Dismiss open kms tooltips on outside click (touch accessibility)
    if (!e.target.closest('.kms-item')) {
        document.querySelectorAll('.kms-item.tooltip-visible').forEach(function (el) { el.classList.remove('tooltip-visible'); });
    }
});
// ── SPARKLINE CHARTS ──
// §CHART — extracted to static/js/chart-engine.js (S37)
// Public API: renderComboChart, drawComboChart, toggleIndicator, loadIndicatorState,
// drawIndicatorOverlays, drawRSISubChart, setTickerChartPeriod, setChartMode,
// chartZoom, chartPan, chartResetZoom, exportChartPNG, initChartHover,
// _redrawCombo, fetchTickerChart, _tryAnnualFinancialsFallback
// ── RENDER TICKER DATA ──
// Per-metric data provenance: set value + title with source label
// §RENDER-DATA — extracted to static/js/ticker-renderer.js (S37)
// Public API: renderData, setMetricWithSource, renderOverviewPanel,
// renderKeyMetricsStrip, renderKeyMetricsCard, renderConsensusEstimates,
// updatePhase2Panels, startPhasePolling, updateHeroTimestamp,
// formatFreshnessLabel, toggleHeroDetails, search13fTicker, search13fFund,
// load13fHoldings, fundBadgeHtml, _loadTickerNote, _saveTickerNote
// §VALUATION — extracted to static/js/valuation-calcs.js
// Moat scorecard, research links, anomaly flags -- extracted to static/js/quality-alerts.js
// §DEBT-CREDIT — extracted to static/js/debt-panels.js
// §COMPANY — extracted to static/js/company-panels.js
// §MACRO — extracted to static/js/macro-view.js
// §PEER — extracted to static/js/peer-view.js
// NOTE: renderCapitalAllocation is now defined in valuation-trends.js
// §CALENDAR — extracted to static/js/calendar-view.js
// ── TIMERS & SERVER ──
// F-19 (external code review 2026-05-21 Day-2): the previous shape
// decremented `countdown` by 1000 every tick — kept ticking in
// backgrounded tabs (browser throttles to 1Hz minimum but still
// schedules the DOM write) AND drifted from wall-clock time when the
// browser throttled below 1Hz. Wall-clock fix: store a target Date,
// compute remaining time on each visible tick. `document.hidden`
// guard skips the tick but the target Date stays authoritative,
// so the next visible tick (either from the interval or the
// visibilitychange listener below) acts on the correct remaining time.
// OWNER 2026-09-27: the NEXT REFRESH status-bar segment (#sb-next) that
// painted this countdown as mm:ss was REMOVED as clutter. The tick no
// longer writes any DOM; it only fires refreshCurrent() when the target
// passes on a VISIBLE tab. The hidden-tab guard below is unchanged.
let _countdownTargetMs = 0;
function _countdownTick() {
    countdown = Math.max(0, _countdownTargetMs - Date.now());
    if (document.hidden) {
        // Keep the target authoritative; skip the DOM write while hidden.
        // 2026-09-01 (queue P3, measured live): do NOT refresh while hidden
        // either. This branch was firing full-payload /api/data refreshes
        // (27.6KB measured) into background tabs -- ~60 origin hits/hour/tab
        // on the priciest endpoint, invisible to the user by definition. On
        // return, the visibilitychange listener below calls _countdownTick
        // once; countdown is already <= 0, so the VISIBLE branch refreshes
        // immediately -- the user still never sees stale data, and a hidden
        // tab costs the origin nothing.
        return;
    }
    if (countdown <= 0 && !_olDeferRefreshOffTickerView()) {
        refreshCurrent();
    } // 2026-10-17: deferred off ticker views (data-pipeline.ts)
}
function resetCountdown() {
    _countdownTargetMs = Date.now() + REFRESH_MS;
    countdown = REFRESH_MS;
    refreshTimer = registerInterval('countdown', _countdownTick, 1000);
}
// F-19 visibilitychange: when the tab becomes visible again, fire the
// tick once so a refresh that came due while hidden fires immediately
// on return (the hidden branch above deliberately skipped it).
document.addEventListener('visibilitychange', function () {
    if (!document.hidden && _countdownTargetMs > 0)
        _countdownTick();
});
async function checkServer() {
    // S27: Skip XHR-based server check — SSE stream handles connection.
    // The workerXHR call hangs on Chrome→Render and consumes connection slots.
    setConnectionStatus(true);
    renderTabs();
    return true;
    try {
        var res = await workerXHR('/api/tickers', 10000);
        if (res.status === 200) {
            var result = JSON.parse(res.body);
            if (Array.isArray(result) && result.length > 0) {
                setConnectionStatus(true);
                if (!activeTicker)
                    activeTicker = tickers[0] || result[0];
                renderTabs();
                return true;
            }
        }
    }
    catch (e) {
        _olDebugWarn('[checkServer] error:', e);
    }
    return false;
}
async function init() {
    if (window._swCleanupDone) {
        // 2026-04-11: race against a 1.5s timeout so init() never hangs on the
        // SW cleanup promise. In Chrome incognito, navigator.serviceWorker
        // .getRegistrations() can return a promise that neither resolves nor
        // rejects under some configurations — try/catch doesn't help because
        // there's no rejection, just non-resolution. Without this race, init()
        // hangs forever and the brand skeleton stays on screen with no console
        // errors. The cleanup is best-effort migration logic; if it doesn't
        // finish in 1.5s, init proceeds and the cleanup continues in background.
        try {
            await Promise.race([
                window._swCleanupDone,
                new Promise(function (r) { setTimeout(r, 1500); })
            ]);
        }
        catch (e) { }
    }
    // P1-6: Beginner mode — de-emphasize advanced nav for new users.
    // User-sim 2026-05-06 finding #7 added a live toggle in the topstrip-b
    // (#stock-beginner-toggle) so users can flip between Beginner ↔ Pro
    // without going to settings. The skillLevel localStorage key is the
    // canonical source; both this init block and the toggle handler write
    // through it.
    // F3.8 (SF-23 OWNER ratification 2026-05-07, Q2=REWRITTEN, Q3=advanced):
    //   Pre-fix this returned true for 'beginner' OR 'learner' (OR empty
    //   OR legacy 'LRN'), so the middle "Default / learner" Settings
    //   value was treated as beginner-mode — silent ambiguity per the
    //   audit. Post-fix the canonical value space is BINARY:
    //   'beginner' (= beginner-mode ON) ↔ 'advanced' (= mode OFF).
    //   Legacy 'learner' / 'expert' / 'LRN' values from prior storage
    //   states are normalized to 'advanced' so existing users don't get
    //   trapped in beginner-mode after this commit lands. The empty
    //   string defaults to 'advanced' (NOT beginner) — new users start
    //   in pro mode unless they explicitly opt in via the topstrip
    //   pill or the welcome-overlay door I (beginner door).
    function _isBeginnerSkillLevel(slRaw) {
        var sl = String(slRaw || '').trim();
        return sl === 'beginner';
    }
    function _applyBeginnerMode(beginner) {
        if (beginner) {
            document.body.classList.add('beginner-mode');
        }
        else {
            document.body.classList.remove('beginner-mode');
        }
        // LIVE → MARKETS rename for beginners (less jargon). Restore the
        // LIVE label when leaving beginner mode so the labels stay
        // consistent with the experienced-user vocab.
        var _liveBtn = document.getElementById('view-macro-btn');
        if (_liveBtn) {
            var txt = (_liveBtn.textContent || '').trim();
            if (beginner && txt === 'LIVE')
                _liveBtn.textContent = 'MARKETS';
            else if (!beginner && txt === 'MARKETS')
                _liveBtn.textContent = 'LIVE';
        }
        // (The Advanced/Simplified toggle button was retired 2026-06-02 — its
        // label-sync lived here. beginner mode is still auto-applied above from
        // the skillLevel set by onboarding + adaptive-ui.)
    }
    try {
        var _slInit = OLStorage.getString('skillLevel', null) || '';
        _applyBeginnerMode(_isBeginnerSkillLevel(_slInit));
    }
    catch (e) { }
    // (The Advanced/Simplified topstrip pill click-handler was retired
    // 2026-06-02 — the manual toggle is gone; skillLevel is set by the
    // onboarding quiz + adaptive-ui auto-detection, and _applyBeginnerMode
    // is still invoked on init above from that persisted value.)
    // Digital clock in ET with market open/close indicator
    function isMarketOpen(et) {
        const day = et.getDay(); // 0=Sun, 6=Sat
        if (day === 0 || day === 6)
            return false;
        const hr = et.getHours();
        const min = et.getMinutes();
        const timeMin = hr * 60 + min;
        // NYSE: 9:30 AM - 4:00 PM ET
        return timeMin >= 570 && timeMin < 960;
    }
    function updateClock() {
        const now = new Date();
        const et = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
        const mon = et.toLocaleString('en-US', { month: 'short' }).toUpperCase();
        const day = et.getDate();
        const yr = et.getFullYear();
        let hr = et.getHours();
        const ampm = hr >= 12 ? 'PM' : 'AM';
        hr = hr % 12 || 12;
        const m = et.getMinutes().toString().padStart(2, '0');
        const s = et.getSeconds().toString().padStart(2, '0');
        // Compute market status line
        const totalMin = et.getHours() * 60 + et.getMinutes();
        const secNow = et.getSeconds();
        const OPEN_MIN = 570; // 9:30 AM ET
        const CLOSE_MIN = 960; // 4:00 PM ET
        const day24 = et.getDay();
        const isWeekend = day24 === 0 || day24 === 6;
        let marketLine = '';
        if (isMarketOpen(et)) {
            const minsLeft = CLOSE_MIN - totalMin - (secNow > 0 ? 1 : 0);
            const hLeft = Math.floor(minsLeft / 60);
            const minLeft = minsLeft % 60;
            marketLine = hLeft > 0
                ? `<span class="mkt-status-open">OPEN \u00b7 closes ${hLeft}h ${minLeft}m</span>`
                : `<span class="mkt-status-open">OPEN \u00b7 closes ${minLeft}m</span>`;
        }
        else if (!isWeekend && totalMin < OPEN_MIN) {
            const minsTo = OPEN_MIN - totalMin;
            const hTo = Math.floor(minsTo / 60);
            const minTo = minsTo % 60;
            marketLine = hTo > 0
                ? `<span class="mkt-status-closed">opens in ${hTo}h ${minTo}m</span>`
                : `<span class="mkt-status-closed">opens in ${minTo}m</span>`;
        }
        else {
            let minsToOpen;
            if (isWeekend) {
                const daysUntilMon = (8 - day24) % 7 || 7;
                minsToOpen = daysUntilMon * 1440 - totalMin + OPEN_MIN;
            }
            else {
                minsToOpen = (1440 - totalMin) + OPEN_MIN;
            }
            const hTo = Math.floor(minsToOpen / 60);
            const minTo = minsToOpen % 60;
            marketLine = hTo >= 24
                ? `<span class="mkt-status-closed">opens in ${Math.floor(hTo / 24)}d ${hTo % 24}h</span>`
                : `<span class="mkt-status-closed">opens in ${hTo}h ${minTo}m</span>`;
        }
        const _logoEl = document.getElementById('logo');
        /* eslint-disable ol/no-unescaped-innerhtml-interpolation -- all interpolations are zero-user-input: mon/day/yr/hr/m/s/ampm are Date()-derived date-time scalars and marketLine is a pre-built trusted mkt-status HTML fragment (escHtml would double-escape its <span>) */
        if (_logoEl)
            _logoEl.innerHTML =
                `${mon} ${day}, ${yr}<br>${hr}:${m}:${s} ${ampm} ET<br><span class="logo-market-line">${marketLine}</span>`;
        /* eslint-enable ol/no-unescaped-innerhtml-interpolation */
        const dot = document.getElementById('market-dot');
        if (isMarketOpen(et)) {
            if (dot) {
                dot.className = 'dot live';
                dot.title = 'Market Open';
            }
            _setTopbarLive(true);
        }
        else {
            if (dot) {
                dot.className = 'dot closed';
                dot.title = 'Market Closed';
            }
            _setTopbarLive(false);
        }
    }
    updateClock();
    var _clockMs = (typeof _isMobile !== 'undefined' && _isMobile) ? 30000 : 1000;
    registerInterval('clock', updateClock, _clockMs, true);
    function updateTopbarHeight() {
        // #135 audit (OWNER 2026-06-04): the ONLY top bar is now TopStripB
        // (#ol-topstrip-b, 30px). Chrome A (#topbar) was DELETED from
        // dashboard.html 2026-05-07. The prior code gated on
        // `body[data-chrome="b"]` and, when that flag wasn't set in time,
        // measured the now-absent #topbar and fell back to 80px — setting
        // `--topbar-height: 80px`, which floated #market-pulse-bar (and the
        // lp-drawer / ask-ai panel, all `top: var(--topbar-height)`) ~50px
        // below the 30px bar = the "gap below the locked bar" on every market
        // view. Measure TopStripB directly regardless of the legacy flag;
        // fall back to its 30px design height (never 0, never 80). The
        // historical 0px overlap (audit pair 1, 2026-05-04) is also avoided —
        // offsetHeight on a present, visible TopStripB is 30, not 0.
        const live = document.getElementById('ol-topstrip-b')
            || document.getElementById('topbar'); // legacy fallback (element deleted)
        const h = (live && live.offsetHeight) || 30;
        document.documentElement.style.setProperty('--topbar-height', h + 'px');
    }
    updateTopbarHeight();
    var _topbarResizeRAF = null;
    window.addEventListener('resize', function () {
        if (_topbarResizeRAF)
            return;
        _topbarResizeRAF = requestAnimationFrame(function () {
            _topbarResizeRAF = null;
            updateTopbarHeight();
        });
    });
    // ── THEME + DENSITY (Phase 8 + 9) ──
    // Restore saved preferences on load
    // Note: theme-init.js already applies data-theme before first paint (flash prevention).
    // This block just keeps the icon state in sync once DOM is ready.
    const _savedTheme = OLStorage.getString('ol_theme', null) || (window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark');
    if (_savedTheme === 'light')
        document.documentElement.setAttribute('data-theme', 'light');
    // 2026-04-28 migration: dashboard.html previously sent
    // data-density-value="comfortable" but the CSS rule key is "comfort"
    // (oxford.css:666). Existing users who clicked Comfortable have
    // "comfortable" persisted in localStorage and would render with no
    // density rule applied. Normalize on read.
    let _savedDensity = OLStorage.getString('ol_density', null);
    if (_savedDensity === 'comfortable') {
        _savedDensity = 'comfort';
        try {
            OLStorage.setString('ol_density', _savedDensity);
        }
        catch (_) { }
    }
    if (_savedDensity)
        document.documentElement.setAttribute('data-density', _savedDensity);
    // #63c (SSR<->SPA convergence 2026-05-15, folds in top-bar #5): the
    // theme-toggle icon is now a pure-CSS swap on <html data-theme> via
    // the shared .ol-chrome-theme-ico contract (oxford.css). The old
    // boot-sync IIFE that did `el.textContent = '\u2600'|'\u263E'` on
    // #topbar-theme-toggle + #theme-toggle-btn DESTROYED the declared
    // inline <svg> children on every boot (feedback_never_destroy_dom)
    // and forked the glyph vs the SSR surface. theme-bootstrap.ts has
    // already set <html data-theme> pre-paint, so the correct icon is
    // shown with ZERO JS. Block deleted \u2014 do not reintroduce a
    // textContent/innerHTML write here (gated by
    // tests/test_ssr_chrome_convergence_contract.py).
    window.toggleTheme = function () {
        const current = document.documentElement.getAttribute('data-theme');
        const next = current === 'light' ? 'dark' : 'light';
        if (next === 'dark') {
            document.documentElement.removeAttribute('data-theme');
        }
        else {
            document.documentElement.setAttribute('data-theme', next);
        }
        try {
            OLStorage.setString('ol_theme', next);
        }
        catch (e) { /* QuotaExceededError — theme still applied to DOM */ }
        // #63c: icon is a pure-CSS swap on <html data-theme> (shared
        // .ol-chrome-theme-ico contract) -- no textContent/innerHTML write
        // on #topbar-theme-toggle / #theme-toggle-btn (was destroying the
        // declared <svg> children; feedback_never_destroy_dom). Setting
        // data-theme above is sufficient for the icon to flip.
        if (typeof showToast === 'function')
            showToast(next === 'light' ? 'Light mode' : 'Dark mode', 'info', 1500);
    };
    window.cycleDensity = function () {
        const modes = ['compact', 'default', 'comfort'];
        const current = document.documentElement.getAttribute('data-density') || 'default';
        const idx = modes.indexOf(current);
        const next = modes[(idx + 1) % modes.length];
        document.documentElement.setAttribute('data-density', next);
        try {
            OLStorage.setString('ol_density', next);
        }
        catch (e) { /* QuotaExceededError — density still applied to DOM */ }
        const btn = document.getElementById('density-toggle-btn');
        if (btn)
            btn.textContent = next === 'compact' ? '\u2630' : next === 'comfort' ? '\u2632' : '\u2631'; // ☰ ☲ ☱
        updateTopbarHeight();
    };
    // I-26: keyboard-triggered density cycle — same logic + toast + tracking
    // Cycles: default → compact → comfort → default (matches existing cycleDensity order)
    window._cycleDensityWithToast = function () {
        const modes = ['default', 'compact', 'comfort'];
        const labels = { default: 'Default', compact: 'Compact', comfort: 'Comfortable' };
        const current = document.documentElement.getAttribute('data-density') || 'default';
        const idx = modes.indexOf(current);
        const next = modes[(idx + 1) % modes.length];
        document.documentElement.setAttribute('data-density', next);
        try {
            OLStorage.setString('ol_density', next);
        }
        catch (e) { /* QuotaExceededError — density still applied to DOM */ }
        const btn = document.getElementById('density-toggle-btn');
        if (btn)
            btn.textContent = next === 'compact' ? '\u2630' : next === 'comfort' ? '\u2632' : '\u2631';
        updateTopbarHeight();
        if (typeof showToast === 'function')
            showToast('Density: ' + (labels[next] || next), '', 2000);
        _track('density_toggle', { mode: next });
    };
    // ── WELCOME SCREEN (first visit only, NON-BLOCKING) ──
    // S31: Redesigned to never block init(). Welcome overlay shows on top
    // while data fetches happen in parallel underneath. User can interact
    // with welcome OR dismiss it — either way, data loads immediately.
    // Root cause of S22 hang: await blocked init() when overlay wasn't visible.
    const onboardingDone = OLStorage.getString('onboardingDone', null);
    // 2026-05-14 OWNER bug report: anonymous visitor clicks "Today's reading"
    // tile on welcome page → full nav to /?view=learn&path=X&module=Y →
    // SPA boots → isFirstVisit was TRUE → welcome overlay opens on top of
    // the deep-linked lesson. User saw welcome modal instead of the lesson
    // they intended to read. Per memory/feedback_user_trust (FOUNDATIONAL),
    // perfect accuracy in user-flow trust matters — when a user clicks
    // a specific tile, deliver THAT, not the welcome flow.
    //
    // Detect explicit deep-link intent and skip the welcome overlay.
    // Covers: view=learn&module=X (lesson deep-link), view=learn&path=Y
    // (path landing deep-link), view=ticker&symbol=AAPL (ticker deep-link),
    // view=learn&tab=reading (Ledge Reads / learn-tab deep-link — added
    // 2026-05-18 when the welcome "From the reading list" tile was
    // re-pointed from the SSR /reading-list/ stub to the in-app reading
    // tab; a deep-linked reading visitor must NOT be swallowed by the
    // first-visit welcome overlay — mirrors the lesson-tile fix above).
    // 2026-05-19 (CHAMP P1): also `section` — the live emitters were
    // re-pointed from ?section= to ?tab= (learn-index.html footer-note +
    // news.ts research quick-start), but legacy ?section=reading|lore
    // links still exist in the wild (shared URLs, bookmarks, external
    // refs). `section` is now routed through canonical tab-activation in
    // views.ts:_restoreFromURL, so a section deep-link is real intent
    // and must skip the overlay too (defense-in-depth — covers any
    // ?section= link the emitter sweep didn't catch).
    // Pure first-time visitors with the bare root URL still see the
    // overlay as before.
    let hasDeepLinkIntent = false;
    try {
        const _p = new URLSearchParams(window.location.search);
        // #20 (2026-05-30): ANY ?view= is deep-link intent. A user on a specific
        // view (?view=portfolio, ?view=macro, ...) has navigated INTO the app and
        // must not be bounced to the welcome gallery on a hard refresh. The prior
        // logic required ?view= AND a sub-param (module/path/symbol/tab/section),
        // so a bare `?view=X` refresh fell through to the welcome redirect —
        // OWNER-reported "user getting forced out of the platform."
        hasDeepLinkIntent = !!(_p.get('view') || _p.get('module') || _p.get('path')
            || _p.get('symbol') || _p.get('ticker') || _p.get('t') || _p.get('tab') || _p.get('section')
            // 2026-06-04: explicit auth intent (?signin=1 / ?signup=1) is deep-link
            // intent too — a first-visit anon who clicked "Sign in" on /welcome must
            // NOT be bounced back to /welcome (which drops the param), the cause of
            // the "press Sign in again" double-step. Counting it keeps isFirstVisit
            // false so the ?signin/?signup modal-opener runs on the FIRST click.
            // (Same "don't force the user out of the platform" rationale as #20.)
            || _p.get('signin') || _p.get('signup') || _p.get('panel'));
    }
    catch (_e) { /* defensive — older browsers, treat as no intent */ }
    // #20: a logged-in user is NEVER a first visit — never client-side-bounce
    // them to the welcome gallery. ol_csrf_hmac is the JS-readable authed-
    // session cookie (the HttpOnly ol_session isn't visible to document.cookie;
    // see #29). New registrants are routed to /welcome by the BACKEND
    // (routes_auth_fastapi), not this client-side first-visit fallback.
    let _hasSessionCookie = false;
    try {
        _hasSessionCookie = typeof document !== 'undefined'
            && document.cookie.indexOf('ol_csrf_hmac=') !== -1;
    }
    catch (_e) { /* no document */ }
    const isFirstVisit = !onboardingDone && !hasDeepLinkIntent && !_hasSessionCookie;
    // Remove brand skeleton for returning users (first-visit users get it removed when welcome opens)
    if (!isFirstVisit) {
        var skel = document.getElementById('brand-skeleton');
        if (skel)
            skel.classList.add('hidden');
        // RU-1 (2026-04-26) — re-engagement hook for lapsed returners.
        // The lapsed-returner persona (60+ days since signup) currently
        // lands on whatever view they last used with no acknowledgement
        // that they've been gone. ol_welcome_ts is written on every
        // welcome dismiss but never read. Now: if last visit was
        // >14 days ago, surface a lightweight "Welcome back" toast.
        // Per-session guard via ol_returner_seen so we don't fire on
        // every page reload within the same returning session.
        try {
            var _wts = parseInt(OLStorage.getString('ol_welcome_ts', null) || '0', 10);
            var _seen = OLStorage.getSessionString('ol_returner_seen', null);
            if (_wts > 0 && !_seen && (Date.now() - _wts > 14 * 86400000)) {
                OLStorage.setSessionString('ol_returner_seen', '1');
                // Update the timestamp so the next 14-day window starts now.
                OLStorage.setString('ol_welcome_ts', String(Date.now()));
                setTimeout(function () {
                    if (typeof showToast === 'function') {
                        // Mobile audit 2026-09-25 S10: was "It's been N days -- markets and
                        // lessons have moved without you", which counts the absence back at
                        // the reader. The 14-day window above still decides WHEN this shows;
                        // the day count drove no content, so it is no longer computed.
                        showToast('Welcome back. Pick up wherever you left off.', 'info', 6000);
                    }
                }, 1200);
            }
        }
        catch (e) { }
    }
    // 2026-06-12 audit 6.3: migrate the device-local anonymous watchlist
    // (ol_anon_watchlist, written by static/js/watchlist.ts for signed-out
    // visitors) into the account on the first authed boot. Server-side
    // dedupe: a 400 ("already in watchlist") counts as migrated. The key
    // is cleared only when every row landed (ok or duplicate) so a
    // transient failure retries on the next boot. Best-effort + deferred —
    // never blocks boot.
    if (_hasSessionCookie) {
        setTimeout(function () {
            try {
                var _anonWl = OLStorage.get('ol_anon_watchlist', []);
                if (!Array.isArray(_anonWl) || _anonWl.length === 0)
                    return;
                var _tk = _anonWl
                    .map(function (r) { return (r && r.ticker ? String(r.ticker) : '').toUpperCase(); })
                    .filter(function (t) { return /^[A-Z0-9.\-]{1,8}$/.test(t); })
                    .slice(0, 50);
                if (_tk.length === 0) {
                    OLStorage.remove('ol_anon_watchlist');
                    return;
                }
                var _csrf = (typeof _getCsrfToken === 'function') ? _getCsrfToken() : '';
                // FE review 2026-07-19 P1: this fired up to 50 PARALLEL signal-less
                // POSTs at boot - the self-inflicted-429/pool-saturation class the
                // read-path dedup work just closed, recreated on the write path.
                // Writes can't dedup, but they can chunk: batches of 5, sequential
                // between batches, 10s timeout per request.
                var _postOne = function (t) {
                    return fetch('/api/watchlist', {
                        method: 'POST',
                        credentials: 'same-origin',
                        headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': _csrf },
                        body: JSON.stringify({ action: 'add', ticker: t }),
                        signal: AbortSignal.timeout(10000),
                    }).then(function (r) { return r.ok || r.status === 400; });
                };
                var _migrateChunked = function (tickers) {
                    var acc = [];
                    var idx = 0;
                    var step = function () {
                        if (idx >= tickers.length)
                            return Promise.resolve(acc);
                        var batch = tickers.slice(idx, idx + 5);
                        idx += 5;
                        return Promise.allSettled(batch.map(_postOne)).then(function (rs) {
                            acc = acc.concat(rs);
                            return step();
                        });
                    };
                    return step();
                };
                _migrateChunked(_tk).then(function (results) {
                    var _allLanded = results.every(function (r) {
                        return r.status === 'fulfilled' && r.value === true;
                    });
                    if (_allLanded) {
                        OLStorage.remove('ol_anon_watchlist');
                        if (typeof showToast === 'function') {
                            showToast('Moved ' + _tk.length + ' saved ticker' + (_tk.length === 1 ? '' : 's') + ' to your account watchlist', 'success', 4000);
                        }
                        if (typeof renderWatchlist === 'function') {
                            try {
                                void renderWatchlist();
                            }
                            catch (_e) { /* noop */ }
                        }
                    }
                });
            }
            catch (_e) { /* best-effort — never block boot */ }
        }, 2500);
    }
    if (isFirstVisit) {
        // 2026-05-28 (OWNER directive — Surface 2 kill): the in-app
        // welcome-overlay was retired; first-visit dashboard arrivals now
        // route to the welcome gallery at /welcome (NUS-4.2 welcome-
        // observatory, env-flag OL_FLAG_OBSERVATORY=1 on prod, query-
        // param fallback for local dev). The query-param is appended so
        // local-dev environments without the env var still land on the
        // editorial gallery surface rather than the legacy landing.html.
        //
        // Pre-retirement: this block materialized tmpl-welcome-overlay
        // (now deleted from dashboard.html), attached a focus trap, +
        // wired dismiss handlers. With the template gone, _materializeView
        // would fall through to fetch /static/templates/welcome-overlay.html
        // (404) and paint an error placeholder — a P0 regression. Replacing
        // the materialization with a redirect closes that hidden-sibling
        // gap (FOUNDATIONAL feedback_label_renames_leave_hidden_siblings).
        //
        // OWNER #134 (2026-06-04): first-time ANON visitors now LAND IN-APP.
        // The client-side bounce to /welcome (window.location.replace) that
        // used to fire here was REMOVED per OWNER ratification — the
        // welcome-trace runtime evidence (source='isFirstVisit') showed it was
        // this block kicking a fresh anon out of the dashboard (and dropping
        // the ?signin= intent on the /?signin=1 path — the #120 double-step).
        // We still stamp onboardingDone + ol_welcome_ts so the NEXT load is
        // treated as "returning" (no default-ticker reset) and the returner-
        // toast window starts, then fall through to the in-app dashboard
        // render below.
        //
        // UNCHANGED, deliberately: (a) new REGISTRANTS are still routed to
        // /welcome by the BACKEND (routes_auth_fastapi post-verify); (b) the
        // bare-root `/` SSR still serves the welcome gallery for anon-empty-
        // query (SEO/LCP cold-entry — routes/pages.py serve_welcome). Those
        // are separate surfaces from this client-side dashboard redirect.
        try {
            OLStorage.setString('onboardingDone', '1');
        }
        catch (_e) { }
        try {
            if (!OLStorage.getString('ol_welcome_ts', null)) {
                OLStorage.setString('ol_welcome_ts', String(Date.now()));
            }
        }
        catch (_e) { }
    }
    if (isFirstVisit) {
        // Auto-set default tickers if user didn't pick a preset (or picked empty)
        if (!window._welcomeTickers || window._welcomeTickers.length === 0) {
            PORTFOLIO_TICKERS.length = 0;
            ['AAPL', 'MSFT', 'JPM', 'AMZN', 'JNJ'].forEach(t => PORTFOLIO_TICKERS.push(t));
        }
        tickers = [...new Set(PORTFOLIO_TICKERS)];
        activeTicker = PORTFOLIO_TICKERS[0];
        savePortfolioTickers();
        try {
            OLStorage.setString('onboardingDone', '1');
        }
        catch (e) { }
        // Audit 5.1e: explain default tickers to new users
        setTimeout(function () {
            if (typeof showToast === 'function') {
                showToast('We loaded Apple, Microsoft, JPMorgan, Amazon, and J&J as starter stocks. Change them anytime in your watchlist.', 'info', 6000);
            }
        }, 3000);
        // Show Quick Start cards for first-time users after onboarding
        try {
            _maybeShowQuickStart();
        }
        catch (e) {
            console.warn('[INIT] quickStart error:', e);
        }
        // ── Loading Bridge: show branded transition while fetching first ticker ──
        // R-CTA (OWNER 2026-09-25): a first visit boots Markets (no deep link by definition); only /ticker earns the ticker bridge.
        if (window.location.pathname === '/ticker') {
            try {
                _showLoadingBridge(activeTicker);
            }
            catch (e) {
                console.warn('[INIT] loadingBridge error:', e);
            }
        }
        // BUG FIX 2026-04-25: safety-net auto-dismiss. The bridge is dismissed
        // by renderData() once ticker data lands (ticker-renderer.js); this
        // timeout is the fallback for failure modes where renderData never
        // fires (anonymous user hitting a tier-gated endpoint, network error,
        // etc.). Without it, first-time visitors landed on a permanent
        // "Preparing your research view…" splash with no path forward.
        setTimeout(function () {
            try {
                if (typeof _dismissLoadingBridge === 'function')
                    _dismissLoadingBridge();
            }
            catch (_e) { }
        }, 6000);
        // Skip second splash for first-time users — loading bridge is sufficient
        // (The welcome screen already provided branding; a second splash is redundant)
        const splashEl = document.getElementById('splash-overlay');
        const splashFactEl = document.getElementById('splash-fact');
        // splashEl.classList.add('open'); // DISABLED — loading bridge handles this now
        // S42 task #11: splash template is never materialized for first visits
        // (loading bridge replaces it). splashFactEl/splashEl are null. Null
        // guards make the dead rotation code path harmless. The earlier theory
        // that removing these guards "unmasked a downstream loop" was wrong —
        // that loop was the /api/data 429 retry loop from the middleware bug,
        // fixed by R3 (4f7ec7a8). Confirmed via local testing on 2026-04-11.
        let _splashFactIdx = 0;
        function _rotateSplashFact() {
            if (!splashFactEl)
                return;
            if (_PULSE_TIPS.length === 0) {
                splashFactEl.textContent = 'Fetching macro indicators and treasury yields...';
                return;
            }
            splashFactEl.classList.add('opacity-0');
            splashFactEl.classList.remove('opacity-1');
            setTimeout(() => {
                if (!splashFactEl)
                    return;
                let tip = _PULSE_TIPS[_splashFactIdx % _PULSE_TIPS.length];
                tip = tip.trim();
                // Detect category for label — quote must START with quote mark AND have attribution
                var isQuote = /^[\u201c"]/.test(tip) && /\s[-\u2014]\s[A-Z]/.test(tip);
                var isFeature = /^Press |^The .* tab |^Click |^Hover |^Visit |^Add |^Set /.test(tip);
                var label = isFeature ? 'Tip' : isQuote ? 'Quote' : 'Fact';
                // Strip legacy "OL Fact/Quote:" prefix from data
                tip = tip.replace(/^OL (?:Fact|Quote|Tip):\s*/i, '');
                splashFactEl.innerHTML = '<div class="splash-fact-label">LEDGE ' + label.toUpperCase() + '</div><div>' + escHtml(tip) + '</div>';
                splashFactEl.classList.remove('opacity-0');
                splashFactEl.classList.add('opacity-1');
                _splashFactIdx++;
            }, 250);
        }
        _rotateSplashFact();
        // Scale rotation interval with text length (min 5s, max 12s)
        let _splashTimer = null;
        function _scheduleSplashRotation() {
            if (!splashFactEl)
                return;
            const text = splashFactEl.textContent || '';
            const readTime = Math.max(5000, Math.min(12000, text.length * 50)); // ~50ms per char
            _splashTimer = setTimeout(() => { _rotateSplashFact(); _scheduleSplashRotation(); }, readTime);
        }
        _scheduleSplashRotation();
        // Dismiss splash: min 2s display, then fade out when data ready
        // ALSO: hard timeout of 15s to prevent users getting stuck forever
        const _splashMinTime = new Promise(r => setTimeout(r, 2000));
        let _splashDismissed = false;
        function _dismissSplash() {
            if (_splashDismissed)
                return;
            _splashDismissed = true;
            clearTimeout(_splashTimer);
            if (!splashEl)
                return;
            splashEl.classList.add('fade-out');
            setTimeout(() => {
                splashEl.classList.remove('open', 'fade-out');
            }, 600);
        }
        window._splashReady = async function () {
            await _splashMinTime;
            _dismissSplash();
        };
        // Hard timeout: dismiss splash after 15s no matter what
        setTimeout(async () => { await _splashMinTime; _dismissSplash(); }, 15000);
    }
    // ── STATE PERSISTENCE: restore returning visitor state ──
    // Visit history only where the server allowed it (OWNER ruling 2026-10-13; storage.ts refuses it too).
    try {
        if (typeof OLStorage.visitHistoryAllowed === 'function' && OLStorage.visitHistoryAllowed())
            OLStorage.setString('lastVisitTime', Date.now().toString());
    }
    catch (e) { }
    const savedTicker = OLStorage.getString('lastTicker', null);
    if (savedTicker && tickers.includes(savedTicker)) {
        activeTicker = savedTicker;
    }
    try {
        renderTabs();
    }
    catch (e) {
        console.error('[INIT] renderTabs error:', e);
    }
    if (typeof initChartHover === 'function') {
        try {
            initChartHover();
        }
        catch (e) {
            console.warn('[INIT] initChartHover:', e);
        }
    }
    if (typeof loadIndicatorState === 'function') {
        try {
            loadIndicatorState();
        }
        catch (e) { }
    }
    try {
        _restoreHeroDetails();
    }
    catch (e) {
        console.warn('[INIT] restoreHero:', e);
    }
    // Deferred chunk-dependent init: these functions live in core/research chunks
    // that may not be loaded yet. Run them when available.
    function _deferredChunkInit() {
        if (typeof initIndChartHover === 'function') {
            try {
                initIndChartHover();
            }
            catch (e) { }
        }
        if (typeof initVolSkewHover === 'function') {
            try {
                initVolSkewHover();
            }
            catch (e) { }
        }
    }
    _deferredChunkInit(); // try immediately (works if full bundle loaded)
    // #199 (2026-07-28): expose the deferred init so _loadChunk's onload re-runs
    // it after EVERY chunk load (boot retries AND later view switches). This is
    // what lets the boot gate below stop demanding view-irrelevant globals — a
    // research chunk loaded later by ?view=screener still wires its hover.
    try {
        window._olDeferredChunkInit = _deferredChunkInit;
    }
    catch (_e) { /* defensive */ }
    // F3 (2026-05-12 Code-Review-Cowork audit P0): exponential backoff
    // for deferred chunk retry, replacing the prior 500ms fixed-interval
    // tight loop that thrashed the main thread for up to 10s when a
    // bundle failed to load on flaky 4G. New behaviour:
    //   - delays: 250 / 500 / 1000 / 2000 / 4000 / 4000 ms (6 attempts)
    //   - total time: ~12s upper bound (was 10s thrashing at 2 Hz)
    //   - on final exhaustion: one-time toast + Sentry capture so
    //     silent chunk failures surface to ops
    // #199 (2026-07-28, Sentry BROWSER-C): the gate is VIEW-SCOPED against the
    // LIVE per-view chunk map (_VIEW_CHUNK_MAP, view-router.ts — a bundle
    // global, so read off window). Both gated globals are view-lazy on the live
    // surface: initIndChartHover lives in core-views (loaded for ?view=news)
    // and initVolSkewHover in research (screener/credit/fundamentals/...). The
    // old gate demanded BOTH on EVERY boot — including ?view=ticker, whose
    // chunk set needs neither — so it could only be satisfied by luck (idle
    // prefetch winning the 12s race) and manufactured chunk_retry.exhausted
    // noise on slow networks. Each global is now demanded only when the boot
    // view's own chunk set includes its owning chunk; _loadChunk's onload
    // re-runs _olDeferredChunkInit for every later view-switch load.
    var _bootView = currentView || 'ticker';
    try {
        _bootView = (new URLSearchParams(window.location.search).get('view') || _bootView);
    }
    catch (_e) { /* defensive */ }
    var _bootViewChunks = ['core-views', 'research']; // legacy demand-set if the map is absent
    try {
        var _vcm = window._VIEW_CHUNK_MAP;
        if (_vcm) {
            _bootViewChunks = _vcm[_bootView] || [];
        }
    }
    catch (_e) { /* defensive */ }
    var _needResearch = _bootViewChunks.indexOf('research') >= 0;
    var _needCoreViews = _bootViewChunks.indexOf('core-views') >= 0;
    var _chunksReady = function () {
        return (!_needCoreViews || typeof initIndChartHover === 'function')
            && (!_needResearch || typeof initVolSkewHover === 'function');
    };
    if (!_chunksReady()) {
        var _chunkRetries = 0;
        var _lastChunkErr = null;
        var _CHUNK_BACKOFF_MS = [250, 500, 1000, 2000, 4000, 4000];
        var _scheduleChunkRetry = function () {
            var delay = _CHUNK_BACKOFF_MS[_chunkRetries] || 4000;
            setTimeout(function () {
                // #199 (2026-07-28) REBASE of the #2 (2026-06-02) active-refetch fix:
                // that fix re-attempted through window.OxfordChunks (lazy-loader.ts),
                // which NOTHING on the dashboard shell loads — the branch was dead
                // code, so the loop had been passively re-checking typeof all along
                // (the true BROWSER-C non-recovery). Re-attempt through the LOCAL
                // _loadChunk instead: it is the live loader (manifest-aware, deduped
                // via _chunksLoaded, and its onerror clears the dedup slot so a retry
                // genuinely re-fetches). Only the chunks the boot view NEEDS and
                // whose global is still missing are attempted — including core-views
                // now (view-lazy on the live surface, per _VIEW_CHUNK_MAP; the old
                // "core-loaded + present" assumption this loop carried was wrong).
                try {
                    if (typeof _loadChunk === 'function') {
                        if (_needResearch && typeof initVolSkewHover !== 'function') {
                            _loadChunk('research').then(_deferredChunkInit).catch(function (e) { _lastChunkErr = (e && e.message) ? String(e.message) : String(e); });
                        }
                        if (_needCoreViews && typeof initIndChartHover !== 'function') {
                            _loadChunk('core-views').then(_deferredChunkInit).catch(function (e) { _lastChunkErr = (e && e.message) ? String(e.message) : String(e); });
                        }
                    }
                }
                catch (_e) { /* defensive — fall through to passive re-check */ }
                _deferredChunkInit();
                if (_chunksReady()) {
                    return; // required chunks loaded; success
                }
                _chunkRetries++;
                if (_chunkRetries < _CHUNK_BACKOFF_MS.length) {
                    _scheduleChunkRetry();
                    return;
                }
                // Exhaustion path. #45 (2026-07-09, Sentry chunk_retry.exhausted —
                // 203 events / 22 users): when the failure is DELIVERY-class (the
                // chunk was never fetched or came back empty — the stale-shell-
                // after-deploy signature: the old content-hashed filename no longer
                // exists on disk, so no amount of re-fetching recovers), the only
                // cure is a full reload to pick up the new shell + manifest. Do it
                // ONCE per tab session (sessionStorage loop guard — if the fresh
                // shell ALSO exhausts, fall through to the toast so we never
                // reload-loop). Slow-network timeouts (perf entry present with a
                // real transferSize) keep the old toast — a reload doesn't fix 2G.
                // (a) telemetry enrichment 2026-06-09 (hoisted 2026-07-09 so the
                // stale-shell reload decision below reuses the same diagnostics):
                // resolved chunk URL + resource-timing (a missing perf entry or 0
                // transferSize => never fetched / 404; a long duration => timeout;
                // a present entry => loaded-but-late).
                var _chunkDiagFor = function (name) {
                    try {
                        var logical = 'bundle-' + name + '.min.js';
                        var manifest = _olAssetManifest();
                        var rel = manifest[logical] ? ('/static/js/' + manifest[logical]) : ('/static/js/' + logical);
                        var perf = null;
                        try {
                            var _abs = window.location.origin + rel;
                            var entries = (window.performance && performance.getEntriesByName) ? performance.getEntriesByName(_abs) : [];
                            if (entries && entries.length) {
                                var pe = entries[entries.length - 1];
                                perf = { transferSize: pe.transferSize, encodedBodySize: pe.encodedBodySize, durationMs: Math.round(pe.duration || 0) };
                            }
                        }
                        catch (_pe) { /* perf API unavailable */ }
                        return { url: rel, fromManifest: !!manifest[logical], perf: perf };
                    }
                    catch (_ce) {
                        return { url: null };
                    }
                };
                var _reloadDiagCharts = _chunkDiagFor('charts');
                var _reloadDiagResearch = _chunkDiagFor('research');
                var _looksNeverDelivered = function (d) {
                    return !!(d && d.url && (!d.perf || d.perf.transferSize === 0));
                };
                // #82 (2026-07-12, Safari stale shell): the embedded meta manifest is as
                // stale as the shell HTML, so a post-deploy stale shell points at chunk
                // hashes that 404 and NO re-fetch recovers — only a reload does. The
                // prior reload gate used a `transferSize === 0` HEURISTIC, but Safari's
                // Resource Timing for a 404'd script is unreliable: it both
                // false-NEGATIVES (a true stale shell whose 404 reported a size never
                // reloads → stuck) and false-POSITIVES (a slow-network user gets a
                // pointless reload that can't fix 2G). Confirm staleness POSITIVELY
                // instead: fetch the live asset_manifest.json (cache-busted + no-store,
                // so it beats the /static/ 1h cache + the edge) and diff a chunk's
                // hashed filename against the embedded manifest.
                //   'stale'   => hashes differ → the shell is old → the one-shot reload
                //                is worth it (and picks up the fresh shell + manifest).
                //   'fresh'   => hashes match → the failure is delivery/network, NOT
                //                staleness → skip the reload, go straight to the toast.
                //   'unknown' => manifest unfetchable (offline / parse fail) → fall back
                //                to the old transferSize heuristic (no behaviour change).
                var _confirmShellStale = _olConfirmShellStale; // hoisted 2026-09-26 (shared with the lazy loaders)
                // Toast + Sentry emit, deferred so the async staleness verdict can be
                // tagged before it fires.
                var _emitChunkExhausted = function (shellVerdict) {
                    try {
                        if (typeof showToast === 'function') {
                            showToast('Some chart features did not load — try refreshing the page.', 'warning', 7000);
                        }
                    }
                    catch (_e) { /* defensive */ }
                    try {
                        var _w = window;
                        // Root-causable from Sentry alone: shell_stale (positive
                        // manifest-diff verdict) + delivery/timeout/loaded-but-late perf +
                        // last loadChunk error + network class. A 'fresh' verdict reaching
                        // HERE is a genuine delivery/network failure (a reload wouldn't
                        // help); a 'stale' verdict here means the tab already spent its one
                        // auto-reload and STILL exhausted (fresh shell also failing).
                        var _netInfo = function () {
                            try {
                                var c = navigator.connection;
                                if (!c)
                                    return null;
                                return { effectiveType: c.effectiveType, downlinkMbps: c.downlink, rttMs: c.rtt, saveData: c.saveData };
                            }
                            catch (_ne) {
                                return null;
                            }
                        };
                        var _chunkExtra = {
                            last_chunk_error: _lastChunkErr,
                            charts: _reloadDiagCharts,
                            research: _reloadDiagResearch,
                            net: _netInfo(),
                            shell_stale_verdict: shellVerdict,
                        };
                        var _reloadGuardTs = OLStorage.getSessionString('ol_chunk_auto_reloaded', null);
                        if (_w.Sentry && typeof _w.Sentry.captureMessage === 'function') {
                            _w.Sentry.captureMessage('chunk_retry.exhausted', {
                                level: 'warning',
                                tags: {
                                    missing_initIndChartHover: typeof initIndChartHover !== 'function',
                                    missing_initVolSkewHover: typeof initVolSkewHover !== 'function',
                                    // #199: which view was booting and which globals it actually
                                    // demanded — an exhaustion here is always view-RELEVANT now.
                                    boot_view: _bootView,
                                    required_core_views: _needCoreViews,
                                    required_research: _needResearch,
                                    // true => this tab already spent its one stale-shell auto-
                                    // reload and STILL exhausted (fresh shell also failing).
                                    stale_shell_reload_guarded: !!_reloadGuardTs,
                                    // Positive verdict: stale (hashes differ) / fresh (match) /
                                    // unknown (manifest unfetchable). Splits real stale-shell from
                                    // slow-network in the Sentry aggregate.
                                    shell_stale: shellVerdict,
                                },
                                extra: _chunkExtra,
                            });
                        }
                        else if (_w.Sentry && typeof _w.Sentry.addBreadcrumb === 'function') {
                            _w.Sentry.addBreadcrumb({
                                category: 'app-init',
                                level: 'warning',
                                message: 'chunk_retry.exhausted',
                                data: {
                                    missing_initIndChartHover: typeof initIndChartHover !== 'function',
                                    missing_initVolSkewHover: typeof initVolSkewHover !== 'function',
                                    last_chunk_error: _lastChunkErr,
                                    charts_url: _chunkExtra.charts && _chunkExtra.charts.url,
                                    research_url: _chunkExtra.research && _chunkExtra.research.url,
                                    net: _chunkExtra.net,
                                    shell_stale: shellVerdict,
                                },
                            });
                        }
                    }
                    catch (_e) { /* defensive */ }
                };
                _confirmShellStale().then(function (verdict) {
                    var _stale = (verdict === 'stale')
                        || (verdict === 'unknown'
                            && (_looksNeverDelivered(_reloadDiagCharts) || _looksNeverDelivered(_reloadDiagResearch)));
                    try {
                        var _alreadyAutoReloaded = !!OLStorage.getSessionString('ol_chunk_auto_reloaded');
                        // Reload ONLY if the loop guard persisted (setSessionString returns
                        // false in private mode / quota-exceeded) — without a persisted
                        // guard we cannot prevent a reload loop, so keep the toast path.
                        if (_stale && !_alreadyAutoReloaded
                            && OLStorage.setSessionString('ol_chunk_auto_reloaded', String(Date.now()))) {
                            window.location.reload();
                            return;
                        }
                    }
                    catch (_e) { /* defensive — fall through to toast + capture */ }
                    _emitChunkExhausted(verdict);
                });
            }, delay);
        };
        _scheduleChunkRetry();
    }
    // Set DOB max dynamically so it never goes stale
    var _dobInput = document.getElementById('auth-reg-dob');
    if (_dobInput)
        _dobInput.max = new Date().toISOString().slice(0, 10);
    // M1: hydrate localStorage prefs in one batch right before URL hydration so
    // import-time stays free of disk I/O. Order: defaults → localStorage → URL
    // override. Each read is wrapped in try/catch — Safari private mode and
    // some embedded browsers throw on getItem.
    try {
        var _ls = window.localStorage;
        // Normalize on read: a browser that stored 'custom' before 2026-09-08
        // would resume in a mode computeWeights no longer implements.
        var _wm = _normalizeWeightMode(_ls.getItem('portfolioWeightMode'));
        if (_wm)
            portfolioWeightMode = _wm;
        var _cp = _ls.getItem('chartPeriod');
        if (_cp)
            tickerChartPeriod = _cp;
        // chartMode intentionally not hydrated — candle mode retired; line is the
        // only supported mode (chart-engine.setChartMode forces 'line').
        var _sc = parseInt(_ls.getItem('portfolioSortCol'), 10);
        if (!isNaN(_sc))
            portfolioSortCol = _sc;
        portfolioSortAsc = _ls.getItem('portfolioSortDir') !== 'desc';
    }
    catch (_e) { /* defaults stand */ }
    // Deep link restoration: URL params take priority over localStorage
    const _urlParams = new URLSearchParams(window.location.search);
    const _urlView = _urlParams.get('view');
    const _urlTicker = _urlParams.get('ticker');
    // BOARD Q5 (2026-09-28): `?t=` (a shared-link shape) is an alias for `symbol`
    // on the ticker view; it was ignored, so the reader's LAST ticker rendered.
    const _urlSymbol = _urlParams.get('symbol') || ((!_urlView || _urlView === 'ticker') ? _urlParams.get('t') : null);
    // Markets-1b (2026-07-15): capture the learn module/path deep-link params
    // HERE — before setView() below rewrites the URL to bare ?view=<view>
    // (view-router.ts:1171 strips module/path/src). The consumer that used to
    // handle these lives in views.ts::_restoreFromURL, which compiles into the
    // CORE-VIEWS chunk — but a cold nav to /?view=learn loads ONLY the education
    // chunk, so _restoreFromURL is never defined at boot (the guarded call near
    // 4316 no-ops) and the module deep-link silently drops onto the generic
    // learn home. Re-home the learn deep-link into boot (below), where it always
    // runs; it needs only window globals (_lpData/_lpOpenPath/_lpOpenDrawer, set
    // by the education chunk) + the home-paint DOM gate, no core-views internals.
    const _urlLpModule = _urlParams.get('module');
    const _urlLpPath = _urlParams.get('path');
    // Wave-5 QA (2026-07-17): `tab` too — ?view=learn&tab=reading (the welcome
    // gallery's "From the reading list" tile) silently landed on Modules for
    // the same reason module/path did pre-Markets-1b: the tab consumer lives
    // in views.ts::_restoreFromURL (core-views chunk), never loaded on a cold
    // learn boot. Observed live.
    const _urlLpTab = _urlParams.get('tab');
    const _urlLpSrcRaw = _urlParams.get('src') || '';
    // UX-N7: secondary state — period (chart timeframe) + weight (portfolio mode)
    // both hydrate from URL when present, falling back to localStorage defaults.
    const _urlPeriod = _urlParams.get('period');
    const _urlWeight = _urlParams.get('weight');
    if (_urlPeriod && typeof tickerChartPeriod !== 'undefined') {
        var _validPeriods = ['1d', '5d', '1m', '3m', '6m', '1y', '5y', 'max'];
        if (_validPeriods.indexOf(_urlPeriod) !== -1) {
            tickerChartPeriod = _urlPeriod;
            try {
                OLStorage.setString('chartPeriod', _urlPeriod);
            }
            catch (_e) { }
        }
    }
    if (_urlWeight && typeof portfolioWeightMode !== 'undefined') {
        // Links shared before 2026-09-08 carry ?weight=custom.
        var _wmUrl = _normalizeWeightMode(_urlWeight);
        if (_wmUrl) {
            portfolioWeightMode = _wmUrl;
            try {
                OLStorage.setString('portfolioWeightMode', _wmUrl);
            }
            catch (_e) { }
        }
    }
    // F3.2 (SF-23 audit 2026-05-07): restore the ?signin=1 handler.
    // Pre-fix the only working modal-opener was ?signup=1, so every
    // "Sign in" anchor across the codebase had to route to ?signup=1
    // and rely on the user finding the "Sign in" tab inside the
    // register modal — the cohort the label is for (returning users)
    // got bumped to a signup form first. F5 (2026-04-30) had documented
    // the workaround in _nav.html:22 + ssr_renderer.py:286 with the
    // note "?signin=1 was dead in the main bundle". This commit makes
    // ?signin=1 actually open the modal in sign-in mode; the four
    // "Sign in" anchors revert to ?signin=1 in the same commit.
    if (_urlParams.get('signin') === '1') {
        var _signinTicker = _urlParams.get('ticker');
        // Capture upgrade intent (mirror the ?signup=1 path's contract
        // so post-auth checkout-resume in milestones-view.ts:1907 fires
        // identically whether the user came from a signup or signin URL).
        var _signinUpgradeTier = _urlParams.get('upgrade');
        if (_signinUpgradeTier) {
            try {
                var _signinUpgradePeriod = _urlParams.get('period') || 'monthly';
                OLStorage.setSessionString('ol_upgrade_intent', JSON.stringify({
                    tier: _signinUpgradeTier, period: _signinUpgradePeriod
                }));
            }
            catch (_e) { }
        }
        // Clean URL so reload doesn't re-trigger.
        // 2026-09-26 (WP-D P2): encoded, so a crafted ?ticker= cannot inject extra
        // query parameters into the cleaned URL.
        window.history.replaceState({}, '', window.location.pathname + (_signinTicker ? '?ticker=' + encodeURIComponent(_signinTicker) : ''));
        setTimeout(function () {
            if (typeof authOpenModal === 'function')
                authOpenModal('signin');
            var siTab = document.getElementById('auth-tab-signin');
            if (siTab)
                siTab.click();
        }, 500);
    }
    // ?signup=1 opens registration modal (stock-page CTAs use this,
    // and as of 2026-04-30 F1 fix, pricing.html paid-tier CTAs too).
    if (_urlParams.get('signup') === '1') {
        var _signupTicker = _urlParams.get('ticker');
        // F1 (2026-04-30 PM) — capture upgrade intent so the post-auth
        // checkout-resume in milestones-view.js (~L1638) can fire. The
        // ?signin=1 path on milestones-view.js:1905-1918 already does
        // this; keeping the breadcrumb on the ?signup=1 path means the
        // pricing CTAs ("Start 7-day trial") preserve tier intent
        // through the auth modal → Stripe-checkout flow. Wrapped in
        // try/except because sessionStorage is rejected in some private-
        // browsing modes (Safari) — failure is non-fatal, just degrades
        // to "modal opens, user re-clicks tier on /pricing post-auth."
        var _upgradeTier = _urlParams.get('upgrade');
        if (_upgradeTier) {
            try {
                var _upgradePeriod = _urlParams.get('period') || 'monthly';
                // Use OLStorage.setSessionString wrapper instead of direct
                // OLStorage.setSessionString(ol/no-direct-localstorage rule —
                // baseline 44 → would jump to 45 without this). The wrapper
                // handles JSON serialization + QuotaExceededError on Safari
                // private mode. milestones-view.js's existing ?signin=1
                // handler still uses raw sessionStorage but is on the
                // codemod's deferred list.
                OLStorage.setSessionString('ol_upgrade_intent', JSON.stringify({
                    tier: _upgradeTier, period: _upgradePeriod
                }));
            }
            catch (_e) { }
        }
        // Clean URL so reload doesn't re-trigger. Preserve only the
        // ticker param (intent for stock-page CTAs); upgrade= is now
        // captured in sessionStorage so it doesn't need to ride the URL.
        window.history.replaceState({}, '', window.location.pathname + (_signupTicker ? '?ticker=' + _signupTicker : ''));
        setTimeout(function () {
            if (typeof authOpenModal === 'function')
                authOpenModal('register');
            var regTab = document.getElementById('auth-tab-register');
            if (regTab)
                regTab.click();
        }, 500);
    }
    // SF-MCP-CONNECT-HOWTO T5 (2026-09-13): /?panel=api-keys. Captured HERE (the
    // setView pushState below drops every param but view); acted on by
    // app-renderers.ts:_openApiKeysPanelOnceAuthed AFTER auth resolves.
    if (_urlParams.get('panel') === 'api-keys') {
        // Wave K / K8 (2026-09-13): the Stripe success URL is /?panel=api-keys&agent_plan=success; the flag rides `window` because api-keys.ts (premium chunk, not parsed yet) consumes it on panel open.
        if (_urlParams.get('agent_plan') === 'success') {
            _urlParams.delete('agent_plan');
            window._olAgentPlanReturn = true;
        }
        _urlParams.delete('panel');
        window.history.replaceState({}, '', window.location.pathname + (_urlParams.toString() ? '?' + _urlParams.toString() : '') + window.location.hash);
        setTimeout(function () { if (typeof _openApiKeysPanelOnceAuthed === 'function')
            _openApiKeysPanelOnceAuthed(); }, 500);
    }
    // #102 (2026-06-23 OWNER prod-QA): a BARE ?upgrade=<tier> with NO signin/signup
    // — an in-app "View Plans" / upgrade CTA (e.g. .lp-live-upgrade-btn) clicked by
    // a logged-in user. With no handler the param was ignored and the SPA fell
    // through to the default ticker view (the reported dead CTA: /?upgrade=pro
    // landed on /?view=ticker&symbol=<current>). Route to the canonical plans page,
    // carrying the tier so /pricing can preselect it. We deliberately do NOT
    // auto-fire _startCheckout from a URL param — auth-handlers.ts:884 flags
    // URL-driven checkout as a social-engineering vector; the user confirms the
    // tier on /pricing, which runs the existing gated checkout flow.
    if (_urlParams.get('upgrade') && !_urlParams.get('signup') && !_urlParams.get('signin')) {
        window.location.replace('/pricing/?plan=' + encodeURIComponent(_urlParams.get('upgrade') || ''));
    }
    // ?walkthrough=1 triggers the guided tour for new visitors.
    //
    // Option β PR2 (2026-05-13 CYCLE ratified Q4+Q5): the LANDING-PAGE
    // CTAs no longer pass ?walkthrough=1 (PR1 swapped the hero ghost
    // and footer CTAs to ?from=hero-* analytics params instead). BUT
    // this handler is PRESERVED for opt-in entry points that the CHAOS
    // persona surfaced:
    //   - routes/routes_auth_fastapi.py:576  (Google OAuth callback)
    //   - routes/routes_auth_fastapi.py:607  (GitHub OAuth callback)
    //   - routes/routes_auth_fastapi.py:1021 (email-verify success)
    //   - routes/misc.py:821 + routes/pages.py:1678 (SSR CTA URLs)
    //   - the hamburger "Take the guided walkthrough" entry (PR3)
    //   - manual URL-typed ?walkthrough=1 by users
    //
    // Removing this handler would silently break post-signup tour for
    // every new Google/GitHub registrant with a ReferenceError. OWNER
    // ratified 2026-05-13: keep firing the tour for opted-in entry
    // points; only the auto-fire from landing CTAs was the problem.
    if (_urlParams.get('walkthrough') === '1') {
        // S5 (mobile audit 2026-09-25): an opted-in tour also waits for the age bar / cookie notice to be dismissed.
        setTimeout(function () { if (!(typeof _olHoldTourForNotices === 'function' && _olHoldTourForNotices(_startGuidedTour)))
            _startGuidedTour(); }, 1500);
    }
    else if (!_urlParams.get('walkthrough')) {
        // P4 #3 (06-11 audit) under OWNER Option A (2026-06-12): the beginner
        // walkthrough auto-fires ONCE for beginner-level users with no history,
        // on the first ticker render (the audit's exact recommendation).
        // _startGuidedTour() gates on shouldShow() (done-key + frequency), so it
        // is idempotent; the 2.5s defer lets the first paint settle.
        try {
            var _wfLevel = (typeof OLStorage !== 'undefined' && OLStorage)
                ? (OLStorage.getString('ol_user_level', null) || OLStorage.getString('skillLevel', null))
                : null;
            var _wfDone = (typeof OLStorage !== 'undefined' && OLStorage)
                ? OLStorage.getString('ol_walkthrough_done', null)
                : '1';
            // Mobile audit 2026-09-25 (Builder S hand-off): this ran BEFORE the boot setView, so `currentView` was
            // always its 'ticker' initializer. Armed here; _navPush fires it on the first REAL ticker view (boot or later).
            if (_wfLevel === 'beginner' && !_wfDone)
                _olBeginnerTourPending = true;
        }
        catch (_e) { /* never block boot on tour heuristics */ }
    }
    if (_urlParams.get('walkthrough') === 'replay') {
        // 2026-06-11 audit P1-F3: the SSR pages' "Replay the walkthrough"
        // drawer affordance now links here (the old <button
        // data-action="replay-tour"> was dead on SSR — its handler lives in
        // this bundle, which SSR pages never load). MUST use restart(), not
        // the '1' path above: _startGuidedTour gates on shouldShow(), which
        // is false for anyone who completed the tour — a silent no-op for
        // exactly the users who click "Replay".
        setTimeout(function () {
            var level = (typeof OLStorage !== 'undefined' && OLStorage)
                ? (OLStorage.getString('ol_user_level', null) || OLStorage.getString('skillLevel', null) || 'beginner')
                : 'beginner';
            var w = window;
            function _replayFire() {
                if (w.Walkthrough && typeof w.Walkthrough.restart === 'function') {
                    w.Walkthrough.restart(level);
                }
                else if (w.Walkthrough && typeof w.Walkthrough.start === 'function') {
                    w.Walkthrough.start(level);
                }
            }
            if (w.Walkthrough && typeof w.Walkthrough.restart === 'function') {
                _replayFire();
            }
            else if (typeof w._loadModule === 'function') {
                w._loadModule('walkthrough').then(_replayFire).catch(function () { });
            }
        }, 1500);
    }
    // S44 batch 11: macro view is back in service. Task #12 fixed the three
    // intertwined bugs (CORS preflight loop, microtask recursion in
    // _ensureViewModule, _VIEW_MODULE_MAP double-injection) that caused the
    // original hang. setView() now wraps macro in an 8s soft watchdog that
    // falls back to news only if the view genuinely fails to render. Stale
    // localStorage `lastView=macro` is no longer purged here.
    var savedView = OLStorage.getString('lastView', null);
    // VOICE-10: Goal-based initial view for first-time users
    var _goalViewMap = { learn: 'learn', research: 'ticker', portfolio: 'portfolio', market: 'ticker' };
    var _userGoal = OLStorage.getString('ol_user_goal', null);
    var _goalView = _userGoal && _goalViewMap[_userGoal] ? _goalViewMap[_userGoal] : null;
    // Detect view from URL path (multi-page routing).
    // Entry default (2026-07-14, OWNER): a BARE `/` lands on the Markets
    // (macro) view, NOT a single ticker. The prior S44 ticker-default made
    // entry force-load the user's last/first ticker and fire its heavy lazy
    // chart chunk + /api/data on boot; when that chunk stalled
    // (chunk_retry.exhausted) or the fetch was aborted by the boot view-switch
    // race, entry dead-ended on a full-screen "Request timed out"
    // (ticker_boot_stuck_reload, prod 2026-07-14). Markets is chunk-light and
    // cannot dead-end on a per-ticker fetch. `/ticker` still maps to ticker;
    // setView's macro soft-watchdog falls back to news if macro itself fails.
    // Returning users keep their view via the `?view=` URL the app writes on
    // every switch — only a bare `/` (fresh login / logo / typed URL) hits this.
    var _pathView = {
        '/': 'macro', '/ticker': 'ticker',
        '/news': 'news', '/portfolio': 'portfolio',
        '/watchlist': 'watchlist', '/learn': 'learn',
        '/live': 'macro', '/credit': 'credit',
        '/13f': '13f', '/screener': 'screener',
        '/bdc': 'bdc', '/calendar': 'calendar',
        '/usage': 'usage',
        // 2026-05-19 (CHAMP P3): removed dead '/analytics': 'analytics'.
        // 'analytics' is in NO viewMap/_lazyMap/renderMap/_VIEW_CHUNK_MAP
        // in view-router.ts and there is NO #analytics-view DOM element or
        // tmpl-analytics-view template anywhere. analytics.ts registers a
        // ViewManager renderer but the nav button is dormant (analytics.ts:11
        // "currently dormant — registration kept for future re-introduction").
        // /analytics was only reachable by manually typing the path and
        // resolved to a blank surface (setView paints into nothing). When
        // analytics is genuinely re-introduced, add the DOM + viewMap entry
        // FIRST, then restore this path mapping.
        '/milestones': 'milestones', '/comps': 'comps',
        '/practicum': 'practicum',
        // 2026-06-11 audit P1-F7: routes/pages.py _spa_routes served
        // dashboard.html for these paths but no key existed here, so boot
        // fell back to 'ticker' (or stale lastView) — a shared /macro or
        // /fundamentals URL landed somewhere unrelated with zero feedback.
        // Contract: tests/test_spa_path_view_parity_contract.py pins
        // _spa_routes ⊆ (_pathView ∪ server-side redirects).
        '/macro': 'macro', '/fundamentals': 'fundamentals',
        '/etf-screener': 'etf-screener',
        // 2026-06-19 audit Phase-1: /settings clean URL 404'd while
        // ?view=settings worked. 'settings' is a registered view (viewMap +
        // settings-view.html lazy template); map the path so a shared/typed
        // /settings link resolves instead of falling back to 'ticker'.
        // Paired with "settings" in routes/pages.py _spa_routes (parity-pinned
        // by tests/test_mobile_nav_breakpoint_contract.py).
        '/settings': 'settings'
    };
    // Priority: ?view= param > ticker/symbol deep-link > pathname mapping > lastView (session resume) > ol_default_view (user preference) > 'macro' (Markets) default
    // Wave-2 F4 (2026-07-16 prod-QA): a bare `?ticker=AAPL` (the shape every
    // email digest deep-link + SSR shell CTA emits) was NOT in this chain, so
    // the persisted lastView won, setView rewrote the URL to `?view=<lastView>`
    // and the ticker param was destroyed before any consumer ran. ?ticker= /
    // ?symbol= without an explicit ?view= IS ticker-view intent.
    var _detectedView = _urlView || ((_urlSymbol || _urlTicker) ? 'ticker' : '') || _pathView[window.location.pathname] || savedView || OLStorage.getString('ol_default_view', null) || 'macro';
    try {
        setView(_detectedView);
    }
    catch (e) {
        console.error('[INIT] setView error:', e);
    }
    // S27: Old individual-file loader DISABLED. Chunk-based loading via
    // _ensureViewModule handles this now. Loading individual .js files
    // causes let/const redeclaration crashes with the chunk bundles.
    // Highlight active nav link based on URL path
    document.querySelectorAll('.view-btn').forEach(function (btn) {
        btn.classList.remove('active');
        btn.setAttribute('aria-selected', 'false');
    });
    var _activeBtn = document.querySelector('.view-btn[href="' + window.location.pathname + '"]')
        || document.querySelector('.view-btn[href="/"]');
    if (_activeBtn) {
        _activeBtn.classList.add('active');
        _activeBtn.setAttribute('aria-selected', 'true');
    }
    // Deep link: ?symbol=AAPL loads that ticker and switches to ticker view.
    // Wave-2 F4 (2026-07-16): `?ticker=` coalesces into the same block — it is
    // the param the email digests and SSR shell CTAs emit, and it previously had
    // NO boot consumer (its only handler, views.ts::_restoreFromURL, both isn't
    // loaded on a cold non-ticker boot AND re-reads location.search after
    // setView already stripped the param). ?symbol= wins when both are present.
    // GATED on no explicit non-ticker ?view=: `/?view=bdc&ticker=ARCC` (the BDC
    // SSR CTAs, bdc-detail.html:126) must stay on the bdc view — there the
    // ticker param belongs to the view module, not this block.
    var _deepLinkSymParam = _urlSymbol || ((!_urlView || _urlView === 'ticker') ? _urlTicker : null);
    if (_deepLinkSymParam) {
        var _deepSym = _deepLinkSymParam.trim().toUpperCase();
        if (_deepSym) {
            // X1/P2 (2026-07-14 prod-QA): make the URL symbol AUTHORITATIVE for
            // activeTicker BEFORE the boot fetchTicker(activeTicker) below (~4307)
            // and the checkServer->setConnectionStatus->fetchTicker path (~3001).
            // Previously activeTicker only moved off the PORTFOLIO_TICKERS[0]
            // default as a SIDE EFFECT of addTickerBySymbol->switchTicker, which
            // the free-tier ticker-cap guard (app-renderers.ts:~888) EARLY-RETURNS
            // past. A portfolio holder deep-linking to a non-held symbol while at
            // the cap therefore left activeTicker on the stale default, so the boot
            // fetch fired the ENTIRE per-ticker panel fan-out (data/changes/segments/
            // regulatory/capital-allocation/insiders/institutional-confluence/
            // analyst-estimates/ticker-annotations/company-financials/timeseries)
            // for the wrong ticker (PORTFOLIO_TICKERS[0]) IN ADDITION to the
            // requested one — ~12-15 wasted requests + a 404 + a "chart features did
            // not load" toast, for a symbol the page never asked about. Setting it
            // here first means every boot fetch targets the deep-link symbol and the
            // duplicate fan-out is never issued.
            activeTicker = _deepSym;
            addTickerBySymbol(_deepSym);
            if (currentView !== 'ticker')
                setView('ticker');
        }
    }
    // Restore full URL state (ticker, tabs, periods, etc.)
    if (_urlView || _urlTicker) {
        if (typeof _restoreFromURL === 'function') {
            try {
                _restoreFromURL();
            }
            catch (e) {
                console.warn('[INIT] restoreURL:', e);
            }
        }
    }
    // Markets-1b (2026-07-15): learn module/path deep-link, run at BOOT so it
    // fires even on /?view=learn where core-views (views.ts::_restoreFromURL) is
    // never loaded (see the param-capture note near 4044). Gate on the learn-home
    // PAINT (the `.lp-tab[data-tab="modules"]` tablist emitted inside
    // renderLearningPaths's innerHTML) not merely on _lpData: the slim
    // /api/learning/paths/index data resolves BEFORE the home paints, and a late
    // paint would wipe a too-early-opened drawer. Then re-issue _lpOpenDrawer
    // until #lp-drawer actually carries `.lp-drawer-open` — on a cold boot the
    // slim data makes _lpOpenDrawer take an async hydrate-then-reenter branch, so
    // the first call may not open synchronously and a late learn re-render can
    // preempt it. Self-correcting; re-issues only while closed; bounded ~8s.
    if (_urlView === 'learn' && (_urlLpModule || _urlLpPath || _urlLpTab)) {
        const _lpWin = window;
        const _SRC_ALLOW = ['ssr_learn', 'drip'];
        const _lpSrc = _SRC_ALLOW.indexOf(_urlLpSrcRaw) >= 0 ? _urlLpSrcRaw : '';
        let _lpDlWaitedMs = 0;
        const _lpDlIv = setInterval(function () {
            _lpDlWaitedMs += 100;
            const _dataReady = !!(_lpWin._lpData && _lpWin._lpData.paths);
            const _homeRendered = !!document.querySelector('#learn-view-content .lp-tab[data-tab="modules"]');
            if (_dataReady && _homeRendered) {
                clearInterval(_lpDlIv);
                // Wave-5: tab deep-link — click the rendered tab button so the
                // delegated learn-tab action owns the transition. Gated to tab-only
                // links so a tab paint can't wipe a module/path drawer open below.
                if (_urlLpTab && !_urlLpModule && !_urlLpPath) {
                    const _tabSafe = _urlLpTab.replace(/[^a-z-]/g, '');
                    const _tabBtn = document.querySelector('#learn-view-content .lp-tab[data-tab="' + _tabSafe + '"]');
                    if (_tabBtn) {
                        try {
                            _tabBtn.click();
                        }
                        catch (_e) { /* non-fatal */ }
                    }
                }
                if (_urlLpPath && typeof _lpWin._lpOpenPath === 'function') {
                    try {
                        _lpWin._lpOpenPath(_urlLpPath);
                    }
                    catch (_e) { /* non-fatal */ }
                }
                if (_urlLpModule && _lpWin._lpData && _lpWin._lpData.paths) {
                    // 2026-10-17 (item B): id first, then a slug scoped to `path=`, then
                    // a slug only when unique (learning-paths.ts::
                    // _lpResolveDeepLinkModuleId, bridged with _lpData). The first-match
                    // loop it replaces opened val-8 for intacc-1's shared slug.
                    const _resolvedId = typeof _lpWin._lpResolveDeepLinkModuleId === 'function'
                        ? _lpWin._lpResolveDeepLinkModuleId(_lpWin._lpData.paths, _urlLpModule, _urlLpPath)
                        : null;
                    if (_resolvedId && typeof _lpWin._lpOpenDrawer === 'function') {
                        const _fnDrawer = _lpWin._lpOpenDrawer;
                        const _rid = _resolvedId;
                        const _opts = _lpSrc ? { source: _lpSrc } : undefined;
                        const _openIv = setInterval(function () {
                            const _dq = document.getElementById('lp-drawer');
                            if (!(_dq && _dq.classList.contains('lp-drawer-open'))) {
                                try {
                                    _fnDrawer(_rid, _opts);
                                }
                                catch (_e) { /* non-fatal */ }
                            }
                        }, 500);
                        setTimeout(function () { clearInterval(_openIv); }, 8000);
                    }
                }
            }
            else if (_lpDlWaitedMs > 8000) {
                clearInterval(_lpDlIv);
            }
        }, 100);
    }
    const live = await checkServer();
    /* @__PURE__ */ _olDebug('[INIT] checkServer returned ' + live);
    if (live) {
        // Perf QW-2: fire-and-forget — don't block init on the first fetch.
        // The skeleton/loading state is already visible; renderData fires via
        // the existing pipeline callbacks when data arrives. 2026-10-17: only on a view that reads it.
        _olFetchActiveTickerForView();
        /* @__PURE__ */ _olDebug('[INIT] fetchTicker ' + (_olActiveTickerFetchDeferred ? 'deferred' : 'fired') + ', dataCache has: ' + Object.keys(dataCache).join(','));
        // #152 (2026-06-09): boot stuck-skeleton safety net. The ticker /api/data
        // fetch can be aborted by a boot-time view-switch race (deep-link +
        // _restoreFromURL + fetchTicker each hit switchTicker -> abortViewFetches),
        // OR the research/charts chunk can fail to load on mobile
        // (chunk_retry.exhausted, 307ev/15u) — either way the ticker skeleton
        // strands with no recovery and the user must hard-refresh. If ~13s after
        // boot we are STILL on the ticker view with NO data cached for the active
        // ticker, do a ONE-TIME reload (re-runs boot cleanly + re-fetches the
        // chunk + /api/data). Mirrors the proven _maybeReloadForStaleChunk guard:
        // sessionStorage key makes a reload loop impossible; skip offline + skip
        // the first-visit path (the welcome loading-bridge owns its own watchdog).
        if (!isFirstVisit && !_olActiveTickerFetchDeferred) { // 2026-10-17: a deferred boot is not a stuck boot
            setTimeout(function () {
                try {
                    var _ss = null;
                    try {
                        _ss = window.sessionStorage;
                    }
                    catch (_e) {
                        _ss = null;
                    }
                    if (!_ss)
                        return; // no guard => can't prove loop-safety => don't reload
                    if (_ss.getItem('ol_ticker_stuck_reload'))
                        return; // already tried once this session
                    if (typeof navigator !== 'undefined' && navigator.onLine === false)
                        return;
                    if (currentView !== 'ticker')
                        return; // user navigated away — not stuck
                    if (dataCache && dataCache[activeTicker])
                        return; // data arrived — not stuck
                    _ss.setItem('ol_ticker_stuck_reload', String(Date.now()));
                    var _w = window;
                    try {
                        if (_w.Sentry && typeof _w.Sentry.captureMessage === 'function')
                            _w.Sentry.captureMessage('ticker_boot_stuck_reload', { level: 'warning', tags: { ticker: String(activeTicker) } });
                    }
                    catch (_e) { /* defensive */ }
                    try {
                        if (typeof showToast === 'function')
                            showToast('Reloading…', 'info', 1500);
                    }
                    catch (_e) { /* defensive */ }
                    setTimeout(function () { try {
                        location.reload();
                    }
                    catch (_e) { } }, 400);
                }
                catch (_e) { /* defensive — the watchdog must never throw */ }
            }, 13000);
        }
        if (window._splashReady)
            window._splashReady();
        resetCountdown();
        // renderMarketPulse and _mbCheckAndShow DEFERRED — they use async fetch
        // which hangs on Chrome→Render. Schedule them after a yield so the browser
        // can paint renderData's DOM updates first.
        setTimeout(function () {
            // Defensive: if renderMarketPulse isn't loaded (bundle/chunk failure
            // path), fall through to clear the dashboard.html:416 placeholder so
            // the pulse bar doesn't stay stuck on "Loading market data…".
            var _pulseEl = document.getElementById('pulse-content');
            if (typeof renderMarketPulse === 'function') {
                try {
                    renderMarketPulse();
                }
                catch (e) {
                    if (_pulseEl)
                        _pulseEl.textContent = '';
                }
            }
            else if (_pulseEl) {
                _pulseEl.textContent = '';
            }
            if (typeof _mbCheckAndShow === 'function')
                try {
                    _mbCheckAndShow();
                }
                catch (e) { }
        }, 2000);
    }
    else {
        setConnectionStatus(false);
        renderData(DEMO_DATA['DAC'] || {});
        // Demo mode (server unreachable): renderMarketPulse is gated above on
        // isLive — clear the placeholder here so the pulse bar doesn't sit on
        // "Loading market data…" indefinitely. checkServer() always returns
        // true today (the XHR probe was retired in S27), but keep this branch
        // defensive in case that changes.
        var _pulseDemo = document.getElementById('pulse-content');
        if (_pulseDemo)
            _pulseDemo.textContent = '';
    }
    // Core support modules load on demand when user switches views.
    // Do NOT auto-load — executing 27 modules freezes the page.
    // Deferred analytics: load AFTER page is interactive (5s delay, ~15KB each)
    // These add engagement tracking without impacting initial load.
    setTimeout(function () {
        var _analyticsModules = ['/static/js/funnel-analytics.js', '/static/js/adaptive-ui.js'];
        // Wave-9 QA (2026-07-17): per-deploy ?v= cache-bust — the #70 view-template
        // mechanism, applied to these standalone (non-content-hashed) files. They
        // are served max-age=14400, and the edge kept serving a 12h-stale pre-fix
        // adaptive-ui.js (const emit → window.AdaptiveUI undefined) after the
        // OXFORD-LEDGE-BROWSER-11 deploy. Token from the content-hashed manifest;
        // absent manifest degrades to the bare URL.
        var _av = '';
        try {
            var _avManifest = _olAssetManifest();
            var _avHashed = String(_avManifest['bundle-app-init.min.js'] || _avManifest['bundle.min.js'] || '');
            var _avMatch = _avHashed.match(/\.([0-9a-f]{8})\.min/);
            if (_avMatch)
                _av = _avMatch[1];
        }
        catch (_e) { /* no manifest -> no token */ }
        _analyticsModules.forEach(function (src) {
            // Wave-4 QA (2026-07-17, OXFORD-LEDGE-BROWSER-11): idempotence guard —
            // skip when the module's tag already exists (double timer registration,
            // chunk co-membership). Both modules are also `var`-declared now, so a
            // stray re-eval degrades to a benign binding replace, not a SyntaxError.
            // (prefix ^= match deliberately ignores the ?v= suffix)
            if (document.querySelector('script[src^="' + src + '"]'))
                return;
            var s = document.createElement('script');
            s.src = src + (_av ? '?v=' + _av : '');
            s.async = true; // non-blocking
            document.head.appendChild(s);
        });
    }, 5000);
    // Guided tour deferred — only after welcome overlay is dismissed.
    // Previously fired on isFirstVisit with a 3s delay, which launched the
    // walkthrough BEHIND the welcome screen before the user picked a door.
    // Now triggered by _dismissWelcome → setView → fetchTicker completion path.
    //
    // F-20 Phase 4 P0 fix (2026-05-28): removed the synchronous
    // `renderDailyGoalWidget` mount block that lived here. The
    // `#daily-goal-widget` DOM element was retired by mini-CYCLE #3
    // (dashboard.html line ~1249-1252) and `getElementById(...)` always
    // returned null. Kept the comment trail so the next maintainer
    // touching this region understands the chunk-leak history.
    // Contract test: tests/test_bundle_education_no_leak_contract.py.
    // 2026-09-26 (external review, always-on P2): the 30s `serverReconnect`
    // interval was DELETED. checkServer() hard-codes live (setConnectionStatus
    // + renderTabs, then `return true`), so `nowLive && !isLive` could never hold
    // and every tick, in every tab, only repainted the tab strip.
}
//# sourceMappingURL=app-init.js.map
;
// ═══ app-init-boot-tail.js ═══
;"use strict";
// @ts-nocheck
// QA 2026-09-03: stash the boot hash at PARSE time -- the authed glossary
// deep-link (/glossary/<term> 302 -> /?view=learn&tab=glossary#term-<slug>,
// F-X4/#287e) loses its fragment when app-init's DOMContentLoaded setView
// rewrite runs; learn-panes prefers the live hash, falls back to this
// stash, and consumes both. Module-level here = guaranteed before any
// DOMContentLoaded handler fires (app-init.ts sits at its line budget).
try {
    window._olBootHash = window.location.hash || '';
}
catch (_e) { /* stash best-effort */ }
// ──────────────────────────────────────────────────────────────────────────
// app-init-boot-tail.ts -- #263 D1b cut out of static/js/app-init.ts
// (5,154 -> 4,762 LOC). Sibling of the #262 ask-ai.ts -> ask-ai-research.ts
// extraction (6d2b259a); same method, same rules.
//
// WHY: app-init.ts sat at 5,154 of a 5,200-line budget
// (tools/file_size_budget.json) -- 46 lines of headroom, so the next
// boot-wiring touch would have redded the file-size gate. This cut buys the
// headroom back without going anywhere near the boot core.
//
// WHAT MOVED: the four module-scope blocks that sat AFTER the closing `}` of
// `init()` -- the tail of app-init.ts's module scope. Boot-ADJACENT, not
// boot-core: init(), checkServer(), _loadChunk/_loadModule, the asset-manifest
// helpers and the cross-chunk `var` globals ALL STAY in app-init.ts.
//   1. the 2026-05-10 pre-hydration click delegator for
//      `toggle-feature-sidecar` (the bundle-app-tail load-order race);
//   2. the NH9 generalized top-bar pre-hydration fallback IIFE (nav / theme /
//      panel-control clicks + the `_replayQ` replay queue);
//   3. the SHIP-5 NF-1 Phase 1 mobile bottom-tab mount
//      (window.OLProduct.chrome.mountBottomTab);
//   4. the Board#13 TRIAGE runtime DOM-budget canary (visible-node sampler ->
//      Sentry `dom.budget_breach`).
// ONE subject: everything app-init does at module scope AFTER the boot core is
// defined -- guard the pre-hydration window, mount the late chrome, observe
// boot health.
//
// NOT the `app-tail` chunk. `bundle-app-tail` is app-renderers + the view
// tail; this file is the tail of app-init.ts and ships in `bundle-app-init`.
//
// BYTE-IDENTICAL: lines 4764-5154 of app-init.ts@4b5ee3c0 moved verbatim; the
// parent is exactly its own first 4,762 lines. Nothing reflowed, renamed or
// re-indented -- verified line-for-line against HEAD.
//
// LOAD-ORDER CONTRACT (load-bearing here, unlike the #262 cut): this block is
// 100% module-scope EXECUTED code (three IIFEs + one addEventListener), not a
// set of declarations. It defines nothing the parent consumes, so nothing
// needs it early -- but it must still run at the SAME point in the global
// execution order. build_bundle.py therefore registers app-init-boot-tail.js
// IMMEDIATELY after app-init.js in BOTH JS_MODULES and JS_CHUNKS["app-init"],
// with no file in between: it was the last thing in app-init.ts's module
// scope, so it is now the first thing in the next concatenated segment and the
// observable order is unchanged. It must stay BEFORE view-router.js /
// app-renderers.js -- the latter is what actually calls `init()`
// (app-renderers.ts:4970).
//
// Script mode: build_bundle.py CONCATENATES into one classic script; no
// import/export. Every name this file reads (OLStorage, _delegatedActions,
// _olDebug, window.OLProduct, Sentry) resolves as an ambient global at CALL
// time, never at parse time. `// @ts-nocheck` mirrors app-init.ts -- this code
// was never strict-checked and the move must not change that; the marker MUST
// stay on line 1 to be effective (feedback_ts_nocheck_line_1 class).
// ──────────────────────────────────────────────────────────────────────────
// ──────────────────────────────────────────────────────────────────────────
// Pre-hydration click delegator for critical mobile UX (added 2026-05-10).
//
// User-reported P0 (re-surfaced on 2026-05-10 after first hitting the
// ROADMAP DEFERRED row 2026-05-07): the hamburger sidecar toggle and the
// TOOLS bottom-bar tab don't open on mobile. Static analysis kept passing
// because the markup, full handlers (`_delegatedActions['toggle-feature-
// sidecar']` in app-renderers.ts:2896, `_toggleMobileMoreSheet` in
// mobile-helpers.ts:76), and central click delegator (app-renderers.ts:
// 3466) all check out. The actual cause is a load-order race: those files
// live in `bundle-app-tail` (`<script defer fetchpriority="low">`) and
// `bundle-app-idle` (same), which on a slow mobile network may not parse
// before the user taps. The click goes nowhere, no toast fires (the
// "Loading feature..." fallback is itself in the unloaded delegator), and
// the user concludes the button is broken.
//
// Fix: register a tiny inline click delegator HERE in bundle-app-init
// (the critical-path chunk that always parses first) that handles JUST the
// `toggle-feature-sidecar` action. Self-contained — no calls into
// _delegatedActions / trapFocus / etc. The full handler in app-renderers.ts
// still registers its own `addEventListener('click', ...)` later. To avoid
// double-fire after bundle-app-tail loads, this fallback short-circuits when
// `_delegatedActions[action]` is defined — the full delegator then owns
// the click. Same DOM-toggle behavior as the canonical handler.
//
// Logic mirrors app-renderers.ts (`toggle-feature-sidecar`) minus the
// cross-chunk analytics calls (nice-to-have, not first-tap-critical).
// (The `toggle-mobile-more-sheet` co-handler this block also carried was
// removed 2026-05-31 with the 2g overflow-sheet retirement.)
document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest)
        return;
    var actionEl = t.closest('[data-action]');
    if (!actionEl)
        return;
    var action = actionEl.dataset.action;
    if (action !== 'toggle-feature-sidecar')
        return;
    // Defer to the full delegator once bundle-app-tail's `_delegatedActions`
    // dict has loaded — `toggle-feature-sidecar` (app-renderers.ts) is inline
    // logic fully defined in bundle-app-tail, so it is safe to hand off the
    // moment the dict is present.
    // (The `toggle-mobile-more-sheet` co-handler was removed 2026-05-31 with the
    // 2g overflow-sheet retirement; the hamburger sidecar is the only pre-
    // hydration-critical mobile toggle left.)
    if (typeof _delegatedActions !== 'undefined' && _delegatedActions[action]) {
        return;
    }
    // 2026-06-03: bulletproof single-toggle. The stopImmediatePropagation below
    // only blocks SAME-phase listeners and relies on cross-chunk
    // `_delegatedActions` visibility; when that flakes, app-init + the central
    // dispatcher both toggled the same `d-none` (open→close = net no-op = "dead
    // hamburger"). Stamp the event object so whichever handler runs first wins
    // and any later one no-ops — independent of phase, chunk load order, or
    // propagation. The central handler (app-renderers.ts) checks the same stamp.
    if (e && e._olFeatureSidecarToggled)
        return;
    if (e)
        e._olFeatureSidecarToggled = true;
    if (e && e.preventDefault)
        e.preventDefault();
    // #68 (2026-06-02): if we reach here the deferral guard above did NOT fire
    // (cross-bundle `_delegatedActions` visibility flakes), so bundle-app-tail's
    // central [data-action] dispatcher will ALSO run `toggle-feature-sidecar` on
    // this SAME click — both toggle the identical `d-none`, so it goes
    // open→close = net no-op and the hamburger looks dead (confirmed: direct
    // single-invoke opens it). This fallback is registered FIRST (bundle-app-init
    // loads before bundle-app-tail), so stopping the event here guarantees
    // exactly ONE toggle. Harmless when the guard DOES defer (we return above).
    if (e && e.stopImmediatePropagation)
        e.stopImmediatePropagation();
    var overlay = document.getElementById('feature-sidecar-overlay');
    var panel = document.getElementById('feature-sidecar');
    if (!overlay || !panel)
        return;
    var isOpen = !panel.classList.contains('d-none');
    if (isOpen) {
        panel.classList.add('d-none');
        overlay.classList.add('d-none');
        actionEl.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = ''; // MA #30: release the scroll-lock (mirrors the full handler)
    }
    else {
        overlay.classList.remove('d-none');
        panel.classList.remove('d-none');
        actionEl.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden'; // MA #30: background scroll-lock (mirrors the full handler)
        // 2026-06-19 audit Phase-1 [High]: move focus into the drawer on open.
        // _olSidecarFocusFirst lives in bundle-app-tail (app-renderers.ts) which
        // may not have parsed yet when this pre-hydration fallback fires — fall
        // back to focusing the first focusable inline so the trap has an anchor.
        var _ff = window._olSidecarFocusFirst;
        if (typeof _ff === 'function') {
            _ff();
        }
        else {
            var _first = panel.querySelector('a[href], button:not([disabled])');
            if (_first && typeof _first.focus === 'function')
                _first.focus();
        }
    }
});
/* ─── NH9 bundle-split race — generalized top-bar pre-hydration fallback
 *     (top-bar audit 2026-05-15, BUILDER option (b); OWNER-ratified) ───
 *
 * The 2026-05-07 NH9 3-way split put the topbar's `_delegatedActions`
 * delegator + the `<a data-view>` interceptor in `bundle-app-tail`
 * (`<script defer fetchpriority="low">`, parses LATE) while `setView`
 * stayed in `bundle-app-init` (this chunk, parses FIRST). In the window
 * after init parses but before tail attaches:
 *   - nav `<a data-action="set-view" href>` + the logo
 *     `<a data-action="go-home" href="/">` fall through to NATIVE
 *     navigation -> hard reload that drops DataCache + active ticker
 *     (the exact regression the tail interceptor exists to prevent);
 *   - the no-href panel buttons (Search/Ask AI/theme/cog/account) are
 *     silent dead no-ops with no feedback.
 * Closed-P0 regression: the 2026-05-04 button audit fixed the defer-
 * race; the LATER NH9 split silently re-opened it because
 * `inline-init.ts:187` bails on `typeof setView === 'function'`, no
 * longer a proxy for "tail delegator attached" post-split. This is a
 * SEPARATE isolated listener so the OWNER-P0-2026-05-12 sidecar
 * listener above is untouched, and inline-init.ts is untouched so its
 * markets-button-prebundle-race contract stays green.
 *
 *   - set-view / go-home  -> COMPLETE fallback: `setView` is in THIS
 *     chunk so we drive it directly (a bubble-phase preventDefault
 *     still cancels the anchor's default nav). Mirrors
 *     app-renderers.ts:2045 / :2037 (incl. the `pricing` external URL).
 *   - toggle-theme        -> COMPLETE fallback: mirror app-renderers.ts:
 *     3204-3208 (data-theme attr + `ol_theme`) MINUS the innerHTML icon
 *     swap (innerHTML on #topbar-theme-toggle destroys the inline <svg>
 *     -- feedback_never_destroy_dom; the tail handler re-syncs the icon).
 *   - open-command-palette / toggle-ask-ai-panel / open-settings-panel
 *     / auth-toggle -> handler + panel markup live in the tail; cannot
 *     be safely reimplemented here. Queue the element + replay a real
 *     `.click()` the instant `_delegatedActions` is defined (=> the
 *     whole tail module evaluated synchronously => the central
 *     delegator at app-renderers.ts:3466 is attached). On replay the
 *     deferral guard short-circuits this listener so the tail owns it
 *     -- no double-fire, no loop. Every topbar control thus degrades to
 *     a correct deferred action instead of a dead click.
 *
 * Deferral guard `typeof _delegatedActions !== 'undefined' &&
 * _delegatedActions[action]` is the proven cross-chunk readiness signal
 * (already used at app-init.ts:3636 from this same chunk).
 *
 * Regression-pinned by tests/test_topbar_prehydration_fallback_contract.py.
 */
(function () {
    var TOPBAR_PREHYDRATE = {
        'set-view': 1, 'go-home': 1, 'toggle-theme': 1,
        'open-command-palette': 1, 'toggle-ask-ai-panel': 1,
        'open-settings-panel': 1, 'auth-toggle': 1,
    };
    var _replayQ = [];
    var _replayArmed = false;
    function _armReplay() {
        if (_replayArmed)
            return;
        _replayArmed = true;
        var tries = 0;
        var iv = setInterval(function () {
            tries++;
            if (typeof _delegatedActions !== 'undefined') {
                clearInterval(iv);
                var q = _replayQ;
                _replayQ = [];
                _replayArmed = false;
                q.forEach(function (el) {
                    // isConnected guards a control re-rendered away mid-race
                    // (topbar is static chrome so this is rare).
                    if (el && el.isConnected && typeof el.click === 'function') {
                        try {
                            el.click();
                        }
                        catch (_e) { /* replay best-effort */ }
                    }
                });
            }
            else if (tries > 160) {
                // ~9.6s safety cap -- tail never arrived; stop polling.
                clearInterval(iv);
                _replayArmed = false;
                _replayQ = [];
            }
        }, 60);
    }
    document.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest)
            return;
        var el = t.closest('[data-action]');
        if (!el)
            return;
        var action = el.dataset.action;
        if (!action || !TOPBAR_PREHYDRATE[action])
            return;
        // Tail delegator attached -> it owns the click (single-handling).
        if (typeof _delegatedActions !== 'undefined' && _delegatedActions[action])
            return;
        if (action === 'set-view') {
            var view = el.getAttribute('data-view');
            if (!view)
                return;
            // Mirror app-renderers.ts:2045 -- truly-external SSR pages keep
            // hard navigation.
            if (view === 'pricing') {
                window.location.href = '/pricing';
                return;
            }
            if (typeof setView === 'function') {
                e.preventDefault();
                try {
                    setView(view);
                }
                catch (_e) { /* tail will retake */ }
            }
            return;
        }
        if (action === 'go-home') {
            // N10 (OWNER 2026-09-25, mobile audit): SUPERSEDES #120. The logo goes to
            // /welcome for EVERYONE -- the main app-renderers handler hard-navigates
            // to the anchor's href. This early-load fallback used to open the sign-in
            // modal for anon and route everyone else to their default view, so the
            // logo went somewhere different depending on whether the tail chunk had
            // parsed yet (CHAOS 2026-09-25). It now mirrors the main handler exactly.
            e.preventDefault();
            window.location.href = el.getAttribute('href') || '/welcome';
            return;
        }
        if (action === 'toggle-theme') {
            // Mirror app-renderers.ts:3204-3208 minus the innerHTML icon swap.
            e.preventDefault();
            var docEl = document.documentElement;
            var nextTheme = docEl.getAttribute('data-theme') === 'light' ? 'dark' : 'light';
            docEl.setAttribute('data-theme', nextTheme);
            try {
                if (typeof OLStorage !== 'undefined')
                    OLStorage.setString('ol_theme', nextTheme);
            }
            catch (_e) { /* QuotaExceededError -- theme still applied to DOM */ }
            return;
        }
        // Panel controls: queue + replay once the tail delegator attaches.
        if (e && e.preventDefault)
            e.preventDefault();
        if (_replayQ.indexOf(el) === -1)
            _replayQ.push(el);
        _armReplay();
    });
})();
// ──────────────────────────────────────────────────────────────────────────
// SHIP-5 NF-1 Phase 1 — mount the new mobile bottom tab bar (2026-05-28).
//
// Plan: docs/board/audit/2026-05-28_DESIGN_handoff_vs_prod_crispness_audit.md
// §F-09 / NF-1. Implementation: static/js/product/chrome/bottom-tab.ts.
// CSS: static/css/bottom-tab.css. Contract test:
// tests/test_mobile_bottom_tab_contract.py.
//
// This is the NEW product-chrome variant of the bottom tab bar (Learn /
// Markets / Portfolio for Phase 1). It coexists with the legacy
// '#mobile-bottom-nav' chrome (rendered in dashboard.html:1846, synced
// by mobile-helpers.ts) while the migration is in flight; Phase 2 will
// retire the legacy node once the new bar reaches feature parity
// (news tab, badge counts, sticky-Resume, search-as-sheet).
//
// The bar is hidden via CSS on viewports ≥ 720px (handoff-product/
// 02-responsive.md:11 mobile breakpoint), so this mount is a no-op on
// desktop — additive per FOUNDATIONAL feedback_zero_ux_friction.
//
// Defensive shim per FOUNDATIONAL feedback_module_top_level_window_-
// global_race: read the mounter via window.OLProduct.chrome (loaded
// before this file in the bundle per JS_MODULES order). Never silent-
// catch — log to console so Sentry's browser LoggingIntegration picks
// it up.
(function () {
    function _mountBottomTab() {
        try {
            var w = window;
            var fn = w.OLProduct && w.OLProduct.chrome && w.OLProduct.chrome.mountBottomTab;
            if (typeof fn === 'function') {
                fn();
            }
            else {
                // Bundle order issue — chrome module not yet attached.
                // Retry once on the next tick to cover any cross-chunk
                // load-order quirk. If still missing after the retry,
                // log + give up (the legacy chrome still ships).
                setTimeout(function () {
                    var w2 = window;
                    var fn2 = w2.OLProduct && w2.OLProduct.chrome && w2.OLProduct.chrome.mountBottomTab;
                    if (typeof fn2 === 'function') {
                        fn2();
                    }
                    else {
                        // eslint-disable-next-line no-console
                        console.error('[app-init] mountBottomTab not found on OLProduct.chrome');
                    }
                }, 0);
            }
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error('[app-init] mountBottomTab threw:', e);
        }
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', _mountBottomTab);
    }
    else {
        _mountBottomTab();
    }
})();
// ── Board#13 TRIAGE (2026-07-17): runtime DOM-budget canary ─────────────────
// The <1000 live-DOM budget (feedback_dom_js_budgets) is enforced at review
// time only; a heavy authed view that blows it in PROD is invisible until an
// OWNER screenshot arrives (frozen-page class). This canary SAMPLES the live
// node count — decoupled from the render path (no setView hook, zero risk to
// rendering) — and reports a breach via the lazy-loaded Sentry, tagged with
// the active view, once per view per session, max 3 reports/session.
// Cost: getElementsByTagName('*').length every 30s ≈ sub-ms; no DOM writes.
(function () {
    // 2026-08-27 CYCLE (docs/board/audit/2026-08-27_CYCLE_dom_budget_breach_decision.md):
    // this alert is now COST-gated, not COUNT-gated. The old `BUDGET = 1000`
    // fired on the app's ordinary density -- the reported distribution was
    // nodes_approx 1000 (51% of events), 1100 (6%), 1600 (9%), i.e. half the
    // breaches sat inside the tag's own rounding of the threshold. A node
    // COUNT was only ever a cheap proxy for render cost; we can measure the
    // cost directly now, so the count is demoted to a look-closer pre-gate
    // and a tag, exactly as nodes_total_approx already is for memory.
    // EVERY NUMBER BELOW CARRIES ITS DERIVATION -- do not retune one without
    // rewriting its reason (the old 1000 was an undated round number that
    // outlived the app it was chosen for).
    // Look-closer pre-gate, NOT the alert. Measured in prod 2026-08-27:
    // steady-state VISIBLE nodes are 749 (?view=macro) and 865 (?view=ticker).
    // Reported breaches cluster at 1000/1100 -- that is ordinary density, not
    // a defect. 1400 sits above that mass and below the genuinely-heavier
    // 1600 tail, which still gets costed.
    var NODE_TRIPWIRE = 1400;
    // One 60fps frame is 16.7ms. A long-animation-frame entry is only emitted
    // for frames ALREADY over 50ms, so this asks whether style+layout alone
    // accounts for a whole dropped frame inside an already-long frame.
    var COST_BUDGET_MS = 16;
    // Only used where cost cannot be observed (no LoAF support). Session 24
    // measured a hard freeze at 6,000 elements (feedback_dom_js_budgets);
    // 3,000 keeps a 2x margin rather than the old undated 6x.
    var HARD_NODE_CEILING = 3000;
    var SAMPLE_MS = 30000;
    var MAX_REPORTS = 3;
    var _sampleTimer = null;
    // Worst style+layout duration seen in any long animation frame this
    // session. -1 means never observed (the browser has no LoAF).
    var _maxStyleLayoutMs = -1;
    var _reported = {};
    var _reportCount = 0;
    // PASSIVE cost observation. We must not force a reflow to measure
    // reflow cost -- that would introduce the very jank this canary guards
    // against. long-animation-frame reports style+layout the browser ALREADY
    // did, at zero cost to us.
    function _startCostObserver() {
        try {
            var PO = window.PerformanceObserver;
            if (!PO || !PO.supportedEntryTypes ||
                PO.supportedEntryTypes.indexOf('long-animation-frame') < 0)
                return;
            var obs = new PO(function (list) {
                var es = list.getEntries();
                for (var i = 0; i < es.length; i++) {
                    var d = es[i].styleAndLayoutDuration;
                    if (typeof d === 'number' && d > _maxStyleLayoutMs) {
                        _maxStyleLayoutMs = d;
                    }
                }
            });
            obs.observe({ type: 'long-animation-frame', buffered: true });
        }
        catch (_e) { /* stays unobserved; the ceiling path covers it */ }
    }
    function _activeView() {
        try {
            return new URLSearchParams(window.location.search).get('view') || 'home';
        }
        catch (_e) {
            return 'unknown';
        }
    }
    // #198 (2026-07-28, Sentry BROWSER-12): the canary originally counted the
    // WHOLE document, but a live measurement of the flagged ?view=macro breach
    // (1,317 total) showed 961 of those nodes inside display:none subtrees —
    // the parked ticker hero (416; kept mounted DELIBERATELY per
    // feedback_never_destroy_dom, it holds the chart canvases) plus the
    // premounted panels (askai 97 / sidecar 44 / apikeys 40 / settings 28).
    // The ACTIVE view was ~356 nodes. The <1000 budget is about render/layout
    // cost, which display:none subtrees do not pay — so the breach gate now
    // counts VISIBLE nodes (top-down walk pruning display:none subtrees; cost
    // is ~one getComputedStyle per visible node + per hidden ROOT, a few ms at
    // 30s cadence). The raw total rides along as a tag so genuine
    // parked-subtree GROWTH (a memory concern, not a render one) stays
    // observable in the same event.
    function _visibleCount() {
        var count = 0;
        function walk(el) {
            try {
                var cs = window.getComputedStyle(el);
                if (cs && cs.display === 'none')
                    return; // prune the parked subtree
            }
            catch (_e) { /* keep counting if style is unreadable */ }
            count++;
            for (var i = 0; i < el.children.length; i++)
                walk(el.children[i]);
        }
        if (document.body)
            walk(document.body);
        return count;
    }
    function _userExpanded() {
        try {
            return document.body && document.body.getAttribute('data-ol-user-expanded') === '1' ? 'yes' : 'no';
        }
        catch (_e) {
            return 'no';
        }
    }
    function _sample() {
        try {
            // 2026-09-26 (external review, always-on P2): stop for good once the
            // report budget is spent, and never walk computed styles in a hidden tab.
            if (_reportCount >= MAX_REPORTS) {
                if (_sampleTimer !== null) {
                    clearInterval(_sampleTimer);
                    _sampleTimer = null;
                }
                return;
            }
            if (document.hidden)
                return;
            var total = document.getElementsByTagName('*').length;
            // Cheap pre-gate: the visible count can never exceed the total, so a
            // total under the tripwire needs no style walk at all.
            if (total <= NODE_TRIPWIRE)
                return;
            var count = _visibleCount();
            if (count <= NODE_TRIPWIRE)
                return;
            // COST decides, not COUNT. A view that is merely large stops paging
            // us; one that is genuinely expensive still does. Where the browser
            // cannot tell us the cost we fall back to the freeze-derived ceiling
            // rather than going silent -- an unobservable cost is not evidence of
            // a cheap page.
            var costed = _maxStyleLayoutMs >= 0;
            if (costed) {
                if (_maxStyleLayoutMs <= COST_BUDGET_MS)
                    return;
            }
            else if (count <= HARD_NODE_CEILING) {
                return;
            }
            var view = _activeView();
            if (_reported[view])
                return;
            var _w = window;
            // Sentry loads lazily; if it isn't up yet, skip — a later sample on the
            // same still-heavy view will catch it (no local queueing complexity).
            if (!(_w.Sentry && typeof _w.Sentry.captureMessage === 'function'))
                return;
            _reported[view] = true;
            _reportCount++;
            _w.Sentry.captureMessage('dom.budget_breach', {
                level: 'warning',
                // Round to the nearest 100 so Sentry groups breaches instead of
                // minting one issue per exact node count.
                tags: {
                    view: view,
                    nodes_approx: String(Math.round(count / 100) * 100),
                    nodes_total_approx: String(Math.round(total / 100) * 100),
                    // What actually decided this alert, so a reader never has to
                    // guess which limb fired.
                    style_layout_ms: costed
                        ? String(Math.round(_maxStyleLayoutMs)) : 'unobserved',
                    cost_source: costed ? 'loaf' : 'unavailable',
                    // 2026-10-05: 'yes' when the reader expanded a capped table (the
                    // BDC "Show all"), so a breach they chose is not read as a regression.
                    user_expanded: _userExpanded(),
                },
            });
        }
        catch (_e) { /* canary must never break the page */ }
    }
    function _start() {
        // First sample well after load so hydration settles; then slow interval.
        _startCostObserver();
        setTimeout(_sample, 8000);
        _sampleTimer = setInterval(_sample, SAMPLE_MS);
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', _start);
    }
    else {
        _start();
    }
})();
//# sourceMappingURL=app-init-boot-tail.js.map
;
// ═══ chrome-indicators.js ═══
;"use strict";
// @ts-nocheck
// ^ MUST be line 1 or it is silently ineffective. INHERITED from
// app-init.ts, not chosen: this code was written and has always run
// under nocheck, and turning checking on for it is a separate change
// with its own risk, not a free rider on a file move.
// ──────────────────────────────────────────────────────────────────────────
// chrome-indicators.ts — the app-chrome progress + feedback indicators.
//
// #125 (2026-08-14): cut out of app-init.ts, which sat at EXACTLY its 4820-line
// size budget, so the next line added to it would have tripped the gate.
// 4820 -> 4563.
//
// WHAT LIVES HERE. One job: tell the user something is happening. The global
// loading bar, the ticker skeleton, the hero count-up animation and its
// direction flash, the top-bar live glow, the pulse-bar refresh scan, the
// enrichment phase indicator, and the button busy state. Every one of them is
// a transient visual signal about work in flight; none of them renders data.
// That is the seam, and it is why this is a module rather than an arbitrary
// 257 lines lifted to make a number go down.
//
// ── LOAD-ORDER INVARIANT — read before moving this file in the bundle list ──
//
// This block contains ZERO module-scope executed statements: 4 plain `var`
// declarations initialised to literals (0 / null), and 12 function
// declarations. Nothing here runs at parse time and nothing here is READ at
// parse time — every caller invokes these at runtime, after boot.
//
// That is what makes the cut safe, and it is a DIFFERENT argument from the two
// prior app-init cuts, so do not reason by analogy from them:
//
//   * app-init-boot-tail.ts (#263 D1b) is 100% module-scope EXECUTED code, so
//     it must sit IMMEDIATELY after app-init.js — adjacency is what preserves
//     the global execution order.
//   * view-skeleton.ts (2026-08-04) had to be ordered FIRST because a
//     top-level `const` is a lexical binding in TDZ until its initialiser
//     runs.
//   * THIS file needs neither — but the two hoists are NOT equivalent, and the
//     difference is the only thing here worth being careful about. Measured by
//     concatenating this file after a probe and running it:
//
//         typeof _showLoading   from an earlier file -> "function"
//         typeof _loadingCount  from an earlier file -> "undefined"
//
//     Function declarations hoist FULLY INITIALISED, so all twelve are callable
//     from anywhere in the chunk. A `var` hoists only its BINDING: the four
//     counters exist (no ReferenceError) but hold `undefined` until this file's
//     line actually runs. `_loadingCount++` on `undefined` is NaN, not 0.
//
//     That is harmless here, and only here, for two reasons that were checked
//     rather than assumed: the four `var`s are referenced by NOTHING outside
//     this file, and every call site of the eleven functions is inside another
//     function — so nothing touches them until the whole bundle has executed.
//     If you ever add a module-scope read of one of these counters from an
//     earlier file, that is when this stops being true.
//
// What IS load-bearing: it must land in the SAME chunk (`app-init`). The
// bundler concatenates a chunk into one script, and cross-file hoisting only
// works inside one script. Split it into a different chunk and `_showLoading`
// becomes a ReferenceError at the first fetch.
//
// The deliberately-cut-adjacent placement in build_bundle.py is belt-and-
// braces, not a requirement — recorded here so a future reader does not
// "discover" the ordering is slack and infer the same of its siblings.
// ──────────────────────────────────────────────────────────────────────────
// ── GLOBAL LOADING BAR API ──
var _loadingCount = 0;
var _loadingBar = null;
var _loadingTimer = null;
var _loadingProgress = 0;
function _showLoading() {
    _loadingCount++;
    if (!_loadingBar)
        _loadingBar = document.getElementById('global-loading-bar');
    if (!_loadingBar)
        return;
    if (_loadingCount === 1) {
        // F-10 (external code review 2026-05-21 MED): CSS-driven width
        // animation replaces the JS setInterval(200ms) that incremented
        // _loadingProgress 5Hz with `p += (90-p) * 0.08`. The .active class
        // now triggers a 10s cubic-bezier keyframe (5% → 90%) defined in
        // dashboard-styles.css. Zero JS wake-up overhead and no leaked
        // timer if a _showLoading/_hideLoading pair gets unbalanced.
        _loadingProgress = 5;
        _loadingBar.classList.remove('indeterminate');
        _loadingBar.classList.remove('complete');
        // Re-flow trick: remove + force reflow + re-add 'active' so the
        // animation restarts on subsequent _showLoading() while a prior
        // sequence is still mid-fade (rare but possible on rapid nav).
        _loadingBar.classList.remove('active');
        void _loadingBar.offsetWidth; // force reflow
        _loadingBar.classList.add('active');
        _loadingBar.style.left = '0';
        // Width is now controlled by the CSS keyframe; don't set inline.
        _loadingBar.style.width = '';
        // Legacy _loadingTimer kept as a no-op handle to preserve
        // back-compat with any external clearInterval(_loadingTimer)
        // callers we haven't enumerated.
        clearInterval(_loadingTimer);
        _loadingTimer = null;
    }
}
function _hideLoading() {
    _loadingCount = Math.max(0, _loadingCount - 1);
    if (_loadingCount === 0) {
        if (!_loadingBar)
            _loadingBar = document.getElementById('global-loading-bar');
        if (!_loadingBar)
            return;
        clearInterval(_loadingTimer);
        _loadingTimer = null;
        // F-10: .complete class overrides the .active keyframe and snaps
        // width to 100% (matching the legacy pre-fade behavior).
        _loadingBar.classList.add('complete');
        setTimeout(() => {
            _loadingBar.classList.remove('active', 'indeterminate', 'complete');
            _loadingBar.style.width = '';
            _loadingProgress = 0;
        }, 300);
    }
}
function _showLoadingIndeterminate() {
    _loadingCount++;
    if (!_loadingBar)
        _loadingBar = document.getElementById('global-loading-bar');
    if (!_loadingBar)
        return;
    clearInterval(_loadingTimer);
    _loadingBar.classList.add('active', 'indeterminate');
}
// §SKELETON ════════════════════════════════════════════════════════════════════
// ── TICKER SKELETON ──
function _showTickerSkeleton() {
    const skel = document.getElementById('ticker-skeleton');
    if (!skel)
        return;
    // LH-2 (2026-06-15): SSR-hydration guard. When the hero was server-rendered
    // for the active ticker (anon cold-load of /?view=ticker — see
    // ssr_renderer.inject_anon_ticker_hero), skip the skeleton flash: the real
    // hero content is already painted (it's the LCP element) and fetchTicker's
    // renderData updates the SAME elements in place. One-shot — the marker is
    // cleared on the first _hideTickerSkeleton, so later ticker switches show the
    // skeleton normally. Avoids flashing a blank skeleton over real data
    // (feedback_user_trust) and keeps the LCP candidate anchored at the SSR paint.
    const _ssrHero = document.getElementById('hero');
    if (_ssrHero) {
        const _ssrSym = _ssrHero.getAttribute('data-ssr-symbol');
        if (_ssrSym && _ssrSym === String(activeTicker || '').toUpperCase())
            return;
    }
    skel.classList.add('visible');
}
function _hideTickerSkeleton() {
    const skel = document.getElementById('ticker-skeleton');
    if (skel)
        skel.classList.remove('visible');
    // Add fade-in to hero elements when skeleton hides
    const hero = document.getElementById('hero');
    if (hero) {
        // LH-2: consume the one-shot SSR-hydration marker once real data has
        // rendered, so subsequent ticker switches show the skeleton normally.
        hero.removeAttribute('data-ssr-symbol');
        hero.classList.add('content-fade-in');
        setTimeout(function () { hero.classList.remove('content-fade-in'); }, 250);
    }
}
// ── HERO NUMBER COUNT-UP ANIMATION ──
//
// `options.fixedDecimals` (number, opt-in): render EVERY frame with exactly
// this many fraction digits — min === max — so the string's CHARACTER COUNT
// cannot change mid-animation.
//
// Why it exists (2026-08-17, the ticker CLS flap). Without it a frame renders
// `{minimumFractionDigits: 2, maximumFractionDigits: decimals}`, so an
// intermediate value can print MORE digits than the settled one: counting to
// -0.071, the frames read "-0.0072", "-0.0735", … (16 chars with the pct
// suffix) while the final reads "-0.071" (15). `#change-hero` therefore grows
// ~8.4px mid-count, pushes `#hero-primary` past its wrap threshold, and
// `#hero-right` bounces to a second flex line and back — measured per-frame:
// hero-right y 70.6 -> 171.6 -> 75.4 -> 171.6, taking `#chart-panel` 29.6px
// with it each time. That single flap was 0.3526 of a 0.3604 CLS (97.8%).
// The `ch` min-width reservation at the call site (#180) could not stop it —
// min-width is a FLOOR, and the defect is the element growing ABOVE it.
// Opt-in so no other caller's formatting changes.
// QA 2026-09-03: complete in-flight number tweens the moment the tab hides
// -- rAF will not fire again until the tab is shown, and the frozen
// intermediate frame is what screenshots, tab previews and the user's
// return glance all see. One listener, module-level; elements register in
// _animateNumber and deregister on natural completion.
const _animatingEls = new Set();
if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', function () {
        if (document.visibilityState !== 'hidden')
            return;
        _animatingEls.forEach(function (el) {
            if (el._animRafId) {
                cancelAnimationFrame(el._animRafId);
                el._animRafId = null;
            }
            if (el._animFinal != null)
                el.textContent = el._animFinal;
        });
        _animatingEls.clear();
    });
}
function _animateNumber(element, targetValue, duration, prefix, suffix, options) {
    if (!element || targetValue == null || isNaN(targetValue))
        return;
    prefix = prefix || '';
    suffix = suffix || '';
    duration = duration || 400;
    options = options || {};
    // Try to parse current displayed value to animate from it (for live updates)
    const currentText = (element.textContent || '').replace(/[^0-9.\-]/g, '');
    const startValue = parseFloat(currentText) || 0;
    const direction = targetValue > startValue ? 'up' : targetValue < startValue ? 'down' : null;
    // Skip animation if values are identical
    // One formatter for all three render paths (skip / instant / per-frame), so
    // the settled string can never differ in width from the animated frames.
    const _fmtNum = function (v) {
        if (options.fixedDecimals != null) {
            return v.toLocaleString('en-US', {
                minimumFractionDigits: options.fixedDecimals,
                maximumFractionDigits: options.fixedDecimals,
            });
        }
        const dec = options.decimals != null
            ? options.decimals
            : (Math.abs(targetValue) >= 1000 ? 2 : (Math.abs(targetValue) >= 1 ? 2 : 4));
        return v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: dec });
    };
    // A '+' prefix is a SIGN, and the sign belongs to the value being RENDERED,
    // not to the target. Callers pass '+' when the FINAL value is positive, but
    // the count-up eases from whatever was on screen — so an early frame that is
    // still negative rendered its own '-' underneath the '+' and produced
    // "+-0.24 (+-0.05%)". Measured live on a cold BRK.B load 2026-08-17: 16
    // chars against a 14-char settled string, which is +2 over the `ch`
    // reservation — enough to push #hero-primary past its wrap threshold on its
    // own. It is also simply wrong to show a reader on a financial figure
    // (`feedback_user_trust`). Emitting the sign per FRAME keeps the width
    // constant too: exactly one sign character either way.
    const _pfxFor = function (v) {
        if (prefix === '+')
            return v < 0 ? '' : '+';
        return prefix;
    };
    if (Math.abs(startValue - targetValue) < 0.001) {
        element.textContent = _pfxFor(targetValue) + _fmtNum(targetValue) + suffix;
        return;
    }
    // F-20 Phase 4 wave-13 P3 (2026-05-28): READ-BEFORE-WRITE batching.
    // Previously: _flashElement() (line below) does classList.remove + read
    // offsetWidth + classList.add (the intentional animation-restart reflow
    // trick), THEN this block read `element.offsetParent` (another forced
    // layout) AFTER the flash writes invalidated layout. Two forced layouts
    // per call × 4 callsites in renderTickerData = 8 forced layouts per
    // ticker switch. Fix: hoist the visibility read BEFORE the flash writes
    // so the layout is read once (clean), then writes batch into one paint.
    // QA 2026-09-03 (the frozen-hero-price finding): offsetParent answers
    // DISPLAY visibility, not TAB visibility -- in a backgrounded tab rAF
    // suspends indefinitely and a tween freezes at an intermediate frame
    // ($30.07 painted for a $51.24 target, live-verified with a pending
    // rafId on the element). A hidden tab gets the final value instantly.
    const isHidden = options.instant || !element.offsetParent
        || (typeof document !== 'undefined' && document.visibilityState === 'hidden');
    // Apply CSS flash class for direction change (Bloomberg-style tick flash)
    if (direction && !options.noFlash) {
        _flashElement(element, direction);
    }
    // If element is not visible or animation is disabled, instant update
    if (isHidden) {
        element.textContent = _pfxFor(targetValue) + _fmtNum(targetValue) + suffix;
        return;
    }
    const startTime = performance.now();
    let rafId = element._animRafId;
    if (rafId)
        cancelAnimationFrame(rafId);
    // Companion to the isHidden visibility check: a tween INTERRUPTED by the
    // tab hiding would still freeze mid-value, so record the settled string
    // and let the one visibilitychange completer below finish it.
    element._animFinal = _pfxFor(targetValue) + _fmtNum(targetValue) + suffix;
    _animatingEls.add(element);
    function step(now) {
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);
        // ease-out cubic for smooth deceleration
        const eased = 1 - Math.pow(1 - progress, 3);
        const current = startValue + (targetValue - startValue) * eased;
        element.textContent = _pfxFor(current) + _fmtNum(current) + suffix;
        if (progress < 1) {
            element._animRafId = requestAnimationFrame(step);
        }
        else {
            element._animRafId = null;
            _animatingEls.delete(element);
        }
    }
    element._animRafId = requestAnimationFrame(step);
}
// Apply directional flash CSS class to an element (green for up, red for down)
function _flashElement(el, direction) {
    if (!el)
        return;
    el.classList.remove('num-flash-up', 'num-flash-down');
    // Force reflow so re-adding the same class restarts the animation
    void el.offsetWidth;
    el.classList.add(direction === 'up' ? 'num-flash-up' : 'num-flash-down');
    // Clean up class after animation completes
    clearTimeout(el._flashTimeout);
    el._flashTimeout = setTimeout(function () {
        el.classList.remove('num-flash-up', 'num-flash-down');
    }, 850);
}
// ── TOPBAR LIVE GLOW ──
function _setTopbarLive(isLive) {
    const tb = document.getElementById('topbar');
    if (!tb)
        return;
    if (isLive)
        tb.classList.add('data-live');
    else
        tb.classList.remove('data-live');
}
// ── PULSE BAR REFRESH SCAN ──
function _setPulseRefreshing(isRefreshing) {
    const pb = document.getElementById('market-pulse-bar');
    if (!pb)
        return;
    if (isRefreshing)
        pb.classList.add('refreshing');
    else
        pb.classList.remove('refreshing');
}
// ── ENRICHMENT PHASE INDICATOR ──
function _updatePhaseIndicator(phase, fetchedAt, quoteNotCurrent) {
    let el = document.getElementById('phase-indicator');
    if (!el) {
        // Create and insert next to last-updated-hero
        const anchor = document.getElementById('last-updated-hero');
        if (!anchor || !anchor.parentElement)
            return;
        el = document.createElement('div');
        el.id = 'phase-indicator';
        el.className = 'phase-indicator';
        anchor.parentElement.insertBefore(el, anchor.nextSibling);
    }
    // PR-G3 CYCLE-G F4: badge text reflects ONLY the quote/price-pipeline
    // signal — the seven panels below (News, 13F, Form 4, Overview, Peers,
    // Analyst, Transcripts) come from independent /api/* calls with their
    // own failure modes; this indicator has no visibility into them and
    // MUST NOT claim panel-level completeness.
    if (phase == null) {
        // EXT-AUDIT T2 (#66): UNKNOWN must not claim FRESH — the cached-snapshot
        // serve has no phase annotation and was rendering "QUOTE FRESH" beside
        // "· cached" (three contradictory freshness claims in one line). Render
        // nothing; the fetchedAt label + cached suffix carry the honest state.
        el.innerHTML = '';
        return;
    }
    if (phase === 2) {
        // #83 T2 (2026-07-06 OWNER capture): phase 2 means the quote FETCH
        // completed — not that the DATA is fresh. PJT rendered "QUOTE FRESH"
        // beside "Updated: Prior close (Sun 7/5) · 22h ago" because the fetch
        // succeeded but FMP served Sunday's close. Gate the FRESH claim on the
        // envelope's own timestamp (the same one the age label renders from);
        // older than 20min (15-min delayed feed + margin) → render nothing —
        // the honest fetchedAt label carries the state (#66 pattern).
        // CHAOS 2026-10-03 F3: a quote that is not the current session's -- a
        // typed previous close (price.quoteKind 'previous_close', whose fetchedAt
        // is the ASSEMBLY time) or the degraded stale-snapshot fallback (_stale)
        // -- is never "fresh", however recent the fetch. Callers pass
        // _quoteIsNotCurrent(d) (ticker-renderer.ts).
        if (quoteNotCurrent) {
            el.innerHTML = '';
            return;
        }
        try {
            if (fetchedAt && fetchedAt !== 'DEMO') {
                var _faStr = String(fetchedAt);
                // Naive "YYYY-MM-DD HH:MM:SS" timestamps parse as LOCAL; the API
                // emits UTC — normalize like the #66 fetchedAt fix.
                if (_faStr.indexOf('T') === -1 && _faStr.indexOf(' ') > 0)
                    _faStr = _faStr.replace(' ', 'T');
                if (!/[zZ]|[+-]\d{2}:?\d{2}$/.test(_faStr))
                    _faStr += 'Z';
                var _faTs = new Date(_faStr).getTime();
                if (isFinite(_faTs) && (Date.now() - _faTs) > 20 * 60 * 1000) {
                    el.innerHTML = '';
                    return;
                }
            }
        }
        catch (_e) { /* unparseable timestamp — fall through to the label */ }
        el.innerHTML = '<span class="phase-dot complete"></span><span class="phase-dot complete"></span> QUOTE FRESH';
    }
    else if (phase === 1) {
        el.innerHTML = '<span class="phase-dot complete"></span><span class="phase-dot active"></span> ENRICHING';
    }
    else {
        el.innerHTML = '<span class="phase-dot active"></span><span class="phase-dot"></span> LOADING';
    }
}
// ── BUTTON LOADING HELPERS ──
function _setBtnLoading(btn, loading) {
    if (!btn)
        return;
    if (loading) {
        btn.classList.add('btn-loading');
        btn.disabled = true;
        if (!btn.querySelector('.btn-spinner')) {
            btn.dataset.origHtml = btn.innerHTML;
            btn.innerHTML = '<span class="btn-spinner"></span>' + btn.innerHTML;
        }
    }
    else {
        btn.classList.remove('btn-loading');
        btn.disabled = false;
        if (btn.dataset.origHtml !== undefined) {
            btn.innerHTML = btn.dataset.origHtml;
            delete btn.dataset.origHtml;
        }
    }
}
// ── BACKOFF NOTICE (OWNER 2026-10-03; moved out of app-init.ts, CHAOS B3) ──
// The one toast a cross-path 429 raises (app-init.ts _backoffOpen calls this
// once per backoff window). An anonymous per-IP 429 carries the shared-network
// sentence as `message` -- written ONCE, server-side, in
// rate_limit_exemptions.ANON_SHARED_NETWORK_429_MESSAGE -- and this shows it
// verbatim; any other 429, or a body that cannot be read, gets the generic line.
// It lives here, not in app-init.ts, because app-init.ts sits at its size budget.
function _olBackoffToast(response) {
    var busy = 'Oxford Ledge is busy — loading the rest in a few seconds.';
    function generic() { try {
        showToast(busy, 'info', 4000);
    }
    catch (_e) { } }
    try {
        response.clone().json().then(function (b) {
            var m = (b && typeof b.message === 'string') ? b.message : '';
            if (m) {
                try {
                    showToast(m, 'info', 8000);
                }
                catch (_e) { }
            }
            else {
                generic();
            }
        }, generic);
    }
    catch (_e) {
        generic();
    }
}
//# sourceMappingURL=chrome-indicators.js.map
;
// ═══ ticker-search-assist.js ═══
;"use strict";
// ticker-search-assist.ts — resolve what a reader types into the in-app
// search box, the same way /look does.
//
// Mobile audit 2026-09-25, pain #1 (search). app-init.ts `addTicker` used to
// take anything shaped like a symbol (1-5 letters) AS a symbol, so the
// commonest first searches -- APPLE, TESLA, INTEL -- went straight to a
// "ticker not found" state and never reached name resolution. /look had the
// same defect and S1 fixed it server-side (routes/misc.py
// `_resolve_lookup_query`): an exact known ticker wins, else a company whose
// NAME begins with the query (word-start, a leading "The " ignored, an active
// listing over a delisted one), else nothing. This is the client half of that
// rule, over the same catalog read: /api/company/search is
// `pg_search_company_profiles_by_name`, the helper /look ranks names with,
// and it ranks an exact ticker first.
//
// Where the two differ, and why it is safe: /look's known-ticker check also
// reads the 13F cusip_ticker_map, which no public route exposes. A real symbol
// that only that map knows (TSM before it entered the catalog) comes back
// "unknown" here, and the caller then tries the typed string as a symbol --
// the pre-change behaviour, with the not-found state's "Did you mean" links
// (data-pipeline.ts) as the net. A catalog outage answers [] / non-200 and
// takes the same path, so an outage never turns a search into a wrong answer.
//
// LOAD ORDER: function declarations plus one `var` holding a plain object;
// no reads at parse time. Same chunk as app-init.js; position not
// load-bearing.
// Symbols this page has already resolved (from the catalog, a picked
// suggestion, or a deliberate try-as-symbol). addTicker skips the round trip
// for these, and for any symbol already open as a tab or loaded.
var _olResolvedSymbols = {};
function _olMarkResolvedSymbol(sym) {
    const s = String(sym || '').trim().toUpperCase();
    if (s)
        _olResolvedSymbols[s] = true;
}
function _olIsResolvedSymbol(sym) {
    return !!(_olResolvedSymbols && _olResolvedSymbols[String(sym || '').toUpperCase()]);
}
// routes/misc.py `_LEGAL_SUFFIXES`, verbatim. A name that is the query plus
// only one of these ("Apple Inc.") is the company the reader meant.
var _OL_LEGAL_SUFFIXES = {
    inc: true, incorporated: true, corp: true, corporation: true, co: true, company: true, ltd: true,
    limited: true, plc: true, llc: true, lp: true, sa: true, nv: true, ag: true, se: true, group: true, holdings: true,
};
// The ranking rule, over rows in the helper's order (exact ticker first, then
// ticker prefix, then dataQuality). Mirrors routes/misc.py
// `_resolve_lookup_query` line for line -- keep them in step.
// CHAOS 2026-09-25 (wave2_search_signup_analytics_flush): mirrors the e9866fd2
// hotfix too. Prod catalog order (dataQuality DESC) puts "Apple Hospitality
// REIT, Inc." (APLE) above "Apple Inc.", so first-survivor-wins picked APLE for
// "Apple" here exactly as /look did on prod. Rank is (active listing, exact
// name modulo a legal suffix, catalog position) -- the server's tuple.
function _olPickCatalogTicker(query, rows) {
    const sym = String(query || '').trim().toUpperCase();
    const qLow = String(query || '').trim().toLowerCase();
    if (!sym)
        return { kind: 'unknown', sym: null };
    const list = Array.isArray(rows) ? rows : [];
    // OWNER ruling R-CASE-DECIDES (2026-09-25), same as the server: ALL-CAPS is
    // a ticker first; any lowercase letter means a WHOLE-WORD name first, then
    // the exact ticker, then the name prefix ("Ford" -> F, "FORD" -> FORD,
    // "gm" -> GM, "cost" -> COST).
    const namesFirst = /[a-z]/.test(String(query || ''));
    const exactTicker = function () {
        for (let i = 0; i < list.length; i++) {
            const tk = String((list[i] && list[i].ticker) || '').trim().toUpperCase();
            if (tk && tk === sym)
                return { kind: 'ticker', sym: tk };
        }
        return null;
    };
    // The name ranking (active, exact-with-legal-suffix, catalog position),
    // optionally over WHOLE-WORD matches only -- routes/misc.py
    // `_pick_lookup_name`. The query must end at a word boundary (end of name,
    // whitespace or punctuation) for "exact" too, so "cost" never makes
    // "Costco Wholesale" exact via the "co" suffix.
    const pickName = function (wholeWord) {
        let best = null;
        let bestRank = 4;
        for (let i = 0; i < list.length; i++) {
            const r = list[i] || {};
            let name = String(r.companyName || '').trim().toLowerCase();
            if (name.indexOf('the ') === 0)
                name = name.slice(4);
            const tk = String(r.ticker || '').trim().toUpperCase();
            if (!tk || name.indexOf(qLow) !== 0)
                continue;
            const atWordEnd = qLow.length >= name.length || !/[A-Za-z0-9]/.test(name.charAt(qLow.length));
            if (wholeWord && !atWordEnd)
                continue;
            const rest = name.slice(qLow.length).replace(/^[ ,.]+|[ ,.]+$/g, '');
            const first = (rest.split(/\s+/)[0] || '').replace(/^[,.]+|[,.]+$/g, '');
            const exact = atWordEnd && (rest === '' || _OL_LEGAL_SUFFIXES[first] === true);
            const rank = (String(r.tickerStatus || 'active').toLowerCase() === 'active' ? 0 : 2) + (exact ? 0 : 1);
            // Strict `<`: among equal ranks the earlier catalog row wins (position).
            if (rank < bestRank) {
                best = tk;
                bestRank = rank;
            }
        }
        return best;
    };
    if (!namesFirst) {
        const hit = exactTicker();
        if (hit)
            return hit;
    }
    else {
        // Refinement of the same ruling: lowercase tickers ("gm", "v", "coin",
        // "cost") stay tickers. A name wins only when the query is >= 3 chars AND
        // a company name begins with it as a WHOLE WORD; else the exact ticker.
        if (qLow.length >= 3) {
            const whole = pickName(true);
            if (whole)
                return { kind: 'name', sym: whole };
        }
        const hit = exactTicker();
        if (hit)
            return hit;
    }
    const best = pickName(false);
    return best ? { kind: 'name', sym: best } : { kind: 'unknown', sym: null };
}
async function _olResolveTickerQuery(query) {
    const q = String(query || '').trim();
    if (!q)
        return { kind: 'unknown', sym: null };
    try {
        const res = await fetch('/api/company/search?q=' + encodeURIComponent(q) + '&limit=50', { credentials: 'same-origin' });
        if (!res || !res.ok)
            return { kind: 'unavailable', sym: null };
        const data = await res.json();
        if (!data || !Array.isArray(data.results))
            return { kind: 'unavailable', sym: null };
        return _olPickCatalogTicker(q, data.results);
    }
    catch (_e) {
        return { kind: 'unavailable', sym: null };
    }
}
//# sourceMappingURL=ticker-search-assist.js.map
;
// ═══ tour-interruptions.js ═══
;"use strict";
// tour-interruptions.ts — keep the beginner walkthrough from stacking on top
// of the first-visit notices.
//
// Mobile audit 2026-09-25 S5 ("interruption stack"): on a first SPA entry the
// age bar (age-gate.ts, #ol-age-gate), the cookie notice
// (#cookie-consent-banner, shown by app-renderers.ts) and the beginner
// walkthrough could all be on screen at once -- two bottom bars and a tour
// bubble competing for one phone screen, each asking to be read first. The
// walkthrough is the only one of the three that can wait, so it waits: it
// never starts while either notice is still up. It starts once both are
// dismissed (if the reader is still on a ticker view), or on the next ticker
// view -- app-init.ts `_navPush` re-arms the one-shot tour flag when this
// module holds it.
//
// LOAD ORDER: function declarations only, no module-scope execution (the one
// pending callback lives on `window`, not in a top-level binding); callers reach `_olHoldTourForNotices` only at
// runtime and behind a `typeof` guard. It must share the `app-init` chunk
// with app-init.js (cross-file hoisting only works inside one script); its
// position inside the chunk is not load-bearing.
// Is a first-visit notice still waiting for the reader? The age bar exists in
// the DOM only until it is answered (both of its dismiss paths remove it).
// The cookie notice is a static element that is hidden on accept (`d-none` +
// an inline display:none); while the age bar is up it is merely CSS-suppressed
// (body.ol-age-gate-active / html.ol-cc-hide) and reappears after, so it
// counts as pending until it is accepted, not only while it is painted.
//
// CHAOS 2026-09-25: the banner SHIPS VISIBLE in dashboard.html (the LCP fix of
// 2026-06-23) and a visitor who consented on an earlier visit never gets
// `d-none` or an inline display -- theme-init.ts hides it with html.ol-cc-hide
// and both show paths return early. Reading the element alone therefore held
// the tour forever for every returning reader (the ?walkthrough=1 opt-in
// included), because no click could ever clear it. Stored consent is what the
// show paths themselves test, so it is what this tests first.
function _olCookieConsentStored() {
    try {
        if (typeof OLStorage === 'undefined' || !OLStorage)
            return false;
        return !!(OLStorage.getString('cookieConsent', null) || OLStorage.getString('ol_cookie_consent', null));
    }
    catch (_e) {
        return false;
    }
}
function _olFirstVisitNoticePending() {
    try {
        if (document.getElementById('ol-age-gate'))
            return true;
        const cc = document.getElementById('cookie-consent-banner');
        if (cc && !_olCookieConsentStored() && !cc.classList.contains('d-none') && cc.style.display !== 'none')
            return true;
    }
    catch (_e) { /* no DOM: nothing can be covered */ }
    return false;
}
// Hold the tour while a notice is pending. Returns true when it held (the
// caller must not start the tour now); `onClear` then runs once, after the
// click that leaves no notice pending. Only the latest hold is kept, so
// repeated ticker views never stack callbacks. Both notices are dismissed by a
// click (Got it / the parental-consent link / the cookie Got it), so one
// document-level click listener, checked after the dismiss handlers have run,
// is enough -- no observer, no polling.
function _olHoldTourForNotices(onClear) {
    if (!_olFirstVisitNoticePending())
        return false;
    const w = window;
    const hadWait = typeof w._olTourNoticeWait === 'function';
    w._olTourNoticeWait = onClear;
    if (!hadWait) {
        const _onClick = function () {
            setTimeout(function () {
                if (_olFirstVisitNoticePending())
                    return;
                document.removeEventListener('click', _onClick);
                const cb = w._olTourNoticeWait;
                w._olTourNoticeWait = null;
                // A short beat after the bar leaves, so the tour does not appear
                // under the finger that just dismissed it.
                if (typeof cb === 'function')
                    setTimeout(cb, 600);
            }, 0);
        };
        document.addEventListener('click', _onClick);
    }
    return true;
}
//# sourceMappingURL=tour-interruptions.js.map
;
// ═══ view-skeleton.js ═══
;"use strict";
// view-skeleton.ts -- the synchronous view-transition skeleton.
//
// EXTRACTED from view-router.ts on 2026-08-04, same shape as the #295
// industry-comps cut from the same file. view-router.ts was at EXACTLY its
// 2,225-line budget -- zero headroom -- so any edit tripped the size gate.
//
// SCRIPT MODE, NOT an ES module. tools/build_bundle.py CONCATENATES these
// files; an import/export would make this a module and every top-level name
// would stop being a bundle global. Registered in JS_MODULES and in the SAME
// 'app-init' chunk as view-router.js, immediately BEFORE it.
//
// Dependency-free apart from `document`: no view-router state crosses the
// boundary, which is what makes the extraction safe (contrast
// _materializeView, which owns the view caches).
// ---------------------------------------------------------------------
// #80 wave 2 (2026-07-06, OWNER CLS directive "never collapse-then-fill"):
// on FIRST visit to a lazy view the template fetch takes hundreds of ms and
// NOTHING paints in the click frame — the old view then visibly collapses and
// the new content pops in, blowing the 500ms input exemption on slow renders.
// These helpers paint a skeleton SYNCHRONOUSLY in the click frame (overlay-
// style sibling, never innerHTML on existing panes — feedback_never_destroy_dom)
// and the materialize .then swaps it out in place.
function _showViewSkeleton() {
    if (document.getElementById('ol-view-skeleton'))
        return;
    const host = document.getElementById('content-wrapper');
    if (!host)
        return;
    const sk = document.createElement('div');
    sk.id = 'ol-view-skeleton';
    sk.className = 'ol-view-skeleton';
    sk.setAttribute('aria-hidden', 'true');
    sk.innerHTML = '<div class="ol-view-skeleton-bar ol-vsk-w40"></div>'
        + '<div class="ol-view-skeleton-bar ol-vsk-w90"></div>'
        + '<div class="ol-view-skeleton-bar ol-vsk-w75"></div>'
        + '<div class="ol-view-skeleton-bar ol-vsk-w85"></div>'
        + '<div class="ol-view-skeleton-bar ol-vsk-w60"></div>';
    host.appendChild(sk);
}
function _hideViewSkeleton() {
    const sk = document.getElementById('ol-view-skeleton');
    if (sk && sk.parentNode)
        sk.parentNode.removeChild(sk);
}
// ── LEARN pending-scaffold reservation (2026-08-04 CLS) ────────────────
//
// The learn view painted three 60px grey bars (~200px) while the v3 chunk
// loaded, then replaced them with the real scaffold: a tab rail plus the
// Landing pane, whose `.lp-landing-loading` box alone carries a 260px
// min-height. That is a ~140px push of everything below, on every cold entry
// to /?view=learn (RUM attributed it to #lp-modules-pane, but that pane ships
// `d-none` and EMPTY and is filled only when the user clicks Modules — which
// is user-initiated and covered by the 500ms input exemption. Cloudflare's
// element attribution is coarse; see the #26 finding).
//
// What makes this one exactly reservable, where the briefing was not: the
// pending state is not standing in for CONTENT of unknown size. It is standing
// in for the SCAFFOLD, whose loading shape is fixed — a six-button rail and a
// 260px box. So the skeleton is built from those same containers and the
// reservation is right at every viewport for free, including the rail's own
// wrap behaviour at narrow widths.
//
// The rail labels are duplicated from the scaffold in learning-paths.ts, which
// is drift-bait; the labels are what set the chip widths and therefore where
// the rail wraps, so a rename that lands in one file only silently un-reserves
// the narrow viewports. Pinned by tests/test_cls_shape_reservation_contract.py.
// CHAOS 2026-09-25 (mobile audit wave 2): three scaffold tabs carry a
// `<br><small>` sub-label, which makes them two lines tall; `.lp-tabs` is a
// stretching flex row, so those three set the height of the whole rail row.
// The entries are therefore the chips' full inner markup, not just the name --
// a name-only skeleton reserved a one-line rail and the landing pane shifted
// down by a caption line on every cold LEARN entry.
const _LEARN_TAB_LABELS = [
    'Modules', 'Ledge Reads<br><small>Reading list</small>',
    'Investment Lore<br><small>Investor stories</small>',
    'Market History', 'Glossary',
    'On This Date<br><small>Market history for today</small>',
];
function _learnScaffoldSkeleton() {
    let tabs = '';
    for (let i = 0; i < _LEARN_TAB_LABELS.length; i++) {
        // <span>, not <button>: an inert placeholder must not be focusable or
        // clickable — the v3 chunk has not loaded, so nothing would happen.
        //
        // This is only safe because `.lp-tabs` is `display: flex`, which
        // BLOCKIFIES its children. `.lp-tab` sets vertical padding but no
        // `display`, so a span outside a flex container would be inline, drop that
        // padding from its height, and reserve a rail SHORTER than the real one —
        // a skeleton that looks right and under-reserves. Keep these spans direct
        // children of .lp-tabs.
        tabs += '<span class="lp-tab' + (i === 0 ? ' lp-tab-active' : '') + '">'
            + _LEARN_TAB_LABELS[i] + '</span>';
    }
    return '<div class="skeleton-container" id="learn-skeleton" aria-hidden="true">'
        + '<div class="lp-progress-strip"></div>'
        + '<div class="lp-tabs">' + tabs + '</div>'
        + '<div id="lp-landing-pane">'
        + '<div class="ol-empty lp-landing-loading">'
        + '<div class="ol-empty-title">Opening your learning room…</div>'
        + '</div></div>'
        + '</div>';
}
//# sourceMappingURL=view-skeleton.js.map
;
// ═══ view-router.js ═══
;"use strict";
// ── view-router.js ───────────────────────────────────────────────────────
//
// TS Migration Phase 2 PR 46 (2026-05-04): renamed .js → .ts.
// Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
//
// This file is the SOURCE OF TRUTH; view-router.js is the build artifact
// produced by `npx tsc -p tsconfig.build.json` (gitignored).
//
// View routing system: setView, materialize deferred views, lazy module
// loading, inline fallback renderers — extracted from app.js §VIEWS.
//
// 2026-05-04 PR 43/45 hotfix lessons applied: top-level identifiers use
// `var` (not `const`/`let`) to tolerate cross-file redeclaration in the
// bundled output. _learnPathsCache / _creditSpreadCache / _bdcListCache
// / _calendarCache / _fundamentalsCache / _tmplFetchCache + the
// _VIEW_CHUNK_MAP / _inline* renderers + setView itself are all bundle-
// global symbols; const/let would break terser parse-check.
function _hydrateVRStyles(rootEl) {
    if (!rootEl || typeof rootEl.querySelectorAll !== 'function')
        return;
    rootEl.querySelectorAll('[data-w],[data-fg],[data-bg],[data-bc]').forEach(function (n) {
        const ds = n.dataset;
        if (ds.bc != null)
            n.style.borderColor = ds.bc;
        if (ds.fg)
            n.style.color = ds.fg;
        if (ds.bg)
            n.style.backgroundColor = ds.bg;
        if (ds.w != null)
            n.style.width = ds.w + '%';
    });
}
// ── VIEW SWITCHING ──
// Lazy-load: materialize deferred view from <template> into live DOM.
var _tmplFetchCache = {};
// #70 (2026-07-16): view-template cache-bust. static/templates/*.html are served
// Cache-Control: public, max-age=14400 (4h), so after a deploy a user's cached
// .html can mismatch the freshly-deployed JS handler for up to 4h (a view
// fragment referencing DOM the new bundle no longer expects, or missing a node
// the new bundle needs). Append a per-deploy token derived from the
// content-hashed asset manifest (every bundle re-hashes on each deploy via
// render-build.sh) so a template re-fetches exactly ONCE per deploy — not on
// every navigation, which would defeat the 4h cache. Falls back to no token
// (pre-#70 behavior) when the meta tag is absent, so nothing breaks if the
// manifest is missing.
var _OL_TMPL_VER = null;
function _tmplCacheBustToken() {
    if (_OL_TMPL_VER !== null)
        return _OL_TMPL_VER;
    _OL_TMPL_VER = '';
    try {
        const meta = document.querySelector('meta[name="ol-asset-manifest"]');
        if (meta) {
            const m = JSON.parse(meta.getAttribute('content') || '{}');
            const hashed = String(m['bundle-app-init.min.js'] || m['bundle.min.js'] || '');
            const mm = hashed.match(/\.([0-9a-f]{8})\.min/);
            if (mm)
                _OL_TMPL_VER = mm[1];
        }
    }
    catch (e) { /* absent/malformed manifest -> no token, safe fallback */ }
    return _OL_TMPL_VER;
}
function _materializeView(viewId) {
    if (document.getElementById(viewId))
        return Promise.resolve();
    const tmpl = document.getElementById('tmpl-' + viewId);
    if (tmpl) {
        const content = tmpl.content || tmpl;
        const clone = document.importNode(content, true);
        const main = document.getElementById('content-wrapper');
        if (main)
            main.appendChild(clone);
        else
            document.body.appendChild(clone);
        tmpl.remove();
        return Promise.resolve();
    }
    const _v = _tmplCacheBustToken();
    const fragUrl = '/static/templates/' + viewId + '.html' + (_v ? '?v=' + _v : '');
    if (Object.prototype.hasOwnProperty.call(_tmplFetchCache, viewId))
        return _tmplFetchCache[viewId];
    const fetchOpts = typeof AbortSignal !== 'undefined' && AbortSignal.timeout
        ? { signal: AbortSignal.timeout(8000) } : {};
    _tmplFetchCache[viewId] = fetch(fragUrl, fetchOpts).then(function (resp) {
        if (!resp.ok)
            throw new Error('Template fetch failed: ' + resp.status);
        return resp.text();
    }).then(function (html) {
        if (document.getElementById(viewId))
            return;
        const container = document.createElement('template');
        container.id = 'tmpl-' + viewId;
        container.innerHTML = html;
        const content = container.content || container;
        const clone = document.importNode(content, true);
        const main = document.getElementById('content-wrapper');
        if (main)
            main.appendChild(clone);
        else
            document.body.appendChild(clone);
    }).catch(function (err) {
        delete _tmplFetchCache[viewId];
        /* @__PURE__ */ _olDebugError('[Oxford Ledge] _materializeView fetch failed for "' + viewId + '":', err);
        const target = document.getElementById(viewId) || document.getElementById('content-wrapper');
        if (target) {
            if (target.querySelector('.ol-view-load-error'))
                return;
            const msg = document.createElement('div');
            msg.className = 'view-load-error ol-view-load-error';
            msg.innerHTML = 'Unable to load this view. Please <button type="button" class="ol-link-blue ol-view-load-refresh" data-action="page-reload">refresh</button>.';
            target.appendChild(msg);
        }
    });
    return _tmplFetchCache[viewId];
}
// S27: Views → required chunks. IIFE-wrapped, lazy-init modules.
// 2026-05-30 (#27 / DESIGN F-7, Phase 5.4): the v3 product surfaces moved
// from the `education` chunk to their own lazy `product` chunk
// (build_bundle.py JS_CHUNKS['product']). Every view whose v3 renderer lives
// in OLProduct.surfaces.* (see _v3ProductMap below) now lists 'product' so
// _ensureViewModule loads it -> the guarded-swap renders v3 consistently
// instead of only after a LEARN visit warmed education. The 'core-views' /
// 'core-portfolio' / 'research' entries stay for each view's LEGACY renderer
// (the guarded-swap fallback).
var _VIEW_CHUNK_MAP = {
    ticker: ['charts'],
    news: ['core-views', 'product'],
    portfolio: ['core-portfolio', 'product'],
    watchlist: ['core-portfolio', 'product'],
    // 2026-06-27 (macro perf): macro-view split into its own lazy 'macro' chunk
    // (JS_CHUNKS['macro'] + _CHUNK_MODULES['macro']). Loads ~84KB instead of the
    // full 216KB 'research' chunk. 'product' stays for the v3 surface renderer;
    // 'charts' was never in this list (renderIndexDecomposition is typeof-guarded
    // fail-soft) so behavior is identical.
    macro: ['macro', 'product'],
    learn: ['education'],
    credit: ['research'],
    screener: ['research'],
    bdc: ['premium'],
    calendar: ['research', 'product'],
    fundamentals: ['research'],
    'etf-screener': ['research'],
    '13f': ['research', 'product'],
    milestones: ['education', 'product'],
    usage: [],
    // Wave-3 QA (2026-07-17): settings previously mapped to NO chunk, but
    // renderSettingsPanel lives in core-enhance (settings-panel.js) and nothing
    // else loads that chunk — a cold nav to ?view=settings left the lazy
    // template's skeleton up forever (renderer never defined; observed live).
    settings: ['core-enhance'],
};
// S42: _VIEW_MODULE_MAP emptied — all modules now load via JS_CHUNKS bundles.
// _loadViewModules kept as harmless no-op for backward compat.
function _loadViewModules(_view) { }
function _ensureViewModule(view) {
    const chunks = _VIEW_CHUNK_MAP[view];
    if (!chunks || chunks.length === 0)
        return;
    const _cl = _chunksLoaded;
    // S42 task #12 root cause: short-circuit if all chunks already cached
    // to avoid microtask-queued recursion via setView re-entry.
    const allCached = chunks.every(function (c) {
        return _cl[c] && _cl[c]._olSettled;
    });
    if (allCached)
        return;
    const promises = chunks.map(function (c) { return _loadChunk(c); });
    Promise.all(promises).then(function () {
        chunks.forEach(function (c) {
            if (_cl[c])
                _cl[c]._olSettled = true;
        });
        if (currentView === view) {
            try {
                setView(view, true);
            }
            catch (e) { /* noop */ }
        }
    }).catch(function () { });
}
// ── INLINE VIEW RENDERERS (S28: zero-chunk, SSE-first) ──────────────────────
function _inlineRenderPortfolio() {
    const el = document.getElementById('portfolio-content');
    if (!el)
        return;
    const allTickers = [];
    const seen = {};
    const src = (typeof PORTFOLIO_TICKERS !== 'undefined' ? PORTFOLIO_TICKERS : []);
    for (let i = 0; i < src.length; i++) {
        if (!seen[src[i]]) {
            seen[src[i]] = 1;
            allTickers.push(src[i]);
        }
    }
    if (allTickers.length === 0) {
        el.innerHTML = OLEmpty.render({ eyebrow: 'PORTFOLIO',
            body: 'Add tickers using the search bar above to begin.' });
        return;
    }
    let rows = '';
    for (let j = 0; j < allTickers.length; j++) {
        const t = allTickers[j];
        const d = (typeof getData === 'function' ? getData(t) : (dataCache[t] || null));
        const price = d && d.price && d.price.current != null ? d.price.current : null;
        const chg = d && d.price && d.price.changePct != null ? d.price.changePct : null;
        const chgAbs = d && d.price && d.price.change != null ? d.price.change : null;
        const co = (d && (d.company || d.name || (d.profile && d.profile.name))) || t;
        const cls = chg != null ? (chg > 0 ? 'pos' : chg < 0 ? 'neg' : '') : '';
        const sign = chg != null && chg >= 0 ? '+' : '';
        const isPH = (typeof PORTFOLIO_TICKERS !== 'undefined' && PORTFOLIO_TICKERS.indexOf(t) >= 0);
        rows += '<tr class="port-row' + (isPH ? ' port-holding' : '') + '" data-action="switch-ticker" data-ticker="' + escHtml(t) + '">'
            + '<td><span class="scr-ticker-blue">' + escHtml(t) + '</span>' + (co !== t ? '<span class="port-company">' + escHtml(co) + '</span>' : '') + '</td>'
            + '<td class="num">' + (price != null ? '$' + fmt(price, 2) : '—') + '</td>'
            + '<td class="num ' + cls + '">' + (chgAbs != null ? sign + fmt(chgAbs, 2) : '—') + '</td>'
            + '<td class="num ' + cls + '">' + (chg != null ? sign + fmt(chg, 2) + '%' : '—') + '</td>'
            + '</tr>';
    }
    el.innerHTML = '<table class="data-table portfolio-table"><thead><tr>'
        + '<th>Ticker</th><th>Price</th><th>Change</th><th>%</th>'
        + '</tr></thead><tbody>' + rows + '</tbody></table>';
    const tsEl = document.getElementById('port-updated-ts');
    if (tsEl)
        tsEl.textContent = 'Updated ' + new Date().toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true, timeZone: 'America/New_York' }) + ' ET';
}
function _inlineRenderMacro() {
    const el = document.getElementById('macro-content');
    if (!el)
        return;
    const indData = (typeof indicatorsCache !== 'undefined') ? indicatorsCache : null;
    if (!indData || typeof indData !== 'object' || Object.keys(indData).length < 2) {
        el.innerHTML = '<div class="loading-msg">Loading market data...</div>';
        // FE-AUDIT 2026-06-25: share the in-flight indicators request with the other
        // cold-news callers (was 3× concurrent). getIndicators uses olFetch
        // internally so the 502-circuit-breaker is preserved; it returns a cloned
        // Response so the .then(res => res.ok ? res.json()) chain is unchanged.
        const _viIndApi = window.OLApi;
        ((_viIndApi && _viIndApi.getIndicators)
            ? _viIndApi.getIndicators({ signal: AbortSignal.timeout(15000) })
            : olFetch(((typeof SERVER !== 'undefined') ? SERVER : '') + '/api/indicators', { signal: AbortSignal.timeout(15000) }))
            .then(function (res) { return res.ok ? res.json() : Promise.reject('HTTP ' + res.status); })
            .then(function (data) {
            indicatorsCache = data;
            const dc = window.DataCache;
            if (dc && dc.keys && dc.keys.marketIndicators)
                dc.set(dc.keys.marketIndicators(), data);
            if (currentView === 'macro')
                _inlineRenderMacro();
        })
            .catch(function () {
            if (currentView === 'macro') {
                el.innerHTML = '<div class="macro-msg">Market data unavailable. <button data-action="macro-retry-view" class="btn-retry">Retry</button></div>';
            }
        });
        return;
    }
    const tsEl = document.getElementById('macro-timestamp');
    if (tsEl) {
        const meta = indData._meta;
        const _macroTs = meta && meta.fetched_at ? new Date(meta.fetched_at) : new Date();
        tsEl.textContent = 'as of ' + _macroTs.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', timeZoneName: 'short' });
    }
    const macroET = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
    const macroMin = macroET.getHours() * 60 + macroET.getMinutes();
    const macroDay = macroET.getDay();
    const marketOpen = macroMin >= 570 && macroMin < 960 && macroDay > 0 && macroDay < 6;
    void marketOpen;
    const columns = [['Indexes'], ['Commodities'], ['Rates', 'Bonds'], ['FX'], ['Shipping', 'Crypto']];
    const reorderMap = { 'Indexes': ['DIA', 'SPY', 'QQQ', 'IWM', 'VIXY'] };
    // COUNSEL 2026-10-13 HARPEX ruling sect-6.3.2 + OWNER trademark note: the legacy card's linked `credit`,
    // "· week of {asOf}", then `trademark_notice` -- twin of markets.ts _createSourceCredit / macro-view.ts.
    function _macroSourceCredit(ind) {
        const credit = String(ind.credit || '').trim(), url = String(ind.source_url || '').trim();
        if (!ind.price || !credit || !/^https:\/\//i.test(url))
            return '';
        const when = ind.asOf ? ' · ' + (ind.cadence === 'weekly' ? 'week of ' : 'as of ') + escHtml(String(ind.asOf)) : '';
        const tm = String(ind.trademark_notice || '').trim();
        return '<div class="mi-attribution"><a href="' + escAttr(url) + '" target="_blank" rel="noopener noreferrer">'
            + escHtml(credit) + '</a>' + when + '</div>'
            + (tm ? '<div class="mi-attribution">' + escHtml(tm) + '</div>' : '');
    }
    function _macroCard(ind) {
        if (!ind.price)
            return '';
        const chg = ind.changePct || 0;
        const isPos = ind.invertColor ? chg < 0 : chg > 0;
        const isNeg = ind.invertColor ? chg > 0 : chg < 0;
        const priceStr = ind.isYield ? ind.price.toFixed(3) + '%' : ind.price >= 100 ? ind.price.toLocaleString('en-US', { maximumFractionDigits: 2 }) : fmt(ind.price, 2);
        const isShipping = ind.name && (ind.name.indexOf('Drewry') >= 0 || ind.name.indexOf('HARPEX') >= 0 || ind.name.indexOf('Baltic') >= 0);
        const staleClass = ind._stale ? ' mi-stale' : '';
        const sign = chg >= 0 ? '+' : '';
        return '<div class="mi-row">'
            + '<div class="mi-name' + (isShipping ? ' mi-name-shipping' : '') + staleClass + '">' + escHtml(ind.name || '') + '</div>'
            + '<div class="mi-vals">'
            + '<span class="mi-price">' + priceStr + '</span>'
            + '<span class="mi-chg ' + (isPos ? 'pos' : isNeg ? 'neg' : '') + '">' + sign + fmt(chg, 2) + '%</span>'
            + '</div></div>';
    }
    let html = '<div class="mi-grid">';
    for (let ci = 0; ci < columns.length; ci++) {
        const groups = columns[ci];
        let hasData = false;
        for (let gi = 0; gi < groups.length; gi++) {
            const items = indData[groups[gi]];
            if (Array.isArray(items) && items.length > 0) {
                hasData = true;
                break;
            }
        }
        if (!hasData)
            continue;
        html += '<div class="mi-card">';
        for (let gi2 = 0; gi2 < groups.length; gi2++) {
            const group = groups[gi2];
            let gItems = indData[group];
            if (!Array.isArray(gItems) || gItems.length === 0)
                continue;
            if (reorderMap[group]) {
                const order = reorderMap[group];
                gItems = gItems.slice().sort(function (a, b) { return (order.indexOf(a.symbol || '') === -1 ? 99 : order.indexOf(a.symbol || '')) - (order.indexOf(b.symbol || '') === -1 ? 99 : order.indexOf(b.symbol || '')); });
            }
            html += '<div class="mi-group-title">' + escHtml(group) + '</div><div>';
            for (let ii = 0; ii < gItems.length; ii++)
                html += _macroCard(gItems[ii]);
            html += '</div>';
            for (let ci2 = 0; ci2 < gItems.length; ci2++)
                html += _macroSourceCredit(gItems[ci2]);
            // OWNER ruling 2026-10-26: FRED's API notice once under a group showing a FRED figure.
            html += olFredNoticeHtml(gItems.some(olIsFredFigure));
        }
        html += '</div>';
    }
    html += '</div>';
    html += '<div class="mi-attribution">Data via <a href="https://fred.stlouisfed.org/" target="_blank" rel="noopener">FRED</a>, Federal Reserve Bank of St. Louis.</div>';
    el.innerHTML = html;
    if (typeof renderMarketBriefing === 'function')
        try {
            renderMarketBriefing();
        }
        catch (e) { /* noop */ }
}
function _inlineRenderWatchlist() {
    const el = document.getElementById('wl-table-wrap');
    if (!el)
        return;
    let wlItems = [];
    try {
        const raw = OLStorage.getString('ol_watchlist', null);
        if (raw)
            wlItems = JSON.parse(raw);
    }
    catch (e) { /* noop */ }
    if (wlItems.length === 0 && typeof isLive !== 'undefined' && isLive && !(typeof olIsAnonymous === 'function' && olIsAnonymous())) { // QA-18: require_auth -- anon takes the empty state below, no 401
        el.innerHTML = '<div class="loading-msg">Loading watchlist...</div>';
        fetch(((typeof SERVER !== 'undefined') ? SERVER : '') + '/api/watchlist', { signal: AbortSignal.timeout(15000) })
            .then(function (res) { return res.ok ? res.json() : Promise.reject('HTTP ' + res.status); })
            .then(function (data) {
            if (Array.isArray(data) && data.length > 0) {
                OLStorage.set('ol_watchlist', data);
                if (currentView === 'watchlist') {
                    _renderWatchlistItems(el, data);
                }
            }
            else {
                el.innerHTML = OLEmpty.render({ eyebrow: 'WATCHLIST',
                    body: 'Track tickers through your research pipeline. Add a ticker above to start.' });
            }
        })
            .catch(function () {
            el.innerHTML = OLEmpty.render({ eyebrow: 'WATCHLIST',
                body: 'Track tickers through your research pipeline. Add a ticker above to start.' });
        });
        return;
    }
    if (wlItems.length === 0) {
        el.innerHTML = OLEmpty.render({ eyebrow: 'WATCHLIST',
            body: 'Track tickers through your research pipeline. Add a ticker above to start.' });
        return;
    }
    _renderWatchlistItems(el, wlItems);
}
function _renderWatchlistItems(el, items) {
    let rows = '';
    for (let i = 0; i < items.length; i++) {
        const w = items[i];
        const t = w.ticker || w.symbol || '';
        const stage = w.stage || 'monitoring';
        const conv = w.conviction != null ? w.conviction : '';
        const notes = w.notes || w.thesis || '';
        const d = (typeof getData === 'function' ? getData(t) : (typeof dataCache !== 'undefined' && dataCache[t] ? dataCache[t] : null));
        const price = d && d.price && d.price.current != null ? '$' + fmt(d.price.current, 2) : '—';
        const chg = d && d.price && d.price.changePct != null ? d.price.changePct : null;
        const sign = chg != null && chg >= 0 ? '+' : '';
        const chgCls = chg != null ? (chg > 0 ? 'pos' : chg < 0 ? 'neg' : '') : '';
        rows += '<tr data-action="switch-ticker" data-ticker="' + escHtml(t) + '">'
            + '<td><span class="scr-ticker-blue">' + escHtml(t) + '</span></td>'
            + '<td class="num">' + price + '</td>'
            + '<td class="num ' + chgCls + '">' + (chg != null ? sign + fmt(chg, 2) + '%' : '—') + '</td>'
            + '<td><span class="wl-stage wl-stage-' + escHtml(stage) + '">' + escHtml(stage) + '</span></td>'
            + '<td class="num">' + (conv !== '' ? conv + '/10' : '—') + '</td>'
            + '<td class="port-company"' + (notes.length > 60 ? ' title="' + escHtml(notes) + '"' : '') + '>' + escHtml(notes.substring(0, 60)) + (notes.length > 60 ? '...' : '') + '</td>'
            + '</tr>';
    }
    el.innerHTML = '<table class="data-table"><thead><tr>'
        + '<th>Ticker</th><th>Price</th><th>Chg%</th><th>Stage</th><th>Conv.</th><th>Notes</th>'
        + '</tr></thead><tbody>' + rows + '</tbody></table>';
}
var _learnPathsCache = null;
// LEARN flash fix Phase B (2026-06-04): timer that falls back to the legacy
// grid if the v3 `education` chunk never loads. Bundle-global `var` (not
// const/let) per the file-header terser-parse contract.
var _learnV3FallbackTimer = null;
function _getLearnProgress() {
    return OLStorage.get('ol_learn_progress', { completedModules: [], lastActive: null });
}
function _saveLearnProgress(prog) {
    OLStorage.set('ol_learn_progress', prog);
    if (typeof _lpSyncModuleToServer === 'function')
        _lpSyncModuleToServer();
}
// #126 (OWNER 2026-06-04): elegant, closeable "register free to unlock" panel
// for an anon visitor who deep-links to a specific lesson (/?view=learn&path=…&
// module=…) but the gated module won't open. Shown once per page. The primary
// CTA opens the existing register modal (authOpenModal); backdrop / Esc / "Keep
// browsing" all dismiss. Reuses the .ol-empty editorial typography vocabulary;
// the overlay/card/button chrome is .ol-anon-gate-* (oxford.css). innerHTML uses
// a static string (no inline handlers — CSP-safe; no canvas children).
function _showAnonLessonGate() {
    const w = window;
    if (w._olAnonLessonGateShown)
        return;
    if (document.getElementById('ol-anon-gate-overlay'))
        return;
    w._olAnonLessonGateShown = true;
    const overlay = document.createElement('div');
    overlay.id = 'ol-anon-gate-overlay';
    overlay.className = 'ol-anon-gate-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Create a free account to open this lesson');
    const card = document.createElement('div');
    card.className = 'ol-anon-gate-card';
    card.innerHTML =
        '<div class="ol-empty-eyebrow">LEARN · FREE</div>'
            + '<div class="ol-empty-title">Create a free account to open this lesson</div>'
            + '<div class="ol-empty-body">Every learning module is free with an account — plus progress tracking and your reading list. No card required.</div>';
    const actions = document.createElement('div');
    actions.className = 'ol-anon-gate-actions';
    const cta = document.createElement('button');
    cta.type = 'button';
    cta.className = 'ol-anon-gate-cta';
    cta.textContent = 'Create free account →';
    const later = document.createElement('button');
    later.type = 'button';
    later.className = 'ol-anon-gate-later';
    later.textContent = 'Keep browsing';
    actions.appendChild(cta);
    actions.appendChild(later);
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'ol-anon-gate-close';
    close.setAttribute('aria-label', 'Close');
    close.textContent = '×';
    card.appendChild(close);
    card.appendChild(actions);
    overlay.appendChild(card);
    function _dismiss() {
        try {
            if (overlay.parentNode)
                overlay.parentNode.removeChild(overlay);
        }
        catch (_e) { /* noop */ }
        document.removeEventListener('keydown', _onKey);
    }
    function _onKey(e) { if (e.key === 'Escape')
        _dismiss(); }
    close.addEventListener('click', _dismiss);
    later.addEventListener('click', _dismiss);
    cta.addEventListener('click', function () {
        _dismiss();
        try {
            if (typeof w.authOpenModal === 'function')
                w.authOpenModal('register');
        }
        catch (_e) { /* noop */ }
    });
    overlay.addEventListener('click', function (e) { if (e.target === overlay)
        _dismiss(); });
    document.addEventListener('keydown', _onKey);
    document.body.appendChild(overlay);
}
function _inlineRenderLearn() {
    const el = document.getElementById('learn-view-content');
    if (!el)
        return;
    if (_learnPathsCache) {
        _renderLearnCards(el, _learnPathsCache);
        return;
    }
    el.innerHTML = '<div class="loading-msg">Loading learning paths...</div>';
    const w = window;
    if (!w.OLApi)
        return;
    w.OLApi.getLearningPaths({ signal: AbortSignal.timeout(15000) })
        .then(function (data) {
        const paths = (Array.isArray(data) ? data : (data && data.paths ? data.paths : []));
        _learnPathsCache = paths;
        if (currentView === 'learn')
            _renderLearnCards(el, paths);
    })
        .catch(function () {
        if (currentView === 'learn') {
            el.innerHTML = OLEmpty.render({ eyebrow: 'LEARN',
                body: 'Learning paths are loading. Check back shortly.' });
        }
    });
}
// LEARN flash fix Phase B (2026-06-04, docs/plans/LEARN_LEGACY_FLASH_FIX.md §3
// Option B). The cold-load "prior version flash" (#58/#88/#99 class) is the
// LEGACY card grid painting via _inlineRenderLearn while the `education` chunk
// (which carries the flash-free v3 `renderLearningPaths` scaffold) is still
// downloading. Phase A (idle-preload, _idle_loader.ts) shrank but did NOT kill
// it on cold / incognito sessions -- 375 kB cannot beat a fast nav, and the
// OWNER confirmed the flash still fires (2026-06-04 browser-verify, legacy grid
// -> v3 landing swap). Phase B: when the v3 renderer is not loaded yet, paint the
// SKELETON (never the legacy grid). _ensureViewModule('learn') — already called
// at the top of setView — is fetching the chunk and re-calls setView('learn')
// on resolve, at which point renderMap.learn resolves to renderLearningPaths and
// the v3 scaffold paints. _inlineRenderLearn is kept ONLY as a true failure
// fallback (chunk never loads) so we never trade a flash for a stuck skeleton.
function _learnPendingV3() {
    const el = document.getElementById('learn-view-content');
    if (!el)
        return;
    // Show the skeleton instead of the legacy grid. (The template ships one in
    // #learn-view-content on first paint, but a prior LEARN visit may have
    // replaced it, so re-inject when absent.) Same markup/classes as the
    // template skeleton (static/templates/learn-view.html).
    if (!document.getElementById('learn-skeleton')) {
        el.innerHTML = _learnScaffoldSkeleton();
    }
    // Failure fallback: if v3 still is not loaded after the timeout (the chunk
    // fetch genuinely failed), the legacy grid beats a stuck skeleton. The
    // _ensureViewModule re-render is the happy path; this only fires on failure.
    if (_learnV3FallbackTimer) {
        clearTimeout(_learnV3FallbackTimer);
    }
    _learnV3FallbackTimer = setTimeout(function () {
        _learnV3FallbackTimer = null;
        if (currentView !== 'learn')
            return; // user navigated away
        if (typeof renderLearningPaths === 'function')
            return; // v3 took over — no-op
        try {
            _inlineRenderLearn();
        }
        catch (_e) { /* leave skeleton up */ }
    }, 8000);
}
function _renderLearnCards(el, paths) {
    if (!paths || paths.length === 0) {
        el.innerHTML = OLEmpty.render({ eyebrow: 'LEARN',
            body: 'No learning paths available yet.' });
        return;
    }
    const esc = typeof escHtml === 'function' ? escHtml : function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
    const prog = _getLearnProgress();
    const done = prog.completedModules || [];
    const last = prog.lastActive;
    // 2026-05-06 brand-audit Round 2: was three semantic colors (green
    // beginner / blue intermediate / gold advanced) — three indicator
    // colors is a dashboard pattern, not editorial. Per Brand v2 P7
    // "gold as seasoning" + audit recommendation ("use one color and
    // rely on the label to do the work"), all three levels now use
    // --text-muted for foreground + bar + a uniform faint border.
    // The Beginner/Intermediate/Advanced LABEL carries the level
    // distinction; the dot is just an inline-flex spacer.
    const levelCfg = {
        beginner: { label: 'Beginner', fg: 'var(--text-muted)', bg: 'transparent', bar: 'var(--text-muted)', order: 0 },
        intermediate: { label: 'Intermediate', fg: 'var(--text-muted)', bg: 'transparent', bar: 'var(--text-muted)', order: 1 },
        advanced: { label: 'Advanced', fg: 'var(--text-muted)', bg: 'transparent', bar: 'var(--text-muted)', order: 2 }
    };
    const groups = { beginner: [], intermediate: [], advanced: [] };
    for (let i = 0; i < paths.length; i++) {
        const lvl = (paths[i].level || 'beginner').toLowerCase();
        if (!groups[lvl])
            groups[lvl] = [];
        groups[lvl].push(paths[i]);
    }
    let continueHtml = '';
    if (last && last.pathId) {
        for (let ci = 0; ci < paths.length; ci++) {
            if (paths[ci].id === last.pathId) {
                const cp = paths[ci];
                const cm = cp.modules || [];
                let cdone = 0;
                for (let cj = 0; cj < cm.length; cj++) {
                    if (done.indexOf(cm[cj].id || '') >= 0)
                        cdone++;
                }
                if (cdone < cm.length) {
                    const clvl = levelCfg[(cp.level || 'beginner').toLowerCase()] || levelCfg.beginner;
                    const cpct = cm.length > 0 ? Math.round((cdone / cm.length) * 100) : 0;
                    let nextMod = '';
                    for (let cn = 0; cn < cm.length; cn++) {
                        if (done.indexOf(cm[cn].id || '') < 0) {
                            nextMod = cm[cn].title || '';
                            break;
                        }
                    }
                    continueHtml = '<div class="lp-continue-wrap">'
                        + '<div class="lp-section-label">Continue Learning</div>'
                        + '<div data-learn-path="' + esc(cp.id || '') + '" class="lp-continue-card vr-level-card" data-bc="' + clvl.bar + '">'
                        + '<div class="lp-continue-card__header">'
                        + '<div class="lp-continue-card__title">' + esc(cp.title || '') + '</div>'
                        + '<span class="lp-continue-card__pct vr-level-label" data-fg="' + clvl.fg + '">' + cpct + '% complete</span></div>'
                        + '<div class="progress-track lp-progress--continue"><div class="progress-fill vr-level-fill" data-w="' + cpct + '" data-bg="' + clvl.bar + '"></div></div>'
                        + '<div class="lp-continue-card__next">Next: ' + esc(nextMod) + '</div>'
                        + '</div></div>';
                }
                break;
            }
        }
    }
    let sectionsHtml = '';
    const levelOrder = ['beginner', 'intermediate', 'advanced'];
    for (let li = 0; li < levelOrder.length; li++) {
        const lvlKey = levelOrder[li];
        const gp = groups[lvlKey];
        if (!gp || gp.length === 0)
            continue;
        const lc = levelCfg[lvlKey] || levelCfg.beginner;
        sectionsHtml += '<div data-learn-level="' + lvlKey + '" class="lp-level-section">'
            + '<div class="lp-level-header vr-level-label" data-fg="' + lc.fg + '">'
            + '<span class="lp-level-dot vr-cal-badge" data-bg="' + lc.bar + '"></span>' + lc.label + ' (' + gp.length + ')</div>';
        for (let gi = 0; gi < gp.length; gi++) {
            const p = gp[gi];
            const mods = p.modules || [];
            let mDone = 0;
            for (let mi = 0; mi < mods.length; mi++) {
                if (done.indexOf(mods[mi].id || '') >= 0)
                    mDone++;
            }
            const pct = mods.length > 0 ? Math.round((mDone / mods.length) * 100) : 0;
            const isComplete = mDone === mods.length && mods.length > 0;
            sectionsHtml += '<div data-learn-path="' + esc(p.id || '') + '" class="lp-path-card">'
                + '<div class="lp-path-card__inner">'
                + '<div class="lp-path-card__body">'
                + '<div class="lp-path-card__title-row">'
                + '<span class="lp-path-card__title">' + esc(p.title || '') + '</span>'
                + (isComplete ? '<span class="lp-complete-badge">COMPLETE</span>' : '')
                + '</div>'
                + '<div class="lp-path-card__progress-row">'
                + '<div class="progress-track lp-progress--card"><div class="progress-fill vr-level-fill" data-w="' + pct + '" data-bg="' + lc.bar + '"></div></div>'
                + '<span class="lp-path-card__count">' + mDone + '/' + mods.length + '</span>'
                + '</div></div>'
                + '<span class="lp-chevron" data-learn-chevron>▶</span>'
                + '</div>'
                + '<div data-learn-modules="' + esc(p.id || '') + '" class="lp-modules-panel hidden"></div>'
                + '</div>';
        }
        sectionsHtml += '</div>';
    }
    const filterHtml = '<div class="li-level-filters">'
        + '<button class="li-filter-btn active" data-level="all">All</button>'
        + '<button class="li-filter-btn" data-level="beginner">Beginner</button>'
        + '<button class="li-filter-btn" data-level="intermediate">Intermediate</button>'
        + '<button class="li-filter-btn" data-level="advanced">Advanced</button>'
        + '<span class="li-filter-sep" aria-hidden="true"></span>'
        + '<button class="li-filter-btn" data-action="toggle-reading-list">Ledge Reads</button>'
        + '<button class="li-filter-btn" data-action="toggle-investment-lore">Investment Lore</button>'
        + '<button class="li-filter-btn" data-action="toggle-defunct-companies">Market History</button>'
        + '</div>';
    el.innerHTML = filterHtml + continueHtml + sectionsHtml;
    _hydrateVRStyles(el);
    el.querySelectorAll('.li-filter-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
            el.querySelectorAll('.li-filter-btn').forEach(function (b) { b.classList.remove('active'); });
            btn.classList.add('active');
            const level = btn.dataset.level;
            const sections = el.querySelectorAll('[data-learn-level]');
            sections.forEach(function (sec) {
                sec.classList.toggle('hidden', !(level === 'all' || sec.dataset.learnLevel === level));
            });
        });
    });
    el.onclick = function (e) {
        const target = e.target;
        const quizOpt = target.closest ? target.closest('[data-quiz-opt]') : null;
        if (quizOpt) {
            const quizWrap = quizOpt.closest('[data-quiz-for]');
            if (!quizWrap)
                return;
            const modId = quizWrap.getAttribute('data-quiz-for') || '';
            const chosen = parseInt(quizOpt.getAttribute('data-quiz-opt') || '0', 10);
            const correct = parseInt(quizWrap.getAttribute('data-quiz-correct') || '0', 10);
            const allOpts = quizWrap.querySelectorAll('[data-quiz-opt]');
            for (let qi = 0; qi < allOpts.length; qi++) {
                const qIdx = parseInt(allOpts[qi].getAttribute('data-quiz-opt') || '0', 10);
                allOpts[qi].classList.add('lp-quiz__opt--locked');
                if (qIdx === correct) {
                    allOpts[qi].classList.add('lp-quiz__opt--correct');
                }
                else if (qIdx === chosen && qIdx !== correct) {
                    allOpts[qi].classList.add('lp-quiz__opt--wrong');
                }
                else {
                    allOpts[qi].classList.add('lp-quiz__opt--faded');
                }
            }
            const expEl = quizWrap.querySelector('[data-quiz-explanation]');
            if (expEl)
                expEl.classList.remove('hidden');
            if (chosen === correct) {
                const pr = _getLearnProgress();
                if (pr.completedModules.indexOf(modId) < 0) {
                    pr.completedModules.push(modId);
                    _saveLearnProgress(pr);
                }
                if (currentView === 'learn')
                    setTimeout(function () { _renderLearnCards(el, _learnPathsCache); }, 800);
            }
            return;
        }
        const modRow = target.closest ? target.closest('[data-learn-mod]') : null;
        if (modRow) {
            const mId = modRow.getAttribute('data-learn-mod') || '';
            const pId = modRow.getAttribute('data-learn-path-id') || '';
            const contentEl = modRow.querySelector('[data-mod-content]');
            if (contentEl) {
                const showing = !contentEl.classList.contains('hidden');
                if (showing) {
                    contentEl.classList.add('hidden');
                }
                else {
                    contentEl.classList.remove('hidden');
                }
                if (!showing) {
                    const pr2 = _getLearnProgress();
                    pr2.lastActive = { pathId: pId, moduleId: mId, timestamp: Date.now() };
                    _saveLearnProgress(pr2);
                }
            }
            return;
        }
        const pathCard = target.closest ? target.closest('[data-learn-path]') : null;
        if (pathCard) {
            const pathId = pathCard.getAttribute('data-learn-path') || '';
            const modsContainer = pathCard.querySelector('[data-learn-modules]');
            if (!modsContainer)
                return;
            const isOpen = !modsContainer.classList.contains('hidden');
            const chev = pathCard.querySelector('[data-learn-chevron]');
            if (isOpen) {
                modsContainer.classList.add('hidden');
                if (chev)
                    chev.textContent = '▶';
            }
            else {
                if (!modsContainer.innerHTML) {
                    let pathData = null;
                    for (let pi = 0; pi < paths.length; pi++) {
                        if (paths[pi].id === pathId) {
                            pathData = paths[pi];
                            break;
                        }
                    }
                    if (!pathData)
                        return;
                    const mList = pathData.modules || [];
                    const curProg = _getLearnProgress();
                    const curDone = curProg.completedModules || [];
                    let foundNext = false;
                    let mHtml = '';
                    for (let mx = 0; mx < mList.length; mx++) {
                        const m = mList[mx];
                        const isDone = curDone.indexOf(m.id || '') >= 0;
                        const isNext = !isDone && !foundNext;
                        if (isNext)
                            foundNext = true;
                        const checkmark = isDone ? '<span class="lp-mod-checkmark lp-mod-checkmark--done">✓</span>'
                            : '<span class="lp-mod-checkmark lp-mod-checkmark--num">' + (mx + 1) + '</span>';
                        const titleStateCls = isNext ? 'lp-mod-title--next' : isDone ? 'lp-mod-title--done' : 'lp-mod-title--pending';
                        mHtml += '<div data-learn-mod="' + esc(m.id || '') + '" data-learn-path-id="' + esc(pathId) + '" class="lp-mod-row">'
                            + '<div class="lp-mod-row__inner">'
                            + checkmark
                            + '<span class="lp-mod-title ' + titleStateCls + '">' + esc(m.title || '') + '</span>'
                            + (m.type === 'practice' ? '<span class="lp-practice-badge">Practice</span>' : '')
                            + '</div>'
                            + '<div data-mod-content class="lp-mod-content hidden">'
                            + '<div class="lp-mod-content__text">' + esc(m.content || '') + '</div>'
                            + (m.action ? '<div class="lp-mod-content__action">➤ ' + esc(m.action) + '</div>' : '');
                        if (m.quiz) {
                            const q = m.quiz;
                            mHtml += '<div data-quiz-for="' + esc(m.id || '') + '" data-quiz-correct="' + q.correct + '" class="lp-quiz">'
                                + '<div class="lp-quiz__question">' + esc(q.question || '') + '</div>';
                            const opts = q.options || [];
                            for (let oi = 0; oi < opts.length; oi++) {
                                mHtml += '<div data-quiz-opt="' + oi + '" class="lp-quiz__opt">' + esc(opts[oi]) + '</div>';
                            }
                            mHtml += '<div data-quiz-explanation class="lp-quiz__explanation hidden">' + esc(q.explanation || '') + '</div>';
                            mHtml += '</div>';
                        }
                        mHtml += '</div></div>';
                    }
                    modsContainer.innerHTML = mHtml;
                }
                modsContainer.classList.remove('hidden');
                if (chev)
                    chev.textContent = '▼';
            }
        }
    };
}
// ── INLINE RENDERERS: Credit, BDC, Calendar, Screener, Fundamentals, ETF Screener ──
var _creditSpreadCache = null;
void _creditSpreadCache;
// _inlineRenderCredit removed 2026-07-21: backend commit e2bb153e fail-closed
// the third-party FRED Credit group (ICE HY/IG OAS) + CBOE VIX, so the inline
// fallback's scan of the now-fail-closed Credit group was always empty. The
// credit view's real renderer is renderCreditView (credit-view.ts, 'research'
// chunk); the renderMap below falls back to null (chunk-load re-render / the
// ViewManager path) exactly like the `news` entry, so no inline fallback is
// needed. The retry-credit action wiring in app-renderers.ts was removed in
// the same change.
var _bdcListCache = null;
// Wave-2 F9 (2026-07-16 prod-QA): /?view=bdc&ticker=ARCC — the landing shape
// of every BDC SSR CTA ("Analyze ARCC in Ledge", bdc-detail.html:126 +
// ssr_bdc.py CTAs) — rendered the GENERIC browser: nothing consumed the
// ticker param before setView's history.pushState('?view=bdc') destroyed it.
// setView stashes the param here at entry (pre-rewrite); the bdc post-switch
// block consumes it via bdcSearchBdc(ticker).
var _bdcDeepLinkTicker = null;
// SF-PRIVATE-CREDIT-COPILOT T7 (2026-09-13, placement CYCLE MOBILE_OPS M-6): the
// two sibling deep-link params the SSR hero anchors carry (/?view=bdc&ticker=T
// &ask=1 and /?view=bdc&borrower=<norm>&ask=1). Stashed at the SAME pre-pushState
// point as the ticker (cold boot only), consumed in the SAME post-switch block
// AFTER the lookups settle. `borrower` is URL text: it only ever becomes an
// input VALUE that bdcSearchBorrower URL-encodes into its own fetch (the server
// resolves it); nothing from the URL is rendered as markup or executed.
var _bdcDeepLinkBorrower = null;
var _bdcDeepLinkAsk = false;
// Consume the stashed intent once the lazy bdc-view chunk has landed: the BDC
// portfolio (ticker), then the borrower lookup (input prefilled from the norm,
// idempotent under normalize_borrower_name), and only THEN -- when ask=1 rode
// the URL -- the lazy `premium` chunk and the panel's deep-link opener. A failed
// lookup still opens the panel: the panel is the thing the reader tapped for.
function _bdcConsumeDeepLink(ticker, borrower, ask) {
    let chain = Promise.resolve();
    if (ticker && typeof bdcSearchBdc === 'function') {
        const _t = ticker;
        chain = chain.then(function () { return bdcSearchBdc(_t); }).catch(function () { });
    }
    if (borrower) {
        const _b = borrower;
        chain = chain.then(function () {
            const inp = document.getElementById('bdc-borrower-input');
            if (inp)
                inp.value = _b;
            if (inp && typeof bdcSearchBorrower === 'function')
                return bdcSearchBorrower();
            return undefined;
        }).catch(function () { });
    }
    if (ask) {
        chain.then(function () { return _loadChunk('premium'); }).then(function () {
            if (currentView !== 'bdc')
                return;
            if (typeof _askAiOpen !== 'undefined' && _askAiOpen)
                return;
            if (typeof _askAiOpenForContextView === 'function')
                _askAiOpenForContextView('ssr_anchor');
        }).catch(function () { });
    }
}
// SF_INDUSTRY_RESEARCH lazy SPA renderer for /?view=industry. Clones the
// _inlineRenderBDC pattern — module-level caches, guarded fetch, empty/error
// fallbacks, innerHTML into fresh result divs (no canvas children, safe per
// feedback_never_destroy_dom). Two segments: federal-contractor leaderboard
// (Phase 1) + FDIC bank explorer (Phase 2). _inlineRenderIndustry is the tab
// controller — it wires the segment buttons idempotently (btn.onclick replaces,
// so re-entry never double-binds) and lazily fetches each segment on first show.
// The default segment reads location.search ?tab= directly (the data-* attr does
// not carry the query param — same pattern as the 13f fund= deep-link).
var _industryContractorsCache = null;
// The contractors fiscal year, cached ALONGSIDE the rows because the header
// span it feeds is shared by all 19 tabs and gets cleared on every switch
// (see showTab). The row cache alone is not enough to restore it.
var _industryContractorsFY = null;
/** Write the federal-contractor obligations year into the shared card header.
 *  Sole writer, so "which tab owns this label" has exactly one answer. */
function _setContractorsMetaFY(fy) {
    const meta = document.getElementById('industry-contractors-meta');
    if (meta)
        meta.textContent = fy ? 'FY' + fy : '';
}
var _industryBanksCache = null;
var _industryBanksAsOf = null;
// SF-KPI Phase 2 cross-issuer operating-metric peer tables (the /?view=industry
// comps tabs) were EXTRACTED to static/js/industry-comps.ts by the #295 D1b cut
// -- the KpiPeer* interfaces, the _kpiPeerTabs registry, _kpiPeerTabByName,
// _fmtQuarter, _kpiPeerTogglePanels, _kpiPeerProbeTabs, _fetchIndustryKpiPeers
// and _renderKpiPeerTable all live there now. Script-mode concat, same
// "app-init" chunk, registered immediately after view-router.js -- the
// controller below calls into it by function name at runtime.
function _inlineRenderIndustry() {
    const cEl = document.getElementById('industry-contractors-results');
    if (!cEl)
        return; // fragment not materialized yet
    const bEl = document.getElementById('industry-banks-results');
    const cPanel = document.getElementById('industry-contractors-panel');
    const bPanel = document.getElementById('industry-banks-panel');
    const aPanel = document.getElementById('industry-atlas-panel');
    const btns = Array.prototype.slice.call(document.querySelectorAll('.industry-seg-btn'));
    function showTab(tab) {
        if (cPanel)
            cPanel.classList.toggle('d-none', tab !== 'contractors');
        if (bPanel)
            bPanel.classList.toggle('d-none', tab !== 'banks');
        if (aPanel)
            aPanel.classList.toggle('d-none', tab !== 'atlas');
        // Browser QA 2026-07-28: #industry-contractors-meta lives in the SHARED
        // card header, not inside a tab body, so the "FY2025" that
        // _fetchIndustryContractors writes rode along on all 19 tabs. On Discount
        // stores it sat directly above a table of 2026-Q1 figures, asserting a
        // period a year off; on Airlines or Hotels it named a federal-obligations
        // fiscal year that has nothing to do with the panel. Same class as the
        // false "ended Mar 31, 2026" period-end fixed in 6ff1321d earlier today:
        // a period label that is only true for the surface it was written for.
        // The span dates to when this view had TWO segments (the template comment
        // still says so) and a contractors-only annotation was unambiguous.
        // Clear on every switch; the contractors fetch re-sets it from its own
        // cached payload below. Withhold rather than guess — an empty header is
        // honest, a wrong year is not.
        const _meta = document.getElementById('industry-contractors-meta');
        if (_meta && tab !== 'contractors')
            _meta.textContent = '';
        _kpiPeerTogglePanels(tab);
        for (let i = 0; i < btns.length; i++) {
            const on = btns[i].getAttribute('data-tab') === tab;
            btns[i].classList.toggle('active', on);
            btns[i].setAttribute('aria-selected', on ? 'true' : 'false');
        }
        if (tab === 'atlas') {
            const aEl = document.getElementById('industry-atlas-results');
            if (aEl)
                _renderKpiAtlas(aEl);
            return;
        }
        if (tab === 'banks') {
            if (bEl)
                _fetchIndustryBanks(bEl);
            return;
        }
        const peer = _kpiPeerTabByName(tab);
        if (peer) {
            const el = document.getElementById('industry-' + tab + '-results');
            if (el)
                _fetchIndustryKpiPeers(el, peer);
            return;
        }
        if (cEl) {
            _fetchIndustryContractors(cEl);
        }
    }
    // K1 (2026-10-05): ONE roster request reveals the KPI peer tabs whose table
    // has data (industry-comps.ts; the per-tab probe is its offline fallback).
    void _fetchKpiRoster();
    for (let i = 0; i < btns.length; i++) {
        (function (b) {
            b.onclick = function () {
                // K3: a user switch is a history entry, so Back returns to the atlas.
                const tab = b.getAttribute('data-tab') || 'atlas';
                const url = '?view=industry' + (tab === 'atlas' ? '' : '&tab=' + encodeURIComponent(tab));
                try {
                    if (location.search !== url)
                        history.pushState({ view: 'industry' }, '', url);
                }
                catch (_e) { /* best-effort */ }
                showTab(tab);
            };
        })(btns[i]);
    }
    // Which segment to open. Two sources, because an in-app sidecar click does a
    // client-side setView('industry') that does NOT carry the anchor's ?tab= into
    // location.search (setView's pushState rewrites the URL to bare ?view=industry
    // — the same F9 trap the BDC ticker deep-link hit). So the shared
    // set-view-close-feature-sidecar handler stashes the clicked item's data-tab on
    // a window field we consume+clear here; a cold-boot / full-nav / modified-click
    // deep-link still carries ?tab=banks in location.search.
    let _pendingTab = null;
    try {
        const _w = window;
        _pendingTab = _w.__olPendingViewTab || null;
        _w.__olPendingViewTab = null;
    }
    catch (_e) { /* noop — best-effort deep-link */ }
    // Post-deploy QA 2026-07-28 (#316 arc): the old banks-only special case
    // sent every OTHER ?tab= deep-link — including the SSR /industries pages'
    // own in-app CTA (?view=industry&tab=<kpi tab>) — to Federal contractors.
    // Honor ANY tab that has a rendered segment button; unknown values still
    // fall back to contractors, so a stale link can never select nothing.
    const _tabMatch = /[?&]tab=([A-Za-z0-9_-]+)/.exec(location.search);
    const _wantTab = _pendingTab || (_tabMatch ? _tabMatch[1] : null);
    let _tabKnown = false;
    for (let i = 0; i < btns.length; i++) {
        if (btns[i].getAttribute('data-tab') === _wantTab) {
            _tabKnown = true;
            break;
        }
    }
    showTab(_tabKnown && _wantTab ? _wantTab : 'atlas'); // K3: no ?tab= opens the atlas
}
function _fetchIndustryContractors(el) {
    if (_industryContractorsCache) {
        // Re-assert the year: showTab() clears the shared header on every non-
        // contractors tab, and this cache branch skips the fetch that first set it.
        // Without this, returning to contractors would show a BLANK year — trading
        // a wrong label for a missing one.
        _setContractorsMetaFY(_industryContractorsFY);
        _renderIndustryContractors(el, _industryContractorsCache);
        return;
    }
    el.innerHTML = '<div class="status-msg status-msg--muted">Loading federal-contractor leaderboard...</div>';
    fetch(((typeof SERVER !== 'undefined') ? SERVER : '') + '/api/industry/federal-contractors', { signal: AbortSignal.timeout(15000) })
        .then(function (res) { return res.ok ? res.json() : Promise.reject('HTTP ' + res.status); })
        .then(function (data) {
        const items = (data && Array.isArray(data.items)) ? data.items : [];
        _industryContractorsCache = items;
        _industryContractorsFY = (data && data.fiscal_year) ? data.fiscal_year : null;
        _setContractorsMetaFY(_industryContractorsFY);
        if (currentView === 'industry')
            _renderIndustryContractors(el, items);
    })
        .catch(function () {
        if (currentView === 'industry') {
            el.innerHTML = '<div class="status-msg status-msg--muted">Federal-contractor data unavailable right now.</div>';
        }
    });
}
function _renderIndustryContractors(el, items) {
    if (!items || items.length === 0) {
        el.innerHTML = '<div class="status-msg status-msg--muted">No federal-contractor data available.</div>';
        return;
    }
    // .industry-table-wrap = overflow-x scroll container so the 4-col table can't
    // clip columns on a narrow screen (body overflow-x is hidden) — same pattern
    // as the sibling f13/cb/scr data tables (MOBILE OPS 2026-07-19).
    let html = '<div class="industry-table-wrap"><table class="ol-data-table industry-contractors-table"><thead><tr>'
        + '<th class="text-right">#</th><th>Company</th>'
        + '<th class="text-right">Federal obligations</th><th class="text-right"># Awards</th>'
        + '</tr></thead><tbody>';
    for (let i = 0; i < items.length; i++) {
        const r = items[i];
        const ticker = r.ticker || '';
        const oblig = fmtAbbrev(r.total_obligations_usd, { dollars: true });
        const awards = (r.entity_count != null) ? String(r.entity_count) : '—';
        // #287 (OWNER QA): full company name, Banks & FDIC style — name
        // prominent + ticker as the secondary chip. An unresolved name renders
        // ticker-only (the backend never sends ticker-as-name).
        const nm = r.name || '';
        const companyCell = nm
            ? '<span class="text-primary">' + escHtml(nm) + '</span>'
                + ' <span class="text-muted fs-9">' + escHtml(ticker) + '</span>'
            : '<span class="text-primary">' + escHtml(ticker) + '</span>';
        html += '<tr class="ol-cursor-pointer learn-card-hover" data-action="switch-ticker" data-ticker="' + escHtml(ticker) + '">'
            + '<td class="text-right text-muted">' + (i + 1) + '</td>'
            + '<td class="fw-600">' + companyCell + '</td>'
            + '<td class="text-right">' + escHtml(oblig) + '</td>'
            + '<td class="text-right text-muted">' + escHtml(awards) + '</td>'
            + '</tr>';
    }
    html += '</tbody></table></div>';
    el.innerHTML = html;
}
function _fetchIndustryBanks(el) {
    if (_industryBanksCache) {
        _renderIndustryBanks(el, _industryBanksCache);
        return;
    }
    el.innerHTML = '<div class="status-msg status-msg--muted">Loading FDIC bank explorer...</div>';
    fetch(((typeof SERVER !== 'undefined') ? SERVER : '') + '/api/industry/banks', { signal: AbortSignal.timeout(15000) })
        .then(function (res) { return res.ok ? res.json() : Promise.reject('HTTP ' + res.status); })
        .then(function (data) {
        const items = (data && Array.isArray(data.items)) ? data.items : [];
        _industryBanksCache = items;
        _industryBanksAsOf = (data && data.as_of) ? String(data.as_of) : null;
        if (currentView === 'industry')
            _renderIndustryBanks(el, items);
    })
        .catch(function () {
        if (currentView === 'industry') {
            el.innerHTML = '<div class="status-msg status-msg--muted">FDIC bank data unavailable right now.</div>';
        }
    });
}
function _renderIndustryBanks(el, items) {
    if (!items || items.length === 0) {
        el.innerHTML = '<div class="status-msg status-msg--muted">No FDIC institution data available.</div>';
        return;
    }
    // Data-freshness stamp (symmetry with the contractors FY chip) — latest FDIC
    // report date across the rows.
    let html = _industryBanksAsOf
        ? '<div class="fs-9 text-muted mb-6">FDIC BankFind &middot; as of ' + escHtml(_industryBanksAsOf) + '</div>'
        : '';
    html += '<div class="industry-table-wrap"><table class="ol-data-table industry-banks-table"><thead><tr>'
        + '<th class="text-right">#</th><th>Institution</th><th>Location</th>'
        + '<th class="text-right">Total assets</th><th class="text-right">Deposits</th>'
        + '</tr></thead><tbody>';
    for (let i = 0; i < items.length; i++) {
        const r = items[i];
        const name = r.name || '';
        const loc = [r.city, r.state].filter(Boolean).join(', ');
        const assets = fmtAbbrev(r.assets_usd, { dollars: true });
        const deposits = fmtAbbrev(r.deposits_usd, { dollars: true });
        // EVERY institution links to its own FDIC detail page /bank/<cert> (cert is
        // always present) so the whole table is navigable — not just the minority
        // with a listed public parent (DESIGN 2026-07-19). A public parent gets a
        // SECONDARY chip that cross-links to that stock (switch-ticker).
        const cert = (r.cert != null) ? String(r.cert) : '';
        const tk = r.ticker || '';
        const nameCell = cert
            ? '<a class="text-primary" href="/bank/' + encodeURIComponent(cert) + '">' + escHtml(name) + '</a>'
            : '<span class="text-primary">' + escHtml(name) + '</span>';
        const tkChip = tk
            ? ' <span class="text-muted fs-9 ol-cursor-pointer" data-action="switch-ticker" data-ticker="' + escHtml(tk) + '">' + escHtml(tk) + '</span>'
            : '';
        html += '<tr class="learn-card-hover">'
            + '<td class="text-right text-muted">' + (i + 1) + '</td>'
            + '<td class="fw-600">' + nameCell + tkChip + '</td>'
            + '<td class="text-muted">' + escHtml(loc) + '</td>'
            + '<td class="text-right">' + escHtml(assets) + '</td>'
            + '<td class="text-right">' + escHtml(deposits) + '</td>'
            + '</tr>';
    }
    html += '</tbody></table></div>';
    el.innerHTML = html;
}
var _calendarCache = null;
function _inlineRenderCalendar() {
    const el = document.getElementById('calendar-content');
    if (!el)
        return;
    if (_calendarCache) {
        _renderCalendarRows(el, _calendarCache);
        return;
    }
    el.innerHTML = '<div class="status-msg status-msg--muted">Loading calendar events...</div>';
    fetch(((typeof SERVER !== 'undefined') ? SERVER : '') + '/api/calendar', { signal: AbortSignal.timeout(15000) })
        .then(function (res) { return res.ok ? res.json() : Promise.reject('HTTP ' + res.status); })
        .then(function (data) {
        const events = (Array.isArray(data) ? data : (data && data.events ? data.events : []));
        _calendarCache = events;
        if (currentView === 'calendar')
            _renderCalendarRows(el, events);
    })
        .catch(function () {
        if (currentView === 'calendar') {
            el.innerHTML = '<div class="status-msg status-msg--muted d-flex align-items-center gap-sm">Calendar data unavailable. <button data-action="cal-retry" class="btn-retry">Retry</button></div>';
        }
    });
}
function _renderCalendarRows(el, events) {
    if (!events || events.length === 0) {
        el.innerHTML = '<div class="status-msg status-msg--muted">No upcoming events found.</div>';
        return;
    }
    const grouped = {};
    const dateOrder = [];
    for (let i = 0; i < Math.min(events.length, 50); i++) {
        const ev = events[i];
        const date = ev.date || ev.event_date || 'TBD';
        if (!grouped[date]) {
            grouped[date] = [];
            dateOrder.push(date);
        }
        grouped[date].push(ev);
    }
    // MA-P2 #34 Wave-1b: calendar EVENT TYPES are a category, not up/down —
    // dividend/ipo off banned green/red onto neutral chart-series hues (bronze/
    // slate) so no event reads as "good/bad" (blue/gold already taken by
    // earnings/economic).
    const typeColors = { earnings: { bg: 'rgba(61,122,184,0.12)', fg: 'var(--oxford-blue-vivid)' }, dividend: { bg: 'rgba(128,96,53,0.12)', fg: 'var(--chart-6)' }, economic: { bg: 'rgba(201,168,76,0.12)', fg: 'var(--gold-brand)' }, ipo: { bg: 'rgba(77,93,112,0.12)', fg: 'var(--chart-quinary)' } };
    let html = '';
    for (let di = 0; di < dateOrder.length; di++) {
        const dt = dateOrder[di];
        const evts = grouped[dt];
        html += '<div class="cal-date-header">' + escHtml(dt) + '</div>';
        for (let ei = 0; ei < evts.length; ei++) {
            const e = evts[ei];
            const title = e.title || e.event || e.name || '';
            const detail = e.detail || e.description || e.ticker || '';
            const evType = (e.type || e.event_type || '').toLowerCase();
            const tc = typeColors[evType] || null;
            const rowAlt = ei % 2 !== 0 ? ' cal-row--alt' : '';
            html += '<div class="cal-row' + rowAlt + '">'
                + (tc ? '<span class="cal-type-badge cal-type-badge--' + escHtml(evType) + ' vr-today-badge" data-bg="' + tc.bg + '" data-fg="' + tc.fg + '">' + escHtml(evType) + '</span>' : '')
                + '<span class="cal-row__title">' + escHtml(title) + '</span>'
                + '<span class="cal-row__detail">' + escHtml(detail) + '</span>'
                + '</div>';
        }
    }
    el.innerHTML = html;
    _hydrateVRStyles(el);
}
function _inlineRenderScreener() {
    const el = document.getElementById('screener-mf-content');
    if (!el)
        return;
    el.innerHTML = '<div class="inline-card">'
        + '<div class="inline-card__title">Stock Screener</div>'
        + '<div class="inline-card__desc">Rank stocks by value and quality metrics including P/E, ROE, debt ratios, and dividend yield.</div>'
        + '<button id="inline-screener-run" data-action="run-screener" class="btn-primary-sm">Run screener</button>'
        + '<div id="inline-screener-results" class="inline-card__results"></div>'
        + '</div>';
    const btn = document.getElementById('inline-screener-run');
    if (btn) {
        btn.onclick = function () {
            const resEl = document.getElementById('inline-screener-results');
            if (!resEl)
                return;
            resEl.innerHTML = '<div class="status-msg status-msg--muted">Running screener...</div>';
            fetch(((typeof SERVER !== 'undefined') ? SERVER : '') + '/api/screener/run', { signal: AbortSignal.timeout(15000) })
                .then(function (res) { return res.ok ? res.json() : Promise.reject('HTTP ' + res.status); })
                .then(function (data) {
                const stocks = (Array.isArray(data) ? data : (data && data.results ? data.results : []));
                if (stocks.length === 0) {
                    resEl.innerHTML = '<div class="status-msg status-msg--muted">No results. Try again later.</div>';
                    return;
                }
                let rows = '';
                for (let i = 0; i < Math.min(stocks.length, 25); i++) {
                    const s = stocks[i];
                    const scrRowAlt = i % 2 !== 0 ? ' scr-row--alt' : '';
                    rows += '<tr class="scr-row' + scrRowAlt + '" data-action="switch-ticker" data-ticker="' + escHtml(s.ticker || s.symbol || '') + '">'
                        + '<td class="td-primary">' + escHtml(s.ticker || s.symbol || '') + '</td>'
                        + '<td class="td-data">' + escHtml(s.name || s.company || '') + '</td>'
                        + '<td class="td-gold td-right">' + (s.score != null ? s.score : '—') + '</td>'
                        + '</tr>';
                }
                resEl.innerHTML = '<table class="data-table"><thead><tr><th>Ticker</th><th>Company</th><th class="td-right">Score</th></tr></thead><tbody>' + rows + '</tbody></table>';
            })
                .catch(function () { resEl.innerHTML = '<div class="status-msg status-msg--muted">Screener unavailable. Try again later.</div>'; });
        };
    }
}
function _inlineRenderETFScreener() {
    const el = document.getElementById('etf-screener-container');
    if (!el)
        return;
    el.innerHTML = '<div class="inline-card">'
        + '<div class="inline-card__title">ETF Screener</div>'
        + '<div class="inline-card__desc">Search and compare ETFs by ticker. Enter an ETF symbol to view holdings, performance, and expense ratios.</div>'
        + '<div class="inline-card__row">'
        + '<input type="text" id="inline-etf-search" placeholder="ETF ticker (e.g. SPY, QQQ, VTI)" class="inline-input" autocomplete="off" />'
        + '<button data-action="etf-search" class="btn-primary-sm">Search</button>'
        + '</div>'
        + '<div id="inline-etf-results" class="inline-card__results"></div>'
        + '</div>';
}
// 2026-06-19 audit Phase-1 [Med]: setView previously accepted any string —
// an unknown view (typo'd ?view=, a renamed-away nav link, a stale deep link)
// set body[data-view] to garbage, hid ticker-view, matched no render target,
// and painted nothing — a silent dead tap. _KNOWN_VIEWS is the authoritative
// set (kept === the render `viewMap` keys by
// tests/test_setview_known_views_contract.py); an unknown view coerces to the
// 'ticker' default so the user always lands somewhere real.
var _KNOWN_VIEWS = [
    'ticker', 'news', '13f', 'portfolio', 'calendar', 'credit', 'bdc',
    'watchlist', 'macro', 'fundamentals', 'screener', 'etf-screener', 'usage',
    'settings', 'invoices', 'learn', 'milestones', 'comps', 'practicum', 'industry'
];
let _routerWroteHistory = false; // N6 (2026-09-25): 1st write REPLACES the landing entry, same URL re-stamps, else push; a flag, not history.state (features null it). tests/test_mobile_audit_n6_history_contract.py
function _historyWrite(view, url) {
    const _replace = !_routerWroteHistory || (window.location.search || '') === url;
    _routerWroteHistory = true;
    history[_replace ? 'replaceState' : 'pushState']({ view: view }, '', url);
}
// _showViewSkeleton() / _hideViewSkeleton() live in view-skeleton.ts (same
// 'app-init' chunk, loaded before this file). Extracted 2026-08-04: this file
// sat at EXACTLY 2225/2225 of its size budget, so the next edit of any size
// tripped the gate, and the gate's instruction is to extract rather than raise
// the cap. They are view-transition CHROME with no view-router state -- they
// read `document` and nothing else.
// Prod QA 2026-10-05: the cold-boot deep-link stashes below keyed on `history.state` being
// null, which holds for a fresh visit but NOT a reload -- the browser keeps the state this
// router wrote, so reloading ?view=industry&tab=bankmetrics (or ?view=bdc&ticker=ARCC) dropped
// the tab before the renderer read it. The FIRST setView of a document is the boot either way.
let _setViewBooted = false;
function setView(view, skipHistory) {
    const _bootCall = !_setViewBooted;
    _setViewBooted = true;
    if (view === 'markets')
        view = 'macro'; // wave-2 F1: "Markets" nav-label alias
    // 2026-08-04: `account` is the name users and older links reach for; the pane
    // is called `settings`. It coerced to `ticker` -- so a link to the account
    // page silently opened a stock chart. Aliased beside `markets`, same shape.
    if (view === 'account')
        view = 'settings';
    if (view && _KNOWN_VIEWS.indexOf(view) === -1) {
        // P1: coerce unknown→default (see _KNOWN_VIEWS above) -- but no longer
        // SILENTLY. The coercion is correct (the user must land somewhere real);
        // what was wrong is that a dead ?view= produced a plausible page and no
        // signal, so the next broken link is found the same way this one was: by
        // somebody noticing. Reported through the existing _track pipeline, guarded
        // the same way as its other callers (app-init.ts:1404) because view-router
        // can load before app-init in some chunk orders.
        try {
            if (typeof _track === 'function')
                _track('view_unknown_coerced', { requested: String(view).slice(0, 40) });
        }
        catch (_e) { /* telemetry must never break navigation */ }
        view = 'ticker';
    }
    // #124B (2026-05-18): authoritative body[data-view] writer. setView is
    // the single funnel for every transition (cold-load, popstate, in-SPA
    // nav); many sites READ document.body data-view (app-init.ts:2115, the
    // oxford.css body[data-view] pulse-bar hide rule ~2171) but nothing ever
    // WROTE it -> hide rule never matched -> empty pulse bar on /?view=learn
    // (2x recurrence 2026-05-12/05-17). Synchronous + first so it precedes
    // the comps/practicum early-returns AND the async _materializeView render
    // (no paint flash). Target is document.body (CSS selector is body[...]).
    // Contract: tests/test_market_pulse_bar_hide_contract.py.
    try {
        if (view && document.body)
            document.body.setAttribute('data-view', view);
    }
    catch (_e) { /* noop — best-effort, never blocks nav */ }
    // 2026-05-04 OWNER hotfix: synchronous ticker-view hide.
    const _syncTickerEl = document.getElementById('ticker-view');
    if (_syncTickerEl) {
        if (view === 'ticker') {
            _syncTickerEl.classList.remove('hidden');
            _syncTickerEl.classList.remove('d-none-i');
        }
        else if (view) {
            _syncTickerEl.classList.add('hidden');
            _syncTickerEl.classList.add('d-none-i');
        }
    }
    // Brand v2 Phase 5 (2026-04-25): sync ChromeB TopStripB active link
    try {
        Promise.resolve().then(function () {
            const v = (typeof currentView === 'string' && currentView) || view;
            const links = document.querySelectorAll('.ol-topstrip-b-link[data-view]');
            for (let i = 0; i < links.length; i++) {
                const match = links[i].getAttribute('data-view') === v;
                links[i].classList.toggle('ol-topstrip-b-link--active', match);
                if (match)
                    links[i].setAttribute('aria-current', 'page');
                else
                    links[i].removeAttribute('aria-current');
            }
            const w = window;
            if (typeof w._olChromeBSyncForView === 'function') {
                w._olChromeBSyncForView(v);
            }
            // 2026-06-19 audit Phase-1 [Med]: sync the mobile bottom-tab highlight
            // for EVERY transition (incl. the internal macro→news watchdog bounce),
            // not just clicks routed through the patched window.setView.
            if (typeof w._olBottomTabSyncForView === 'function') {
                w._olBottomTabSyncForView(v);
            }
        });
    }
    catch (_e) { /* noop */ }
    if (view === 'macro') {
        try {
            try {
                OLStorage.remove('ol_macro_disabled');
            }
            catch (_e) { /* noop */ }
            setTimeout(function () {
                const macroEl = document.getElementById('macro-view');
                const rendered = macroEl && !macroEl.classList.contains('d-none-i') && macroEl.children.length > 0;
                if (typeof currentView === 'string' && currentView === 'macro' && !rendered) {
                    try {
                        if (typeof showToast === 'function') {
                            showToast('Markets view failed to load; showing News instead.', 'warning');
                        }
                        setView('news', true);
                    }
                    catch (_e) { /* noop */ }
                }
            }, 8000);
        }
        catch (_e) { /* noop */ }
    }
    if (view === 'comps') {
        if (typeof renderCompsView === 'function') {
            renderCompsView();
        }
        else {
            _loadModule('comp-builder').then(function () { if (typeof renderCompsView === 'function')
                renderCompsView(); });
        }
        return;
    }
    if (view === 'practicum') {
        _materializeView('practicum-view').then(function () {
            const _pracEl = document.getElementById('practicum-view');
            if (_pracEl)
                _pracEl.classList.remove('d-none-i');
            const _allViewIds = ['ticker-view', 'news-view', 'view-13f', 'portfolio-view', 'calendar-view',
                'credit-view', 'bdc-view', 'watchlist-view', 'macro-view', 'fundamentals-view',
                'screener-mf-view', 'etf-screener-view', 'usage-view', 'learn-view', 'milestones-view', 'comps-view'];
            _allViewIds.forEach(function (id) {
                const el = document.getElementById(id);
                if (el)
                    el.classList.add('d-none-i');
            });
            const _tv = document.getElementById('ticker-view');
            if (_tv)
                _tv.classList.add('hidden');
            const _pracPrevView = currentView;
            currentView = view;
            if (typeof _olSyncTickerTitle === 'function')
                _olSyncTickerTitle(); // Q6: tab title follows the view
            if (typeof _navPush === 'function')
                _navPush(view);
            try {
                OLStorage.setString('lastView', view);
            }
            catch (_) { /* noop */ }
            if (!skipHistory)
                _historyWrite(view, '?view=' + encodeURIComponent(view));
            let _pracRendered = false;
            const _pracFallbackTimer = setTimeout(function () {
                if (_pracRendered)
                    return;
                _allViewIds.forEach(function (id) {
                    const el = document.getElementById(id);
                    if (el)
                        el.classList.remove('d-none-i');
                });
                if (_pracEl)
                    _pracEl.classList.add('d-none-i');
                currentView = _pracPrevView || 'macro';
                if (typeof _olSyncTickerTitle === 'function')
                    _olSyncTickerTitle(); // Q6/F9
                try {
                    OLStorage.setString('lastView', currentView);
                }
                catch (_) { /* noop */ }
                if (typeof showToast === 'function') {
                    showToast('Education module failed to load. Please try again.', 'error', 5000);
                }
            }, 10000);
            _loadChunk('education').then(function () {
                if (typeof renderPracticumView === 'function') {
                    renderPracticumView();
                    _pracRendered = true;
                    clearTimeout(_pracFallbackTimer);
                }
            }).catch(function () {
                clearTimeout(_pracFallbackTimer);
                if (_pracEl)
                    _pracEl.classList.add('d-none-i');
                _allViewIds.forEach(function (id) {
                    const el = document.getElementById(id);
                    if (el)
                        el.classList.remove('d-none-i');
                });
                currentView = _pracPrevView || 'macro';
                if (typeof _olSyncTickerTitle === 'function')
                    _olSyncTickerTitle(); // Q6/F9
                try {
                    OLStorage.setString('lastView', currentView);
                }
                catch (_) { /* noop */ }
                if (typeof showToast === 'function') {
                    showToast('Education module failed to load. Please try again.', 'error', 5000);
                }
            });
        });
        return;
    }
    _ensureViewModule(view);
    _loadViewModules(view);
    const _chunk = _VIEW_CHUNKS[view];
    if (_chunk && !_chunksLoaded[_chunk]) {
        _loadChunk(_chunk).catch(function () { });
    }
    // Abort ONLY on a real view CHANGE. `currentView` is still the PREVIOUS view
    // here (assigned further down), so this compares against where we came from.
    // A repeat setView for the already-active view otherwise kills the fetches the
    // first call started, with no retry — measured as a blank ticker hero.
    // S55 (app-renderers.ts) fixed the topbar-CLICK instance; the boot path has no
    // click to stop, so the guard belongs at the funnel. A genuine ticker change
    // still aborts — switchTicker calls abortViewFetches() itself. Full evidence:
    // tests/test_setview_same_view_abort_contract.py
    if (view !== currentView)
        abortViewFetches();
    clearAllIntervals();
    // F2 micro-hardening (OWNER-ratified 2026-05-16): clearAllIntervals()
    // only sweeps _intervalRegistry; the LEARN drawer's _lpTimerIntervals
    // is a separate cross-chunk map it cannot reach. Sweep it on every
    // view switch so a drawer left open on SPA-nav-away cannot orphan its
    // 10s save-timer. typeof-guarded (the learn chunk may not be loaded)
    // + try-wrapped -- a no-op when absent or the map is empty.
    {
        const _lpTd = window._lpTeardownAllTimers;
        if (typeof _lpTd === 'function') {
            try {
                _lpTd();
            }
            catch (e) { /* noop */ }
        }
    }
    const _vrCmp = window;
    if (_vrCmp.AdaptiveUI && _vrCmp.AdaptiveUI.cleanup)
        _vrCmp.AdaptiveUI.cleanup();
    if (typeof cleanupAchievements === 'function')
        cleanupAchievements();
    if (view === 'macro' || view === 'watchlist' || view === 'news') {
        const _fb = document.getElementById('fotd-banner');
        if (_fb)
            _fb.classList.add('d-none');
    }
    const _cfm = document.getElementById('company-facts-modal');
    if (_cfm)
        _cfm.classList.remove('visible');
    const _cmdP = document.getElementById('command-palette');
    if (_cmdP)
        _cmdP.classList.remove('open');
    if (_vrCmp._cmpOpen && typeof closeCompareModal === 'function')
        closeCompareModal();
    if (typeof closeMoreDropdown === 'function')
        closeMoreDropdown();
    if (typeof _track === 'function') {
        if (typeof _currentTrackedView !== 'undefined' && _currentTrackedView && typeof _viewEnteredAt !== 'undefined' && _viewEnteredAt) {
            const _dur = Math.round((Date.now() - _viewEnteredAt - (typeof _viewPausedTotal !== 'undefined' && _viewPausedTotal != null ? _viewPausedTotal : 0)) / 1000);
            if (_dur > 1 && _dur < 7200)
                _track('view_duration', { view: _currentTrackedView, seconds: _dur });
            if (typeof _viewPausedTotal !== 'undefined')
                _viewPausedTotal = 0;
        }
        _viewEnteredAt = Date.now();
        _currentTrackedView = view;
        _track('page_view', { view });
    }
    const w2 = window;
    if (w2._quickstartAutoHide) {
        _dismissQuickStart();
    }
    if (_vrCmp.AdaptiveUI && _vrCmp.AdaptiveUI.trackViewVisit)
        _vrCmp.AdaptiveUI.trackViewVisit(view);
    if (currentView === 'watchlist' && view !== 'watchlist' && typeof stopMoversAutoRefresh === 'function')
        stopMoversAutoRefresh();
    if (view === 'watchlist' && currentView !== 'watchlist' && typeof startHeatmapRefresh === 'function')
        startHeatmapRefresh();
    if (currentView === 'watchlist' && view !== 'watchlist' && typeof stopHeatmapRefresh === 'function')
        stopHeatmapRefresh();
    if (currentView === 'ticker' && view !== 'ticker' && typeof stopNewsAutoRefresh === 'function')
        stopNewsAutoRefresh();
    // F-08 (external code review 2026-05-21 Day-2): the macro-view watchdog
    // interval (12s) + chart-overlay subscription kept running after the user
    // left those views because cleanupMacroView/cleanupChartOverlays were
    // defined but never called from setView. The macro watchdog's runCheck
    // guarded against work via `currentView === 'macro'` so user-visible damage
    // was nil, but the wake-up was leaked. Wire the cleanup callbacks into
    // setView so leaving each view actually releases the timers/listeners.
    // FE review 2026-07-19 P1: pass the destination — cleanupMacroView keeps
    // the ambient indicators refresher alive when heading to news (the other
    // view it serves); everything else about the macro teardown is unchanged.
    if (currentView === 'macro' && view !== 'macro' && typeof cleanupMacroView === 'function')
        cleanupMacroView(view);
    if (currentView === 'ticker' && view !== 'ticker') {
        const _wCO = window;
        if (typeof _wCO.cleanupChartOverlays === 'function')
            _wCO.cleanupChartOverlays();
    }
    if (currentView === 'ticker' && view !== 'ticker') {
        if (typeof OLPolling !== 'undefined' && OLPolling && OLPolling.clearByKeyPrefix) {
            OLPolling.clearByKeyPrefix('phase:');
        }
        else {
            const _ppt = phasePollingTimers;
            for (const _phTk in _ppt) {
                if (!Object.prototype.hasOwnProperty.call(_ppt, _phTk))
                    continue;
                const _phH = _ppt[_phTk];
                if (_phH && typeof _phH.clear === 'function')
                    _phH.clear();
                else if (typeof _phH === 'number')
                    clearInterval(_phH);
                delete _ppt[_phTk];
            }
        }
    }
    // #22 (audit 2026-06-18): generic per-view OLPolling teardown. Leaving ANY
    // view clears that view's network pollers (keys prefixed `<view>:`) so they
    // stop firing after navigation — the credit/watchlist/macro "fires forever
    // after one visit" drain class. Complements the specific stop* cleanups
    // above; a new view-scoped poller only needs to key as `<view>:<name>`.
    // `currentView` is still the OUTGOING view here (reassigned next line).
    if (currentView && currentView !== view) {
        const _olpTeardown = (typeof OLPolling !== 'undefined' && OLPolling)
            ? OLPolling : null;
        if (_olpTeardown && _olpTeardown.clearByKeyPrefix)
            _olpTeardown.clearByKeyPrefix(currentView + ':');
    }
    currentView = view;
    if (typeof _olSyncTickerTitle === 'function')
        _olSyncTickerTitle(); // Q6: tab title follows the view
    if (typeof _navPush === 'function')
        _navPush(view);
    if (typeof renderTabs === 'function')
        renderTabs();
    const btnMap = { ticker: 'view-ticker-btn', news: 'view-news-btn', portfolio: 'view-portfolio-btn', watchlist: 'view-watchlist-btn', macro: 'view-macro-btn', '13f': 'view-13f-btn', screener: 'view-screener-btn', fundamentals: 'view-fundamentals-btn', learn: 'view-learn-btn' };
    for (const [v, id] of Object.entries(btnMap)) {
        const el = document.getElementById(id);
        if (el) {
            el.classList.toggle('active', view === v);
            el.setAttribute('aria-selected', view === v ? 'true' : 'false');
        }
    }
    // SF-23 vestige removed 2026-05-27: the `moreMap` (more-calendar /
    // more-credit / more-bdc / more-etf-screener / more-usage /
    // more-milestones / more-13f / more-screener / more-fundamentals /
    // more-learn) + the `#more-dropdown-btn .has-active` toggle drove the
    // deleted MORE dropdown markup (Phase C 2026-05-07). All
    // getElementById calls returned null in prod; the block was a no-op
    // under a parent `if (moreBtn)` null-guard.
    const _lazyMap = { ticker: 'ticker-view', news: 'news-view', '13f': 'view-13f',
        portfolio: 'portfolio-view', calendar: 'calendar-view', credit: 'credit-view',
        bdc: 'bdc-view', watchlist: 'watchlist-view', macro: 'macro-view',
        fundamentals: 'fundamentals-view', screener: 'screener-mf-view',
        'etf-screener': 'etf-screener-view', usage: 'usage-view', settings: 'settings-view',
        invoices: 'invoices-view', // F3.5 (SF-23 audit 2026-05-07)
        learn: 'learn-view', milestones: 'milestones-view', industry: 'industry-view' };
    const _lazyTarget = _lazyMap[view];
    // #80 wave 2: when the target view needs a template FETCH (first visit),
    // hide the outgoing panes and paint the skeleton NOW — synchronously in
    // the click frame — instead of leaving the old view up until the network
    // returns. Class toggles only; no existing DOM is destroyed.
    const _skelNeeded = !!(_lazyTarget && !document.getElementById(_lazyTarget));
    if (_skelNeeded) {
        document.querySelectorAll('#content-wrapper > [id$="-view"]:not(.d-none-i), #view-13f:not(.d-none-i)').forEach(function (el) {
            el.classList.add('d-none-i');
        });
        _showViewSkeleton();
    }
    const _materializePromise = _lazyTarget ? _materializeView(_lazyTarget) : Promise.resolve();
    _materializePromise.then(function () {
        _hideViewSkeleton();
        const viewMap = { ticker: 'ticker-view', news: 'news-view', '13f': 'view-13f', portfolio: 'portfolio-view', calendar: 'calendar-view', credit: 'credit-view', bdc: 'bdc-view', watchlist: 'watchlist-view', macro: 'macro-view', fundamentals: 'fundamentals-view', screener: 'screener-mf-view', 'etf-screener': 'etf-screener-view', usage: 'usage-view', settings: 'settings-view', invoices: 'invoices-view', learn: 'learn-view', milestones: 'milestones-view', comps: 'comps-view', practicum: 'practicum-view', industry: 'industry-view' };
        document.getElementById('ticker-view')?.classList.toggle('hidden', view !== 'ticker');
        for (const [v, id] of Object.entries(viewMap)) {
            if (v === 'ticker')
                continue;
            const el = document.getElementById(id);
            if (el)
                el.classList.toggle('active', view === v);
        }
        const activeViewId = viewMap[view];
        for (const id of Object.values(viewMap)) {
            const el = document.getElementById(id);
            if (!el)
                continue;
            if (id === activeViewId) {
                el.classList.remove('d-none-i');
            }
            else {
                el.classList.add('d-none-i');
            }
        }
        const w3 = window;
        if (view === 'ticker' && w3._pendingChartRender) {
            setTimeout(() => { if (w3._pendingChartRender)
                w3._pendingChartRender(); }, 150);
        }
        const activeEl = document.getElementById(viewMap[view]);
        if (activeEl) {
            activeEl.classList.remove('view-enter', 'view-exit');
            void activeEl.offsetWidth;
            activeEl.classList.add('view-enter');
        }
        if (activeEl) {
            activeEl.setAttribute('role', 'tabpanel');
            const _labelBtnId = (btnMap[view]) || ('view-' + view + '-btn');
            activeEl.setAttribute('aria-labelledby', _labelBtnId);
        }
        // SF-HANDOFF-REDESIGN PR2 Phase 3.B (2026-05-27): try OLProduct.surfaces.*
        // FIRST. If a v3 surface renderer exists + renders without throwing, skip
        // the legacy renderMap below. If absent (chunk-load race) or throws, fall
        // through to legacy — Sentry captures with tags so we know if a surface
        // is broken in prod. Same guarded-swap pattern as PR1 Phase 3.B.
        const _v3ProductMap = {
            milestones: { fn: 'renderAchievements', paneId: 'milestones-view' },
            '13f': { fn: 'renderThirteenF', paneId: 'view-13f' },
            watchlist: { fn: 'renderWatchlist', paneId: 'watchlist-view' },
            // portfolio: v3 surface RETIRED 2026-07-15 (OWNER prod-QA "QA-6"). The v3
            // OLProduct.surfaces.renderPortfolio (static/js/product/surfaces/portfolio.ts)
            // built the Holdings tab plus four tab BUTTONS — Analytics / vs Benchmarks /
            // Correlations / Risk — that were completely inert: _buildTabs gave them
            // `data-tab` but no `data-action` and no click handler, and renderPortfolio
            // only ever assembled the Holdings body (no _buildAnalytics/_buildBenchmark/
            // _buildCorrelations/_buildRisk exist). So 4 of 5 portfolio sub-tabs did
            // nothing on click. Same failure class + fix as the `news` retirement below:
            // dropping `portfolio` here lets the guarded-swap fall through to the legacy
            // renderMap['portfolio'] → renderPortfolio (static/js/portfolio.ts), which
            // fills the intact portfolio-view.html template whose tab rail
            // (data-action="set-portfolio-tab" → setPortfolioTab) drives all five
            // working sections (Analytics/Risk via analytics.ts, Benchmarks/Correlations
            // via portfolio-extra.ts). The v3 surface remains DEFINED but is no longer
            // dispatched (dead-but-harmless; re-list here only when the four missing
            // sections + tab-switch are actually implemented in the v3 surface).
            // news: v3 surface RETIRED 2026-05-31 (OWNER prod-QA). The v3 renderNews
            // painted a daily-research lede + Related Case File hero row and a top
            // topic-chip rail that (a) dispatched an unhandled `news-topic` action,
            // (b) duplicated the legacy `#news-filter-wrap` bar, and (c) created
            // `#market-indicators-host` where the legacy filler writes
            // `#market-indicators` — so on a filter click renderNewsView threw
            // "Cannot set properties of null (setting 'innerHTML')" and aborted,
            // leaving headlines blank-until-click and Market Indicators empty.
            // Dropping `news` here lets the guarded-swap fall through to the legacy
            // renderNewsView (renderMap['news']) which fills the lazy-loaded
            // news-view.html template directly — that template already has the
            // compact sentiment strip under Market Headlines, ONE filter bar under
            // Company & Industry, and the correct indicator scaffold. The v3
            // OLProduct.surfaces.renderNews remains defined but is no longer
            // dispatched (dead-but-harmless; revisit if the redesign is re-scoped).
            macro: { fn: 'renderMarkets', paneId: 'macro-view' },
            calendar: { fn: 'renderCalendar', paneId: 'calendar-view' },
        };
        const _v3Entry = _v3ProductMap[view];
        const _v3Pane = _v3Entry ? document.getElementById(_v3Entry.paneId) : null;
        const _olp = window.OLProduct;
        if (_v3Entry && _v3Pane && _olp && _olp.surfaces && typeof _olp.surfaces[_v3Entry.fn] === 'function') {
            try {
                _olp.surfaces[_v3Entry.fn](_v3Pane);
                return; // v3 surface owns the view; skip legacy renderMap
            }
            catch (e) {
                if (window.Sentry && window.Sentry.captureException) {
                    window.Sentry.captureException(e, { tags: { surface: 'product-v3', view: view } });
                }
                if (typeof console !== 'undefined' && console.error) {
                    console.error('[product-v3] surface render failed, falling back to legacy:', view, e);
                }
            }
        }
        // SF-HANDOFF-REDESIGN PR1 Phase 3.B (2026-05-27, FULL CHIP-AWARE DISPATCH;
        // REGRESSION FIX: previous ship returned early on v3-paint success,
        // which skipped the legacy renderLearningPaths that paints the LEARN
        // top tab rail — OWNER saw new modules layout but lost the rail with
        // Modules / Ledge Reads / Investment Lore / Market History tabs).
        //
        // Approach: do NOT return early. Let renderLearningPaths run via the
        // renderMap[view='learn'] entry below (paints chip rail + initial
        // modules pane), THEN call renderModules to overwrite the modules
        // pane content with the new editorial design. The DOM-write phase
        // of renderLearningPaths is synchronous, so the upgrade fires before
        // the browser paints the legacy modules grid — no visible flash.
        //
        // Chip-to-surface map for tab switches lives in app-renderers.ts:3577-3599
        // (the `learn-tab` action handler). That handler re-dispatches to
        // OLLearn.surfaces.render* whenever the user clicks a chip.
        //
        // SUPERSEDED 2026-05-28 wave-23 Phase 1A per OWNER ratification +
        // PROFESSOR+DESIGN sign-off
        // (`docs/board/audit/2026-05-28_PROFESSOR_DESIGN_wave23_phase1a_option_b_signoff.md`,
        // Q2 92% conf). Prior decision: "Why renderModules (not renderLanding)
        // on entry: the All/Beginner/Intermediate/Advanced chips OWNER named
        // as the regression surface live INSIDE renderModules (modules.ts:228-232
        // SearchRow). The default entry point for /?view=learn is the Modules
        // tab." That decision was a pragmatic regression-prevention call; the
        // wave-23 decision is to HONOR the handoff spec at
        // `handoff-learn/surfaces/00-landing.md:9-23,35,83,135`
        // ("Renders the LEARN landing. Tab rail visible but no tab 'active'.")
        // by dispatching renderLanding into #lp-landing-pane on entry. The
        // chip filter is one click away (Modules chip remains in the rail,
        // Q5a tab-rail unchanged). Per FOUNDATIONAL
        // `feedback_owner_decision_updates_contract` this comment is updated
        // in the SAME commit that flips the dispatch.
        //
        // Q5b PRIMARY placement: Progress also renders into #lp-progress-strip
        // (full-width section ABOVE the tab rail), always-visible for authed
        // users so the Reading-Room Ledger frontispiece travels into every
        // tab. Q3 anon-guard: hidden for anon users via .lp-anon-hide class;
        // authed-zero shows a Q6 "Start with Personal Finance Foundations"
        // collapsed-strip CTA. Q4a: NO Landing chip in the rail.
        //
        // The actual v3 upgrade happens in the post-render `if (view === 'learn')`
        // block below (after _viewRendered fires renderLearningPaths). This
        // block here just claims the visited-flag bookkeeping that the
        // post-render legacy block would otherwise own twice.
        // Return type widened to `void | Promise<unknown>` 2026-05-27: some
        // renderers (e.g. renderLearningPaths) are async — the post-render
        // v3 upgrade block below awaits the Promise so async paint lands
        // before the v3 upgrade tries to find #lp-modules-pane. (Without
        // this widening, capturing the return value below as `void` fails
        // tsc strict-mode TS1345 — caught by Render's tsc-build-time gate.)
        const renderMap = {
            portfolio: typeof renderPortfolio === 'function' ? renderPortfolio : _inlineRenderPortfolio,
            news: typeof renderNewsView === 'function' ? renderNewsView : null,
            calendar: typeof renderCalendarView === 'function' ? renderCalendarView : _inlineRenderCalendar,
            credit: typeof renderCreditView === 'function' ? () => { renderCreditView(); } : null,
            bdc: typeof renderBdcView === 'function' ? renderBdcView : _inlineRenderBDC,
            watchlist: typeof renderWatchlist === 'function' ? renderWatchlist : _inlineRenderWatchlist,
            fundamentals: typeof renderFundamentalsView === 'function' ? renderFundamentalsView : _inlineRenderFundamentals,
            macro: typeof renderMacroView === 'function' ? renderMacroView : _inlineRenderMacro,
            usage: typeof renderUsageView === 'function' ? renderUsageView : null,
            // LEARN flash Phase B: cold fallback is the SKELETON-gate (_learnPendingV3),
            // NOT the legacy grid (_inlineRenderLearn) — see _learnPendingV3 above.
            learn: typeof renderLearningPaths === 'function' ? renderLearningPaths : _learnPendingV3,
            screener: typeof renderScreenerView === 'function' ? renderScreenerView : _inlineRenderScreener,
            'etf-screener': typeof renderETFScreener === 'function' ? () => { renderETFScreener(); } : _inlineRenderETFScreener,
            industry: _inlineRenderIndustry,
        };
        let _viewRendered = false;
        let _viewRenderPromise = null;
        if (renderMap[view]) {
            try {
                // Capture the return value so async renderers (e.g.
                // renderLearningPaths) can be awaited by the post-render
                // upgrade block below. The legacy code dropped the Promise
                // on the floor, which raced the v3 upgrade vs. the legacy
                // DOM-write — the v3 upgrade was finding `lp-modules-pane`
                // absent (async paint hadn't landed yet) and falling back
                // to wiping the whole `learn-view-content` container,
                // taking the chip rail down with it.
                const _ret = renderMap[view]();
                if (_ret && typeof _ret.then === 'function') {
                    _viewRenderPromise = _ret;
                }
                _viewRendered = true;
            }
            catch (err) {
                /* @__PURE__ */ _olDebugError('[Oxford Ledge] setView render for "' + view + '" failed:', err);
            }
        }
        if (!_viewRendered && _vrCmp.ViewManager) {
            const _vmFn = _vrCmp.ViewManager.getRenderFn ? _vrCmp.ViewManager.getRenderFn(view) : null;
            if (typeof _vmFn === 'function') {
                try {
                    _vmFn();
                }
                catch (err) {
                    /* @__PURE__ */ _olDebugError('[Oxford Ledge] setView ViewManager render for "' + view + '" failed:', err);
                }
            }
        }
        if (view === '13f' && activeTicker) {
            const inp = document.getElementById('f13-ticker-input');
            if (inp && !inp.value) {
                inp.value = activeTicker;
            }
        }
        if (view === '13f') {
            // #125 (OWNER 2026-06-04): the welcome-observatory "13F holdings"
            // tile deep-links /?view=13f&fund=<name> so the visitor lands on
            // that fund's full 13F (not a generic view). Honor the param on
            // cold load: pre-fill the fund search and run it. One-shot —
            // guarded by !value so a manual search isn't clobbered on re-render.
            try {
                const _lp = new URLSearchParams(window.location.search);
                const _fund = (_lp.get('fund') || '').trim();
                if (_fund) {
                    const fInp = document.getElementById('f13-fund-input');
                    if (fInp && !fInp.value) {
                        fInp.value = _fund;
                        if (typeof window.search13fFund === 'function') {
                            setTimeout(() => { try {
                                window.search13fFund();
                            }
                            catch (_e) { /* noop */ } }, 150);
                        }
                    }
                }
            }
            catch (_e) { /* fund deep-link is non-critical */ }
        }
        if (view === 'learn') {
            // #126 (OWNER 2026-06-04): an anon visitor who clicks a specific lesson
            // deep-links to /?view=learn&path=…&module=… but the gated module never
            // opens — they silently land on the generic landing (a dead-end). Show an
            // elegant, closeable "register free to unlock" panel instead. One-shot.
            try {
                const _anonLesson = (typeof window.olIsAnonymous === 'function' ? window.olIsAnonymous() : window._userTier === 'anonymous');
                let _deepLesson = false;
                try {
                    const _lp = new URLSearchParams(window.location.search);
                    _deepLesson = !!(_lp.get('path') || _lp.get('module'));
                }
                catch (_e) { /* noop */ }
                if (_anonLesson && _deepLesson)
                    _showAnonLessonGate();
            }
            catch (_e) { /* gate is non-critical */ }
            // Flash fix (OWNER 2026-06-23: "the old Ledge Reads template appears
            // before refreshing"). These two calls used to PRE-PAINT the LEGACY
            // reading-list / market-history renderers into their (hidden) panes on
            // every learn entry. When the user then opened the Ledge Reads / Market
            // History tab, the pane unhid showing that stale legacy paint for a frame
            // before the learn-tab handler's v3 surface (OLLearn.surfaces.renderReads
            // / renderHistory) swapped in — a guaranteed old→new flash. The panes are
            // hidden by default (Modules is the active tab) and the learn-tab handler
            // already renders the chosen pane on demand (v3-first, app-renderers.ts
            // `learn-tab`), incl. for ?tab= deep-links (views.ts clicks the .lp-tab).
            // So the pre-paint is pure flash with no benefit whenever the v3 surface
            // is present; only fall back to the legacy pre-paint when it is absent.
            const _v3Surfaces = window.OLLearn && window.OLLearn.surfaces;
            if (!(_v3Surfaces && typeof _v3Surfaces.renderReads === 'function')) {
                if (typeof renderReadingList === 'function')
                    renderReadingList();
            }
            if (!(_v3Surfaces && typeof _v3Surfaces.renderHistory === 'function')) {
                if (typeof renderDefunctCompanies === 'function')
                    renderDefunctCompanies();
            }
            // SF-HANDOFF-REDESIGN PR1 Phase 3.B upgrade (2026-05-27, FIX-2):
            //
            // The v3 upgrade overwrites the modules PANE (`#lp-modules-pane`)
            // with the editorial design from `OLLearn.surfaces.renderModules`,
            // leaving the chip rail (`.lp-tabs`) — which is a SIBLING of the
            // modules pane inside `#learn-view-content` — intact.
            //
            // Race fix: `renderLearningPaths` is async (it awaits the
            // `/api/learn/paths` fetch BEFORE writing `container.innerHTML =
            // html`), so on a cold LEARN entry `#lp-modules-pane` does NOT
            // exist yet when this block runs synchronously. The prior fix
            // fell back to `#learn-view-content` (the parent), and
            // `renderModules`'s `rootEl.textContent = ''` wiped the chip
            // rail along with the modules pane. We now wait for the legacy
            // promise to resolve before firing — `#lp-modules-pane` has
            // painted by then, so the v3 upgrade strictly targets the pane
            // (no parent fallback). If `lp-modules-pane` STILL isn't there
            // after the legacy resolves, we skip the upgrade entirely
            // rather than wipe the wrong scope.
            //
            // Sub-view skip (FIX for Issue 2 — path-card flash):
            // when the URL carries `?path=` or `?module=`, views.ts:311
            // polls `_lpData` and calls `_lpOpenPath` → that handler writes
            // the path-detail HTML into `#learn-view-content`, blowing away
            // `#lp-modules-pane`. If we then fired `renderModules` on top
            // of it, we'd race the user back to the modules grid (which
            // is exactly what OWNER reported: "loads old then forcefully
            // re-loads new"). Skip the v3 upgrade whenever a sub-view is
            // in the URL.
            //
            // Anon-gate skip (per CHAOS 2026-05-27 audit BLOCKING #1):
            // the v3 renderModules has no anon awareness; the legacy
            // renderLearningPaths already paints the _lpRenderAnonGate
            // snapshot for anon users (learning-paths.ts:1749).
            //
            // Idempotency: if `_olLearnV3Rendered === true` AND the
            // current pane already carries `.ol-modules-surface`, skip
            // — the surface is already up; firing again would just
            // re-flash. (Wires the previously-dead read site flagged
            // by CHAOS TRACK #3.)
            const _runLearnV3Upgrade = () => {
                try {
                    const _isAnon = (typeof window.olIsAnonymous === 'function' ? window.olIsAnonymous() : window._userTier === 'anonymous');
                    // STRICT: only target the modules pane. Do NOT fall back
                    // to learn-view-content — that wipes the chip rail.
                    const _v3Pane = document.getElementById('lp-modules-pane');
                    const _oll = window.OLLearn;
                    // Sub-view skip
                    let _hasSubView = false;
                    try {
                        const _qp = new URLSearchParams(window.location.search);
                        _hasSubView = !!(_qp.get('path') || _qp.get('module'));
                    }
                    catch (_e) { /* noop */ }
                    // Idempotent skip
                    if (window._olLearnV3Rendered === true
                        && _v3Pane
                        && _v3Pane.classList.contains('ol-modules-surface')) {
                        return;
                    }
                    if (!_isAnon && !_hasSubView && _v3Pane) {
                        if (_oll && _oll.surfaces && typeof _oll.surfaces.renderModules === 'function') {
                            _oll.surfaces.renderModules(_v3Pane);
                            window._olLearnV3Rendered = true;
                        }
                        else if (!window._olLearnV3Retried) {
                            // 2026-06-02 (OWNER "old LEARN quizzes rendering"): renderModules
                            // lives in the EDUCATION chunk. If it isn't loaded when this fires
                            // (flaky-chunk session — same class as the insider panel + chart
                            // features), the v3 upgrade silently no-oped and the LEGACY quiz
                            // grid stayed, with no re-fire when education arrived. Load it +
                            // retry ONCE so the modules surface replaces the legacy render.
                            window._olLearnV3Retried = true;
                            try {
                                const _ox = window.OxfordChunks;
                                if (_ox && typeof _ox.loadChunk === 'function') {
                                    _ox.loadChunk('education').then(_runLearnV3Upgrade).catch(() => { });
                                }
                            }
                            catch (_e2) { /* fail closed — legacy grid remains */ }
                        }
                    }
                }
                catch (e) {
                    window._olLearnV3Rendered = false;
                    if (window.Sentry && window.Sentry.captureException) {
                        window.Sentry.captureException(e, { tags: { surface: 'learn-v3', view: view } });
                    }
                    if (typeof console !== 'undefined' && console.error) {
                        console.error('[learn-v3] modules surface upgrade failed, legacy grid remains:', e);
                    }
                }
            };
            // 2026-05-28 wave-23 Phase 1A: Landing + Progress dispatch.
            // Per OWNER + PROFESSOR+DESIGN sign-off
            // (`docs/board/audit/2026-05-28_PROFESSOR_DESIGN_wave23_phase1a_option_b_signoff.md`):
            // - Q2 Landing-on-entry: upgrade #lp-landing-pane via
            //   OLLearn.surfaces.renderLanding + flip pane-active classes so
            //   Landing replaces Modules as the active pane on cold entry.
            // - Q5b primary placement: upgrade #lp-progress-strip via
            //   OLLearn.surfaces.renderProgress (always-visible section above
            //   the tab rail).
            // - Q3 anon guard: skip Progress + add .lp-anon-hide; Landing's
            //   own renderer paints the sign-in invite in the hero.
            // - Sentry-tagged try/catch mirrors the _v3ProductMap pattern at
            //   lines 1156-1167 + the _runLearnV3Upgrade pattern above.
            // - Sub-view skip: when ?path= or ?module= or ?tab= is in the URL,
            //   the user is deep-linking past Landing; skip both upgrades so
            //   the legacy flow + the modules-pane upgrade own the paint.
            const _runLearnLandingProgressUpgrade = () => {
                try {
                    const _isAnon = (typeof window.olIsAnonymous === 'function' ? window.olIsAnonymous() : window._userTier === 'anonymous');
                    let _hasSubView = false;
                    try {
                        const _qp = new URLSearchParams(window.location.search);
                        _hasSubView = !!(_qp.get('path') || _qp.get('module') || _qp.get('tab'));
                    }
                    catch (_e) { /* noop */ }
                    const _oll = window.OLLearn;
                    // #88 cutover step 1 — HARDEN the landing dispatch: renderLanding lives
                    // in the education chunk. If it isn't loaded when this fires (the
                    // flaky-chunk / race session that left the legacy entry view stuck),
                    // load it + retry ONCE — mirroring _runLearnV3Upgrade's retry, which
                    // the landing/progress dispatch was missing. Without this the Landing
                    // silently no-ops and the scaffold's loading placeholder (or, pre-step-1,
                    // the legacy grid) stuck.
                    if ((!_oll || !_oll.surfaces || typeof _oll.surfaces.renderLanding !== 'function')
                        && !window._olLearnLandingRetried) {
                        window._olLearnLandingRetried = true;
                        try {
                            const _ox = window.OxfordChunks;
                            if (_ox && typeof _ox.loadChunk === 'function') {
                                _ox.loadChunk('education').then(_runLearnLandingProgressUpgrade).catch(function () { });
                            }
                        }
                        catch (_e2) { /* fail closed — placeholder remains */ }
                        return;
                    }
                    const _landingPane = document.getElementById('lp-landing-pane');
                    const _modulesPane = document.getElementById('lp-modules-pane');
                    const _progressStrip = document.getElementById('lp-progress-strip');
                    // Landing-on-entry (Q2). Skip on sub-view deep links so the
                    // legacy `?path=` / `?module=` / `?tab=` flows own the paint.
                    // Anon users STILL get Landing — the renderer paints the
                    // sign-in invitation in the hero (Q3 PROFESSOR §2.2).
                    if (!_hasSubView && _landingPane && _modulesPane && _oll && _oll.surfaces
                        && typeof _oll.surfaces.renderLanding === 'function') {
                        try {
                            _oll.surfaces.renderLanding(_landingPane);
                            // Flip active panes: Landing on, Modules off. Tab rail
                            // stays at Modules `lp-tab-active` for visual continuity
                            // (handoff: "Tab rail visible but no tab 'active'" —
                            // clicking Modules takes you to /?view=learn&tab=modules).
                            _landingPane.classList.add('lp-pane-active');
                            _landingPane.classList.remove('d-none');
                            _modulesPane.classList.remove('lp-pane-active');
                            _modulesPane.classList.add('d-none');
                        }
                        catch (e) {
                            if (window.Sentry && window.Sentry.captureException) {
                                window.Sentry.captureException(e, { tags: { surface: 'learn-v3-landing', view: 'learn' } });
                            }
                            if (typeof console !== 'undefined' && console.error) {
                                console.error('[learn-v3-landing] renderLanding failed; legacy modules pane remains active:', e);
                            }
                        }
                    }
                    // Progress strip (Q5b primary placement). Anon hide (Q3) via
                    // the .lp-anon-hide class; renderer also detects anon + bails
                    // early as a belt-and-suspenders. Skip on sub-view deep links
                    // for the same reason as Landing.
                    if (_progressStrip) {
                        if (_isAnon) {
                            _progressStrip.classList.add('lp-anon-hide');
                        }
                        else {
                            _progressStrip.classList.remove('lp-anon-hide');
                            if (!_hasSubView && _oll && _oll.surfaces
                                && typeof _oll.surfaces.renderProgress === 'function') {
                                try {
                                    _oll.surfaces.renderProgress(_progressStrip);
                                }
                                catch (e) {
                                    if (window.Sentry && window.Sentry.captureException) {
                                        window.Sentry.captureException(e, { tags: { surface: 'learn-v3-progress', view: 'learn' } });
                                    }
                                    if (typeof console !== 'undefined' && console.error) {
                                        console.error('[learn-v3-progress] renderProgress failed:', e);
                                    }
                                }
                            }
                        }
                    }
                }
                catch (e) {
                    if (window.Sentry && window.Sentry.captureException) {
                        window.Sentry.captureException(e, { tags: { surface: 'learn-v3-landing-progress', view: 'learn' } });
                    }
                    if (typeof console !== 'undefined' && console.error) {
                        console.error('[learn-v3-landing-progress] dispatch failed:', e);
                    }
                }
            };
            if (_viewRenderPromise) {
                _viewRenderPromise
                    .then(_runLearnV3Upgrade)
                    .then(_runLearnLandingProgressUpgrade)
                    .catch(() => { _runLearnV3Upgrade(); _runLearnLandingProgressUpgrade(); });
            }
            else {
                // No promise captured (e.g. _inlineRenderLearn path or
                // synchronous render). Best-effort fire; the pane may
                // already be in DOM.
                _runLearnV3Upgrade();
                _runLearnLandingProgressUpgrade();
            }
            try {
                OLStorage.setString('ol_learn_visited', '1');
            }
            catch (_e) { /* noop */ }
            const _lbadge = document.getElementById('learn-badge');
            if (_lbadge) {
                _lbadge.classList.remove('pulse-active');
                _lbadge.style.display = 'none';
            }
        }
        if (view === 'milestones') {
            // CYCLE R1 (2026-06-11, OWNER D1): the legacy renderMilestonesView
            // fallback is RETIRED — it read a different data shape from a
            // different store, which is why the same crash class needed fixes
            // in two renderers (06-09 + 06-11). The v3 Honors surface
            // (OLProduct.surfaces.renderAchievements) is the ONLY renderer;
            // if the guarded-swap above fell through (chunk race / throw),
            // paint an honest retry state instead of a divergent renderer.
            const _msPane = document.getElementById('milestones-view');
            if (_msPane && !_msPane.childElementCount) {
                _msPane.textContent = '';
                const _msErr = document.createElement('div');
                _msErr.className = 'ol-achievements-error';
                const _msLbl = document.createElement('span');
                _msLbl.className = 'ol-section-label ol-section-label--gold-deep';
                _msLbl.textContent = 'HONORS';
                const _msNote = document.createElement('p');
                _msNote.className = 'ol-editorial-note ol-editorial-note--muted-cream';
                _msNote.textContent = 'The ledger is briefly out of reach. Refresh to try again.';
                _msErr.appendChild(_msLbl);
                _msErr.appendChild(_msNote);
                _msPane.appendChild(_msErr);
            }
        }
        if (view === 'settings') {
            // 2026-05-27 OWNER prod-QA: /?view=settings was hanging on
            // skeleton loaders. Root cause: view-router fires this synchronous
            // dispatch BEFORE the lazy template loader has resolved
            // `settings-view.html`, so `getElementById('settings-panel')` in
            // renderSettingsPanel returns null and the skeleton (declared
            // inside the lazy template) stays. Retry on a short delay so the
            // template has time to land. The renderer is idempotent.
            // Wave-3 QA (2026-07-17): the typeof-guard moved INSIDE the retry — it
            // used to gate the whole retry loop, so when the core-enhance chunk
            // (which defines renderSettingsPanel; now wired via _VIEW_CHUNK_MAP)
            // hadn't landed at dispatch time, no retry ever started and the
            // skeleton was permanent. Horizon widened 1s -> 6s: cold-anon template
            // + chunk fetches routinely exceed the old 10x100ms budget.
            const _tryRender = function (attempt) {
                if (currentView !== 'settings')
                    return;
                if (document.getElementById('settings-panel') && typeof renderSettingsPanel === 'function') {
                    renderSettingsPanel();
                    return;
                }
                if (attempt < 40)
                    setTimeout(function () { _tryRender(attempt + 1); }, 150);
            };
            _tryRender(0);
        }
        if (view === 'usage') {
            if (typeof renderShareSettings === 'function')
                renderShareSettings();
            if (typeof renderDataFreshness === 'function')
                renderDataFreshness(activeTicker);
        }
        // F3.5 (SF-23 audit 2026-05-07): /?view=invoices renders the
        // Stripe-customer-invoices listing populated by /api/billing/invoices.
        // F-20 Phase 3a (2026-05-21): invoices-view.js is now lazy-loaded via
        // _loadModule. Standalone <script> tag removed from dashboard.html;
        // the JS only ships when a user navigates to /?view=invoices.
        if (view === 'invoices') {
            const _w = window;
            if (typeof _w.renderInvoicesView === 'function') {
                _w.renderInvoicesView();
            }
            else if (typeof _loadModule === 'function') {
                _loadModule('invoices-view').then(function () {
                    if (typeof _w.renderInvoicesView === 'function')
                        _w.renderInvoicesView();
                });
            }
        }
        if (view === 'etf-screener') {
            const etfScrContainer = document.getElementById('etf-screener-container');
            if (etfScrContainer && typeof renderETFScreener === 'function') {
                renderETFScreener(etfScrContainer);
            }
        }
        // Wave-9 QA: the screener boot helper lives in a LATER bundle than this
        // caller -- _initScreenerPresets in app-tail (app-renderers.ts; it had ZERO
        // callers since the app.js monolith retirement, so the preset chips the
        // empty-state copy points at never hydrated for anyone). Call it as soon
        // as its bundle lands; bounded poll with currentView bail. (Its sibling,
        // the free-tier filter-count hint, was removed with the client caps on
        // 2026-09-24.)
        if (view === 'screener') {
            let _scrPresetsDone = false;
            const _scrKick = function () {
                if (!_scrPresetsDone && typeof _initScreenerPresets === 'function') {
                    _initScreenerPresets();
                    _scrPresetsDone = true;
                }
                return _scrPresetsDone;
            };
            if (!_scrKick()) {
                let _scrTries = 0;
                const _scrTimer = setInterval(function () {
                    _scrTries++;
                    if (currentView !== 'screener' || _scrTries > 40 || _scrKick())
                        clearInterval(_scrTimer);
                }, 150);
            }
        }
        // Wave-2 F9: consume the stashed BDC deep-link ticker. bdcSearchBdc lives
        // in the lazy bdc-view chunk, so poll briefly until both the input DOM and
        // the function exist (same late-hydrate pattern as the learn drawer).
        // T7 (2026-09-13): the same poll now also carries the borrower + ask=1
        // params the SSR anchors deep-link; all three are consumed here, in order,
        // by _bdcConsumeDeepLink (lookups first, the panel open last).
        if (view === 'bdc' && (_bdcDeepLinkTicker || _bdcDeepLinkBorrower || _bdcDeepLinkAsk)) {
            const _bdcDLT = _bdcDeepLinkTicker;
            const _bdcDLB = _bdcDeepLinkBorrower;
            const _bdcDLAsk = _bdcDeepLinkAsk;
            _bdcDeepLinkTicker = null;
            _bdcDeepLinkBorrower = null;
            _bdcDeepLinkAsk = false;
            let _bdcDLTries = 0;
            const _bdcDLTimer = setInterval(function () {
                _bdcDLTries++;
                if (currentView !== 'bdc') {
                    clearInterval(_bdcDLTimer);
                    return;
                }
                const _bdcDLInp = document.getElementById('bdc-ticker-input');
                if (_bdcDLInp && typeof bdcSearchBdc === 'function') {
                    clearInterval(_bdcDLTimer);
                    try {
                        _bdcConsumeDeepLink(_bdcDLT, _bdcDLB, _bdcDLAsk);
                    }
                    catch (_e) { /* noop */ }
                }
                else if (_bdcDLTries > 40) {
                    clearInterval(_bdcDLTimer);
                    if (_bdcDLInp && _bdcDLT)
                        _bdcDLInp.value = _bdcDLT; // degrade: prefill so one click completes the intent
                    const _bdcDLBInp = document.getElementById('bdc-borrower-input');
                    if (_bdcDLBInp && _bdcDLB)
                        _bdcDLBInp.value = _bdcDLB;
                }
            }, 150);
        }
        const chartPanel = document.getElementById('chart-panel');
        if (chartPanel)
            chartPanel.classList.toggle('d-none', view !== 'ticker');
        _updatePracticeFab(view);
    }).catch(function (e) { /* 2026-09-26 review P2: a throw in view setup no longer leaves an unhandled rejection or a stuck skeleton */ try {
        _hideViewSkeleton();
    }
    catch (_e2) { /* already hidden */ } _olDebugError('[setView] view setup threw', e); });
    // ── Non-DOM-dependent post-switch bookkeeping (runs immediately) ──────────
    // P1.2 retire (2026-05-04): typeof OLStorage guards removed. storage.js
    // loads as a standalone defer (dashboard.html:187) before bundle-app.min.js,
    // so OLStorage is guaranteed defined when view-router runs. The try/catch
    // wrappers stay as runtime-error safety nets.
    try {
        OLStorage.setString('lastView', view);
    }
    catch (_) { /* noop */ }
    // Wave-2 F9: stash the BDC deep-link ticker BEFORE the pushState below
    // rewrites the URL to bare ?view=bdc; the bdc post-switch block consumes
    // it via bdcSearchBdc (see _bdcDeepLinkTicker decl).
    if (view === 'bdc' && !_bdcDeepLinkTicker) {
        try {
            // history.state is null only on the cold boot nav — an in-app switch
            // to bdc with a RESIDUAL ?ticker= in the URL (e.g. the ?signin=1
            // cleaned-URL shape) must not auto-load that ticker's portfolio.
            if (!history.state || _bootCall) {
                const _bdcQS = new URLSearchParams(window.location.search);
                const _bdcQT = _bdcQS.get('ticker');
                if (_bdcQT && _bdcQT.trim())
                    _bdcDeepLinkTicker = _bdcQT.trim().toUpperCase();
                // T7: the borrower norm (space-keyed; the query carries it because the
                // path segment is the hyphen slug) and the ask=1 flag ride the same
                // cold-boot stash. Bounded: control characters stripped, 120 chars max
                // -- the value is only ever an input's .value, resolved server-side.
                const _bdcQB = _bdcQS.get('borrower');
                if (_bdcQB) {
                    const _bdcQBClean = _bdcQB.replace(/[\u0000-\u001f\u007f<>]/g, '').replace(/\s+/g, ' ').trim().slice(0, 120);
                    if (_bdcQBClean)
                        _bdcDeepLinkBorrower = _bdcQBClean;
                }
                if (_bdcQS.get('ask') === '1')
                    _bdcDeepLinkAsk = true;
            }
        }
        catch (_e) { /* noop — deep-link is best-effort */ }
    }
    // SF_INDUSTRY_RESEARCH: the SAME F9 stash for the ?tab= deep-link. A COLD-BOOT
    // URL /?view=industry&tab=banks (typed, shared, or crawled) loses ?tab= to the
    // pushState below before _inlineRenderIndustry reads location.search, so it
    // defaulted to the contractors segment. Capture it here (pre-pushState) into
    // the same window field the in-app sidecar click uses; the renderer consumes
    // + clears it. Only on cold boot (history.state null) so a residual ?tab= on
    // an in-app switch can't hijack the segment.
    // K6/K12 (2026-10-05): the cold-boot deep link's tab, focus column and lens are KEPT in the
    // rewritten URL -- the renderer reads &focus= / &lens= from it, and a shared link must survive.
    let _indKeep = '';
    if (view === 'industry' && (!history.state || _bootCall)) {
        try {
            const _indQ = new URLSearchParams(window.location.search);
            const _indTab = _indQ.get('tab');
            if (_indTab && _indTab.trim()) {
                window.__olPendingViewTab = _indTab.trim();
            }
            ['tab', 'focus', 'lens'].forEach(function (k) { const v = _indQ.get(k); if (v && /^[A-Za-z0-9._-]{1,24}$/.test(v))
                _indKeep += '&' + k + '=' + encodeURIComponent(v); });
        }
        catch (_e) { /* noop — best-effort deep-link */ }
    }
    // QA 2026-10-17: a shared /?view=screener&preset=<id> lost ?preset= to this rewrite before the presets JSON hydrated and _maybeAutoApplyUrlPreset read it. Kept, like the industry params.
    if (view === 'screener' && (!history.state || _bootCall)) {
        try {
            const _scrP = new URLSearchParams(window.location.search).get('preset');
            if (_scrP && /^[A-Za-z0-9._-]{1,64}$/.test(_scrP))
                _indKeep += '&preset=' + encodeURIComponent(_scrP);
        }
        catch (_e) { /* noop — best-effort deep-link */ }
    }
    if (view === 'bdc' && (!history.state || _bootCall)) {
        try {
            const _bq = new URLSearchParams(window.location.search);
            ['mode', 'q', 't'].forEach(function (k) { const v = (_bq.get(k) || '').replace(/[\u0000-\u001f\u007f<>]/g, '').replace(/\s+/g, ' ').trim().slice(0, 120); if (v && (k !== 'mode' || v === 'borrower' || v === 'bdc'))
                _indKeep += '&' + k + '=' + encodeURIComponent(v); });
        }
        catch (_e) { /* noop — CHAOS 2026-10-25: a shared ?view=bdc&mode=&q=&t= link kept, as the screener preset is (bdc-browser-nav.ts restores it) */ }
    }
    if (!skipHistory) {
        let _histUrl = '?view=' + encodeURIComponent(view) + _indKeep;
        if (typeof activeTicker !== 'undefined' && activeTicker && view === 'ticker')
            _histUrl += '&symbol=' + encodeURIComponent(activeTicker);
        _historyWrite(view, _histUrl);
    }
    let _visitedViews = [];
    try {
        _visitedViews = OLStorage.get('ol_visited_views', []);
        if (_visitedViews.indexOf(view) < 0)
            _visitedViews.push(view);
        OLStorage.set('ol_visited_views', _visitedViews);
    }
    catch (_) { /* noop */ }
    if (typeof setAchievement === 'function')
        setAchievement('all_views', _visitedViews.length);
    if (typeof setAchievement === 'function')
        setAchievement('views_visited', _visitedViews.length);
}
void _hydrateVRStyles;
void _materializeView;
void _loadViewModules;
void _ensureViewModule;
void _inlineRenderPortfolio;
void _inlineRenderMacro;
void _inlineRenderWatchlist;
void _renderWatchlistItems;
void _inlineRenderLearn;
void _renderLearnCards;
void _inlineRenderBDC;
void _renderBDCList;
void _inlineRenderCalendar;
void _renderCalendarRows;
void _inlineRenderScreener;
void _inlineRenderETFScreener;
void setView;
//# sourceMappingURL=view-router.js.map
;
// ═══ industry-comps.js ═══
;"use strict";
// ── industry-comps.ts ── the /?view=industry cross-issuer peer tables ──
//
// #295 D1b (2026-07-28): extracted VERBATIM from static/js/view-router.ts,
// which sat at EXACTLY its 2,360-line file-size budget
// (tools/file_size_budget.json) -- zero headroom, so the next view-routing
// touch would have redded the gate. Sibling of the #262 ask-ai-research and
// #263 app-init-boot-tail cuts; same method, same rules.
//
// ONE subject: the SF-KPI Phase 2 cross-issuer operating-metric peer tables
// (GET /api/industry/<industry>-kpis) behind the /?view=industry comps tabs.
// What lives here:
//   - the KpiPeer* wire interfaces (envelope, metric column, carrier row,
//     partition option, tab def) + the #315 context-column shapes
//   - _kpiPeerTabs                the 23-industry tab registry
//   - _kpiPeerTabByName           registry lookup
//   - _fmtQuarter                 '2026-Q2' -> 'Q2 2026'
//   - _kpiPeerTogglePanels        show/hide every registered peer panel
//   - _fetchKpiRoster             K1: the ONE roster request that reveals the tabs
//                                 (GET /api/industry/kpi-roster) + _kpiRosterHolder,
//                                 the payload Phase B's atlas reads
//   - _kpiPeerProbeTabs           the flag-dark reveal probe (one per industry) --
//                                 since K1 the offline fallback only
//   - _fetchIndustryKpiPeers      cache-aware fetch (subtype + period lanes)
//   - _renderKpiPeerTable         the single generic renderer (no per-industry
//                                 fork), incl. the #289 reporting-period
//                                 switcher, the partition-lane selector,
//                                 glossary-linked metric labels and the #315
//                                 leading context figures
//   - _kpiCellsByMetric /         the #317 TRANSPOSED row builders: companies
//     _kpiPeerCompanyHeaders /    across the top, figures down the rows (the
//     _kpiPeerMetricRow /         standard comps-sheet geometry). Shared by the
//     _kpiPeerPeriodRow           levels table and the #293 growth table so the
//                                 two can never drift into different shapes.
//
// WHAT STAYED in view-router.ts: _inlineRenderIndustry (the tab CONTROLLER,
// which also owns the federal-contractor + FDIC-bank segments), those two
// segments' fetch/render pairs, and their module-level caches. The controller
// reaches into this file through FUNCTIONS ONLY (_kpiPeerTogglePanels /
// _kpiPeerTabByName / _fetchIndustryKpiPeers / _fetchKpiRoster) -- never the
// `const _kpiPeerTabs` binding -- so no cross-file block-scoped read exists
// and load order is not load-bearing.
//
// SCRIPT MODE, NOT an ES module. tools/build_bundle.py CONCATENATES these
// files; an import/export would make this a module and every top-level name
// would stop being a bundle global. Registered directly after view-router.js
// in JS_MODULES and in the SAME "app-init" chunk -- same chunk matters: a
// top-level `const` lives in the global LEXICAL environment, so the registry
// is only visible to view-router.js when both land in one concatenated
// script. Every name read from the parent half resolves at CALL time as an
// ambient global: escHtml, currentView, SERVER.
//
// The .ts is the SoT; industry-comps.js is the gitignored tsc build artifact
// (tracked-ness follows its parent view-router.js, which is gitignored too).
// ──────────────────────────────────────────────────────────────────────
const _kpiPeerTabs = [
    { tab: 'airlines', endpoint: '/api/industry/airline-kpis', label: 'Airline', noun: 'carrier', group: 'Transport & leisure', name: 'Airlines', cache: null },
    { tab: 'homebuilders', endpoint: '/api/industry/homebuilder-kpis', label: 'Homebuilder', noun: 'builder', group: 'Real estate & housing', name: 'Homebuilders', cache: null },
    { tab: 'telecoms', endpoint: '/api/industry/telecom-kpis', label: 'Telecom', noun: 'carrier', group: 'Tech & telecom', name: 'Telecom', cache: null },
    { tab: 'managedcare', endpoint: '/api/industry/managed-care-kpis', label: 'Managed care', noun: 'insurer', group: 'Healthcare', name: 'Managed care', cache: null },
    { tab: 'reits', endpoint: '/api/industry/reit-kpis', label: 'REIT', noun: 'REIT', group: 'Real estate & housing', name: 'REITs', cache: null },
    { tab: 'capmkts', endpoint: '/api/industry/capital-markets-kpis', label: 'Capital markets', noun: 'firm', group: 'Financials', name: 'Capital markets', cache: null },
    { tab: 'apparel', endpoint: '/api/industry/apparel-kpis', label: 'Apparel', noun: 'brand', group: 'Consumer', name: 'Apparel', cache: null },
    { tab: 'bankmetrics', endpoint: '/api/industry/bank-kpis', label: 'Bank metrics', noun: 'bank', group: 'Financials', name: 'Bank metrics', cache: null },
    { tab: 'beverage', endpoint: '/api/industry/beverage-kpis', label: 'Beverage', noun: 'company', group: 'Consumer', name: 'Beverage', cache: null },
    { tab: 'discount', endpoint: '/api/industry/discount-stores-kpis', label: 'Discount stores', noun: 'retailer', group: 'Consumer', name: 'Discount stores', cache: null },
    { tab: 'insurance', endpoint: '/api/industry/insurance-kpis', label: 'Insurance', noun: 'insurer', group: 'Financials', name: 'Insurance', cache: null },
    { tab: 'casino', endpoint: '/api/industry/casino-kpis', label: 'Casinos', noun: 'operator', group: 'Transport & leisure', name: 'Casinos', cache: null },
    { tab: 'lifescience', endpoint: '/api/industry/life-science-kpis', label: 'Life science', noun: 'company', group: 'Healthcare', name: 'Life science', cache: null },
    { tab: 'retailrest', endpoint: '/api/industry/retail-restaurant-kpis', label: 'Restaurants', noun: 'restaurant', group: 'Consumer', name: 'Restaurants', cache: null },
    { tab: 'homeimprovement', endpoint: '/api/industry/home-improvement-kpis', label: 'Home improvement', noun: 'company', group: 'Consumer', name: 'Home improvement', cache: null },
    { tab: 'hardware', endpoint: '/api/industry/hardware-kpis', label: 'Hardware', noun: 'company', group: 'Tech & telecom', name: 'Hardware', cache: null },
    { tab: 'specchem', endpoint: '/api/industry/specialty-chem-kpis', label: 'Specialty chem', noun: 'company', group: 'Energy & materials', name: 'Specialty chem', cache: null },
    { tab: 'meddevice', endpoint: '/api/industry/med-device-kpis', label: 'Med device', noun: 'company', group: 'Healthcare', name: 'Med device', cache: null },
    { tab: 'hotel', endpoint: '/api/industry/hotel-kpis', label: 'Hotels', noun: 'company', group: 'Transport & leisure', name: 'Hotels', cache: null },
    { tab: 'ep', endpoint: '/api/industry/ep-kpis', label: 'E&P', noun: 'company', group: 'Energy & materials', name: 'E&P', cache: null },
    { tab: 'refiner', endpoint: '/api/industry/refiner-kpis', label: 'Refiners', noun: 'company', group: 'Energy & materials', name: 'Refiners', cache: null },
    { tab: 'resort', endpoint: '/api/industry/resort-kpis', label: 'Resorts', noun: 'company', group: 'Transport & leisure', name: 'Resorts', cache: null },
    { tab: 'hospital', endpoint: '/api/industry/hospital-kpis', label: 'Hospitals', noun: 'company', group: 'Healthcare', name: 'Hospitals', cache: null },
];
function _kpiPeerTabByName(tab) {
    for (let i = 0; i < _kpiPeerTabs.length; i++) {
        if (_kpiPeerTabs[i].tab === tab)
            return _kpiPeerTabs[i];
    }
    return null;
}
// #315: the PREFORMATTED display for one context cell, or '' when the issuer
// has no value on file. '' paints an EMPTY cell -- an honest gap, never a '0'
// and never an 'N/A', both of which would read as a real figure. (The metric
// columns use an em-dash instead; the context columns follow the SSR
// /industries table, which leaves them blank.)
function _kpiContextDisplay(ctx, key) {
    if (!ctx)
        return '';
    const cell = ctx[key];
    if (!cell || typeof cell === 'string')
        return '';
    return cell.display || '';
}
// CHAOS F10 (2026-10-13): the SSR twin's dagger (ssr_industry_pages._nonrecourse_mark). An
// enterprise value whose total debt includes non-recourse VIE debt carries a linked dagger
// INSIDE its cell, and only beside a figure -- the label rides with the EV, so a withheld EV
// (the public price cut-back drops the column) carries none. The link target is fixed here.
const _KPI_NONRECOURSE_HREF = '/methodology/total-debt#non-recourse';
function _kpiNonrecourseMark(ctx, key) {
    if (!ctx || key !== 'enterprise_value')
        return '';
    const cell = ctx[key];
    if (!cell || typeof cell === 'string' || !cell.note || !cell.display)
        return '';
    const note = escHtml(String(cell.note));
    return ' <a href="' + _KPI_NONRECOURSE_HREF + '" title="' + note + '" aria-label="' + note + '">&dagger;</a>';
}
// The sentence that explains the dagger, when one rendered (the SSR twin's _nonrecourse_caption).
function _kpiNonrecourseCaption(carriers, cols) {
    if (!cols.some(function (cc) { return cc.key === 'enterprise_value'; }))
        return '';
    if (!carriers.some(function (c) { return _kpiNonrecourseMark(c.context, 'enterprise_value') !== ''; }))
        return '';
    return '<p class="text-muted fs-9 mt-8">&dagger; Total debt in this enterprise value includes non-recourse '
        + 'debt of consolidated variable-interest entities, as the balance sheet presents it. '
        + '<a href="' + _KPI_NONRECOURSE_HREF + '">How total debt is defined</a>.</p>';
}
// '2026-Q2' -> 'Q2 2026' (escaped); em-dash for a missing period.
function _fmtQuarter(p) {
    if (!p)
        return '&mdash;';
    const m = /^(\d{4})-(Q\d)$/.exec(p);
    return m ? escHtml(m[2] + ' ' + m[1]) : escHtml(p);
}
// Show the peer panel for `tab` and hide every other registered one. Moved out
// of _inlineRenderIndustry's showTab by the #295 cut (body verbatim, one
// indent level shallower) -- it iterates the registry, so it belongs with it.
function _kpiPeerTogglePanels(tab) {
    _kpiPeerTabs.forEach(function (t) {
        const panel = document.getElementById('industry-' + t.tab + '-panel');
        if (panel)
            panel.classList.toggle('d-none', tab !== t.tab);
    });
    _kpiNavReveal(tab);
}
// Prod QA 2026-10-05: on a phone the grouped nav is one sideways-scrolling strip (the
// wrapped groups stood 640px tall at 390px); bring the open tab's chip into the strip's view.
// Horizontal only -- scrollIntoView would also move the page.
function _kpiNavReveal(tab) {
    const nav = document.querySelector('.kpi-nav');
    const btn = document.getElementById('industry-' + tab + '-tab');
    if (!nav || !btn || nav.scrollWidth <= nav.clientWidth)
        return;
    const nr = nav.getBoundingClientRect();
    const br = btn.getBoundingClientRect();
    if (br.left < nr.left || br.right > nr.right)
        nav.scrollLeft += (br.left - nr.left) - 16;
}
// QA-07 (2026-09-28): the probe roster -- which tabs have a table -- memoised in
// this page and in device storage so a re-entry or reload does not re-probe all
// 23 industries. Only DEFINITE answers are kept (see _kpiPeerProbeTabs).
const _KPI_ROSTER_KEY = 'ol_kpi_peer_roster_v1';
const _KPI_ROSTER_TTL_MS = 30 * 60 * 1000;
const _KPI_PROBE_CONCURRENCY = 4;
let _kpiRosterMem = null;
function _kpiRosterLoad() {
    if (_kpiRosterMem)
        return _kpiRosterMem;
    let stored = null;
    try {
        stored = OLStorage.get(_KPI_ROSTER_KEY, null);
    }
    catch (_e) {
        stored = null;
    }
    _kpiRosterMem = (stored && typeof stored === 'object') ? stored : {};
    return _kpiRosterMem;
}
// tab -> available, for the entries still inside the TTL; absent = unknown.
function _kpiRosterRead() {
    const out = {};
    const now = Date.now();
    const mem = _kpiRosterLoad();
    Object.keys(mem).forEach(function (tab) {
        const e = mem[tab];
        if (Array.isArray(e) && typeof e[0] === 'boolean' && typeof e[1] === 'number'
            && now - e[1] < _KPI_ROSTER_TTL_MS)
            out[tab] = e[0];
    });
    return out;
}
// Record a definite answer; `null` forgets the tab (probe it again next time).
function _kpiRosterNote(tab, available) {
    const mem = _kpiRosterLoad();
    if (available === null)
        delete mem[tab];
    else
        mem[tab] = [available, Date.now()];
    try {
        OLStorage.set(_KPI_ROSTER_KEY, mem);
    }
    catch (_e) { /* storage off: this page still remembers */ }
}
const _KPI_ROSTER_ENDPOINT = '/api/industry/kpi-roster';
const _KPI_ROSTER_PAYLOAD_TTL_MS = 15 * 60 * 1000; // matches the server cache
// The last roster this page received -- Phase B's atlas (K3) reads `entries`
// from here rather than fetching again. `pending` is the in-flight request, so
// a tab opened before the roster lands waits for it instead of racing it.
const _kpiRosterHolder = { entries: null, at: 0, pending: null };
function _kpiRosterIsPayload(body) {
    if (!Array.isArray(body) || body.length === 0)
        return false;
    return body.every(function (e) {
        const r = e;
        return !!r && typeof r.tab === 'string' && typeof r.available === 'boolean';
    });
}
// true / false from the roster this page holds; null = no roster (or the tab
// is not in it), in which case the caller behaves exactly as before K1.
function _kpiRosterAvailable(tab) {
    const entries = _kpiRosterHolder.entries;
    if (!entries)
        return null;
    for (let i = 0; i < entries.length; i++) {
        if (entries[i].tab === tab)
            return entries[i].available;
    }
    return null;
}
// ONE pass, same CLS discipline as the probe: reveal every available tab and
// collapse every other one in the same frame. Honest-or-absent: a tab the
// roster marks unavailable is d-none, never shown. An available answer is also
// remembered for the offline fallback (an unavailable one is not -- the roster
// cannot say whether that was a dark table or a read that failed this time).
function _kpiRosterApply(entries) {
    const avail = {};
    entries.forEach(function (e) { avail[e.tab] = e.available === true; });
    _kpiPeerTabs.forEach(function (t) {
        const btn = document.getElementById('industry-' + t.tab + '-tab');
        if (!btn)
            return;
        btn.classList.remove('is-probing');
        if (avail[t.tab] === true) {
            btn.classList.remove('d-none');
            _kpiRosterNote(t.tab, true);
        }
        else
            btn.classList.add('d-none');
    });
    _kpiNavGroupsSync();
}
// K3: a nav group whose every chip is hidden hides its heading too, so the
// grouped nav never shows an empty "Healthcare" kicker. Same frame as the chips.
function _kpiNavGroupsSync() {
    const groups = document.querySelectorAll('.kpi-nav-group');
    for (let i = 0; i < groups.length; i++) {
        const g = groups[i];
        const shown = g.querySelectorAll('.industry-seg-btn:not(.d-none)').length > 0;
        g.classList.toggle('d-none', !shown);
    }
}
// Called once on view entry (view-router.ts _inlineRenderIndustry). Re-entry
// inside the TTL re-applies the held roster with no request.
function _fetchKpiRoster() {
    const h = _kpiRosterHolder;
    if (h.entries && Date.now() - h.at < _KPI_ROSTER_PAYLOAD_TTL_MS) {
        _kpiRosterApply(h.entries);
        return Promise.resolve(h.entries);
    }
    if (h.pending)
        return h.pending;
    h.pending = fetch(((typeof SERVER !== 'undefined') ? SERVER : '') + _KPI_ROSTER_ENDPOINT, { signal: AbortSignal.timeout(15000) })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (body) {
        if (!_kpiRosterIsPayload(body))
            return null;
        h.entries = body;
        h.at = Date.now();
        _kpiRosterApply(body);
        return body;
    })
        .catch(function () { return null; })
        .then(function (entries) {
        h.pending = null;
        if (!entries)
            _kpiPeerProbeTabs(); // offline fallback: the pre-K1 per-tab probe
        return entries;
    });
    return h.pending;
}
// ── K6 step 3: "Compare {T} in {Industry} ->" on the ticker page (OWNER 2026-10-05) ──
// The ticker->tab map is the roster's per-tab `tickers` (the cohort of the table each tab
// OPENS on), so the link renders only when the table it lands on shows the company, and it
// costs no new fan-out: the roster is one cached request, shared with the Industry view.
let _kpiRosterQuietPending = null;
// The roster WITHOUT touching the Industry view's chips (the ticker page has none) and without
// the per-tab probe fallback: a failed roster here simply links nothing. A successful one is
// kept in _kpiRosterHolder, so a later Industry visit inside the TTL makes no request.
function _kpiRosterQuiet() {
    const h = _kpiRosterHolder;
    if (h.entries && Date.now() - h.at < _KPI_ROSTER_PAYLOAD_TTL_MS)
        return Promise.resolve(h.entries);
    if (h.pending)
        return h.pending;
    if (_kpiRosterQuietPending)
        return _kpiRosterQuietPending;
    _kpiRosterQuietPending = fetch(((typeof SERVER !== 'undefined') ? SERVER : '') + _KPI_ROSTER_ENDPOINT, { signal: AbortSignal.timeout(15000) })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (body) {
        if (!_kpiRosterIsPayload(body))
            return null;
        h.entries = body;
        h.at = Date.now();
        return body;
    })
        .catch(function () { return null; })
        .then(function (v) { _kpiRosterQuietPending = null; return v; });
    return _kpiRosterQuietPending;
}
// The tab a ticker's comparison opens. DETERMINISTIC: the FIRST tab in registry order (the
// roster's order) whose opening table lists the ticker -- a company in two tabs (a bank in
// Bank metrics and in Capital markets) always opens the earlier one. null = no tab shows it.
function _kpiTabForTicker(ticker, entries) {
    const want = (ticker || '').toUpperCase();
    for (let i = 0; i < _kpiPeerTabs.length; i++) {
        const t = _kpiPeerTabs[i];
        for (let j = 0; j < entries.length; j++) {
            const e = entries[j];
            if (e.tab === t.tab && e.available && Array.isArray(e.tickers) && e.tickers.indexOf(want) >= 0)
                return t;
        }
    }
    return null;
}
// Called by the ticker page's Peer Comparison (Comps) panel (peer-view.ts renderPeerComparison)
// on every render. Owns ONE slot, inserted once above the panel's content node -- never an
// innerHTML on the panel -- and resolves each ticker once.
function _kpiRenderCompareLink(ticker) {
    const body = document.getElementById('peers-panel-body');
    const content = document.getElementById('peers-panel-content');
    const want = (ticker || '').toUpperCase();
    if (!body || !content || !/^[A-Z0-9.\-]{1,10}$/.test(want))
        return;
    let slot = document.getElementById('peers-industry-compare');
    if (!slot) {
        slot = document.createElement('p');
        slot.id = 'peers-industry-compare';
        slot.className = 'kpi-compare d-none';
        body.insertBefore(slot, content);
    }
    if (slot.getAttribute('data-ticker') === want)
        return; // already resolved (or resolving)
    slot.setAttribute('data-ticker', want);
    slot.classList.add('d-none'); // the previous ticker's link never shows under this one
    slot.textContent = '';
    const s = slot;
    _kpiRosterQuiet().then(function (entries) {
        if (!entries || s.getAttribute('data-ticker') !== want)
            return; // superseded
        const t = _kpiTabForTicker(want, entries);
        if (!t)
            return; // honest-absent: no Industry table shows this company
        const href = '/?view=industry&tab=' + encodeURIComponent(t.tab) + '&focus=' + encodeURIComponent(want);
        s.innerHTML = '<a class="kpi-compare-link" href="' + escHtml(href) + '" data-action="kpi-compare" data-tab="'
            + escHtml(t.tab) + '">Compare ' + escHtml(want) + ' in ' + escHtml(_kpiTabDisplayName(t)) + ' &rarr;</a>';
        s.classList.remove('d-none');
    });
}
// The delegated `kpi-compare` action (app-renderers.ts). A client-side switch that KEEPS the
// link's ?tab= and &focus= in the URL (setView would rewrite it to bare ?view=industry): push
// the href, then switch without a second history write. A modified click (new tab) and any
// failure fall through to the plain href, which a cold boot reads the same way.
function _kpiOpenCompare(e) {
    const me = e;
    if (me && (me.metaKey || me.ctrlKey || me.shiftKey || me.button === 1))
        return;
    const a = (e && e.target) ? e.target.closest('[data-action="kpi-compare"]') : null;
    const href = a ? a.getAttribute('href') : null;
    if (!a || !href || typeof setView !== 'function')
        return;
    try {
        history.pushState({ view: 'industry' }, '', href);
    }
    catch (_e) {
        return;
    }
    if (e.preventDefault)
        e.preventDefault();
    try {
        window.__olPendingViewTab = a.getAttribute('data-tab');
    }
    catch (_e) { /* noop */ }
    setView('industry', true);
}
// Moved out of _inlineRenderIndustry by the #295 cut (body verbatim) -- it
// iterates the registry, so it belongs with the registry.
// Since K1 (2026-10-05) this is the OFFLINE FALLBACK only -- _fetchKpiRoster
// calls it when the one roster request fails.
function _kpiPeerProbeTabs() {
    const roster = _kpiRosterRead();
    const jobs = [];
    const probes = _kpiPeerTabs.map(function (t) {
        const tabBtn = document.getElementById('industry-' + t.tab + '-tab');
        if (!tabBtn)
            return Promise.resolve(null);
        const known = roster[t.tab];
        if (known === false)
            return Promise.resolve(null);
        if (known === true)
            return Promise.resolve({ t: t, btn: tabBtn, data: t.cache });
        return new Promise(function (resolve) {
            jobs.push(function () {
                return fetch(((typeof SERVER !== 'undefined') ? SERVER : '') + t.endpoint, { signal: AbortSignal.timeout(15000) })
                    .then(function (res) {
                    if (res.ok)
                        return res.json();
                    // CHAOS F1 (2026-09-28): only a GENUINE not-found is an answer -- the
                    // flag-dark / no-rows 404 carries {"error": "not_found"}. A failed
                    // build answers 503 {"error": "build_failed"} and anything else
                    // (429, 5xx, an HTML error page) is unknown: hidden for this load,
                    // probed again next time, never remembered.
                    if (res.status === 404) {
                        return res.json().then(function (b) {
                            if (b && b.error === 'not_found')
                                _kpiRosterNote(t.tab, false);
                            return null;
                        }, function () { return null; });
                    }
                    return null;
                })
                    .then(function (data) {
                    if (data)
                        _kpiRosterNote(t.tab, !!data.available);
                    return (data && data.available) ? { t: t, btn: tabBtn, data: data } : null;
                })
                    .catch(function () { return null; /* keep the tab hidden on any failure */ })
                    .then(function (v) { resolve(v); return v; });
            });
        });
    });
    // A small pool drains the queue: each worker takes the next job when its
    // current probe settles (every job resolves -- its .catch returns null).
    let next = 0;
    function _drain() {
        if (next >= jobs.length)
            return Promise.resolve();
        const job = jobs[next++];
        return job().then(function () { return _drain(); });
    }
    for (let w = 0; w < _KPI_PROBE_CONCURRENCY; w++) {
        void _drain();
    }
    Promise.allSettled(probes).then(function (results) {
        // ONE frame: reveal what resolved AND collapse what never will. The chips
        // ship `is-probing` (visibility:hidden), so they have been holding their
        // real boxes since first paint -- the strip is already the right height and
        // revealing costs no reflow at all. The only geometry change left is the
        // shrink from collapsing the tabs whose endpoint never answered (~4 of 23),
        // and doing it in this same pass keeps that to a single row rather than a
        // second shift after the first.
        const revealed = {};
        results.forEach(function (r) {
            const v = (r.status === 'fulfilled') ? r.value : null;
            if (!v)
                return;
            if (v.data)
                v.t.cache = v.data;
            v.btn.classList.remove('is-probing');
            revealed[v.t.tab] = true;
        });
        _kpiPeerTabs.forEach(function (t) {
            if (revealed[t.tab])
                return;
            const btn = document.getElementById('industry-' + t.tab + '-tab');
            // d-none, not is-probing: an unavailable tab must stop reserving space.
            // Leaving it visibility:hidden would hold a permanent gap in the strip.
            if (btn) {
                btn.classList.remove('is-probing');
                btn.classList.add('d-none');
            }
        });
        _kpiNavGroupsSync();
    });
}
function _fetchIndustryKpiPeers(el, t, subtype, period) {
    // K1: never request an endpoint the roster marks unavailable. A ?tab= deep
    // link can open a tab before the roster lands, so wait for an in-flight
    // roster first rather than racing it into a 404.
    if (_kpiRosterHolder.pending) {
        _kpiRosterHolder.pending.then(function () { _fetchIndustryKpiPeers(el, t, subtype, period); });
        return;
    }
    if (_kpiRosterAvailable(t.tab) === false) {
        el.innerHTML = '<div class="status-msg status-msg--muted">No ' + escHtml(t.label.toLowerCase()) + ' peer data available.</div>';
        return;
    }
    // A partition (subtype) or period (#289) selection always re-fetches that
    // lane; only the default view uses the cache.
    if (!subtype && !period && t.cache) {
        _renderKpiPeerTable(el, t.cache, t);
        return;
    }
    const qp = [];
    if (subtype)
        qp.push('subtype=' + encodeURIComponent(subtype));
    if (period)
        qp.push('period=' + encodeURIComponent(period));
    const url = t.endpoint + (qp.length ? ('?' + qp.join('&')) : '');
    el.innerHTML = '<div class="status-msg status-msg--muted">Loading ' + escHtml(t.label.toLowerCase()) + ' peer table&hellip;</div>';
    fetch(((typeof SERVER !== 'undefined') ? SERVER : '') + url, { signal: AbortSignal.timeout(15000) })
        .then(function (res) {
        // A remembered-available tab whose table went dark (flag off, rows
        // pruned): forget it, so the next entry probes instead of revealing it.
        if (res.status === 404 && !subtype && !period)
            _kpiRosterNote(t.tab, null);
        return res.ok ? res.json() : Promise.reject('HTTP ' + res.status);
    })
        .then(function (data) { t.cache = data; if (currentView === 'industry')
        _renderKpiPeerTable(el, data, t); })
        .catch(function () {
        if (currentView === 'industry') {
            el.innerHTML = '<div class="status-msg status-msg--muted">' + escHtml(t.label) + ' peer data unavailable right now.</div>';
        }
    });
}
// #317 (OWNER directive 2026-07-28): the comps tables are TRANSPOSED -- companies run ACROSS
// THE TOP (the standard finance comps-sheet convention) and every figure is a ROW. A cohort is
// 4-10 issuers while the figure count is 7-15+ (5 context rows + the period row + the operating
// metrics), so the rotated aspect ratio is the one that fits without a horizontal scrollbar.
// The GEOMETRY is all that rotated: each issuer still carries its OWN reporting period (now the
// "As of" ROW), a blank is still an honest coverage gap and never a zero, the #315 context
// figures still lead, the caveats are unchanged, and the column order across the top is the
// server's alphabetical carrier order (NO rank -- OWNER decision 4).
// One carrier's cells keyed by metric. The pre-#317 renderer walked `c.cells` positionally
// because a row WAS a carrier; a transposed row walks the carriers for ONE metric, so the
// lookup has to be by metric name rather than by index.
function _kpiCellsByMetric(c) {
    const out = {};
    (c.cells || []).forEach(function (cell) { out[cell.metric] = cell; });
    return out;
}
// The header row's company columns (#317): ticker chip with the full issuer name beneath
// (#287/#294 -- the OWNER made display names a directive). The whole cell carries the
// switch-ticker action the pre-#317 <tr> carried; the global delegated handler resolves
// `closest('[data-action]')`, so a <th> works exactly as the row did.
function _kpiPeerCompanyHeaders(carriers, focusIdx) {
    let head = '';
    carriers.forEach(function (c, i) {
        const nameLine = c.name ? '<div class="kpi-co-name">' + escHtml(c.name) + '</div>' : '';
        head += '<th scope="col" class="text-right ol-cursor-pointer' + (i === focusIdx ? ' kpi-focus' : '')
            + '" data-action="switch-ticker"'
            + ' data-ticker="' + escHtml(c.ticker) + '"><span class="scr-ticker-blue">'
            + escHtml(c.ticker) + '</span>' + nameLine + '</th>';
    });
    return head;
}
// K6: the focus column's index in this roster, -1 when absent.
function _kpiFocusIndex(carriers) {
    const f = _kpiFocusTicker();
    if (!f)
        return -1;
    for (let i = 0; i < carriers.length; i++) {
        if ((carriers[i].ticker || '').toUpperCase() === f)
            return i;
    }
    return -1;
}
// The one period the roster shares, in reader form, or '' when issuers differ
// (then a gap's title names no period rather than a wrong one).
function _kpiCommonPeriod(carriers) {
    let p;
    for (let i = 0; i < carriers.length; i++) {
        const cp = carriers[i].period || null;
        if (p === undefined)
            p = cp;
        else if (cp !== p)
            return '';
    }
    if (!p)
        return '';
    const m = /^(\d{4})-(Q\d)$/.exec(p);
    return m ? (m[2] + ' ' + m[1]) : p;
}
// One metric's ROW: the label (glossary-linked where present) + its coverage affix lead the
// row as its <th scope="row">, then one cell per carrier in header order.
// #318 (OWNER 2026-07-28): when every POPULATED cell in a metric row carries the IDENTICAL
// non-empty badge, the annotation is a fact about the metric as this cohort reports it —
// hoist it into the row header once instead of repeating it per cell. Any variation (a cell
// badged differently, or badged cells mixed with unbadged populated cells) keeps the badges
// per-cell: the difference IS the disclosure.
function _kpiUniformRowBadge(m, cellMaps) {
    let uniform = null;
    for (let i = 0; i < cellMaps.length; i++) {
        const cell = cellMaps[i][m.metric];
        if (!cell || !cell.display) {
            continue;
        }
        const badge = cell.badge || '';
        if (uniform === null) {
            uniform = badge;
        }
        else if (badge !== uniform) {
            return '';
        }
    }
    return uniform || '';
}
// ── K4-K6 (OWNER industry-page design handoff, 2026-10-05) ──────────────────
// The table now answers "who leads" without the reader comparing eight numbers.
// SUPERSEDES the "NO rank (OWNER decision 4)" note above for SHADING only: the
// COLUMNS are still the server's alphabetical order (nothing is re-sorted); a
// ranked metric's cells are tinted by rank and its best value carries "1st".
// Rules, all deliberate:
//   * only a metric whose server `better` is 'high' | 'low' is ranked -- the
//     direction is never assumed (CASM, combined ratio, MLR are lower-is-better);
//   * only cells with a finite numeric `value` that SHARE ONE unit AND ONE basis badge
//     are ranked (CHAOS T4, 2026-10-05: an occupancy by MW never outranks one by square
//     foot -- a basis-mixed row ranks NOTHING and its figures say why in their title);
//   * a `positive_only` column (the server's direction-registry property, CHAOS T5:
//     cost per unit, expense and loss ratios, length of stay) ignores a value <= 0 --
//     printed, never ranked; no metric name is listed here;
//   * a truncated table ranks nothing (CHAOS T6, via _kpiRankable);
//   * fewer than 2 rankable values -> no rank; a tie for best -> no "1st".
// This is the line-for-line mirror of `rank_cells` in ssr_operating_kpis_roster.py (the
// roster card, the teaser, the crawlable page); the WHY strings are the same words.
const _KPI_WHY_UNITS = 'Not ranked: these figures are in different units';
const _KPI_WHY_BASIS = 'Not ranked: these figures are reported on different bases';
function _kpiRankWhy(m, cellMaps) {
    if (m.better !== 'high' && m.better !== 'low')
        return { rank: null, why: '' };
    // Only the row's NEWEST calendar quarter that at least two companies report is
    // ranked. The default view puts each issuer's own newest quarter side by side,
    // and a Q1 load factor is not beaten by a Q2 one. Every other cell stays null:
    // shown, never shaded.
    const byQ = {};
    cellMaps.forEach(function (byMetric, i) {
        const cell = byMetric[m.metric];
        if (!cell || !cell.display || typeof cell.value !== 'number' || !isFinite(cell.value))
            return;
        // OWNER 2026-10-11: a labeled segment figure (WMT's Walmart U.S.) is shown, never ranked
        if (cell.rank_excluded)
            return;
        if (m.positive_only && cell.value <= 0)
            return;
        const pm = /^(\d{4})-Q([1-4])$/.exec(cell.period || '');
        if (!pm)
            return;
        const key = pm[1] + pm[2];
        (byQ[key] = byQ[key] || []).push(i);
    });
    const pick = Object.keys(byQ).sort().reverse().filter(function (k) { return byQ[k].length >= 2; })[0];
    if (!pick)
        return { rank: null, why: '' };
    let idx = byQ[pick];
    const units = {};
    const bases = {};
    idx.forEach(function (i) {
        units[String(cellMaps[i][m.metric].unit || '')] = true;
        // the basis a cell ranks on: `rank_basis` when present (OWNER 2026-10-10), else its badge
        const rc = cellMaps[i][m.metric];
        bases[String(('rank_basis' in rc ? rc.rank_basis : rc.badge) || '')] = true;
    });
    if (Object.keys(units).length > 1)
        return { rank: null, why: _KPI_WHY_UNITS };
    if (Object.keys(bases).length > 1)
        return { rank: null, why: _KPI_WHY_BASIS };
    const values = cellMaps.map(function () { return null; });
    idx.forEach(function (i) { values[i] = cellMaps[i][m.metric].value; });
    const hi = m.better === 'high';
    idx = idx.slice().sort(function (a, b) {
        return hi ? values[b] - values[a] : values[a] - values[b];
    });
    const q = values.map(function () { return null; });
    idx.forEach(function (i, pos) {
        // tied values share the rank of the first of them
        let r = pos;
        while (r > 0 && values[idx[r - 1]] === values[i])
            r--;
        q[i] = Math.min(3, Math.floor((r / idx.length) * 4));
    });
    const lead = (values[idx[0]] !== values[idx[1]]) ? idx[0] : -1;
    const u0 = cellMaps[idx[0]][m.metric].unit;
    return { rank: { q: q, lead: lead, values: values, unit: u0 || null, period: 'Q' + pick.slice(4) + ' ' + pick.slice(0, 4) }, why: '' };
}
function _kpiRankRow(m, cellMaps) {
    return _kpiRankWhy(m, cellMaps).rank;
}
// K6: the column to highlight -- ?focus=DAL, set by a ticker page's comps link.
function _kpiFocusTicker() {
    // A render outside a page (the node harnesses that evaluate this file) has no `location`;
    // _renderKpiPeerTable now asks for the focus first thing (N9), so read it defensively.
    const q = (typeof location !== 'undefined' && location && location.search) || '';
    const m = /[?&]focus=([A-Za-z0-9.\-]{1,10})(?:&|$)/.exec(q);
    return m ? m[1].toUpperCase() : '';
}
// K5: one-line strip plot of the row's spread -- pure string SVG, no library,
// no inline style (SVG attributes are fine under the CSP). Colours come from
// CSS classes so both themes read it.
function _kpiStripSvg(rank, focusIdx) {
    const xs = rank.values.filter(function (v) { return v !== null; });
    const lo = Math.min.apply(null, xs);
    const hi = Math.max.apply(null, xs);
    let dots = '';
    rank.values.forEach(function (v, i) {
        if (v === null)
            return;
        const x = (4 + ((v - lo) / ((hi - lo) || 1)) * 112).toFixed(1);
        if (i === focusIdx)
            dots += '<circle class="kpi-strip-ring" cx="' + x + '" cy="7" r="5"></circle>';
        dots += '<circle class="' + (i === rank.lead ? 'kpi-strip-lead' : 'kpi-strip-dot') + '" cx="' + x
            + '" cy="7" r="' + (i === rank.lead ? '3.6' : '2.6') + '"></circle>';
    });
    return '<svg class="kpi-strip" viewBox="0 0 120 14" width="120" height="14" aria-hidden="true" focusable="false">'
        + '<line class="kpi-strip-axis" x1="2" y1="7" x2="118" y2="7"></line>' + dots + '</svg>';
}
// One metric's ROW: label (glossary-linked) + direction + coverage + strip in the
// <th scope="row">, then one cell per carrier in header order. `tickers` and
// `focusIdx` are optional so every caller that predates K6 keeps working.
function _kpiPeerMetricRow(m, cellMaps, tickers, focusIdx, periodLabel) {
    const fIdx = (typeof focusIdx === 'number') ? focusIdx : -1;
    const label = m.glossary_slug
        ? '<a class="kpi-gloss" href="/glossary/' + encodeURIComponent(m.glossary_slug) + '">' + escHtml(m.label) + '</a>'
        : escHtml(m.label);
    const hoisted = _kpiUniformRowBadge(m, cellMaps);
    const hoistedHtml = hoisted ? ' <span class="kpi-basis">' + escHtml(hoisted) + '</span>' : '';
    // CHAOS T4: a directed row that ranks nothing (mixed bases or units) says why on each figure
    const rw = _kpiRankWhy(m, cellMaps);
    const rank = rw.rank;
    const dir = rank ? '<span class="kpi-dir">' + (m.better === 'low' ? 'lower is better' : 'higher is better') + '</span>' : '';
    // K7: the coverage sub-note only when some company does not report this metric.
    const cov = (m.coverage < m.coverage_total)
        ? '<span class="kpi-cov">' + m.coverage + ' of ' + m.coverage_total + ' report'
            // CHAOS 2026-10-11 SF3: a labeled segment cell shows a value but is not a company-wide report
            + (cellMaps.some(function (bm) {
                return !!(bm[m.metric] && bm[m.metric].rank_excluded);
            }) ? ' company-wide' : '')
            + '</span>' : '';
    // K9: a ranked row gets a real <button> (keyboard-native) that opens the ranked view.
    const expand = rank
        ? '<button type="button" class="kpi-expand-toggle" data-action="kpi-expand" data-metric="'
            + escHtml(m.metric) + '" aria-expanded="false">Ranked view</button>' : '';
    let row = '<tr' + (rank ? ' data-kpi-metric="' + escHtml(m.metric) + '"' : '') + '><th scope="row" class="text-left">'
        + '<span class="kpi-row-label">' + label + hoistedHtml + '</span>' + dir + cov
        + (rank ? _kpiStripSvg(rank, fIdx) : '') + expand + '</th>';
    cellMaps.forEach(function (byMetric, i) {
        const cell = byMetric[m.metric];
        const cls = ['text-right'];
        if (rank && rank.q[i] !== null)
            cls.push('kpi-q' + (rank.q[i] + 1));
        if (i === fIdx)
            cls.push('kpi-focus');
        if (cell && cell.display) {
            const badge = (!hoisted && cell.badge)
                ? ' <span class="kpi-basis">' + escHtml(cell.badge) + '</span>' : '';
            const lead = (rank && rank.lead === i) ? '<span class="kpi-lead">1st</span>' : '';
            // A shown-but-unshaded cell in a ranked row says WHY, so a reader never reads the
            // missing tint as "worst": another quarter, or a value this metric never ranks.
            let why = cell.rank_excluded || (rank ? '' : rw.why);
            if (rank && rank.q[i] === null && !cell.rank_excluded) {
                const own = /^(\d{4})-(Q[1-4])$/.exec(cell.period || '');
                why = own ? (own[2] + ' ' + own[1] + ' figure; ranked only among ' + rank.period + ' reporters')
                    : 'Not ranked: not comparable with the ' + rank.period + ' figures';
            }
            row += '<td class="' + cls.join(' ') + '"' + (why ? ' title="' + escHtml(why) + '"' : '') + '>'
                + lead + escHtml(cell.display) + badge + '</td>';
        }
        else {
            // K4: an honest coverage gap is a titled BLANK -- never a zero, never a dash.
            cls.push('kpi-na');
            const who = (tickers && tickers[i]) ? tickers[i] : 'this company';
            const title = 'Not reported by ' + who + (periodLabel ? ' for ' + periodLabel : '');
            row += '<td class="' + cls.join(' ') + '" title="' + escHtml(title) + '"><span class="kpi-na-mark" aria-label="'
                + escHtml(title) + '"></span></td>';
        }
    });
    return row + '</tr>';
}
// The §3.2 honesty row: every carrier's OWN reporting period, read across one row. Pre-#317
// this was the "As of" COLUMN; the label and the copy are unchanged.
//
// The printed label alone is not enough and never was: 'FY2026-Q1' means one quarter to a
// start-named filer and a quarter a YEAR away to an end-named one, and _fmtQuarter passes the
// FY form through verbatim because it only normalises the 7-char '2026-Q2' shape. The
// server-preformatted period-END rides beneath the label as a muted sub-line -- the coordinate
// the label withholds. Since the OWNER's 2026-07-28 ratification the COLUMN is a calendar
// quarter (period-END snapped to the nearest anchor) while this row stays the issuer's OWN
// printed label -- so the row answers "what did THIS filer call it, and when did it actually
// end", which is what ties our figure back to the source document. The collision guard this
// comment used to reference was retired by that ratification: bucketing on the calendar
// quarter makes a label collision impossible, and the guard's tolerance would have evicted
// issuers the convention places correctly. Heading matches the SSR twin ("Reported period",
// not "As of", which reads as a price date).
// K7 (2026-10-05): metadata rows (this one and the #315 context rows) carry
// `kpi-meta` so they read as secondary and sit above the measured KPIs.
function _kpiPeerPeriodRow(carriers, focusIdx) {
    let row = '<tr class="kpi-meta"><th scope="row" class="text-left">Reported period</th>';
    carriers.forEach(function (c, i) {
        const end = c.period_end
            ? '<span class="d-block">ended ' + escHtml(c.period_end) + '</span>' : '';
        row += '<td class="text-right' + (i === focusIdx ? ' kpi-focus' : '') + '">'
            + _fmtQuarter(c.period) + end + '</td>';
    });
    return row + '</tr>';
}
// The builder's reader-facing omission sentences, one <p> each, ABOVE the table it describes
// (the SSR twin places them identically, beside its truncation note). Both are facts about WHO
// IS IN the roster, and a reader has to know the roster is short before reading the roster.
//
// The copy is NOT written here. It is built once on the envelope by
// ssr_operating_kpis._omission_notes and rendered verbatim, the same discipline
// `context_caption` follows -- a disclosure the SSR page words one way and this surface another
// is the divergence class this change exists to close. '' when nothing was removed.
function _kpiOmissionNotes(notes) {
    if (!notes || notes.length === 0)
        return '';
    let out = '';
    notes.forEach(function (n) {
        if (n)
            out += '<p class="text-muted fs-9 mb-8">' + escHtml(n) + '</p>';
    });
    return out;
}
// #293 I-A: the "Growth rates" table -- rendered as its OWN stacked table below the levels one,
// never as extra rows on it. Its own carrier header row, its own coverage counts (against its
// own roster) and its own caveat, because a growth rate and a level are different kinds of
// number. '' when the envelope carries no growth block, which is every pre-#293 industry.
function _renderKpiPeerGrowth(g, t) {
    if (!g || !g.metrics || g.metrics.length === 0 || !g.carriers || g.carriers.length === 0)
        return '';
    const nounCap = t.noun.charAt(0).toUpperCase() + t.noun.slice(1);
    const gFocus = _kpiFocusIndex(g.carriers);
    const head = '<th scope="col">' + escHtml(nounCap) + '</th>'
        + _kpiPeerCompanyHeaders(g.carriers, gFocus);
    const gMaps = g.carriers.map(_kpiCellsByMetric);
    const gTickers = g.carriers.map(function (c) { return c.ticker; });
    const gPeriod = _kpiCommonPeriod(g.carriers);
    let rows = _kpiPeerPeriodRow(g.carriers, gFocus);
    _kpiRankable(g).forEach(function (m) {
        rows += _kpiPeerMetricRow(m, gMaps, gTickers, gFocus, gPeriod); // sign-forced displays pass through unchanged
    });
    const spread = (g.period_spread && g.period_spread.length)
        ? 'Periods: ' + g.period_spread.map(function (p) { return escHtml(p); }).join(', ') + '. '
        : '';
    const truncated = g.truncated
        ? 'This comparison reached the source read limit, so coverage may be incomplete. '
        : '';
    // Anon-partial honesty (queue 2026-07-29): the column-header coverage affix
    // (N/M) counts the COHORT while the anon teaser shows only the first
    // _KPI_ANON_TEASER_ROWS columns — without this sentence the growth tab
    // asserted "(5/5)" over a 3-column table. Same copy as the levels table's
    // teaser above; the envelope has carried partial/total_carriers since #293.
    // OWNER 2026-10-05, K11 step 3: only a COLUMN-partial table (g.partial with fewer carriers
    // than g.total_carriers) is short of companies; the new anonymous teaser carries them all.
    const teaser = (g.partial && g.carriers.length < (g.total_carriers || 0))
        ? '<a href="/">Sign in</a> to see all ' + g.total_carriers + ' ' + escHtml(t.noun) + 's. '
        : '';
    // K12 (2026-10-05): the growth table is a LENS now, so it gets the levels table's
    // treatment -- the kpi-peer-table class (tints, sticky header) and its own phone list,
    // placed before the table so the phone CSS swaps the one for the other.
    return '<h3 class="fs-11 mt-16 mb-8">' + escHtml(g.title || 'Growth rates') + '</h3>'
        + _kpiOmissionNotes(g.omission_notes)
        + _kpiMobileList(g, gMaps, 'growth')
        + '<div class="industry-table-wrap"><table class="ol-data-table kpi-peer-table" aria-label="'
        + escHtml(t.label) + ' growth-rate comparison"><thead><tr>' + head
        + '</tr></thead><tbody>' + rows + '</tbody></table></div>'
        + '<p class="text-muted fs-9 mt-8">' + spread + truncated + teaser + escHtml(g.caveat || '') + '</p>';
}
// Partition selector (REIT by property subtype): a lane picker above the table. Each lane is a
// SEPARATE comparable series (never pooled across subtypes). Absent for flat industries.
// #335: extracted from _renderKpiPeerTable so it can be built BEFORE the
// growth-only early return — see the note there.
function _kpiPartitionSelector(data, t) {
    const opts = data.partition_options;
    if (!opts || opts.length <= 1)
        return '';
    let out = '<div class="d-flex gap-8 mb-12 flex-wrap" role="tablist" aria-label="'
        + escHtml(t.label) + ' segment">';
    opts.forEach(function (o) {
        const on = o.value === data.partition;
        out += '<button type="button" class="btn-chip kpi-partition-btn' + (on ? ' active' : '')
            + '" data-subtype="' + escHtml(o.value) + '" role="tab" aria-selected="' + (on ? 'true' : 'false')
            + '">' + escHtml(o.label) + ' <span class="fs-9 text-muted">(' + o.coverage_total + ')</span></button>';
    });
    return out + '</div>';
}
// #289 (OWNER): reporting-period switcher — "Latest" (the default
// newest-per-issuer view) + one chip per period with data, newest first
// (capped at 8 so an old cohort doesn't wrap the header). Selecting a
// period pins EVERY cell to it; issuers without that period drop out
// server-side (honest omission, never a stale substitute).
// #335: extracted alongside _kpiPartitionSelector, same reason.
function _kpiPeriodSelector(data, t) {
    const popts = data.period_options;
    if (!popts || popts.length <= 1)
        return '';
    let out = '<div class="d-flex gap-8 mb-12 flex-wrap" role="tablist" aria-label="'
        + escHtml(t.label) + ' reporting period">';
    out += '<button type="button" class="btn-chip kpi-period-btn' + (data.period_selected ? '' : ' active')
        + '" data-period="" role="tab" aria-selected="' + (data.period_selected ? 'false' : 'true')
        + '">Latest</button>';
    popts.slice(0, 8).forEach(function (p) {
        const on = p === data.period_selected;
        out += '<button type="button" class="btn-chip kpi-period-btn' + (on ? ' active' : '')
            + '" data-period="' + escHtml(p) + '" role="tab" aria-selected="' + (on ? 'true' : 'false')
            + '">' + _fmtQuarter(p) + '</button>';
    });
    return out + '</div>';
}
// ── K8 / K9 / K10 / K12 (OWNER industry-page design handoff, 2026-10-05) ──
// The roster entry for a tab, or null (no roster, or the tab is not in it).
function _kpiRosterEntry(tab) {
    const entries = _kpiRosterHolder.entries;
    if (!entries)
        return null;
    for (let i = 0; i < entries.length; i++) {
        if (entries[i].tab === tab)
            return entries[i];
    }
    return null;
}
// The plural display name a reader sees on the chip ("Airlines"); the registry
// label is the singular adjective used in copy ("Airline peer table").
function _kpiTabDisplayName(t) {
    return t.name || t.label;
}
// K12: the section kicker -- {GROUP} · {INDUSTRY} · {PERIOD}.
function _kpiKicker(t, periodLabel) {
    const r = _kpiRosterEntry(t.tab);
    const parts = [(r && r.group) || t.group, _kpiTabDisplayName(t)];
    if (periodLabel)
        parts.push(periodLabel);
    return '<div class="kpi-kicker">' + parts.map(function (p) { return escHtml(p); }).join(' &middot; ') + '</div>';
}
function _kpiCompanyLink(c) {
    // A <button>, not <a href="#">: the delegated dispatcher does not preventDefault,
    // so an anchor would also push a "#" onto the URL.
    return '<button type="button" class="kpi-lede-co" data-action="switch-ticker" data-ticker="' + escHtml(c.ticker) + '">'
        + escHtml(c.name || c.ticker) + '</button>';
}
// K8: one sentence generated from the table under it. Never names a metric the
// table does not show. "Among N" counts the companies that REPORT the metric, not
// the cohort, so it cannot overclaim. A COLUMN-partial table shows only the first
// columns, so its sentence comes from the server roster, which ranks the whole public
// cohort (OQ-1) -- a leader chosen from three alphabetical columns would be a false
// claim. The 2026-10-05 anonymous teaser (every carrier, one metric) is not
// column-partial: its sentence comes from its own full-cohort column like any table.
// Prod QA 2026-10-05: the atlas read "3 companys". A consonant + y noun takes -ies.
function _kpiPlural(noun, n) {
    if (n === 1)
        return noun;
    return /[^aeiou]y$/i.test(noun) ? noun.slice(0, -1) + 'ies' : noun + 's';
}
// CHAOS 2026-10-11 B2 -- mirror of ssr_operating_kpis_roster.headline_display: a cell that ranks
// on a basis other than its badge (rank_basis) carries the badge into the headline.
function _kpiHeadlineDisplay(cell) {
    const d = cell.display || '';
    const b = cell.badge || '';
    if (d && b && ('rank_basis' in cell) && (cell.rank_basis || '') !== b)
        return d + ', ' + b;
    return d;
}
function _kpiPeerLede(data, t, cellMaps, periodLabel) {
    const r = _kpiRosterEntry(t.tab);
    const noun = function (n) { return _kpiPlural(t.noun, n); };
    if (_kpiColumnPartial(data)) {
        // leader_basis_count = the companies the leader was chosen FROM (the reporters of
        // that metric in its newest shared period), so "Among N" never overclaims.
        const basis = (typeof r?.leader_basis_count === 'number') ? r.leader_basis_count : 0;
        if (!r || !r.leader_ticker || !r.headline_label || !r.leader_display || basis < 3)
            return '';
        return '<p class="kpi-lede">Among ' + basis + ' ' + escHtml(noun(basis))
            + (r.period ? ' in ' + escHtml(_fmtQuarterText(r.period)) : '') + ', ' + escHtml(r.leader_ticker)
            + ' leads on ' + escHtml(r.headline_label) + ' (' + escHtml(r.leader_display) + ').</p>';
    }
    const ranked = [];
    const tables = [{ tbl: data, maps: cellMaps }];
    const g = data.growth;
    if (g && g.metrics && g.carriers && g.carriers.length)
        tables.push({ tbl: g, maps: g.carriers.map(_kpiCellsByMetric) });
    tables.forEach(function (x) {
        _kpiRankable(x.tbl).forEach(function (m) {
            const rank = _kpiRankRow(m, x.maps);
            if (rank && rank.lead >= 0)
                ranked.push({ m: m, rank: rank, carriers: x.tbl.carriers, maps: x.maps });
        });
    });
    if (ranked.length === 0)
        return '';
    const head = data.headline_metric || (r ? r.headline_metric : null);
    ranked.sort(function (a, b) {
        return (a.m.metric === head ? 0 : 1) - (b.m.metric === head ? 0 : 1);
    });
    const first = ranked[0];
    const n = first.rank.values.filter(function (v) { return v !== null; }).length;
    if (n < 3)
        return '';
    const lc = first.carriers[first.rank.lead];
    const lv = first.maps[first.rank.lead][first.m.metric];
    // The ranked quarter, not the roster's: rank.period is the one quarter the leader was
    // chosen within, so the sentence can never name a period it did not compare.
    let s = 'Among ' + n + ' ' + escHtml(noun(n)) + ' reporting it for ' + escHtml(first.rank.period)
        + ', ' + _kpiCompanyLink(lc) + ' leads on ' + escHtml(first.m.label) + ' (' + escHtml(_kpiHeadlineDisplay(lv)) + ')';
    for (let i = 1; i < ranked.length; i++) {
        const c2 = ranked[i].carriers[ranked[i].rank.lead];
        // a different COMPANY (compared by ticker: two tables index their columns differently)
        if (c2.ticker !== lc.ticker && ranked[i].rank.period === first.rank.period) {
            const v2 = ranked[i].maps[ranked[i].rank.lead][ranked[i].m.metric];
            s += ', while ' + _kpiCompanyLink(c2) + ' leads on ' + escHtml(ranked[i].m.label) + ' (' + escHtml(_kpiHeadlineDisplay(v2)) + ')';
            break;
        }
    }
    return '<p class="kpi-lede">' + s + '.</p>';
}
// '2026-Q2' -> 'Q2 2026' as PLAIN text (the caller escapes).
function _fmtQuarterText(p) {
    const m = /^(\d{4})-(Q\d)$/.exec(p);
    return m ? (m[2] + ' ' + m[1]) : p;
}
// K9: the ranked bars for one metric -- ink bars, the leader gold, the focus
// company outlined, a value label at each bar end. Pure string SVG.
// Prod QA 2026-10-05: bars were |value| from zero, so on a negative growth row the WORST
// figure drew the longest bar (life science: leader CRL -1.5% short, BRKR -4.4% full width).
// Bars now run from a zero line: all-positive rows are unchanged; an all-negative row's bars
// run LEFT from a zero line at the right edge; a mixed row's zero line sits between.
function _kpiBarGeom(v, vals, W) {
    const lo = Math.min(0, Math.min.apply(null, vals));
    const hi = Math.max(0, Math.max.apply(null, vals));
    const span = (hi - lo) || 1;
    const z = ((0 - lo) / span) * W;
    const end = ((v - lo) / span) * W;
    return { x: Math.min(z, end), w: Math.max(1, Math.abs(end - z)) };
}
function _kpiRankBarsSvg(data, m) {
    const maps = data.carriers.map(_kpiCellsByMetric);
    const rank = _kpiRankRow(m, maps);
    if (!rank)
        return '';
    const order = rank.values.map(function (v, i) { return v === null ? -1 : i; })
        .filter(function (i) { return i >= 0; });
    const hi = m.better === 'high';
    order.sort(function (a, b) {
        return hi ? rank.values[b] - rank.values[a] : rank.values[a] - rank.values[b];
    });
    const vals = order.map(function (i) { return rank.values[i]; });
    const focus = _kpiFocusIndex(data.carriers);
    const rowH = 22;
    let body = '';
    order.forEach(function (i, pos) {
        const y = pos * rowH;
        const g = _kpiBarGeom(rank.values[i], vals, 300);
        const cls = i === rank.lead ? 'kpi-bar-lead' : 'kpi-bar';
        body += '<text class="kpi-bar-label" x="0" y="' + (y + 15) + '">' + escHtml(data.carriers[i].ticker) + '</text>'
            + '<rect class="' + cls + (i === focus ? ' kpi-bar-focus' : '') + '" x="' + (64 + g.x).toFixed(1) + '" y="' + (y + 4) + '" width="'
            + g.w.toFixed(1) + '" height="14"></rect>'
            + '<text class="kpi-bar-value" x="' + (64 + g.x + g.w + 6).toFixed(1) + '" y="' + (y + 15) + '">'
            + escHtml(maps[i][m.metric].display) + '</text>';
    });
    const h = order.length * rowH + 4;
    return '<svg class="kpi-bars" viewBox="0 0 460 ' + h + '" width="460" height="' + h + '" role="img" aria-label="'
        + escHtml(m.label + ' ranked, ' + (hi ? 'higher' : 'lower') + ' is better') + '">' + body + '</svg>';
}
// One expanded row at a time across the view.
const _kpiExpandState = { data: null, open: '', tab: '' };
function _kpiFindMetric(metric) {
    const d = _kpiExpandState.data;
    if (!d)
        return null;
    const tables = [d];
    if (d.growth)
        tables.push(d.growth);
    for (let i = 0; i < tables.length; i++) {
        const ms = tables[i].metrics || [];
        for (let j = 0; j < ms.length; j++) {
            if (ms[j].metric === metric)
                return { tbl: tables[i], m: ms[j] };
        }
    }
    return null;
}
// The delegated `kpi-expand` action (registered in app-renderers.ts). Inserts one
// <tr class="kpi-expand-row"> under the clicked row; a second click collapses it.
// Targeted child insertion -- never innerHTML on the table (DOM rule).
function _kpiExpandRow(btn) {
    if (!btn)
        return;
    const metric = btn.getAttribute('data-metric') || '';
    const tr = btn.closest('tr');
    const tbody = tr ? tr.parentElement : null;
    if (!tr || !tbody)
        return;
    const prev = document.querySelectorAll('.kpi-expand-row');
    for (let i = 0; i < prev.length; i++) {
        const p = prev[i];
        if (p.parentElement)
            p.parentElement.removeChild(p);
    }
    const opened = document.querySelectorAll('.kpi-expand-toggle[aria-expanded="true"]');
    for (let i = 0; i < opened.length; i++)
        opened[i].setAttribute('aria-expanded', 'false');
    if (_kpiExpandState.open === metric) {
        _kpiExpandState.open = '';
        return;
    }
    const hit = _kpiFindMetric(metric);
    if (!hit)
        return;
    const bars = _kpiRankBarsSvg(hit.tbl, hit.m);
    if (!bars)
        return;
    const row = document.createElement('tr');
    row.className = 'kpi-expand-row';
    const td = document.createElement('td');
    td.colSpan = (tr.children.length || 1);
    const maps = hit.tbl.carriers.map(_kpiCellsByMetric);
    const rank = _kpiRankRow(hit.m, maps);
    // K9 trend lines: every caller since OWNER 2026-10-10 (the anonymous teaser's headline metric
    // gets its quarterly trend too; /api/industry/kpi-history no longer refuses anonymous callers).
    const withTrend = !!rank;
    td.innerHTML = '<div class="kpi-kicker">' + escHtml(hit.m.label) + ' &middot; ranked'
        + (rank ? ' for ' + escHtml(rank.period) : '') + ' &middot; '
        + (hit.m.better === 'low' ? 'lower' : 'higher') + ' is better</div>' + bars
        + (rank ? _kpiRankAlso(hit.tbl.carriers, hit.m, maps, rank) : '')
        + (withTrend ? '<div class="kpi-trend"><p class="kpi-trend-note">Loading the quarterly trend&hellip;</p></div>' : '')
        + (hit.m.note ? '<p class="kpi-note">' + escHtml(hit.m.note) + '</p>' : '');
    row.appendChild(td);
    tbody.insertBefore(row, tr.nextSibling);
    btn.setAttribute('aria-expanded', 'true');
    _kpiExpandState.open = metric;
    const slot = withTrend ? td.querySelector('.kpi-trend') : null;
    if (slot && rank) {
        const d = _kpiExpandState.data;
        _kpiFetchTrend(_kpiExpandState.tab, (d && d.partition) || '', metric).then(function (h) {
            slot.innerHTML = _kpiTrendHtml(h, hit.tbl.carriers, hit.m, rank);
        });
    }
}
const _kpiTrendCache = {};
// CHAOS N6 (2026-10-05): the per-tab tables and the trend cache are shaped by WHO asked (an
// anonymous caller gets the one-metric teaser; history is open to all since 2026-10-10). An in-app sign-in or sign-out
// does not reload the page, so without this the teaser kept showing after sign-in. Drop every
// cached table and series, and re-fetch the tab that is open.
function _kpiOnAuthChange() {
    _kpiPeerTabs.forEach(function (t) { t.cache = null; });
    Object.keys(_kpiTrendCache).forEach(function (k) { delete _kpiTrendCache[k]; });
    if (typeof currentView === 'undefined' || currentView !== 'industry')
        return;
    _kpiPeerTabs.forEach(function (t) {
        const panel = document.getElementById('industry-' + t.tab + '-panel');
        const el = document.getElementById('industry-' + t.tab + '-results');
        if (panel && el && !panel.classList.contains('d-none'))
            _fetchIndustryKpiPeers(el, t);
    });
}
try {
    window.addEventListener('ol-user-signed-in', _kpiOnAuthChange);
    window.addEventListener('ol-user-signed-out', _kpiOnAuthChange);
}
catch (_e) { /* no window: nothing to listen to */ }
const _KPI_TREND_MAX = 8;
function _kpiFetchTrend(tab, lane, metric) {
    const key = tab + '|' + lane + '|' + metric;
    const held = _kpiTrendCache[key];
    if (held)
        return held;
    const url = '/api/industry/kpi-history?tab=' + encodeURIComponent(tab) + '&metric=' + encodeURIComponent(metric)
        + (lane ? '&subtype=' + encodeURIComponent(lane) : '');
    const p = fetch(((typeof SERVER !== 'undefined') ? SERVER : '') + url, { signal: AbortSignal.timeout(15000) })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (body) {
        if (!body || !Array.isArray(body.periods) || !Array.isArray(body.series)) {
            delete _kpiTrendCache[key];
            return null;
        }
        return body;
    })
        .catch(function () { delete _kpiTrendCache[key]; return null; });
    _kpiTrendCache[key] = p;
    return p;
}
// Which companies get a line, at most 8: the leader, the focus company, then the rest in
// rank order (the bars' order), then any other company with history.
function _kpiTrendPick(h, carriers, m, rank) {
    const has = {};
    h.series.forEach(function (s) { has[s.ticker] = true; });
    const hi = m.better === 'high';
    const ranked = rank.values.map(function (v, i) { return v === null ? -1 : i; })
        .filter(function (i) { return i >= 0; })
        .sort(function (a, b) {
        return hi ? rank.values[b] - rank.values[a] : rank.values[a] - rank.values[b];
    }).map(function (i) { return carriers[i].ticker; });
    const want = [rank.lead >= 0 ? carriers[rank.lead].ticker : '', _kpiFocusTicker()].concat(ranked)
        .concat(h.series.map(function (s) { return s.ticker; }));
    const out = [];
    want.forEach(function (t) {
        if (t && has[t] && out.indexOf(t) < 0 && out.length < _KPI_TREND_MAX)
            out.push(t);
    });
    return out;
}
// The trend block for one metric: an SVG with one line per company on a shared CALENDAR-
// quarter axis, or one muted line saying why there is none (honest-absent). Each point sits
// at its OWN quarter, a missing quarter breaks the line rather than bridging it, and only one
// unit is ever drawn on one axis.
function _kpiTrendHtml(h, carriers, m, rank) {
    const note = function (s) { return '<p class="kpi-trend-note">' + s + '</p>'; };
    if (!h)
        return note('The quarterly trend could not load right now.');
    if (h.reason === 'sign_in')
        return note('Quarterly history is in Ledge.');
    const periods = (h.periods || []).filter(function (p) { return /^\d{4}-Q[1-4]$/.test(p); });
    if (!h.available || periods.length < 2) {
        return note(periods.length === 1
            ? 'Only one quarter of ' + escHtml(m.label) + ' is on file so far, so there is no trend to draw yet.'
            : 'No quarterly history of ' + escHtml(m.label) + ' is on file yet.');
    }
    const pick = _kpiTrendPick(h, carriers, m, rank);
    const units = {};
    h.series.forEach(function (s) {
        if (pick.indexOf(s.ticker) < 0)
            return;
        s.points.forEach(function (p) { const u = String(p.unit || ''); units[u] = (units[u] || 0) + 1; });
    });
    const unit = Object.keys(units).sort(function (a, b) { return units[b] - units[a]; })[0];
    let dropped = 0;
    const lines = [];
    pick.forEach(function (t) {
        const s = h.series.filter(function (x) { return x.ticker === t; })[0];
        const pts = [];
        s.points.forEach(function (p) {
            const i = periods.indexOf(p.period);
            if (i < 0 || typeof p.value !== 'number' || !isFinite(p.value))
                return;
            if (String(p.unit || '') !== unit) {
                dropped++;
                return;
            }
            pts.push({ i: i, p: p });
        });
        if (pts.length)
            lines.push({ t: t, pts: pts });
    });
    if (!lines.length)
        return note('No quarterly history of ' + escHtml(m.label) + ' is on file yet.');
    const all = [];
    lines.forEach(function (l) { l.pts.forEach(function (q) { all.push(q.p); }); });
    const lo = all.reduce(function (a, b) { return b.value < a.value ? b : a; });
    const hiP = all.reduce(function (a, b) { return b.value > a.value ? b : a; });
    const L = 56, R = 380, T = 14, B = 150;
    const span = (hiP.value - lo.value) || 1;
    const x = function (i) { return L + (periods.length === 1 ? 0 : (i / (periods.length - 1)) * (R - L)); };
    const y = function (v) { return hiP.value === lo.value ? (T + B) / 2 : B - ((v - lo.value) / span) * (B - T); };
    const lead = rank.lead >= 0 ? carriers[rank.lead].ticker : '';
    const focus = _kpiFocusTicker();
    let svg = '<line class="kpi-trend-grid" x1="' + L + '" y1="' + T + '" x2="' + R + '" y2="' + T + '"></line>'
        + '<line class="kpi-trend-grid" x1="' + L + '" y1="' + B + '" x2="' + R + '" y2="' + B + '"></line>'
        + '<text class="kpi-trend-axis" x="' + (L - 6) + '" y="' + (T + 4) + '" text-anchor="end">' + escHtml(hiP.display) + '</text>'
        + '<text class="kpi-trend-axis" x="' + (L - 6) + '" y="' + (B + 4) + '" text-anchor="end">' + escHtml(lo.display) + '</text>';
    // ~46px per quarter at eight: past five, every OTHER quarter is labelled (always the newest)
    // so the reader-form labels never print over each other; every point still names its own
    // quarter in its <title>.
    periods.forEach(function (p, i) {
        if (periods.length > 5 && (periods.length - 1 - i) % 2 !== 0)
            return;
        svg += '<text class="kpi-trend-axis" x="' + x(i).toFixed(1) + '" y="' + (B + 22) + '" text-anchor="middle">'
            + escHtml(_fmtQuarterText(p)) + '</text>';
    });
    // ink lines first, then the focus company, then the leader on top (gold)
    const order = lines.slice().sort(function (a, b) {
        const w = function (t) { return t === lead ? 2 : (t === focus ? 1 : 0); };
        return w(a.t) - w(b.t);
    });
    const labels = [];
    order.forEach(function (l) {
        const cls = l.t === lead ? 'kpi-trend-lead' : (l.t === focus ? 'kpi-trend-focus' : 'kpi-trend-line');
        let run = [];
        const flush = function () {
            if (run.length > 1)
                svg += '<polyline class="' + cls + '" points="' + run.join(' ') + '"></polyline>';
            run = [];
        };
        l.pts.forEach(function (q, k) {
            if (k > 0 && q.i !== l.pts[k - 1].i + 1)
                flush(); // a missing quarter breaks the line
            run.push(x(q.i).toFixed(1) + ',' + y(q.p.value).toFixed(1));
        });
        flush();
        l.pts.forEach(function (q) {
            svg += '<circle class="' + cls + '-dot" cx="' + x(q.i).toFixed(1) + '" cy="' + y(q.p.value).toFixed(1) + '" r="2.4">'
                + '<title>' + escHtml(l.t + ' ' + _fmtQuarterText(q.p.period) + ': ' + q.p.display
                + (q.p.badge ? ', ' + q.p.badge : '')) + '</title></circle>';
        });
        const last = l.pts[l.pts.length - 1];
        // CHAOS 2026-10-11 B2: a series that ranks past its badge (DAL ex-refinery) names it
        labels.push({ t: l.t, x: x(last.i) + 6, y: y(last.p.value) + 4,
            text: l.t + ' ' + last.p.display + (last.p.badge ? ', ' + last.p.badge : ''), cls: cls });
    });
    // end-of-line value labels, nudged apart so two close lines never print on each other
    labels.sort(function (a, b) { return a.y - b.y; });
    for (let i = 1; i < labels.length; i++) {
        if (Math.abs(labels[i].x - labels[i - 1].x) < 1 && labels[i].y - labels[i - 1].y < 13)
            labels[i].y = labels[i - 1].y + 13;
    }
    labels.forEach(function (lb) {
        svg += '<text class="kpi-trend-value' + (lb.cls === 'kpi-trend-line' ? '' : ' ' + lb.cls + '-label') + '" x="'
            + lb.x.toFixed(1) + '" y="' + lb.y.toFixed(1) + '">' + escHtml(lb.text) + '</text>';
    });
    const h2 = Math.max(B + 30, Math.ceil(labels.reduce(function (a, lb) { return Math.max(a, lb.y); }, 0)) + 8);
    return '<div class="kpi-kicker">' + escHtml(m.label) + ' &middot; quarterly trend</div>'
        + '<svg class="kpi-trend-svg" viewBox="0 0 520 ' + h2 + '" width="520" height="' + h2 + '" role="img" aria-label="'
        + escHtml(m.label + ' by calendar quarter, ' + _fmtQuarterText(periods[0]) + ' to '
            + _fmtQuarterText(periods[periods.length - 1]) + ', ' + lines.length + ' companies') + '">' + svg + '</svg>'
        + (dropped ? note(dropped + ' figure' + (dropped === 1 ? '' : 's') + ' in another unit not drawn on this axis.') : '')
        + note('Each point is its own calendar quarter; a gap is a quarter the company did not report.');
}
// K10: below 720px the transposed table is replaced (by CSS, not JS) with a
// metric picker and a ranked list of companies for that metric.
// A COLUMN-partial table (fewer carriers than the cohort -- the pre-2026-10-05 anonymous
// teaser's first three alphabetical columns, or such a payload still cached) would crown the
// best of three, not the leader -- so the shading, the 1st mark, the strip and the ranked
// views are withheld there, exactly as the lede refuses to name a leader from those columns
// (QA 2026-10-05). The figures still render; only the direction is dropped.
// OWNER 2026-10-05, K11 step 3: the anonymous teaser now carries EVERY carrier for its one
// metric. It is still `partial` (metrics are withheld) but not column-partial, so it ranks:
// its leader is the real leader of the full cohort.
function _kpiColumnPartial(tbl) {
    return !!tbl.partial && (tbl.carriers || []).length < (tbl.total_carriers || 0);
}
// CHAOS T6 (2026-10-05): a TRUNCATED table (a read hit the row cap, so the cohort is cut off
// alphabetically) ranks nothing either -- the note under it already says coverage may be
// incomplete, and a "1st" among issuers A-M would contradict it.
function _kpiRankable(tbl) {
    if (!_kpiColumnPartial(tbl) && !tbl.truncated)
        return tbl.metrics;
    return tbl.metrics.map(function (m) {
        return Object.assign({}, m, { better: null });
    });
}
// `src` names which lens table the list belongs to ('levels' | 'growth'): one list per lens,
// each beside its own table, so the phone view follows the active lens (K12).
function _kpiMobileList(data, cellMaps, src) {
    const ranked = _kpiRankable(data).filter(function (m) { return !!_kpiRankRow(m, cellMaps); });
    if (ranked.length === 0)
        return '';
    const lens = src || 'levels';
    let opts = '';
    ranked.forEach(function (m, i) {
        opts += '<option value="' + escHtml(m.metric) + '"' + (i === 0 ? ' selected' : '') + '>' + escHtml(m.label)
            + ' &middot; ' + (m.better === 'low' ? 'lower' : 'higher') + ' is better</option>';
    });
    const id = 'kpi-metric-pick-' + lens;
    return '<div class="kpi-mobile" data-kpi-src="' + escHtml(lens) + '"><label class="kpi-kicker" for="' + id + '">Metric</label>'
        + '<select id="' + id + '" class="kpi-metric-pick">' + opts + '</select>'
        + '<div class="kpi-mobile-list">' + _kpiMobileRanked(data, ranked[0], cellMaps) + '</div></div>';
}
function _kpiMobileRanked(data, m, cellMaps) {
    const rank = _kpiRankRow(m, cellMaps);
    if (!rank)
        return '';
    const order = rank.values.map(function (v, i) { return v === null ? -1 : i; })
        .filter(function (i) { return i >= 0; });
    const hi = m.better === 'high';
    order.sort(function (a, b) {
        return hi ? rank.values[b] - rank.values[a] : rank.values[a] - rank.values[b];
    });
    const focus = _kpiFocusIndex(data.carriers);
    const vals = order.map(function (i) { return rank.values[i]; });
    let out = m.note ? '<p class="kpi-note">' + escHtml(m.note) + '</p>' : '';
    out += '<ol class="kpi-rank-list">';
    order.forEach(function (i) {
        const c = data.carriers[i];
        const g = _kpiBarGeom(rank.values[i], vals, 100);
        out += '<li class="kpi-rank-item' + (i === focus ? ' kpi-focus' : '') + '"><button type="button" class="kpi-rank-co"'
            + ' data-action="switch-ticker" data-ticker="' + escHtml(c.ticker) + '">'
            + (i === rank.lead ? '<span class="kpi-lead">1st</span>' : '') + escHtml(c.ticker) + '</button>'
            + '<span class="kpi-rank-val">' + escHtml(cellMaps[i][m.metric].display) + '</span>'
            // a bar whose LENGTH is the value (SVG attributes, since the CSP forbids style=)
            + '<svg class="kpi-rank-bar" viewBox="0 0 100 6" preserveAspectRatio="none" aria-hidden="true" focusable="false">'
            + '<rect class="kpi-rank-track" width="100" height="6"></rect><rect class="'
            + (i === rank.lead ? 'kpi-bar-lead' : 'kpi-bar') + '" x="' + g.x.toFixed(1) + '" width="'
            + g.w.toFixed(1) + '" height="6"></rect></svg></li>';
    });
    return out + '</ol>' + _kpiRankAlso(data.carriers, m, cellMaps, rank);
}
// A figure the table shows but the ranking leaves out (another quarter) is still a
// reported figure: the phone list and the ranked view name it under the bars rather
// than dropping it (QA 2026-10-05). '' when every shown figure was ranked.
function _kpiRankAlso(carriers, m, cellMaps, rank) {
    const also = [];
    const seg = [];
    cellMaps.forEach(function (byMetric, i) {
        const cell = byMetric[m.metric];
        if (!cell || !cell.display || rank.values[i] !== null)
            return;
        // CHAOS 2026-10-11 SF5: a labeled segment figure is unranked for its OWN reason, not its quarter
        if (cell.rank_excluded) {
            seg.push(escHtml(carriers[i].ticker) + ' ' + escHtml(cell.display)
                + (cell.badge ? ' (' + escHtml(cell.badge) + ')' : '') + '. ' + escHtml(cell.rank_excluded));
            return;
        }
        const own = /^(\d{4})-(Q[1-4])$/.exec(cell.period || '');
        also.push(escHtml(carriers[i].ticker) + ' ' + escHtml(cell.display)
            + (own ? ' (' + own[2] + ' ' + own[1] + ')' : ''));
    });
    return (also.length
        ? '<p class="kpi-rank-also">Not ranked against ' + escHtml(rank.period) + ': ' + also.join(', ') + '</p>' : '')
        + seg.map(function (t) { return '<p class="kpi-rank-also">' + t + '</p>'; }).join('');
}
// K3: the atlas -- one tile per available industry from the roster, grouped.
// A tile opens its tab through the tab's own chip, so the controller's tab logic
// (panels, fetch, history) stays in one place.
function _renderKpiAtlas(el) {
    const entries = _kpiRosterHolder.entries;
    if (!entries) {
        el.innerHTML = '<div class="status-msg status-msg--muted">Loading industries&hellip;</div>';
        if (_kpiRosterHolder.pending)
            _kpiRosterHolder.pending.then(function () { _renderKpiAtlas(el); });
        return;
    }
    const live = entries.filter(function (e) { return e.available && !!_kpiPeerTabByName(e.tab); });
    if (live.length === 0) {
        el.innerHTML = '<div class="status-msg status-msg--muted">No industry comparisons are available right now.</div>';
        return;
    }
    let html = '<p class="kpi-lede">The numbers each industry runs on, compared across every company that reports them,'
        + ' from their own SEC filings. Pick an industry to see who leads and how the peers spread out.</p>'
        + '<div class="kpi-atlas">';
    live.forEach(function (e) {
        const t = _kpiPeerTabByName(e.tab);
        const name = _kpiTabDisplayName(t);
        const n = e.peer_count || 0;
        const lead = (e.leader_ticker && e.leader_display && e.headline_label)
            ? '<span class="kpi-atlas-metric">' + escHtml(e.headline_label) + ' leader</span>'
                + '<span class="kpi-atlas-lead"><span>' + escHtml(e.leader_ticker) + '</span><span class="kpi-atlas-val">'
                + escHtml(e.leader_display) + '</span></span>'
            : '<span class="kpi-atlas-metric">Compare the reported metrics</span>';
        html += '<button type="button" class="kpi-atlas-tile" data-kpi-open="' + escHtml(e.tab) + '">'
            + '<span class="kpi-kicker">' + escHtml(e.group || t.group) + '</span>'
            + '<span class="kpi-atlas-name">' + escHtml(name) + '<span class="kpi-atlas-count">' + n + ' '
            + escHtml(_kpiPlural(t.noun, n)) + '</span></span>' + lead
            + '<span class="kpi-atlas-foot">' + (e.period ? escHtml(_fmtQuarterText(e.period)) + ' &middot; ' : '')
            + 'Open table &rarr;</span></button>';
    });
    el.innerHTML = html + '</div>';
    const tiles = Array.prototype.slice.call(el.querySelectorAll('.kpi-atlas-tile'));
    tiles.forEach(function (tile) {
        tile.onclick = function () {
            const chip = document.getElementById('industry-' + (tile.getAttribute('data-kpi-open') || '') + '-tab');
            if (chip)
                chip.click();
        };
    });
}
function _renderKpiPeerTable(el, data, t) {
    _kpiLensDefault = _kpiDefaultLensFor(data);
    const growthHtml = data ? _renderKpiPeerGrowth(data.growth, t) : '';
    // #335 (CHAOS T5, 2026-07-28): build BOTH selectors before the growth-only
    // guard below. That guard returns early with growthHtml alone, so an
    // industry that is growth-only AND lane-scoped would render its growth
    // table with no way to switch lane or period — the picker was built ten
    // lines too late to survive the return.
    //
    // Latent, not live: no industry is currently both, which is exactly why it
    // would have shipped unnoticed the first time one is. Both selectors
    // self-suppress when there is nothing to pick (<= 1 option), so a flat
    // growth-only industry renders byte-identically to before.
    const partitionSel = data ? _kpiPartitionSelector(data, t) : '';
    const periodSel = data ? _kpiPeriodSelector(data, t) : '';
    if (!data || !data.available || !data.metrics || data.metrics.length === 0
        || !data.carriers || data.carriers.length === 0) {
        // #293 I-A: an industry whose ONLY comparable figures are growth rates still has a table.
        // The no-table branch is where a reason matters MOST: when the server's prune withheld the
        // only period there is, an unexplained empty tab reads as "we have no data" when the truth
        // is "we declined to draw this comparison". Those are different claims about us.
        el.innerHTML = growthHtml
            ? (partitionSel + periodSel + _kpiOmissionNotes(data && data.omission_notes) + growthHtml
                + _kpiTeaserLine(data))
            : (_kpiOmissionNotes(data && data.omission_notes)
                + '<div class="status-msg status-msg--muted">No ' + escHtml(t.label.toLowerCase()) + ' peer data available.</div>');
        // The selectors are only rendered on the growthHtml path, and a rendered
        // selector MUST be wired — see _wireKpiSelectors.
        if (growthHtml) {
            _kpiExpandState.data = data;
            _kpiExpandState.tab = t.tab;
            _kpiExpandState.open = '';
            _wireKpiSelectors(el, data, t);
        }
        return;
    }
    // #289 (OWNER): reporting-period switcher — "Latest" (the default
    // newest-per-issuer view) + one chip per period with data, newest first
    // (capped at 8 so an old cohort doesn't wrap the header). Selecting a
    // period pins EVERY cell to it; issuers without that period drop out
    // server-side (honest omission, never a stale substitute).
    // NO rank (OWNER decision 4): the COLUMNS are the server's alphabetical carrier order.
    // Each metric row shows its coverage (N/M) in its row label; a blank cell is an honest
    // coverage gap (anti-pooling -- a different-basis value was never pooled in).
    // Glossary-linked metric labels (§D education) ride in the row header.
    const nounCap = t.noun.charAt(0).toUpperCase() + t.noun.slice(1);
    // #315: the context figures lead -- the first ROWS, above the reported-period
    // ("As of") row and the operating metrics. An envelope without the roster (an
    // older cached response) yields an empty list, so the body and the note below
    // both fall back to exactly the pre-#315 table.
    const ctxCols = data.context_columns || [];
    // #317: the header row IS the issuer roster -- corner label, then one column
    // per company (#287 two-line ticker + full name).
    const focusIdx = _kpiFocusIndex(data.carriers);
    const head = '<th scope="col">' + escHtml(nounCap) + '</th>'
        + _kpiPeerCompanyHeaders(data.carriers, focusIdx);
    let rows = '';
    // #315 row group: one row per roster column, in roster order, each cell from
    // the server's preformatted display. A blank display paints an EMPTY cell.
    ctxCols.forEach(function (cc) {
        rows += '<tr class="kpi-meta"><th scope="row" class="text-left">' + escHtml(cc.label || '') + '</th>';
        data.carriers.forEach(function (c, i) {
            rows += (i === focusIdx ? '<td class="text-right kpi-focus">' : '<td class="text-right">')
                + escHtml(_kpiContextDisplay(c.context, cc.key)) + _kpiNonrecourseMark(c.context, cc.key) + '</td>';
        });
        rows += '</tr>';
    });
    rows += _kpiPeerPeriodRow(data.carriers, focusIdx);
    const cellMaps = data.carriers.map(_kpiCellsByMetric);
    const tickers = data.carriers.map(function (c) { return c.ticker; });
    const periodLabel = _kpiCommonPeriod(data.carriers);
    _kpiRankable(data).forEach(function (m) {
        rows += _kpiPeerMetricRow(m, cellMaps, tickers, focusIdx, periodLabel);
    });
    const spread = (data.period_spread && data.period_spread.length)
        ? 'Periods: ' + data.period_spread.map(function (p) { return escHtml(p); }).join(', ') + '. '
        : '';
    const teaser = _kpiColumnPartial(data)
        ? '<a href="/">Sign in</a> to see all ' + data.total_carriers + ' ' + escHtml(t.noun) + 's. '
        : '';
    // #315: the context columns' provenance differs from the operating metrics'
    // (exchange data + quarterly-filing sums, not the SEC-exhibit extraction), so
    // the envelope's caption is rendered VERBATIM as its own note above the B9
    // caveat -- the caveat must never silently annex these columns. Same note
    // styling as the caveat below it. Rendered only when the columns are.
    const ctxCaption = (ctxCols.length && data.context_caption)
        ? '<p class="text-muted fs-9 mt-8">' + escHtml(data.context_caption) + '</p>'
        : '';
    const nrCaption = _kpiNonrecourseCaption(data.carriers, ctxCols);
    // §3.7 parity with the SSR twin: an alphabetically cut-off cohort is a false coverage claim
    // wherever it is rendered, and this surface had no sentence for it.
    const truncated = data.truncated
        ? 'This comparison reached the source read limit, so coverage may be incomplete. '
        : '';
    const levelsHtml = _kpiMobileList(data, cellMaps, 'levels')
        + '<div class="industry-table-wrap"><table class="ol-data-table kpi-peer-table" '
        + 'aria-label="' + escHtml(t.label) + ' operating-metrics peer comparison"><thead><tr>' + head
        + '</tr></thead><tbody>' + rows + '</tbody></table></div>'
        // K11 step 3: the anonymous teaser's ONE honest line sits directly under its table
        + _kpiTeaserLine(data) + ctxCaption + nrCaption
        + '<p class="text-muted fs-9 mt-8">' + spread + truncated + teaser + escHtml(data.caveat) + '</p>';
    // #293 I-A: a growth rate is never merged into the levels columns. K12 (OWNER 2026-10-05):
    // with both tables present the two are LENSES behind a Levels | Growth control instead of
    // stacked; the choice lives in the URL (&lens=growth). Both panels are rendered once and the
    // inactive one is hidden -- switching toggles visibility, never rebuilds the DOM.
    const body = growthHtml
        ? _kpiLensControl(t) + _kpiLensPanel(t, 'levels', levelsHtml) + _kpiLensPanel(t, 'growth', growthHtml)
        : levelsHtml;
    const html = _kpiKicker(t, periodLabel) + _kpiPeerLede(data, t, cellMaps, periodLabel)
        + partitionSel + periodSel + _kpiOmissionNotes(data.omission_notes) + body;
    el.innerHTML = html;
    _kpiExpandState.data = data;
    _kpiExpandState.tab = t.tab;
    _kpiExpandState.open = '';
    _wireKpiSelectors(el, data, t);
}
// ── K11 step 3: the anonymous teaser line (OWNER 2026-10-05) ──────────────────
// One honest line under the full first metric: n is the server's count of the metrics it
// withheld, and the arrow opens sign-in / sign-up through the existing auth action. '' on
// every signed-in payload (the field is absent there). No blur, no fake rows.
// OWNER 2026-10-10: the headline metric's quarterly TREND is open to every caller, so this
// line no longer promises "quarterly history"; what signing in adds is the other metrics and
// the period switcher (earlier quarters' tables).
function _kpiTeaserLine(data) {
    const n = data ? data.withheld_metric_count : null;
    if (typeof n !== 'number' || !isFinite(n) || n < 0)
        return '';
    const copy = n > 0
        ? n + ' more ' + (n === 1 ? 'metric' : 'metrics') + ' and earlier quarters in Ledge'
        : 'Earlier quarters in Ledge';
    return '<p class="kpi-teaser"><button type="button" class="kpi-teaser-link" data-action="auth-toggle">'
        + escHtml(copy) + ' &rarr;</button></p>';
}
// ── K12: the Levels | Growth lens (OWNER 2026-10-05) ─────────────────────────
// Reuses the design-system segmented control (.ol-settings-segmented / .ol-settings-seg,
// oxford-dashboard.css) -- ink active, cream text inside #industry-view -- rather than a new
// button class. ARIA tabs: role=tablist, aria-selected, roving tabindex, arrow keys.
// CHAOS N9 (2026-10-05): with no &lens= in the URL, the default follows the focus company:
// a company in the growth table only (the roster's `tickers` are the union of both) would
// otherwise open on Levels, where its column is absent. Set per render, from the table.
let _kpiLensDefault = 'levels';
function _kpiLens() {
    const q = location.search || '';
    if (/[?&]lens=growth(?:&|$)/.test(q))
        return 'growth';
    if (/[?&]lens=/.test(q))
        return 'levels';
    return _kpiLensDefault;
}
// 'growth' when the focus ticker is in the growth table and not the levels table.
function _kpiDefaultLensFor(data) {
    const f = _kpiFocusTicker();
    if (!f || !data)
        return 'levels';
    const has = function (rows) {
        return (rows || []).some(function (r) { return (r.ticker || '').toUpperCase() === f; });
    };
    return (!has(data.carriers) && data.growth && has(data.growth.carriers)) ? 'growth' : 'levels';
}
function _kpiLensControl(t) {
    const cur = _kpiLens();
    let out = '<div class="ol-settings-segmented mb-12" role="tablist" aria-label="'
        + escHtml(_kpiTabDisplayName(t)) + ' table: levels or growth rates">';
    [['levels', 'Levels'], ['growth', 'Growth']].forEach(function (o) {
        const on = o[0] === cur;
        out += '<button type="button" role="tab" class="ol-settings-seg' + (on ? ' active' : '') + '" id="kpi-lens-tab-'
            + o[0] + '-' + escHtml(t.tab) + '" data-kpi-lens="' + o[0] + '" aria-selected="' + (on ? 'true' : 'false')
            + '" aria-controls="kpi-lens-' + o[0] + '-' + escHtml(t.tab) + '" tabindex="' + (on ? '0' : '-1') + '">'
            + o[1] + '</button>';
    });
    return out + '</div>';
}
function _kpiLensPanel(t, lens, inner) {
    return '<div class="kpi-lens-panel' + (lens === _kpiLens() ? '' : ' d-none') + '" id="kpi-lens-' + lens + '-'
        + escHtml(t.tab) + '" role="tabpanel" data-kpi-lens-panel="' + lens + '" aria-labelledby="kpi-lens-tab-'
        + lens + '-' + escHtml(t.tab) + '">' + inner + '</div>';
}
// Show `lens` in place: toggles the two panels' visibility and the control's state. The
// panels' DOM (tables, an open ranked view, the phone list) is never rebuilt.
function _kpiApplyLens(root, lens) {
    const tabs = root.querySelectorAll('[data-kpi-lens]');
    for (let i = 0; i < tabs.length; i++) {
        const b = tabs[i];
        const on = b.getAttribute('data-kpi-lens') === lens;
        b.classList.toggle('active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.setAttribute('tabindex', on ? '0' : '-1');
    }
    const panels = root.querySelectorAll('.kpi-lens-panel');
    for (let i = 0; i < panels.length; i++) {
        const p = panels[i];
        p.classList.toggle('d-none', p.getAttribute('data-kpi-lens-panel') !== lens);
    }
}
// The current URL with &lens=growth set (or removed for the default); tab and focus kept.
function _kpiLensHref(lens) {
    const parts = (location.search || '').replace(/^\?/, '').split('&').filter(function (p) {
        return !!p && p.indexOf('lens=') !== 0;
    });
    if (lens === 'growth')
        parts.push('lens=growth');
    return '?' + parts.join('&');
}
function _kpiSetLens(root, lens) {
    _kpiApplyLens(root, lens);
    const href = _kpiLensHref(lens);
    // A history entry, like a tab switch (K3): Back returns to the other lens, and the
    // popstate re-render (setView) reads the lens back out of the URL.
    try {
        if (location.search !== href)
            history.pushState({ view: 'industry' }, '', href);
    }
    catch (_e) { /* best-effort */ }
}
// #335: the click-wiring, extracted for the same reason as the two builders —
// it lived AFTER the growth-only early return, so rendering the selectors in
// that branch without moving this too would have painted a VISIBLE BUT DEAD
// picker. A control that looks clickable and does nothing is worse than the
// absent control this ticket set out to fix. Both branches now wire.
// Re-attached on every render (innerHTML replaces the nodes).
function _wireKpiSelectors(el, data, t) {
    if (!data)
        return;
    // K10: each phone list's metric picker re-renders only its own ranked list. One list per
    // lens (K12): `data-kpi-src` says which table -- levels or growth -- it reads.
    const mobiles = Array.prototype.slice.call(el.querySelectorAll('.kpi-mobile'));
    mobiles.forEach(function (mob) {
        const src = mob.getAttribute('data-kpi-src') === 'growth' ? data.growth : data;
        const pick = mob.querySelector('.kpi-metric-pick');
        const list = mob.querySelector('.kpi-mobile-list');
        if (!src || !pick || !list || !src.metrics)
            return;
        const tbl = src;
        const maps = (tbl.carriers || []).map(_kpiCellsByMetric);
        pick.onchange = function () {
            for (let i = 0; i < tbl.metrics.length; i++) {
                if (tbl.metrics[i].metric === pick.value) {
                    list.innerHTML = _kpiMobileRanked(tbl, tbl.metrics[i], maps);
                    return;
                }
            }
        };
    });
    // K12: the Levels | Growth lens -- click, Enter/Space (native <button>) and the arrow keys.
    const lensBtns = Array.prototype.slice.call(el.querySelectorAll('[data-kpi-lens]'));
    lensBtns.forEach(function (b, i) {
        b.onclick = function () { _kpiSetLens(el, b.getAttribute('data-kpi-lens') || 'levels'); };
        b.onkeydown = function (ev) {
            if (ev.key !== 'ArrowLeft' && ev.key !== 'ArrowRight' && ev.key !== 'Home' && ev.key !== 'End')
                return;
            ev.preventDefault();
            const n = lensBtns.length;
            const j = ev.key === 'Home' ? 0 : ev.key === 'End' ? n - 1 : (i + (ev.key === 'ArrowRight' ? 1 : n - 1)) % n;
            const to = lensBtns[j];
            _kpiSetLens(el, to.getAttribute('data-kpi-lens') || 'levels');
            to.focus();
        };
    });
    // Partition lane picker — re-fetches that subtype's table. A partition
    // switch resets the period pin (each lane has its own period set).
    const opts = data.partition_options;
    if (opts && opts.length > 1) {
        const pbtns = Array.prototype.slice.call(el.querySelectorAll('.kpi-partition-btn'));
        for (let i = 0; i < pbtns.length; i++) {
            (function (b) {
                b.onclick = function () { _fetchIndustryKpiPeers(el, t, b.getAttribute('data-subtype') || ''); };
            })(pbtns[i]);
        }
    }
    // #289: the period switcher — preserves the active partition lane.
    const popts = data.period_options;
    if (popts && popts.length > 1) {
        const qbtns = Array.prototype.slice.call(el.querySelectorAll('.kpi-period-btn'));
        for (let i = 0; i < qbtns.length; i++) {
            (function (b) {
                b.onclick = function () {
                    _fetchIndustryKpiPeers(el, t, data.partition || '', b.getAttribute('data-period') || '');
                };
            })(qbtns[i]);
        }
    }
}
//# sourceMappingURL=industry-comps.js.map
;
// ═══ view-router-fund-fallback.js ═══
;"use strict";
// ── view-router-fund-fallback.ts ── the 2026-09-03 QA honesty cluster ──
//
// Browser QA round 2 (docs/board/audit/2026-09-03_QA_fundamentals_browser.md
// finding 1 + finding 3): extracted from static/js/view-router.ts (crossed
// its 2,225 budget) and static/js/ticker-renderer.ts (AT its 4,650 cap) --
// the #295 industry-comps method: verbatim move, script mode, no
// import/export (tools/build_bundle.py CONCATENATES; an export would make
// this a module and unhoist every top-level name).
//
// ONE subject: the honesty seams that keep degraded/first-paint states from
// serving unlabeled or garbage figures.
//   - _fundamentalsCache / _inlineFundChunkFailed /
//     _inlineRenderFundamentals   the /?view=fundamentals fallback:
//     delegates FIRST to the rich renderer, holds a loading state through a
//     research-chunk retry, and only behind the one-way failure latch
//     renders the bare table below.
//   - _renderFundamentalsTable    the degraded terminal table -- carries the
//     delisted_notice passthrough (a verbatim backend string; the label
//     VOCABULARY lives only in fundamentals.ts) + an as-filed caveat.
//   - _validNextEarningsDate      the next-earnings date shape guard used by
//     ticker-renderer's three render sites ('FY2028' / 'Invalid Date' class).
//
// The renderMap entry in view-router.ts references _inlineRenderFundamentals
// LAZILY (the map is built per setView call), so concat order is not
// load-bearing for dispatch; ticker-renderer calls the validator at render
// time only. Contracts: tests/test_label_parity_contract.py round-2 section.
var _fundamentalsCache = {};
// One-way latch: flips true only after an explicit research-chunk retry
// failed, licensing the bare fallback table below.
var _inlineFundChunkFailed = false;
function _inlineRenderFundamentals() {
    // Browser QA 2026-09-03 finding 1: this inline table used to render the
    // SAME payload as the rich module with ZERO honesty labels (no rung-2
    // dagger, no eps-inconsistency, no delisted notice) -- the
    // hidden-sibling class. It now (a) DELEGATES whenever the rich renderer
    // exists, (b) shows a loading state (never unlabeled figures) while
    // the research chunk is in flight -- _ensureViewModule re-runs setView
    // on chunk arrival, which dispatches to the rich renderer -- and only
    // (c) on genuine chunk failure renders the bare table, WITH an explicit
    // as-filed caveat and the delisted_notice passthrough (a verbatim
    // backend string -- no second label vocabulary lives here).
    if (typeof renderFundamentalsView === 'function') {
        void renderFundamentalsView();
        return;
    }
    const el = document.getElementById('fundamentals-content');
    if (!el)
        return;
    const ticker = (typeof activeTicker !== 'undefined') ? activeTicker : null;
    if (!ticker) {
        el.innerHTML = '<div class="status-msg status-msg--muted">Select a ticker to view 10-year financials.</div>';
        return;
    }
    const titleEl = document.getElementById('fundamentals-title');
    if (titleEl)
        titleEl.textContent = ticker + ' — Historical Financials';
    if (!_inlineFundChunkFailed) {
        // Chunk still loading (or not yet retried): hold at a loading state and
        // give the research chunk one explicit retry; success re-enters via
        // setView and the rich renderer takes over.
        el.innerHTML = '<div class="status-msg status-msg--muted">Loading ' + escHtml(ticker) + ' financials...</div>';
        if (typeof _loadChunk === 'function') {
            _loadChunk('research').then(function () {
                if (currentView === 'fundamentals' && typeof renderFundamentalsView === 'function') {
                    void renderFundamentalsView();
                }
                else if (currentView === 'fundamentals') {
                    _inlineFundChunkFailed = true;
                    _inlineRenderFundamentals();
                }
            }).catch(function () {
                _inlineFundChunkFailed = true;
                if (currentView === 'fundamentals')
                    _inlineRenderFundamentals();
            });
        }
        else {
            _inlineFundChunkFailed = true;
            _inlineRenderFundamentals();
        }
        return;
    }
    if (_fundamentalsCache[ticker]) {
        _renderFundamentalsTable(el, _fundamentalsCache[ticker], ticker);
        return;
    }
    el.innerHTML = '<div class="status-msg status-msg--muted">Loading ' + escHtml(ticker) + ' financials...</div>';
    fetch(((typeof SERVER !== 'undefined') ? SERVER : '') + '/api/fundamentals?ticker=' + encodeURIComponent(ticker), { signal: AbortSignal.timeout(15000) })
        .then(function (res) { return res.ok ? res.json() : Promise.reject('HTTP ' + res.status); })
        .then(function (data) {
        _fundamentalsCache[ticker] = data;
        if (currentView === 'fundamentals')
            _renderFundamentalsTable(el, data, ticker);
    })
        .catch(function () {
        if (currentView === 'fundamentals') {
            el.innerHTML = '<div class="status-msg status-msg--muted">Financials unavailable for ' + escHtml(ticker) + '.</div>';
        }
    });
}
function _renderFundamentalsTable(el, data, ticker) {
    const annual = (Array.isArray(data) ? data : (data && data.annual ? data.annual : (data && data.financials ? data.financials : [])));
    if (annual.length === 0) {
        el.innerHTML = '<div class="status-msg status-msg--muted">No financial data available for ' + escHtml(ticker) + '.</div>';
        return;
    }
    function _fmtB(v) { return fmtAbbrev(v); } // DS-P2a: canonical $ K/M/B
    let html = '<table class="data-table fund-table">'
        + '<thead><tr>'
        + '<th>Year</th>'
        + '<th class="td-right">Revenue</th>'
        + '<th class="td-right">Net Income</th>'
        + '<th class="td-right">EPS</th>'
        + '</tr></thead><tbody>';
    for (let i = 0; i < Math.min(annual.length, 10); i++) {
        const yr = annual[i];
        let year = yr.year || yr.date || yr.fiscal_year || '';
        if (typeof year === 'string' && year.length > 4)
            year = year.substring(0, 4);
        const rev = yr.revenue || yr.totalRevenue || null;
        const ni = yr.netIncome || yr.net_income || null;
        const eps = yr.eps || yr.earningsPerShare || null;
        const fundRowAlt = i % 2 !== 0 ? ' fund-row--alt' : '';
        html += '<tr class="fund-row' + fundRowAlt + '">'
            + '<td>' + escHtml(String(year)) + '</td>'
            + '<td class="td-data td-right">' + _fmtB(rev) + '</td>'
            + '<td class="td-data td-right' + (ni != null && ni < 0 ? ' color-negative' : '') + '">' + _fmtB(ni) + '</td>'
            + '<td class="td-data td-right">' + (eps != null ? '$' + Number(eps).toFixed(2) : '—') + '</td>'
            + '</tr>';
    }
    html += '</tbody></table>';
    // Degraded-mode honesty (QA 2026-09-03): the rich module failed to load,
    // so the data-quality flags cannot render -- SAY so rather than serving
    // silently unlabeled figures; and the delisted notice is a verbatim
    // backend string, so it travels even here.
    const _dn = (data && typeof data === 'object')
        ? data.delisted_notice : undefined;
    let pre = '';
    if (_dn)
        pre += '<div class="fun-delisted-notice">' + escHtml(_dn) + '</div>';
    el.innerHTML = pre + html
        + '<div class="fun-source-line">Figures as filed (SEC EDGAR). The full financials module '
        + 'did not load, so per-year data-quality flags are not shown here — reload to see them.</div>';
}
function _validNextEarningsDate(s) {
    // QA 2026-09-03: earn.nextDate arrived as 'FY2028' (an estimate-period
    // label leaked into the date field) and every consumer trusted it raw --
    // the hero rendered literal 'Invalid Date' and the earnings card said
    // 'FY2028 - reported' (a NaN countdown falls into the reported branch).
    // The server seam now shape-guards too; this is the belt for every data
    // path: render ONLY a real parseable date, else absence (the IR-calendar
    // / OL-estimate ladder below already handles absence honestly).
    if (typeof s !== 'string' || !/^\d{4}-\d{2}-\d{2}/.test(s))
        return null;
    const d = new Date(s.slice(0, 10) + 'T00:00:00');
    return isNaN(d.getTime()) ? null : s;
}
//# sourceMappingURL=view-router-fund-fallback.js.map
;
// ═══ view-router-bdc.js ═══
;"use strict";
// ── view-router-bdc.ts ── the /?view=bdc inline fallback cluster ──
//
// Extracted VERBATIM from static/js/view-router.ts on 2026-09-28 (the file sat
// at exactly its 2,225-line budget and the signed-in prod audit's BDC fixes
// needed room) -- the #295 industry-comps / view-router-fund-fallback method:
// script mode, no import/export (tools/build_bundle.py CONCATENATES; an export
// would make this a module and unhoist every top-level name).
//
//   - _inlineRenderBDC   the zero-chunk /?view=bdc fallback: the mode and the
//                        start-state rails (_bdcRenderRails, 2026-10-27), which
//                        paint into hosts of their own, never a results panel.
//   - the capture-phase Random-click hold: while the lazy 'premium' chunk is in
//                        flight, a Random click waits for it and runs the real
//                        bdcRandomBdc / bdcRandomBorrower.
//   - _renderBDCList     the BDC rail (was the directory grid).
//
// `var _bdcListCache` stays declared in view-router.ts (pinned there by
// tests/test_ts_migration_pr46_contract.py). Registered in the SAME app-init
// chunk right after view-router.js; the renderMap references _inlineRenderBDC
// lazily (built per setView call), so concat order is not load-bearing.
// Contracts: tests/test_bdc_view_audit_fixes_contract.py.
const _BDC_MODE_KEY = 'ol_bdc_mode';
function _bdcModeOf(v) {
    return v === 'borrower' || v === 'bdc' ? v : null;
}
// The remembered mode; 'bdc' for a first visit, whose panel has the directory.
function _bdcStoredMode() {
    try {
        return _bdcModeOf(OLStorage.getString(_BDC_MODE_KEY, null)) || 'bdc';
    }
    catch (_e) {
        return 'bdc';
    }
}
function _bdcCurrentMode() {
    const root = document.getElementById('bdc-view');
    return _bdcModeOf(root ? root.getAttribute('data-bdc-mode') : null) || 'bdc';
}
function _bdcApplyMode(mode) {
    const m = _bdcModeOf(mode);
    if (!m)
        return;
    const root = document.getElementById('bdc-view');
    if (root)
        root.setAttribute('data-bdc-mode', m);
    document.querySelectorAll('[data-bdc-mode-target]').forEach(function (b) {
        const on = b.getAttribute('data-bdc-mode-target') === m;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        // 2026-10-27 (OWNER browser-page ruling 3): the segments are .btn-chip, and
        // .btn-chip.active is the DS active state (--chip-active-*), stable in both
        // themes -- the one-off segment painted --text-primary, near-white in dark.
        if (on)
            b.classList.add('active');
        else
            b.classList.remove('active');
    });
    try {
        OLStorage.setString(_BDC_MODE_KEY, m);
    }
    catch (_e) { /* storage blocked: the mode still applies */ }
    // QA P2-6: the other mode's rail is built the first time that mode shows.
    // typeof: some contracts lift this function alone, without the flag's declaration.
    if (typeof _bdcRailsStarted !== 'undefined' && _bdcRailsStarted)
        _bdcRenderRails();
}
function _inlineRenderBDC() {
    _bdcApplyMode(_bdcStoredMode());
    _bdcRenderRails();
}
let _bdcListLoad = null;
let _bdcTopBorrowersCache = null;
// The directory, fetched once per page life (a failure clears the promise, so
// the next render retries). bdc-view.ts renderBdcView reads the same promise.
function _bdcLoadList() {
    if (_bdcListCache)
        return Promise.resolve(_bdcListCache);
    if (!_bdcListLoad) {
        _bdcListLoad = fetch(((typeof SERVER !== 'undefined') ? SERVER : '') + '/api/bdc/list', { signal: AbortSignal.timeout(15000) })
            .then(function (res) { return res.ok ? res.json() : Promise.reject(new Error('HTTP ' + res.status)); })
            .then(function (data) {
            const list = (Array.isArray(data) ? data : (data && data.bdcs ? data.bdcs : []));
            _bdcListCache = list;
            return list;
        });
        _bdcListLoad.catch(function () { _bdcListLoad = null; });
    }
    return _bdcListLoad;
}
const _BDC_RAIL_LOADING = 'data-bdc-rail-loading';
// The skeleton is the 13F rail's: the REAL card containers with .skel-bar
// primitives, so the loading box takes the filled rail's height from the same
// CSS (the RUM CLS fix of thirteen-f.ts _renderGalleryLoading).
function _bdcRailSkeleton(label) {
    let h = '<div class="sr-only" role="status">' + escHtml(label) + '</div><div class="ol-browse-rail__grid" aria-hidden="true">';
    for (let i = 0; i < 6; i++) {
        h += '<div class="ol-featured-filer"><div class="ol-featured-filer__head"><div class="ol-featured-filer__name"><span class="skel-bar skel-bar-md"></span></div></div>'
            + '<div class="ol-featured-filer__pills"><span class="ol-featured-filer__pill"><span class="skel-bar skel-bar-sm"></span></span>'
            + '<span class="ol-featured-filer__pill"><span class="skel-bar skel-bar-sm"></span></span></div></div>';
    }
    return h + '</div>';
}
function _bdcRailPill(label, value) {
    return '<span class="ol-featured-filer__pill"><span class="ol-featured-filer__pill-label">' + escHtml(label)
        + '</span><span class="ol-featured-filer__pill-sep" aria-hidden="true"> · </span><span class="ol-featured-filer__pill-value">'
        + escHtml(value) + '</span></span>';
}
// One card: `attrs` is pre-escaped attribute text built below from escHtml'd
// values only; every other argument is escaped here. The list item is a WRAPPER
// (CHAOS 2026-10-27 F4): role="listitem" on the <button> itself replaced its
// button role, so a screen reader announced a list item, not a control.
function _bdcRailCard(attrs, name, ticker, pills, note, foot, cta) {
    return '<div role="listitem"><button type="button" class="ol-featured-filer" ' + attrs + '>'
        + '<div class="ol-featured-filer__head"><div class="ol-featured-filer__name">' + escHtml(name) + '</div>'
        + (ticker ? '<span class="ol-featured-filer__ticker">' + escHtml(ticker) + '</span>' : '') + '</div>'
        + (pills.length ? '<div class="ol-featured-filer__pills">' + pills.join('') + '</div>' : '')
        + (note ? '<div class="ol-featured-filer__note">' + escHtml(note) + '</div>' : '')
        + '<div class="ol-featured-filer__foot">'
        + (foot ? '<span class="ol-featured-filer__latest"><span class="ol-featured-filer__latest-label">Filed</span><span class="ol-featured-filer__pill-sep" aria-hidden="true"> · </span><span class="ol-featured-filer__latest-value">' + escHtml(foot) + '</span></span>'
            : '<span aria-hidden="true"></span>')
        + '<span class="ol-featured-filer__cta">' + escHtml(cta) + '</span></div></button></div>';
}
function _bdcRailNote(text) {
    return '<div class="ol-browse-rail__note"><p class="ol-editorial-note ol-editorial-note--muted-cream">' + escHtml(text) + '</p></div>';
}
// Paint into a host only while OUR loading marker is still there: a second
// render of the view, or a second load, never repaints over a painted rail.
function _bdcRailClaim(id, label) {
    const host = document.getElementById(id);
    if (!host || host.querySelector('[' + _BDC_RAIL_LOADING + ']') || host.querySelector('.ol-featured-filer[data-action]'))
        return null;
    host.innerHTML = '<div ' + _BDC_RAIL_LOADING + '="1">' + _bdcRailSkeleton(label) + '</div>';
    return host;
}
function _bdcRailMine(host) { return !!host.querySelector('[' + _BDC_RAIL_LOADING + ']'); }
// 2026-10-27 prod QA P2-6 (DOM budget): both rails were built on every render,
// and the hidden mode's rail is still DOM -- measured 855 elements for the
// borrower rail under a BDC book (#bdc-view 2,006). Only the shown mode's rail
// is built; _bdcApplyMode builds the other when its mode first shows.
var _bdcRailsStarted = false; // var, not let: _bdcApplyMode above reads it, and a var has no TDZ
function _bdcRenderRails() {
    _bdcRailsStarted = true;
    const mode = _bdcCurrentMode();
    const bdcHost = mode === 'bdc' ? _bdcRailClaim('bdc-rail-bdc', 'Loading BDCs') : null;
    if (bdcHost) {
        _bdcLoadList().then(function (list) { if (_bdcRailMine(bdcHost))
            _renderBDCList(bdcHost, list); }, function () { if (_bdcRailMine(bdcHost))
            bdcHost.innerHTML = _bdcRailNote('The BDC list is unavailable right now. The search above still finds any BDC by ticker.'); });
    }
    const borHost = mode === 'borrower' ? _bdcRailClaim('bdc-rail-borrower', 'Loading borrowers') : null;
    if (borHost) {
        const paint = function (rows) { if (_bdcRailMine(borHost))
            _bdcRenderBorrowerRail(borHost, rows); };
        if (_bdcTopBorrowersCache) {
            paint(_bdcTopBorrowersCache);
            return;
        }
        fetch(((typeof SERVER !== 'undefined') ? SERVER : '') + '/api/bdc/top-borrowers?limit=12', { signal: AbortSignal.timeout(15000) })
            .then(function (res) { return res.ok ? res.json() : Promise.reject(new Error('HTTP ' + res.status)); })
            .then(function (data) {
            const rows = (data && Array.isArray(data.borrowers) ? data.borrowers : []);
            if (rows.length)
                _bdcTopBorrowersCache = rows;
            paint(rows);
        })
            .catch(function () { if (_bdcRailMine(borHost))
            borHost.innerHTML = _bdcRailNote('The borrower list is unavailable right now. The search above still finds any borrower.'); });
    }
}
function _bdcRenderBorrowerRail(el, rows) {
    const usable = (rows || []).filter(function (b) { return !!(b && b.borrowerNorm && b.borrowerName); });
    if (!usable.length) {
        el.innerHTML = _bdcRailNote('No borrower list to show yet. The search above still finds any borrower.');
        return;
    }
    let html = '<div class="ol-browse-rail__grid" role="list">';
    usable.forEach(function (b) {
        const pills = [];
        if (b.holderCount != null && isFinite(Number(b.holderCount)))
            pills.push(_bdcRailPill('Lenders', String(b.holderCount)));
        if (b.totalFvLatest != null && isFinite(Number(b.totalFvLatest)))
            pills.push(_bdcRailPill('Fair value', fmtAbbrev(Number(b.totalFvLatest))));
        html += _bdcRailCard('data-action="bdc-open-borrower" data-borrower-norm="' + escHtml(String(b.borrowerNorm)) + '" data-borrower-name="' + escHtml(String(b.borrowerName)) + '"', String(b.borrowerName), '', pills, b.industry ? String(b.industry) : '', '', 'See lenders');
    });
    el.innerHTML = html + '</div>';
}
// 2026-09-28 prod audit: "the first Random click on a cold BDC view did
// nothing". bdcRandomBdc / bdcRandomBorrower live in the lazy 'premium' chunk
// (_VIEW_CHUNK_MAP.bdc). Until it lands, the central [data-action] dispatcher
// (app-renderers.ts) falls back to a hard-coded example list -- no
// /api/bdc/random-* request at all -- and the late /api/bdc/list paint above
// could then overwrite the result. While the chunk is still in flight, this
// capture-phase listener holds the click, waits for the chunk, and runs the
// REAL action; once the functions exist it steps aside and the dispatcher runs
// as before. A chunk that fails to load hands the click back to the
// dispatcher's fallback. One pending load per action: a double-click during
// the wait does not queue two lookups.
var _bdcRandomPending = {};
function _bdcRandomReady(action) {
    return action === 'bdc-random-bdc' ? typeof bdcRandomBdc === 'function' : typeof bdcRandomBorrower === 'function';
}
function _bdcRandomRun(action) {
    if (action === 'bdc-random-bdc')
        void bdcRandomBdc();
    else
        void bdcRandomBorrower();
}
document.addEventListener('click', function (e) {
    const t = e.target;
    const btn = (t && typeof t.closest === 'function')
        ? t.closest('[data-action="bdc-random-bdc"],[data-action="bdc-random-borrower"]')
        : null;
    if (!btn)
        return;
    const action = btn.getAttribute('data-action') || '';
    if (_bdcRandomReady(action) || typeof _loadChunk !== 'function')
        return;
    e.stopImmediatePropagation();
    if (_bdcRandomPending[action])
        return;
    _bdcRandomPending[action] = true;
    const _settle = function () {
        _bdcRandomPending[action] = false;
        if (_bdcRandomReady(action)) {
            _bdcRandomRun(action);
            return;
        }
        const _da = (typeof _delegatedActions !== 'undefined') ? _delegatedActions : null;
        if (_da && typeof _da[action] === 'function')
            void _da[action](e);
    };
    _loadChunk('premium').then(_settle, _settle);
}, true);
// The BDC rail: the largest BDCs by book (a null fair value sorts last), each
// card opening that BDC's book. A real <button>, so a keyboard reader opens it
// natively; its name is its text (never truncated -- the 2026-10-24 ellipsis,
// and the aria-label that compensated for it, are gone).
// Twelve, the borrower rail's count (CHAOS 2026-10-27 F2): every BDC (~48 in
// prod) at ~19 elements a card took #bdc-view from ~145 to ~1,170 elements and
// the document past 2,000 (the 1,000-element DOM budget), for a sideways rail
// nobody scrolls to the end of. The rest stay one search, or Random, away.
const _BDC_RAIL_MAX = 12;
function _renderBDCList(el, list) {
    if (!list || list.length === 0) {
        el.innerHTML = _bdcRailNote('No BDC data available yet. The search above still finds any BDC by ticker.');
        return;
    }
    const fv = function (b) { const v = Number(b.totalFairValue); return b.totalFairValue != null && isFinite(v) ? v : -1; };
    const rows = list.filter(function (b) { return !!(b.ticker || b.symbol); })
        .sort(function (a, b) { return fv(b) - fv(a); }).slice(0, _BDC_RAIL_MAX);
    let html = '<div class="ol-browse-rail__grid" role="list">';
    rows.forEach(function (b) {
        const ticker = String(b.ticker || b.symbol || '');
        const pills = [];
        if (fv(b) >= 0)
            pills.push(_bdcRailPill('Fair value', fmtAbbrev(fv(b))));
        if (b.holdingCount != null && isFinite(Number(b.holdingCount)))
            pills.push(_bdcRailPill('Holdings', Number(b.holdingCount).toLocaleString()));
        html += _bdcRailCard('data-action="bdc-search-bdc" data-ticker="' + escHtml(ticker) + '"', String(b.name || b.company || ticker), ticker, pills, '', b.filingDate ? String(b.filingDate) : '', 'Open book');
    });
    el.innerHTML = html + '</div>';
}
//# sourceMappingURL=view-router-bdc.js.map
;
// ═══ data-pipeline.js ═══
;"use strict";
// ── data-pipeline.js ─────────────────────────────────────────────────────
//
// TS Migration Phase 2 PR 36 (2026-05-04): renamed .js → .ts.
// Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
//
// This file is the SOURCE OF TRUTH; data-pipeline.js is the build
// artifact produced by `npx tsc -p tsconfig.build.json` (gitignored).
//
// Data fetching pipeline: 502 circuit breaker, olFetch, fetchTicker,
// refreshCurrent — extracted from app.js §FETCH-TICKER. Plus the
// CR-C6 degraded-banner UI (5s show-delay, 1s countdown tick).
const _cbBreakers = {};
const _CB_PROBE_DELAY_INITIAL_MS = 60000;
const _CB_PROBE_DELAY_MAX_MS = 600000;
const _CB_PREFIXES = [
    '/api/data',
    '/api/movers',
    '/api/portfolio',
    '/api/indicators',
    '/api/news',
    '/api/options',
    '/api/insider',
    '/api/macro',
    '/api/earnings',
    '/api/watchlist',
    '/api/form4',
    '/api/screener',
    '/api/transcripts',
    '/api/peers',
    '/api/etf',
    '/api/bond',
];
const _CB_MAX_RETRIES = 3;
const _CB_JITTER_MAX_MS = 3000;
function _cbKeyFor(url) {
    const path = url.replace(/^https?:\/\/[^/]+/, '');
    let best = '/api/other';
    for (let i = 0; i < _CB_PREFIXES.length; i++) {
        if (path.indexOf(_CB_PREFIXES[i]) === 0) {
            best = _CB_PREFIXES[i];
            break;
        }
    }
    return best;
}
function _cbGet(key) {
    if (!_cbBreakers[key]) {
        _cbBreakers[key] = {
            count: 0, pausedUntil: 0, backoffMs: 10000, retryAttempts: 0,
            state: 'closed', nextProbeAt: 0, probeDelayMs: _CB_PROBE_DELAY_INITIAL_MS,
        };
    }
    return _cbBreakers[key];
}
function _cbEmitEvent(key, state, nextProbeAt) {
    try {
        window.dispatchEvent(new CustomEvent('ol-circuit-breaker-state', {
            detail: { key: key, state: state, nextProbeAt: nextProbeAt || 0 },
        }));
    }
    catch (_e) { }
}
function _cbRecord502(key) {
    const b = _cbGet(key);
    b.count++;
    b.retryAttempts++;
    if (b.count >= 3) {
        b.backoffMs = Math.min(b.backoffMs * 2, 120000);
        const jitter = Math.floor(Math.random() * _CB_JITTER_MAX_MS);
        b.pausedUntil = Date.now() + b.backoffMs + jitter;
        if (b.retryAttempts >= _CB_MAX_RETRIES) {
            b.state = 'open';
            b.nextProbeAt = Date.now() + b.probeDelayMs;
            // #112 FE-STORM P2 (2026-07-01): gate behind _OL_DEBUG to match the :260
            // sibling fix — no console.* for production signals (CLAUDE.md §Observability).
            // _cbEmitEvent below is the real telemetry channel; the raw warn was redundant noise.
            /* @__PURE__ */ _olDebugWarn('[Circuit Breaker][' + key + '] OPEN — max retries reached. Half-open probe in ' + Math.round(b.probeDelayMs / 1000) + 's');
            _cbEmitEvent(key, 'open', b.nextProbeAt);
            if (typeof showToast === 'function') {
                showToast('Data service temporarily unavailable for ' + key + '. Auto-retrying shortly.', 'error', 6000);
            }
        }
        else {
            /* @__PURE__ */ _olDebugWarn('[Circuit Breaker][' + key + '] 502 storm (' + b.count + ' failures). Pausing ' + Math.round((b.backoffMs + jitter) / 1000) + 's (incl. ' + Math.round(jitter / 1000) + 's jitter). Retry #' + b.retryAttempts);
        }
    }
}
function _cbProbeFailure(key) {
    const b = _cbGet(key);
    b.probeDelayMs = Math.min(b.probeDelayMs * 2, _CB_PROBE_DELAY_MAX_MS);
    b.nextProbeAt = Date.now() + b.probeDelayMs;
    b.state = 'open';
    /* @__PURE__ */ _olDebugWarn('[Circuit Breaker][' + key + '] Probe failed — back to OPEN. Next probe in ' + Math.round(b.probeDelayMs / 1000) + 's');
    _cbEmitEvent(key, 'open', b.nextProbeAt);
}
function _cbClear(key) {
    const b = _cbBreakers[key];
    if (b && (b.count > 0 || b.state !== 'closed')) {
        const wasOpen = b.state === 'open' || b.state === 'half-open';
        b.count = 0;
        b.backoffMs = 10000;
        b.pausedUntil = 0;
        b.retryAttempts = 0;
        b.state = 'closed';
        b.nextProbeAt = 0;
        b.probeDelayMs = _CB_PROBE_DELAY_INITIAL_MS;
        if (wasOpen) {
            // console.info removed (P2-C no-console) — _cbEmitEvent carries the structured breaker signal.
            _cbEmitEvent(key, 'closed', 0);
        }
    }
}
function _cbProbeIfDue(key) {
    const b = _cbBreakers[key];
    if (!b || b.state !== 'open')
        return;
    if (Date.now() >= b.nextProbeAt) {
        b.state = 'half-open';
        // console.info removed (P2-C no-console) — _cbEmitEvent carries the structured breaker signal.
        _cbEmitEvent(key, 'half-open', b.nextProbeAt);
    }
}
function _cbIsPaused(key) {
    const b = _cbBreakers[key];
    if (!b)
        return false;
    if (b.state === 'open') {
        _cbProbeIfDue(key);
        if (b.state === 'open')
            return true;
        if (b.state === 'half-open')
            return false;
    }
    if (b.state === 'half-open')
        return false;
    if (b.pausedUntil && Date.now() < b.pausedUntil)
        return true;
    if (b.pausedUntil && Date.now() >= b.pausedUntil) {
        b.pausedUntil = 0;
    }
    return false;
}
// Mobile-QA 2026-08-17: in-flight + short-settle GET dedup at the ONE seam
// every panel renderer routes through. Measured live on /?view=ticker&symbol=
// SPOT at 375px: the whole per-ticker panel fan-out (institutional-holders/
// changes, segments, fdic/regulatory, insiders, insider-cluster,
// institutional-confluence, ticker-modules) fired TWICE ~40ms apart — boot
// setView('ticker') renders once, then the deep-link/switchTicker path
// renders again — and the 95KB holders payload downloaded both times, with
// the second pass self-contending (segments 561ms -> 974ms). fetchTicker
// already collapses its own burst (#82 Fix A); the PANEL fetches had no seam.
// Same class as #157's calendar dedup, generalized: identical bare /api/ GETs
// within the window share ONE network request; every consumer gets a clone()
// so bodies stay independently readable. Deliberately narrow:
//   - only when opts is ABSENT (a caller passing a signal/method/headers owns
//     its request — abortViewFetches semantics stay per-caller);
//   - failures and non-OK responses evict immediately, so retries hit origin;
//   - 2.5s settle window, well under the 60s API cache and the 15-min poller.
const _olFetchDedup = (typeof Map !== 'undefined') ? new Map() : null;
const _OLFETCH_DEDUP_TTL_MS = 2500;
function _olFetchDedupSweep() {
    if (!_olFetchDedup || _olFetchDedup.size <= 50)
        return;
    const now = Date.now();
    _olFetchDedup.forEach(function (entry, key) {
        if (now - entry.at >= _OLFETCH_DEDUP_TTL_MS)
            _olFetchDedup.delete(key);
    });
}
function olFetch(url, opts) {
    const _dedupable = !!_olFetchDedup && opts === undefined && url.indexOf('/api/') === 0;
    if (_dedupable) {
        const hit = _olFetchDedup.get(url);
        if (hit) {
            if (Date.now() - hit.at < _OLFETCH_DEDUP_TTL_MS) {
                return hit.p.then(function (res) { return res.clone(); });
            }
            _olFetchDedup.delete(url);
        }
    }
    const _p = _olFetchRaw(url, opts);
    if (_dedupable) {
        _olFetchDedupSweep();
        const shared = _p.then(function (res) {
            // Only a healthy response is worth sharing — evict failures so the
            // next caller (a retry) goes to origin instead of replaying an error.
            if (!res.ok)
                _olFetchDedup.delete(url);
            return res;
        }, function (err) {
            _olFetchDedup.delete(url);
            throw err;
        });
        _olFetchDedup.set(url, { p: shared, at: Date.now() });
        return shared.then(function (res) { return res.clone(); });
    }
    return _p;
}
function _olFetchRaw(url, opts) {
    const key = _cbKeyFor(url);
    let wasHalfOpen = !!(_cbBreakers[key] && _cbBreakers[key].state === 'half-open');
    if (_cbIsPaused(key)) {
        wasHalfOpen = !!(_cbBreakers[key] && _cbBreakers[key].state === 'half-open');
        if (!wasHalfOpen) {
            const b = _cbBreakers[key];
            const retryInSec = b && b.nextProbeAt > Date.now()
                ? Math.ceil((b.nextProbeAt - Date.now()) / 1000) : '?';
            return Promise.reject(new Error('Circuit breaker: server recovering (' + key + ') — probe in ' + retryInSec + 's'));
        }
    }
    const probing = !!(_cbBreakers[key] && _cbBreakers[key].state === 'half-open');
    return fetch(url, opts).then(function (res) {
        if (res.status === 502 || res.status === 503) {
            if (probing) {
                _cbProbeFailure(key);
            }
            else {
                _cbRecord502(key);
            }
            return Promise.reject(new Error('HTTP ' + res.status));
        }
        // WP-B (2026-09-26 external review): a 429 is the rate limiter, not a
        // recovered server -- it must neither TRIP the breaker (the service is up)
        // nor CLEAR it (a 429 during a 502 storm is no evidence of recovery). The
        // global backoff gate in app-init.ts owns the wait. Before, every non-502/
        // 503 status fell through to _cbClear. A half-open probe answered with a
        // 429 stays half-open, so the next call probes again.
        if (res.status === 429)
            return res;
        _cbClear(key);
        return res;
    });
}
const _fetchTickerInflight = (typeof Map !== 'undefined') ? new Map() : null;
// #46 quick-win 2 (persona cycle 2026-07-09): one deferred self-heal refetch
// per ticker per page-life when the first payload came back COLD (price-only,
// fundamentals still enriching server-side). Keyed here so repeat visits to
// the same thin ticker don't retry-loop.
const _coldTickerHealed = {};
const _tickerResultCache = (typeof Map !== 'undefined') ? new Map() : null;
const _TICKER_RESULT_TTL_MS = 4000;
function _normTicker(t) {
    return (t || '').trim().toUpperCase();
}
function _tickerResultCacheGet(ticker) {
    if (!_tickerResultCache)
        return null;
    const norm = _normTicker(ticker);
    const hit = _tickerResultCache.get(norm);
    if (!hit)
        return null;
    if (Date.now() - hit.at > _TICKER_RESULT_TTL_MS) {
        _tickerResultCache.delete(norm);
        return null;
    }
    return hit.data;
}
function _tickerResultCacheSet(ticker, data) {
    if (!_tickerResultCache)
        return;
    _tickerResultCache.set(_normTicker(ticker), { data: data, at: Date.now() });
}
function _tickerResultCacheClear(ticker) {
    if (!_tickerResultCache)
        return;
    _tickerResultCache.delete(_normTicker(ticker));
}
// #82 Fix B (2026-07-22): one deferred auto-retry per ticker per page-life when
// the first /api/data attempt fails TRANSIENTLY (5xx / network / timeout) and
// nothing has rendered yet. Without it, a boot 503 paints the load-error banner
// and leaves the hero at dashes until the 15-min countdown or a manual Retry —
// even though the origin recovers seconds later once the self-inflicted burst
// (Fix A) subsides. The retry re-hydrates the hero via the normal success path.
// Guarded once-per-ticker so a genuine sustained outage cannot become a storm.
const _tickerRecoverRetried = {};
// S1 (first-time-user audit, 2026-09-25) + CHAOS fix (same day): /look sends
// an unresolvable query to `/?view=ticker&ticker=<Q>&lookup=<q>`. The hint is
// captured HERE, at chunk evaluation, because switchTicker (app-init.ts)
// history.replaceState()s the URL to `?view=ticker&symbol=<T>` before the
// /api/data response arrives -- a read at response time never sees it (the
// builder's first version did exactly that and was dead code in the browser).
// One-shot: consumed by the first ticker it names.
let _olLookupHint = (function () {
    try {
        return (new URLSearchParams(window.location.search).get('lookup') || '').trim().slice(0, 40);
    }
    catch (_e) {
        return '';
    }
})();
// The not-a-company copy when the captured hint names THIS ticker, else null.
// No quote, apostrophe or ampersand in the template: until 2026-09-25
// _showClassifiedErrorToast escHtml()d the message and showToast escaped it
// again (a literal &quot;). It now escapes once; the rule is kept as margin.
function _olLookupHintMessage(ticker) {
    if (!_olLookupHint || _olLookupHint.toUpperCase() !== String(ticker).toUpperCase())
        return null;
    const h = _olLookupHint;
    _olLookupHint = '';
    // Worded as what WE could not do, not as a fact about the world: the
    // catalog stores "The Walt Disney Company", so "Disney" can land here too.
    return 'We could not match ' + h + ' to a company. Try the search box: you can type a company name or a ticker symbol.';
}
function _olNotFoundSuggestionList(raw) {
    const out = [];
    if (!Array.isArray(raw))
        return out;
    for (let i = 0; i < raw.length && out.length < 3; i++) {
        const r = raw[i];
        const tk = r && typeof r.ticker === 'string' ? r.ticker.trim().toUpperCase() : '';
        if (!/^[A-Z0-9][A-Z0-9.\-]{0,11}$/.test(tk))
            continue;
        const nm = r && typeof r.name === 'string' ? r.name.trim().slice(0, 80) : '';
        out.push({ ticker: tk, name: nm });
    }
    return out;
}
function _olRenderTickerSuggestions(list) {
    if (!list.length)
        return;
    const host = document.querySelector('#ticker-view .load-error');
    if (!host)
        return;
    const old = host.querySelector('.load-error-suggest');
    if (old && old.parentNode)
        old.parentNode.removeChild(old);
    const box = document.createElement('div');
    box.className = 'load-error-suggest';
    box.setAttribute('role', 'group');
    box.setAttribute('aria-label', 'Did you mean');
    box.appendChild(document.createTextNode('Did you mean '));
    list.forEach(function (sg, i) {
        const a = document.createElement('a');
        a.className = 'load-error-suggest-link';
        a.href = '/?view=ticker&symbol=' + encodeURIComponent(sg.ticker);
        a.setAttribute('data-ticker', sg.ticker);
        a.textContent = sg.name ? sg.name + ' (' + sg.ticker + ')' : sg.ticker;
        a.addEventListener('click', function (ev) {
            // In the SPA, open it as a tab like any other search; the href is the
            // fallback when the renderer chunk has not loaded yet.
            const w = window;
            if (typeof w.addTickerBySymbol === 'function') {
                ev.preventDefault();
                w.addTickerBySymbol(sg.ticker);
            }
        });
        box.appendChild(a);
        if (i < list.length - 1)
            box.appendChild(document.createTextNode(i === list.length - 2 ? ' or ' : ', '));
    });
    box.appendChild(document.createTextNode('?'));
    host.appendChild(box);
}
// OWNER ruling 2026-10-19 (3): an anonymous viewer reaches no vendor and no
// SEC endpoint, so a REAL ticker we have never stored answers /api/data with a
// 404 whose error_type is 'not_stored' (an unknown string stays a plain 404).
// That is not "not found": the company exists, we just load new companies
// only for signed-in readers. Show that state with the sign-in CTA instead of
// the not-found copy and its Retry (retrying cannot help an anonymous viewer).
// Built with createElement/textContent inside the existing .load-error box --
// no innerHTML on #ticker-view (feedback_never_destroy_dom).
function _olRenderNotStored(ticker) {
    if (typeof LoadingStates === 'undefined')
        return;
    const sym = String(ticker || '').toUpperCase();
    LoadingStates.showError('ticker-view', 'Oxford Ledge loads new companies for signed-in readers. Signing in is free.', null, null);
    const box = document.querySelector('#ticker-view .load-error');
    if (!box)
        return;
    box.classList.add('load-error--not-stored');
    box.setAttribute('data-not-stored-ticker', sym);
    const hint = box.querySelector('.load-error-hint');
    if (hint && hint.parentNode)
        hint.parentNode.removeChild(hint);
    const title = document.createElement('div');
    title.className = 'load-error-title';
    title.textContent = 'Sign in (free) to load ' + sym;
    const msg = box.querySelector('.load-error-msg');
    box.insertBefore(title, msg);
    const cta = document.createElement('button');
    cta.className = 'load-error-cta';
    cta.type = 'button';
    cta.textContent = 'Sign in (free)';
    cta.addEventListener('click', function () {
        if (typeof authOpenModal === 'function') {
            authOpenModal('signin');
            return;
        }
        window.location.href = '/?signin=1&ticker=' + encodeURIComponent(sym);
    });
    box.appendChild(cta);
}
// CHAOS 2026-10-24: the CTA's sign-in happens in the modal, which reloads
// nothing -- so the reader who signed in to load this ticker was left on the
// "Sign in to load" box. When a session arrives while that box is showing for
// the active ticker, load it again. `revalidate` bypasses the browser's copy of
// the anonymous 404 (the server also sends it no-store); the server now
// fetches live for a signed-in reader. Every other ol-user-signed-in (a session
// restored at boot, a sign-in elsewhere) finds no such box and does nothing.
function _olReloadNotStoredOnSignIn() {
    const box = document.querySelector('#ticker-view .load-error--not-stored');
    const sym = box ? box.getAttribute('data-not-stored-ticker') : null;
    if (!box || !sym || sym !== String(activeTicker || '').toUpperCase())
        return;
    box.setAttribute('data-not-stored-ticker', '');
    void _fetchTickerJoined(sym, false, true);
}
try {
    window.addEventListener('ol-user-signed-in', _olReloadNotStoredOnSignIn);
}
catch (_e) { /* noop */ }
// Hoisted out of _fetchTickerImpl (was an inner closure over `ticker`) so the
// Fix-A in-memory-cache-hit path in fetchTicker can render a cached payload
// through the exact same apply logic. `renderData` re-hydrates the hero on any
// valid payload — that IS the Fix-B recover-render on a late 200 (renderData
// also clears a stale ticker-view load-error banner; see ticker-renderer.ts).
function _applyTickerPayload(ticker, data, fromCache) {
    if (data.ticker || data.price || data.company) {
        dataCache[ticker] = data;
        _evictDataCache();
        // Fix A: cache the valid payload so repeat consumers within one load reuse
        // it instead of re-hitting the origin. Never cache a re-render of a value
        // that itself came from the cache (fromCache) — that would refresh the TTL
        // on stale data and keep it alive indefinitely.
        if (!fromCache)
            _tickerResultCacheSet(ticker, data);
        if (ticker === activeTicker)
            renderData(data);
        if (typeof DataCache !== 'undefined' && !fromCache) {
            const dc = DataCache;
            dc.set(dc.keys.ticker(ticker), data);
        }
        renderTabs();
        if (currentView === 'portfolio' && typeof renderPortfolio === 'function')
            renderPortfolio();
    }
    else if (data.error_type) {
        /* @__PURE__ */ _olDebugWarn('[' + ticker + '] Classified: ' + data.error_type + ' — ' + data.message);
        if (ticker === activeTicker)
            _showClassifiedErrorToast(data.error_type, data.message || (ticker + ': unable to load'), data.retry_after);
    }
    else if (data.error) {
        // #22 (2026-06-19 audit P2): was an ungated console.warn (prod-noise on
        // every server-side data error); the sibling branch above already uses
        // the _OL_DEBUG-gated _olDebugWarn — match it (CLAUDE.md §Observability:
        // no console.* for production signals; the user-facing toast remains).
        /* @__PURE__ */ _olDebugWarn('[' + ticker + '] Server: ' + data.error);
        showToast("We couldn't load data for " + ticker + '. Try again in a moment.', 'error', 4000);
    }
}
async function fetchTicker(ticker, nocache = false) {
    // #82 Fix A: serve a very-recent SUCCESS from the in-memory result cache so
    // the ~15x fan-out (boot + panels + ws push + poller) collapses to one origin
    // hit. Explicit refresh (nocache) always bypasses; demo mode falls through to
    // the impl's DEMO_DATA path. Only VALID payloads are ever cached, so a
    // transient failure is never served from here.
    if (!nocache && isLive) {
        const _cachedResult = _tickerResultCacheGet(ticker);
        if (_cachedResult) {
            _applyTickerPayload(ticker, _cachedResult, true);
            setLoading(false);
            _hideTickerSkeleton();
            // Mirror the DataCache early-return teardown so a cache-served paint
            // doesn't leave the welcome-flow loading bridge up for the safety timer.
            try {
                const _wBridge = window;
                if (typeof _wBridge._dismissLoadingBridge === 'function')
                    _wBridge._dismissLoadingBridge();
            }
            catch (_e) { /* defensive */ }
            return;
        }
    }
    return _fetchTickerJoined(ticker, nocache, false);
}
// In-flight collapse for fetchTicker and the cold-payload heal below. The key
// carries the mode, so a plain call never joins a forced or revalidating one.
function _fetchTickerJoined(ticker, nocache, revalidate) {
    if (_fetchTickerInflight) {
        const _key = ticker + '|' + (nocache ? '1' : (revalidate ? 'r' : '0'));
        const existing = _fetchTickerInflight.get(_key);
        if (existing)
            return existing;
        const promise = _fetchTickerImpl(ticker, nocache, revalidate).finally(function () {
            _fetchTickerInflight.delete(_key);
        });
        _fetchTickerInflight.set(_key, promise);
        return promise;
    }
    return _fetchTickerImpl(ticker, nocache, revalidate);
}
// `nocache` asks the SERVER for a forced live refetch (`&nocache=1`: the route
// skips its caches and its DB snapshot tier and spends a vendor fetch).
// `revalidate` asks only the BROWSER to skip its HTTP cache (fetch
// cache:'no-cache', same URL): the server answers from its own caches, which
// is what the cold-payload heal needs. Both skip the client-side caches.
async function _fetchTickerImpl(ticker, nocache = false, revalidate = false) {
    // Search telemetry (mobile audit 2026-09-25): still ONE ticker_search per
    // call, as before, but sent at the verdict so it carries result_count
    // (1 = the ticker loaded, 0 = it did not) and not_found (it does not exist
    // for us: a 404 or a not-found envelope) -- the pair that answers "how often
    // does a search dead-end?". `suggestions` counts the "Did you mean" links
    // offered with a not-found. Every exit below sends it exactly once.
    const _ts = { ticker: ticker, result_count: 0, not_found: false };
    let _tsSent = false;
    const _tsSend = function () {
        if (_tsSent)
            return;
        _tsSent = true;
        try {
            _track('ticker_search', _ts);
        }
        catch (_e) { /* telemetry never blocks a render */ }
    };
    if (!isLive) {
        const demo = DEMO_DATA[ticker];
        if (demo) {
            dataCache[ticker] = demo;
            if (ticker === activeTicker)
                renderData(demo);
        }
        _ts.result_count = demo ? 1 : 0;
        _ts.not_found = !demo;
        _tsSend();
        return;
    }
    if (typeof navigator !== 'undefined' && !navigator.onLine) {
        showToast('You appear to be offline. Showing cached data if available.', 'warning', 4000);
        const cached = dataCache[ticker];
        if (cached && ticker === activeTicker)
            renderData(cached);
        _ts.offline = true;
        _tsSend();
        return;
    }
    _setPulseRefreshing(true);
    if (!nocache && !revalidate && typeof DataCache !== 'undefined') {
        const dc = DataCache;
        const cached = dc.get(dc.keys.ticker(ticker));
        if (cached && cached.data) {
            _applyTickerPayload(ticker, cached.data, true);
            setLoading(false);
            _hideTickerSkeleton();
            // #82 (2026-07-18 QA): burst guard. A single ticker-view page load
            // fired /api/data 13x for the SAME symbol — every panel/boot/retry
            // caller re-ran the network refetch even when the cache was seconds
            // old (the in-flight map only collapses CONCURRENT calls). A <60s
            // payload is already rendered above; skip the redundant network
            // round-trip. Explicit refresh (nocache) and the 15-min auto-refresh
            // bypass this by construction.
            const _ageMs = cached.age_ms;
            if (typeof _ageMs === 'number' && _ageMs < 60000) {
                _setPulseRefreshing(false);
                _ts.result_count = 1;
                _tsSend();
                // F-12: this early return bypasses the finally block — tear the
                // welcome-flow loading bridge down here too, or a cache-served
                // first paint leaves the bridge up for the 6s safety-net timer.
                try {
                    const _wBridge = window;
                    if (typeof _wBridge._dismissLoadingBridge === 'function')
                        _wBridge._dismissLoadingBridge();
                }
                catch (_e) { /* defensive */ }
                return;
            }
        }
    }
    let _ftSuggest = [];
    let _ftNotStored = false;
    try {
        let url = `/api/data?ticker=${encodeURIComponent(ticker)}`;
        if (nocache)
            url += '&nocache=1';
        const _ftViewSig = (typeof getViewSignal === 'function') ? getViewSignal() : null;
        const _ftTimeoutSig = AbortSignal.timeout(15000);
        const _ftSignal = (_ftViewSig && typeof AbortSignal.any === 'function')
            ? AbortSignal.any([_ftViewSig, _ftTimeoutSig])
            : _ftTimeoutSig;
        const _ftInit = { signal: _ftSignal };
        if (revalidate && !nocache)
            _ftInit.cache = 'no-cache';
        const _ftResp = await fetch(url, _ftInit);
        // PR1 (audit triage 2026-05-06): on 402, parse the ctx envelope
        // (requiredTier + currentTier from
        // routes/api_errors.py::tier_gate_exception_handler) so the
        // downstream showError can rewrite the body with the tier label +
        // price. Other 4xx/5xx codes still fall through to the generic
        // throw so retry/circuit logic upstream is unchanged.
        if (_ftResp.status === 402) {
            // F11 (Code-Review-Cowork audit 2026-05-12): pass the fetch URL
            // through so error-copy.lookup() can name the feature in the
            // body ("Screener export is on Researcher tier..."). `feature` is
            // unset here (data-pipeline doesn't know the friendly label);
            // error-copy derives it from `url` via _URL_TO_FEATURE_LABEL.
            let _tierCtx = { url: url };
            // F4.7 (SF-23 audit 2026-05-07): branch on reason==='service_unavailable'
            // (set by services/billing/usage.py:404-425 when PG fail-closed).
            // Pre-fix the FE treated PG-outage 402s identically to capacity-hit
            // 402s — a brief outage made the platform look like 'charging
            // without explanation'. Post-fix, service-unavailable shows a
            // toast that explicitly tells the user usage isn't being charged
            // and links to the deep-health endpoint for self-check, instead
            // of routing to the upgrade banner.
            let _isServiceUnavailable = false;
            try {
                const _402body = await _ftResp.clone().json();
                if (_402body && _402body.reason === 'service_unavailable') {
                    _isServiceUnavailable = true;
                }
                if (_402body && (_402body.requiredTier || _402body.currentTier)) {
                    _tierCtx = {
                        requiredTier: _402body.requiredTier || null,
                        currentTier: _402body.currentTier || null,
                        url: url // preserved for F11 feature-label derivation
                    };
                }
            }
            catch (_e) { /* ignore: fall through to generic 402 copy */ }
            if (_isServiceUnavailable) {
                // Service-unavailable: bypass the upgrade-required path entirely.
                // Show a status toast with self-check link; the FE never charges
                // and the user understands this is a brief platform issue, not
                // a billing event.
                try {
                    if (typeof showToast === 'function') {
                        showToast("We're having trouble reaching our database. Try again in a moment — your usage isn't being charged.", 'warning', 6000);
                    }
                }
                catch (_e) { /* defensive */ }
            }
            else if (typeof LoadingStates !== 'undefined' && ticker === activeTicker) {
                LoadingStates.showError('ticker-view', 'Upgrade required', null, '402', _tierCtx);
            }
            // NCR1 (cowork-fix-prompt 2026-05-06): the welcome-flow loading
            // bridge stays up until renderData() fires, but renderData()
            // never fires on a 402 — leaving first-time visitors looking at
            // a 6-second blank page before the safety-net auto-dismiss
            // (app.ts:2882). Dismissing the bridge here surfaces the
            // upgrade banner immediately so the user sees the path forward.
            // Defensive: the function might not exist on every host page
            // (settings, /pricing, etc.) — typeof guard prevents the
            // 402 path from raising here.
            try {
                const w = window;
                if (typeof w._dismissLoadingBridge === 'function') {
                    w._dismissLoadingBridge();
                }
            }
            catch (_e) { /* defensive */ }
            return;
        }
        if (_ftResp.status === 404) {
            // Mobile audit 2026-09-25: read the "Did you mean" list before the throw
            // below discards the body (a clone, so nothing else loses the stream).
            try {
                const _nf = await _ftResp.clone().json();
                _ftSuggest = _olNotFoundSuggestionList(_nf ? _nf.suggestions : null);
                // OWNER 2026-10-19 (3): a real ticker not stored yet, for an anonymous viewer.
                _ftNotStored = !!_nf && _nf.error_type === 'not_stored';
            }
            catch (_e) {
                _ftSuggest = [];
            }
        }
        if (!_ftResp.ok)
            throw new Error('HTTP ' + _ftResp.status);
        // Publish the freshness HEADERS this response already carries.
        //
        // `middleware/data_age.py` stamps X-Data-Age + X-Data-Staleness on every
        // /api/data response, but the two consumers that render them
        // (_renderChartFreshnessBadge in ticker-renderer.ts, and
        // data-freshness-pill.ts) could not reach them: this function parses the
        // body and discards the Response, so each consumer issued its OWN
        // `&fields=ticker,fetchedAt` request purely to read two headers. Measured
        // live 2026-08-17 on a switchTicker: the badge's refetch landed 246ms
        // after this one, for the same ticker, while this payload was mid-render.
        // Stashing them here removes that round trip without changing what either
        // consumer displays — the badge falls back to its own fetch when the map
        // has no entry (a cache-served render, or a consumer that runs first).
        try {
            const _wAge = window;
            const _ageRaw = _ftResp.headers.get('X-Data-Age');
            if (_ageRaw != null) {
                const _age = parseInt(_ageRaw, 10);
                if (!isNaN(_age)) {
                    _wAge.__olDataAge = _wAge.__olDataAge || {};
                    _wAge.__olDataAge[String(ticker).toUpperCase()] = {
                        age: _age,
                        tier: _ftResp.headers.get('X-Data-Staleness') || '',
                        at: Date.now(),
                    };
                }
            }
        }
        catch (_e) { /* additive — a missing header must never block the render */ }
        const data = await _ftResp.json();
        /* @__PURE__ */ _olDebug('[fetchTicker] ' + ticker + ': ' + (data.price ? '$' + data.price.current : 'no price'));
        if (data && data.error_type) {
            /* @__PURE__ */ _olDebugWarn('[' + ticker + '] Classified error:', data.error_type, data.message);
            if (!dataCache[ticker]) {
                let _errMsg = data.message || ('Unable to load ' + ticker);
                // S1 (first-time-user audit, 2026-09-25): /look could not resolve
                // the query as a ticker OR a company name and redirected here with
                // a `lookup=<q>` hint (captured at load -- see _olLookupHint). The
                // backend message is true of a real issuer we have not parsed; it is
                // the wrong sentence for a string that is not a company at all.
                const _hintMsg = _olLookupHintMessage(ticker);
                if (_hintMsg)
                    _errMsg = _hintMsg;
                // P1-6 (external review 2026-09-26): portfolio / watchlist / compare
                // fetch tickers that are NOT on screen; their failures must not paint
                // over the one that is. Caching + telemetry stay unconditional.
                if (typeof LoadingStates !== 'undefined' && ticker === activeTicker) {
                    // Code null on the hint path: with a code, OLErrorCopy's body wins
                    // over the message and the panel would never show the hint.
                    LoadingStates.showError('ticker-view', _errMsg, _hintMsg ? null : function () { void fetchTicker(ticker); }, _hintMsg ? null : data.error_type);
                }
                if (ticker === activeTicker)
                    _showClassifiedErrorToast(data.error_type, _errMsg, data.retry_after);
            }
            _ts.not_found = data.error_type === 'ticker_not_found' || data.error_type === 'no_data';
            const _envSuggest = _olNotFoundSuggestionList(data.suggestions);
            if (_ts.not_found)
                _ts.suggestions = _envSuggest.length;
            if (ticker === activeTicker)
                _olRenderTickerSuggestions(_envSuggest);
        }
        else {
            _applyTickerPayload(ticker, data, false);
            _ts.result_count = (data && (data.ticker || data.price || data.company)) ? 1 : 0;
            // #46 quick-win 2 (docs/board/audit/2026-07-09_PERSONA_ticker_page_
            // loading_cycle.md): a COLD ticker's first /api/data returns a
            // price-only payload (_source==='ticker_cache', financials/metrics
            // null) while the server's Phase-2 enrichment runs (~5-10s) — panels
            // painted empty until the user manually reloaded. Self-heal: ONE
            // deferred PLAIN refetch (no nocache — by then the enriched payload
            // sits in the server cache, so the retry is cheap and idempotent).
            // If the retry is still thin, panels keep the honest empty state.
            try {
                const _d = data;
                const _thin = !!_d && _d._source === 'ticker_cache' && !_d.financials && !_d.metrics;
                // 2026-09-01 (OWNER report: Y/Y column blank): the heal predicate
                // only caught the price-only COLD shape. A Phase-1 payload WITH
                // financials but WITHOUT fiveYearHistory (snapshot expired, rebuild
                // in flight) escaped it -- the fin table painted and its Y/Y cells
                // (computed from fiveYearHistory) stayed blank for the page-life,
                // because the market-closed refresher never re-renders. Measured
                // live: dataCache later HELD the full history and a re-render filled
                // every cell. Same one-shot heal, longer delay (Phase 2 is ~5-10s
                // typical, 90s deadline -- one retry at 12s catches the typical case
                // and the honest blank stays for the tail).
                const _histAbsent = !!_d && !!_d.financials && !_d.fiveYearHistory;
                if ((_thin || _histAbsent) && !nocache && !revalidate && !_coldTickerHealed[ticker]) {
                    _coldTickerHealed[ticker] = true;
                    setTimeout(function () {
                        // Fix A: the thin payload is in the in-memory result cache; clear it
                        // so this deferred refetch actually hits the origin for the enriched
                        // payload (the server's Phase-2 enrichment has landed by now).
                        _tickerResultCacheClear(ticker);
                        // 2026-09-01: bypassing the BROWSER cache is load-bearing.
                        // /api/data serves Cache-Control: private, max-age=60, so a plain
                        // refetch inside that window replays the SAME thin body (measured
                        // live: 19 consecutive 0-byte cache hits on this URL).
                        //
                        // 2026-10-17: but `&nocache=1` was the wrong way to bypass it. The
                        // 09-01 note said the server ignores the param; it does not -- it
                        // is `force_refresh` (routes_ticker_data_fastapi.py), which skips
                        // the server's caches AND its DB snapshot tier and runs a live
                        // vendor fetch. That fetch returns Phase 1 only (fiveYearHistory
                        // is Phase 2), so the heal could never deliver what it waited
                        // for, spent a signed-in viewer's vendor quota on every
                        // DB-snapshot payload (that tier never carries fiveYearHistory, so
                        // `_histAbsent` held for all of them), and 404'd when the live
                        // fetch came back empty (browser QA 2026-10-17:
                        // /api/data?ticker=SPOT&nocache=1 -> 404 on Learn). A revalidating
                        // fetch of the SAME URL skips only the browser cache; the server
                        // answers from its in-memory cache (which the snapshot tier's
                        // background refresh warms, Phase 2 included) or, on a worker that
                        // has not warmed it, the same snapshot -- no forced vendor fetch.
                        void _fetchTickerJoined(ticker, false, true);
                    }, _thin ? 4500 : 12000);
                }
            }
            catch (_e) { /* self-heal must never break first paint */ }
        }
    }
    catch (e) {
        const err = e;
        /* @__PURE__ */ _olDebugError('[' + ticker + '] Fetch error:', e);
        // 2b (2026-07-14): an AbortError here is a DELIBERATE cancellation — the
        // view-aware abort signal (getViewSignal, AbortSignal.any above) fired
        // because the user navigated away OR a boot-time view-switch race
        // superseded this fetch (app-init.ts fetchTicker + _restoreFromURL both
        // hit switchTicker -> abortViewFetches). It is NOT a timeout; painting the
        // full-screen "Request timed out" error for a fetch WE cancelled is the
        // observed data?ticker=SPOT "(canceled)" -> "Request timed out" bug. Bail
        // before the error UI — the `finally` block still runs its skeleton/bridge
        // cleanup, and the superseding view/fetch owns the next paint. A genuine
        // 15s stall is a TimeoutError (AbortSignal.timeout), which still classifies
        // as 'timeout' below.
        if (err.name === 'AbortError') {
            return;
        }
        if (_ftNotStored && err.message && /^HTTP\s+404\b/.test(err.message)
            && !dataCache[ticker]) {
            // Not "not found": the sign-in state (see _olRenderNotStored). No error
            // toast and no recover-retry -- a 404 is not transient.
            _ts.not_stored = true;
            if (ticker === activeTicker)
                _olRenderNotStored(ticker);
        }
        else if (!dataCache[ticker]) {
            let _netErrType = 'unknown';
            let _netErrMsg = 'Could not load ' + ticker + ' just now. Retry in a moment.';
            if (err.name === 'TimeoutError' || (err.message && err.message.indexOf('timeout') !== -1)) {
                _netErrType = 'timeout';
                // #13 (2026-05-30): softened from the alarming "Request ... timed out.
                // Please try again." A timeout here is most often the data provider
                // being busy under daily-quota pressure (the "Approaching daily
                // provider quota" banner), not a user/network fault -- so the copy
                // names the likely cause + a calm retry instead of an error tone.
                _netErrMsg = ticker + ' is taking longer than usual to load. The data provider may be busy; retry in a moment.';
            }
            else if (err.message && err.message.indexOf('fetch') !== -1) {
                _netErrType = 'api_unavailable';
                _netErrMsg = 'Market data is temporarily unavailable. Please try again shortly.';
            }
            else if (err.message && /^HTTP\s+[45]\d\d/.test(err.message)) {
                _netErrType = err.message;
            }
            // S1 CHAOS fix (2026-09-25): /api/data answers an unknown ticker with a
            // 404, which lands HERE (the `!_ftResp.ok` throw), never in the
            // error_type branch above -- so the /look hint must be applied here too.
            const _hint404 = /^HTTP\s+404\b/.test(_netErrType) ? _olLookupHintMessage(ticker) : null;
            if (_hint404)
                _netErrMsg = _hint404;
            if (typeof LoadingStates !== 'undefined' && ticker === activeTicker) {
                LoadingStates.showError('ticker-view', _netErrMsg, _hint404 ? null : function () { void fetchTicker(ticker); }, _hint404 ? null : _netErrType);
            }
            if (/^HTTP\s+404\b/.test(_netErrType)) {
                _ts.not_found = true;
                _ts.suggestions = _ftSuggest.length;
                if (ticker === activeTicker)
                    _olRenderTickerSuggestions(_ftSuggest);
            }
            if (ticker === activeTicker)
                _showClassifiedErrorToast(_netErrType, _netErrMsg);
            // #82 Fix B (recover-render): schedule ONE deferred retry so the hero
            // re-hydrates once the origin recovers, instead of a terminal dashes
            // state until the 15-min countdown / manual Retry. Only for TRANSIENT
            // failures (5xx / api_unavailable / timeout); AbortError already returned
            // above. Once per ticker per page-life, and only while nothing has
            // rendered and the user is still on this ticker — a genuine sustained
            // outage self-limits to a single extra request (never a storm). The
            // in-flight map + result cache keep the retry from re-fanning-out.
            const _transient = _netErrType === 'timeout'
                || _netErrType === 'api_unavailable'
                || /^HTTP\s+5\d\d/.test(_netErrType);
            if (_transient && !nocache && !_tickerRecoverRetried[ticker]) {
                _tickerRecoverRetried[ticker] = true;
                _tickerResultCacheClear(ticker);
                setTimeout(function () {
                    if (ticker === activeTicker
                        && !dataCache[ticker]) {
                        void fetchTicker(ticker);
                    }
                }, 2500);
            }
        }
    }
    finally {
        _tsSend();
        // P1-6: a background fetch for another ticker must not tear down the
        // loading state of the one on screen (it would reveal a half-loaded page).
        if (ticker === activeTicker) {
            setLoading(false);
            _hideTickerSkeleton();
            if (typeof LoadingStates !== 'undefined') {
                LoadingStates.hideSkeleton('metrics-rows');
                LoadingStates.hideSkeleton('chart-panel');
            }
        }
        _setPulseRefreshing(false);
        // F-12 (external code review 2026-05-21 MED): tear down the welcome-
        // flow loading bridge from the finally block so EVERY exit from
        // _fetchTickerImpl (success, 402, 401, 5xx, network error) dismisses
        // it. Previously only the 402 branch dismissed (lines ~347-352), so
        // 401/5xx/network paths left the full-screen "Preparing your research
        // view…" bridge up until the 6-second safety-net timer at
        // app-init.ts:_dismissLoadingBridge auto-dismiss. The 402-branch
        // dismiss is kept for early-eject (it fires ~0ms before finally on
        // 402, net behavior identical, but defensive against future refactors
        // moving the early-return). Both calls are idempotent — once-dismissed
        // bridge is a no-op.
        try {
            const w = window;
            if (typeof w._dismissLoadingBridge === 'function') {
                w._dismissLoadingBridge();
            }
        }
        catch (_e) { /* defensive */ }
    }
}
// ── Active-ticker fetch: only on a view that reads it (2026-10-17) ──
// Browser QA (signed-in, /?view=learn): page load fired GET /api/data for the
// last-viewed ticker, then the `&nocache=1` heal above 12s later -- on a view
// that shows no quote. /api/data can spend vendor quota (api/fmp_quota.py), so
// the active ticker's fetch waits for a view that needs it. What the boot
// payload fed on a NON-ticker view, mapped from the tree:
//   renderData           -- returns unless currentView === 'ticker' (ticker-renderer.ts)
//   renderTabs           -- #ticker-tabs exists in no template; returns at once
//   portfolio / news     -- fetch their own rows (portfolio.ts, news.ts bulk news)
//   pulse "YOURS" chip   -- cache-only by design; honestly absent until quotes load
//   Markets briefing     -- pools dataCache news; one arbitrary ticker drops out
//   glossary worked example + "updated" stamp -- degrade to '' / a dash with no data
//   ticker_search telemetry -- a boot fetch logged a search nobody typed
// None needs it. Callers (app-init.ts): checkServer -> setConnectionStatus and
// init() at boot (_olFetchActiveTickerForView), setView -> _navPush on every
// transition (_olOnViewEnteredForActiveTicker), and the 15-min _countdownTick
// (_olDeferRefreshOffTickerView). A boot ON the ticker view (or a ?symbol=
// deep link, resolved before checkServer) still fetches at boot.
var _OL_TICKER_DATA_VIEWS = { ticker: 1, fundamentals: 1 };
var _olActiveTickerFetchDeferred = false;
function _olViewReadsActiveTicker(view) {
    return Object.prototype.hasOwnProperty.call(_OL_TICKER_DATA_VIEWS, String(view || ''));
}
// Boot: fetch the active ticker when the current view reads it, else defer.
function _olFetchActiveTickerForView() {
    if (!activeTicker)
        return;
    if (_olViewReadsActiveTicker(currentView)) {
        _olActiveTickerFetchDeferred = false;
        void fetchTicker(activeTicker);
    }
    else {
        _olActiveTickerFetchDeferred = true;
    }
}
// Every view transition. Fires the deferred fetch the first time a ticker-data
// view is entered; switchTicker / addTickerBySymbol set activeTicker BEFORE
// their setView('ticker'), so this fetches the right symbol, and their own
// fetchTicker(t) right after joins it in flight. The flag is only ever set at
// the END of boot, so the boot setView(_detectedView) cannot fetch the stale
// default before a deep link moves activeTicker (the X1/P2 "SPOT leak").
function _olOnViewEnteredForActiveTicker(view) {
    if (!_olActiveTickerFetchDeferred || !_olViewReadsActiveTicker(view))
        return;
    if (!activeTicker || !isLive)
        return;
    _olActiveTickerFetchDeferred = false;
    void fetchTicker(activeTicker);
    // A deferred 15-min refresh is served by this fetch: restart the clock.
    if (typeof resetCountdown === 'function')
        resetCountdown();
}
// CHAOS 2026-10-17 (independent review): one surface outside the ticker-data
// views reads the active ticker's payload -- Quick Compare (Q / the command
// palette, any view) prefills its first column with activeTicker and never
// fetches that column itself (compare-modal.ts fetches only columns 2 and 3).
// After a deferred boot that column stayed blank. It claims the deferred fetch
// here; null when nothing was deferred (the payload is already loaded or in
// flight on the usual path).
function _olClaimDeferredActiveTickerFetch() {
    if (!_olActiveTickerFetchDeferred || !activeTicker || !isLive)
        return null;
    _olActiveTickerFetchDeferred = false;
    const p = fetchTicker(activeTicker);
    if (typeof resetCountdown === 'function')
        resetCountdown();
    return p;
}
// The 15-min tick's refresh is refreshCurrent -> a FORCED `&nocache=1` refetch
// (a live vendor fetch for a signed-in viewer). Off a ticker-data view nothing
// shows it: defer it like the boot fetch. True = deferred, skip the refresh.
function _olDeferRefreshOffTickerView() {
    if (_olViewReadsActiveTicker(currentView))
        return false;
    _olActiveTickerFetchDeferred = true;
    return true;
}
let _refreshDebounce = 0;
async function refreshCurrent() {
    if (!isLive) {
        return;
    }
    const _rfNow = Date.now();
    if (_rfNow - _refreshDebounce < 1000)
        return;
    _refreshDebounce = _rfNow;
    const btn = document.getElementById('refresh-btn');
    _setBtnLoading(btn, true);
    delete dataCache[activeTicker];
    const renderNewsViewMaybe = window.renderNewsView;
    if (typeof renderNewsViewMaybe !== 'undefined' && renderNewsViewMaybe._fetched) {
        renderNewsViewMaybe._fetched.delete(activeTicker);
    }
    try {
        await fetchTicker(activeTicker, true);
    }
    finally {
        _setBtnLoading(btn, false);
    }
    resetCountdown();
}
const _olCBApi = {
    reset: function (key) {
        _cbClear(key);
        _cbEmitEvent(key, 'closed', 0);
    },
    resetAll: function () {
        const keys = Object.keys(_cbBreakers);
        for (let i = 0; i < keys.length; i++) {
            _olCBApi.reset(keys[i]);
        }
    },
};
window.OLCircuitBreaker = _olCBApi;
(function () {
    const _CB_BANNER_ID = 'ol-cb-degraded-banner';
    const _CB_BANNER_SHOW_DELAY_MS = 5000;
    const _cbBannerTimers = {};
    const _cbBannerShowTimers = {};
    function _cbGetBanner() {
        return document.getElementById(_CB_BANNER_ID);
    }
    function _cbRemoveBanner(key) {
        if (_cbBannerShowTimers[key]) {
            clearTimeout(_cbBannerShowTimers[key]);
            delete _cbBannerShowTimers[key];
        }
        if (_cbBannerTimers[key]) {
            clearInterval(_cbBannerTimers[key]);
            delete _cbBannerTimers[key];
        }
        const anyOpen = Object.keys(_cbBreakers).some(function (k) {
            const b = _cbBreakers[k];
            return !!(b && (b.state === 'open' || b.state === 'half-open'));
        });
        if (!anyOpen) {
            const banner = _cbGetBanner();
            if (banner && banner.parentNode) {
                banner.parentNode.removeChild(banner);
            }
        }
    }
    function _cbUpdateCountdown(_key, nextProbeAt) {
        const banner = _cbGetBanner();
        if (!banner)
            return;
        const countEl = banner.querySelector('.ol-cb-banner-countdown');
        if (!countEl)
            return;
        const sec = Math.max(0, Math.ceil((nextProbeAt - Date.now()) / 1000));
        countEl.textContent = sec > 0 ? sec + 's' : 'now';
    }
    function _cbShowBanner(key, nextProbeAt) {
        const existing = _cbGetBanner();
        if (existing) {
            _cbUpdateCountdown(key, nextProbeAt);
            return;
        }
        const banner = document.createElement('div');
        banner.id = _CB_BANNER_ID;
        banner.className = 'ol-cb-degraded-banner';
        banner.setAttribute('role', 'status');
        banner.setAttribute('aria-live', 'polite');
        banner.setAttribute('data-cb-key', key);
        const msg = document.createElement('span');
        msg.className = 'ol-cb-banner-msg';
        const countSpan = document.createElement('span');
        countSpan.className = 'ol-cb-banner-countdown';
        const sec = Math.max(0, Math.ceil((nextProbeAt - Date.now()) / 1000));
        countSpan.textContent = sec > 0 ? sec + 's' : 'now';
        msg.appendChild(document.createTextNode('Data feed degraded — retrying in '));
        msg.appendChild(countSpan);
        const retryBtn = document.createElement('button');
        retryBtn.className = 'ol-cb-banner-retry';
        retryBtn.setAttribute('data-cb-key', key);
        retryBtn.setAttribute('data-action', 'cb-retry-now');
        retryBtn.textContent = 'Retry now';
        retryBtn.addEventListener('click', function () {
            const k = retryBtn.getAttribute('data-cb-key') || key;
            const w = window;
            if (w.OLCircuitBreaker)
                w.OLCircuitBreaker.reset(k);
        });
        const closeBtn = document.createElement('button');
        closeBtn.className = 'ol-cb-banner-close';
        closeBtn.setAttribute('aria-label', 'Dismiss');
        closeBtn.setAttribute('data-action', 'cb-dismiss-banner');
        closeBtn.textContent = '×';
        closeBtn.addEventListener('click', function () {
            _cbRemoveBanner(key);
        });
        banner.appendChild(msg);
        banner.appendChild(retryBtn);
        banner.appendChild(closeBtn);
        let inserted = false;
        const pulseBar = document.getElementById('market-pulse-bar');
        if (pulseBar && pulseBar.parentNode) {
            pulseBar.parentNode.insertBefore(banner, pulseBar.nextSibling);
            inserted = true;
        }
        if (!inserted) {
            const mainContent = document.getElementById('main-content');
            if (mainContent) {
                mainContent.insertBefore(banner, mainContent.firstChild);
                inserted = true;
            }
        }
        if (!inserted && document.body) {
            document.body.insertBefore(banner, document.body.firstChild);
        }
        if (_cbBannerTimers[key]) {
            clearInterval(_cbBannerTimers[key]);
        }
        _cbBannerTimers[key] = setInterval(function () {
            const b = _cbGetBanner();
            if (!b) {
                clearInterval(_cbBannerTimers[key]);
                delete _cbBannerTimers[key];
                return;
            }
            _cbUpdateCountdown(key, nextProbeAt);
        }, 1000);
    }
    window.addEventListener('ol-circuit-breaker-state', function (evt) {
        const ce = evt;
        if (!ce || !ce.detail)
            return;
        const key = ce.detail.key;
        const state = ce.detail.state;
        const nextProbeAt = ce.detail.nextProbeAt || 0;
        if (state === 'closed') {
            _cbRemoveBanner(key);
            return;
        }
        if (state === 'open') {
            if (_cbBannerShowTimers[key]) {
                clearTimeout(_cbBannerShowTimers[key]);
            }
            _cbBannerShowTimers[key] = setTimeout(function () {
                delete _cbBannerShowTimers[key];
                const b = _cbBreakers[key];
                if (b && b.state === 'open') {
                    _cbShowBanner(key, nextProbeAt);
                }
            }, _CB_BANNER_SHOW_DELAY_MS);
        }
    });
})();
void olFetch;
void fetchTicker;
void refreshCurrent;
//# sourceMappingURL=data-pipeline.js.map
;
// ═══ formatting.js ═══
;"use strict";
// Oxford Ledge — Formatting Utilities (extracted from dashboard.html)
//
// TS Migration Phase 2 PR 22 (2026-05-04): renamed .js → .ts.
// Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
//
// This file is now the SOURCE OF TRUTH; the sibling formatting.js
// is the build artifact produced by `npx tsc -p tsconfig.build.json`
// (gitignored).
//
// Foundational helper module — escHtml + fmt* + emptyState + CSV/
// XLSX export are consumed by 30+ other modules. Type-strict
// migration with cross-chunk declarations in globals.d.ts.
// OWNER 2026-10-12 (R3 "Cut back display now"): for an anonymous visitor the
// server withholds the vendor price from /api/data and flags the payload
// (`_vendor_prices_withheld` + `_price_notice`). The ticker hero says so in
// the price slot -- not a dash, not "Price unavailable" (the price exists; it
// is not shown publicly). The SSR hero (ssr_anon_ticker_hero.py) paints the
// same note first. Lives here, not in ticker-renderer.ts, which sits at its
// file-size budget; ticker-renderer calls it from the hero render.
function olPriceWithheldHero(priceEl, chgEl, d) {
    if (priceEl) {
        priceEl.style.minWidth = '';
        priceEl.textContent = '';
        const note = document.createElement('span');
        note.className = 'price-withheld-note';
        note.textContent = String((d && d._price_notice) || 'Market prices are shown to signed-in users.');
        priceEl.appendChild(note);
    }
    if (chgEl) {
        chgEl.textContent = '';
        chgEl.style.minWidth = '';
        chgEl.className = 'change-hero neu';
    }
}
function fmt(n, decimals = 2) {
    if (n == null || isNaN(Number(n)))
        return '—';
    return Number(n).toFixed(decimals);
}
/* Canonical percent formatter (2026-09-05 DESIGN audit P1-6: replaced 4 of
 * the 5 independent per-file implementations; the 5th was a weight formatter
 * in disguise and was renamed to its real contract). em-dash for null/NaN/
 * non-finite; opts.sign prints the explicit + convention for change values;
 * opts.label prefixes ('YTD +1.23%') and survives the dash case. */
function fmtPct(v, decimals = 2, opts) {
    const label = opts && opts.label ? opts.label + ' ' : '';
    if (v == null || !isFinite(v))
        return label + '—';
    const sign = opts && opts.sign && v >= 0 ? '+' : '';
    return label + sign + v.toFixed(decimals) + '%';
}
// Input is $ MILLIONS. The sign leads the currency symbol: "-$42.39B", never
// "$-42.39B" (QA 2026-10-04: the AAPL Company card rendered "Net Cash
// $-42.39B" through this formatter, and so did every other negative figure
// that reached it -- the root, so it is fixed here rather than per caller).
function fmtM(n) {
    if (n == null || isNaN(Number(n)))
        return '—';
    const sign = Number(n) < 0 ? '-' : '';
    const abs = Math.abs(Number(n));
    if (abs >= 1000)
        return sign + '$' + (abs / 1000).toFixed(2) + 'B';
    return sign + '$' + abs.toFixed(0) + 'M';
}
// Signed dollars per share (EPS, an EPS estimate): "-$1.23", never "$-1.23".
function fmtUsd(n, decimals = 2) {
    if (n == null || !isFinite(Number(n)))
        return '—';
    return (Number(n) < 0 ? '-$' : '$') + Math.abs(Number(n)).toFixed(decimals);
}
// The Company card's cash-vs-debt stat (QA 2026-10-04). The label follows the
// sign -- "Net Debt $42.39B" when debt exceeds cash, a positive magnitude
// rather than a negative "net cash" -- and the stat is withheld, with the
// backend's reason, where the payload marks it not meaningful (banks,
// insurers, BDCs: f.netCashNote). f.netCash is the backend's signed figure;
// absent it, cash - debt is derived only when BOTH are known: a null balance
// sheet is never a $0 fact (EXT-AUDIT T1 #52).
function fmtNetCashStat(f) {
    const g = f || {};
    const cash = g.cash;
    const debt = g.totalDebt;
    const note = g.netCashNote ? String(g.netCashNote) : '';
    let netCash = null;
    if (typeof g.netCash === 'number')
        netCash = g.netCash;
    else if (!note && cash != null && debt != null)
        netCash = cash - debt;
    if (netCash == null)
        return { label: 'Net Cash', text: '—', cls: 'color-text-secondary', title: note };
    if (netCash < 0)
        return { label: 'Net Debt', text: fmtM(-netCash), cls: 'color-negative', title: 'Total debt minus cash' };
    return { label: 'Net Cash', text: fmtM(netCash), cls: netCash > 0 ? 'color-positive' : 'color-text-secondary', title: 'Cash minus total debt' };
}
function finPanelTitle(f) {
    const p = (f && f.period);
    // No stamped period (a failed read, a tier the overlay did not reach):
    // claim none, rather than the "TTM" the annual block used to sit under.
    return p && p.label ? 'Financials (' + p.label + ')' : 'Financials';
}
// A row's own stamp, shown only when it differs from the panel's basis (an
// item that fell back to the fiscal year, a balance-sheet "as of" date).
const _FIN_ROW_KEY = {
    'Revenue': 'revenue', 'EBITDA': 'ebitda', 'Net Income': 'netIncome', 'EPS': 'eps',
    'Free Cash Flow': 'freeCashFlow', 'Cash & Equivalents': 'cash', 'Total Debt': 'totalDebt',
};
function finRowStamp(f, glossKey) {
    const p = (f && f.period);
    const key = _FIN_ROW_KEY[glossKey];
    const stamp = p && p.items && key ? p.items[key] : '';
    if (!stamp || (p && p.basis === 'ttm' && stamp.indexOf('TTM') === 0) || (p && stamp === p.label))
        return '';
    return ' <span class="fin-period-stamp">(' + escHtml(stamp) + ')</span>';
}
// Valuation row labels name the period of the earnings they divide by
// (m.peBasis "FY2025" when no trailing four quarters exist; the forward
// consensus year for P/E (Fwd)). The row KEY stays 'P/E (TTM)' for the
// median / insight / glossary maps -- only the displayed text changes.
function olMetricLabel(label, m) {
    const g = m || {};
    if (label === 'P/E (TTM)' && g.peBasis && g.peBasis !== 'TTM')
        return 'P/E (' + escHtml(String(g.peBasis)) + ')';
    if (label === 'P/E (Fwd)' && g.forwardPeBasis)
        return 'P/E (Fwd, ' + escHtml(String(g.forwardPeBasis)) + ')';
    return label;
}
// Normalize raw dollar values to millions for fmtM. Values > 10B raw are assumed full-dollar.
function toM(val) {
    if (val == null || isNaN(Number(val)))
        return null;
    if (Math.abs(val) > 1e7)
        return val / 1e6; // raw dollars → millions
    return val; // already in millions
}
function sanityCheckM(val, label) {
    if (val != null && Math.abs(val) > 10000000) {
        /* @__PURE__ */ _olDebugWarn('Suspicious financial value for ' + label + ': ' + val + ' - possible unit error');
        return null;
    }
    return val ?? null;
}
function fmtVol(n) {
    if (!n)
        return '—';
    if (n >= 1e6)
        return (n / 1e6).toFixed(2) + 'M';
    if (n >= 1e3)
        return (n / 1e3).toFixed(0) + 'K';
    return n.toString();
}
function fmtMktCap(n) {
    if (n == null)
        return '—';
    const abs = Math.abs(n);
    const sign = n < 0 ? '-' : '';
    if (abs >= 1000)
        return sign + '$' + (abs / 1000).toFixed(2) + 'T';
    if (abs >= 1)
        return sign + '$' + abs.toFixed(1) + 'B';
    return sign + '$' + (abs * 1000).toFixed(0) + 'M';
}
// DS-P2a (2026-07-05 audit [TRUST]): THE canonical K/M/B/T abbreviator. The
// audit found 126 hand-rolled threshold sites in 31 files with DIFFERENT
// rounding — the same dollar figure rendered differently per panel. This
// matches the BACKEND formatter (services/ai_proxy_context._format_large_number:
// $1.7B / $480.4M / $500K — 1 decimal for T/B/M, 0 for K, em-dash null), so
// panels and AI answers agree on the same number. New hand-rolls fail the
// abbrev ratchet (test_fmt_abbrev_ratchet in the css-drift contract file);
// burn-down = replace the local site with fmtAbbrev, delete its baseline line.
function fmtAbbrev(n, opts) {
    if (n == null || !isFinite(Number(n)))
        return '—';
    const dollars = !opts || opts.dollars !== false;
    const v = Number(n);
    const abs = Math.abs(v);
    const sign = v < 0 ? '-' : '';
    const cur = dollars ? '$' : '';
    if (abs >= 1e12)
        return sign + cur + (abs / 1e12).toFixed(1) + 'T';
    if (abs >= 1e9)
        return sign + cur + (abs / 1e9).toFixed(1) + 'B';
    if (abs >= 1e6)
        return sign + cur + (abs / 1e6).toFixed(1) + 'M';
    if (abs >= 1e3)
        return sign + cur + (abs / 1e3).toFixed(0) + 'K';
    return sign + cur + abs.toFixed(dollars ? 2 : 0);
}
// DS-P2a: THE canonical up/down class. The audit found >=8 vocabularies
// (pos/neg, positive/negative, cv-color-*, mb-up/down, port-pnl-pos...) with
// invert-aware ternaries re-typed 4x in one file. 'pos' is the dominant
// vocabulary (58 sites). `invert` covers credit semantics (spread WIDENING is
// bad -> a positive delta renders neg). Migrating the other vocabularies onto
// this is the DS-P2a burn-down; new code uses pctClass from day one.
function pctClass(v, opts) {
    if (v == null || !isFinite(Number(v)) || Number(v) === 0)
        return 'neu';
    const up = Number(v) > 0;
    const invert = !!(opts && opts.invert);
    return (up !== invert) ? 'pos' : 'neg';
}
function escHtml(s) {
    if (s == null)
        return '';
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
// DS-P1 (2026-07-05 audit): the canonical escaper escapes BOTH quote chars,
// so it is attribute-safe for quoted attributes — escAttr makes that intent
// explicit at attribute call sites. The audit found 30+ LOCAL escHtml
// re-implementations (some quote-skipping = attr-context XSS risk); the
// escaper ratchet (test_escaper_ratchet_contract.py) freezes that census —
// new escapers belong HERE, not in feature files.
function escAttr(s) {
    return escHtml(s);
}
// Wave-3 WP-G (2026-09-26 external review, P2 news links): the ONE scheme
// allowlist for third-party article URLs bound to an href / data-url /
// window.open. escHtml stops attribute breakout but not a `javascript:` or
// `data:` URL, which is a valid attribute value. Only absolute http(s) passes;
// everything else (javascript:, data:, vbscript:, relative, protocol-relative)
// becomes '#'. Same regex as the ask-ai.ts citation sink. Still escape the
// result at the sink: this checks the scheme, not the markup.
function safeHttpUrl(u) {
    const s = u == null ? '' : String(u).trim();
    return /^https?:\/\//i.test(s) ? s : '#';
}
// DS-P2b (2026-07-05): emptyState() RETIRED — it was the pre-OLEmpty factory
// (emitted the competing .ol-empty-state markup) and the audit flagged two
// coexisting "canonical" empty-state factories. All 5 callers migrated to
// OLEmpty.render({icon,title,body,cta}). NOTE the escaping difference: this
// fn escaped `desc`; OLEmpty.body does NOT (supports inline markup) — callers
// passing user strings must escAttr/escHtml them at the call site. Deleting
// the fn makes any future caller a compile error (tsc), which is the ratchet.
function newsRecencyClass(dateStr) {
    if (!dateStr)
        return '';
    try {
        const d = new Date(dateStr.includes('T') ? dateStr : dateStr + 'T00:00:00');
        const diff = Date.now() - d.getTime();
        if (diff < 0 || isNaN(diff))
            return '';
        if (diff < 1800000)
            return 'today fresh'; // <30min: glowing new badge
        if (diff < 3600000)
            return 'today recent'; // <1h: bold + accent timestamp
        if (diff < 86400000)
            return 'today'; // <24h: accent left border
        if (diff < 604800000)
            return 'this-week'; // <7d: subtle left border
        return 'stale'; // >7d: faded
    }
    catch (_e) { }
    return '';
}
// #93 (A16 Phase 3): the canonical relative-time helper for the whole app.
// Accepts a date STRING or an epoch-MS number, plus an optional { uncapped } to
// keep emitting "Nd ago" past 7 days (surfaces like notifications / recents that
// legitimately show older items) instead of the default null (which lets callers
// fall back to an absolute date). The string + default-cap behaviour is unchanged
// byte-for-byte, so existing string callers are unaffected.
function timeAgo(input, opts) {
    if (input === null || input === undefined || input === '')
        return null;
    try {
        let d;
        if (typeof input === 'number') {
            d = new Date(input);
        }
        else {
            const s = String(input);
            d = new Date(s.replace(' ', 'T') + (s.includes('T') ? '' : ':00Z'));
        }
        const diff = Date.now() - d.getTime();
        if (diff < 0 || isNaN(diff))
            return null;
        if (diff < 60000)
            return 'just now';
        const mins = Math.floor(diff / 60000);
        if (mins < 60)
            return `${mins}m ago`;
        const hrs = Math.floor(diff / 3600000);
        if (hrs < 24)
            return `${hrs}h ago`;
        const days = Math.floor(diff / 86400000);
        if (days === 1)
            return '1d ago';
        if (days < 7)
            return `${days}d ago`;
        return (opts && opts.uncapped) ? `${days}d ago` : null; // capped: fall back to absolute date
    }
    catch {
        return null;
    }
}
function fmtVal13f(v) {
    if (!v)
        return '—';
    if (v >= 1e9)
        return '$' + (v / 1e9).toFixed(2) + 'B';
    if (v >= 1e6)
        return '$' + (v / 1e6).toFixed(1) + 'M';
    if (v >= 1e3)
        return '$' + (v / 1e3).toFixed(0) + 'K';
    return '$' + v.toLocaleString();
}
/**
 * Safe numeric formatting — guards against null, undefined, NaN.
 * Returns the em-dash for non-numeric values instead of 'undefined' or 'NaN'.
 */
function fmtSafe(n, decimals, prefix, suffix) {
    if (n == null || n === '' || (typeof n === 'number' && isNaN(n)))
        return '—';
    const num = Number(n);
    if (isNaN(num))
        return '—';
    return (prefix || '') + num.toFixed(decimals != null ? decimals : 2) + (suffix || '');
}
// ── XLSX EXPORT UTILITY ──
function exportToXlsx(data, filename, sheetName) {
    if (typeof XLSX === 'undefined') {
        if (typeof showToast === 'function')
            showToast('XLSX library not loaded, falling back to CSV', 'warning');
        return false;
    }
    const wb = XLSX.utils.book_new();
    let ws;
    if (Array.isArray(data) && data.length > 0 && Array.isArray(data[0])) {
        ws = XLSX.utils.aoa_to_sheet(data);
    }
    else {
        ws = XLSX.utils.json_to_sheet(data);
    }
    XLSX.utils.book_append_sheet(wb, ws, sheetName || 'Sheet1');
    XLSX.writeFile(wb, filename);
    if (typeof trackAchievement === 'function')
        trackAchievement('export_xlsx');
    return true;
}
function _preferXlsx() {
    try {
        return OLStorage.getString('ol_export_format', null) === 'xlsx' && typeof XLSX !== 'undefined';
    }
    catch (_e) {
        return false;
    }
}
// ── CSV DOWNLOAD UTILITY ──
function _downloadCSV(filename, headers, rows) {
    // Check if user prefers XLSX export
    if (_preferXlsx()) {
        const xlsxName = filename.replace(/\.csv$/i, '.xlsx');
        const aoa = [headers].concat(rows.map(function (r) { return r || []; }));
        if (exportToXlsx(aoa, xlsxName, 'Data'))
            return;
    }
    const escapeCsv = (v) => {
        let s = String(v == null ? '' : v);
        // CSV formula-injection defense (SEC-5, 2026-06-29): a cell whose first char
        // is = + - @ (or a leading tab/CR) is executed as a formula by Excel/Sheets
        // when the file is opened. Prefix with a single quote so the cell is treated
        // as literal text. Applies to every FE CSV export routed through _downloadCSV.
        if (/^[=+\-@\t\r]/.test(s))
            s = "'" + s;
        s = s.replace(/"/g, '""');
        return /[,"\n\r]/.test(s) ? '"' + s + '"' : s;
    };
    let csv = headers.map(escapeCsv).join(',') + '\n';
    rows.forEach(row => {
        if (!row || !row.length) {
            csv += '\n';
            return;
        }
        csv += row.map(escapeCsv).join(',') + '\n';
    });
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
    // Achievement: CSV export
    if (typeof trackAchievement === 'function')
        trackAchievement('export_csv');
}
// Event delegation for emptyState CTA buttons — safe dispatch (no eval/new Function)
document.addEventListener('click', function (e) {
    const target = e.target;
    if (!(target instanceof Element))
        return;
    const btn = target.closest('[data-empty-action]');
    if (!btn)
        return;
    const action = btn.dataset.emptyAction;
    if (action) {
        const fn = window[action];
        if (typeof fn === 'function') {
            try {
                fn();
            }
            catch (err) {
                console.warn('emptyState action failed:', err);
            }
        }
    }
});
// Suppress "declared but never read" for top-level surfaces.
void fmt;
void fmtM;
// OWNER ruling 2026-10-26: FRED's API notice wherever a FRED-sourced figure is
// rendered, and only there. The server's copy is services/fred_notice.py
// FRED_API_NOTICE; this is the ONE client copy, for surfaces whose payload
// carries no notice text. Pinned equal by tests/test_fred_notice_everywhere_contract.py.
const OL_FRED_API_NOTICE = 'This product uses the FRED® API but is not endorsed or certified by the Federal Reserve Bank of St. Louis.';
// A provenance label the backend writes for a FRED read: "fred" (/api/fred rows,
// /api/yield-curve-history), "FRED (DGS)" / "FRED (VIXCLS)" (/api/indicators items),
// "fred_calendar" (macro_events). Every one starts with "fred"; no other source does.
function olIsFredSource(src) {
    return typeof src === 'string' && /^\s*fred/i.test(src);
}
// A row / indicator item that shows a FRED figure: stamped `fred_notice` by the
// server or labelled with a FRED source, AND carrying a value (a failed read shows
// nothing of FRED's). Reads `price` (indicator items) or `value` (/api/fred rows).
// `historySource` (OWNER T2 2026-10-27): a Rates item whose movement fields and
// sparkline came from FRED's DGS rows beside a Treasury.gov price.
function olIsFredFigure(it) {
    if (!it || typeof it !== 'object')
        return false;
    const r = it;
    if (!(r.fred_notice || olIsFredSource(r.source) || olIsFredSource(r._source) || olIsFredSource(r.historySource)))
        return false;
    const v = ('price' in r) ? r.price : (('value' in r) ? r.value : true);
    return v != null;
}
// The notice as markup, or '' when nothing FRED-sourced is shown. `tag` lets an
// inline strip use a <span>; 'mark' is the compact form for a one-line nowrap strip
// (the market pulse; it borrows the chip label's class -- .ol-source-note's
// margin-top dropped it 6px off the chip's baseline): a visible FRED(R) mark whose title holds the full sentence
// (CHAOS 2026-10-26 F5; COUNSEL: FRED's notice is product-level, not per-figure).
function olFredNoticeHtml(show, tag) {
    if (!show)
        return '';
    if (tag === 'mark')
        return '<span class="pulse-item-name" data-fred-notice="1" title="' + escAttr(OL_FRED_API_NOTICE) + '">FRED®</span>';
    const t = tag === 'span' ? 'span' : 'p';
    return '<' + t + ' class="ol-source-note" data-fred-notice="1">' + escHtml(OL_FRED_API_NOTICE) + '</' + t + '>';
}
// DOM twin for surfaces that must not rebuild via innerHTML: keeps ONE notice
// as the element right after `anchor` when `show`, and removes it otherwise.
function olPlaceFredNotice(anchor, show) {
    if (!anchor || !anchor.parentNode)
        return;
    const next = anchor.nextElementSibling;
    const have = !!(next && next.getAttribute('data-fred-notice') === '1');
    if (show && !have) {
        const p = document.createElement('p');
        p.className = 'ol-source-note';
        p.setAttribute('data-fred-notice', '1');
        p.textContent = OL_FRED_API_NOTICE;
        anchor.parentNode.insertBefore(p, anchor.nextSibling);
    }
    else if (!show && have && next) {
        next.remove();
    }
}
void fmtUsd;
void fmtNetCashStat;
void finPanelTitle;
void finRowStamp;
void olMetricLabel;
void toM;
void sanityCheckM;
void fmtVol;
void fmtMktCap;
void escHtml;
void olIsFredSource;
void olIsFredFigure;
void olFredNoticeHtml;
void olPlaceFredNotice;
void escAttr;
void safeHttpUrl;
void fmtAbbrev;
void pctClass;
void newsRecencyClass;
void timeAgo;
void fmtVal13f;
void fmtSafe;
void exportToXlsx;
void _downloadCSV;
//# sourceMappingURL=formatting.js.map
;
// ═══ ws-client.js ═══
;"use strict";
// ── ws-client.js ─────────────────────────────────────────────────────────
//
// TS Migration Phase 2 PR 30 (2026-05-04): renamed .js → .ts.
// Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
//
// This file is the SOURCE OF TRUTH; ws-client.js is the build artifact
// produced by `npx tsc -p tsconfig.build.json` (gitignored).
//
// WebSocket real-time client: price updates, market pulse, phase2
// signals, exponential-backoff reconnection with jitter, pulse polling
// fallback. Top-level fns + state stay global so app.js + ticker
// renderer can read _wsConnected etc.
const WS_URL = SERVER.replace(/^http/, 'ws').replace(/:\d+/, ':' + (parseInt(SERVER.match(/:(\d+)/)?.[1] || '8765') + 1));
let _ws = null;
let _wsConnected = false;
let _wsReconnectDelay = 1000;
let _wsReconnectTimer = null;
let _wsReconnectAttempts = 0;
const _WS_MAX_RECONNECT_DELAY = 30000;
const _WS_MAX_RECONNECT_ATTEMPTS = 5;
let _wsPulsePollingFallback = false;
// OWNER 2026-09-28: _wsUpdateStatus (the bottom bar's FEED segment,
// #sb-ws-seg / #sb-ws-status) is REMOVED with the bar. It un-hid itself into
// a permanent "POLL" in prod (SERVER is empty there), which told a reader
// nothing. Connection state is still tracked in _wsConnected /
// _wsPulsePollingFallback for the code that reads it.
function _wsConnect() {
    if (_ws && (_ws.readyState === WebSocket.CONNECTING || _ws.readyState === WebSocket.OPEN))
        return;
    try {
        _ws = new WebSocket(WS_URL);
    }
    catch (_e) {
        _wsOnClose();
        return;
    }
    _ws.onopen = function () {
        _wsConnected = true;
        _wsReconnectDelay = 1000;
        _wsReconnectAttempts = 0;
        _wsPulsePollingFallback = false;
        /* @__PURE__ */ _olDebug('[WS] Connected to', WS_URL);
    };
    _ws.onmessage = function (evt) {
        try {
            const msg = JSON.parse(evt.data);
            _wsHandleMessage(msg);
        }
        catch (e) {
            /* @__PURE__ */ _olDebugWarn('[WS] Bad message:', e);
        }
    };
    _ws.onclose = function () {
        _wsOnClose();
    };
    _ws.onerror = function () {
        // onclose will fire after onerror
    };
}
function _wsOnClose() {
    _wsConnected = false;
    _wsPulsePollingFallback = true;
    void _wsConnected;
    void _wsPulsePollingFallback;
    _ws = null;
    if (_wsReconnectTimer)
        clearTimeout(_wsReconnectTimer);
    _wsReconnectTimer = null;
    _wsReconnectAttempts++;
    if (_wsReconnectAttempts > _WS_MAX_RECONNECT_ATTEMPTS) {
        /* @__PURE__ */ _olDebugWarn('[WS] Max reconnect attempts reached. Connection lost.');
        return;
    }
    _wsReconnectDelay = Math.min(_wsReconnectDelay * 1.5, _WS_MAX_RECONNECT_DELAY);
    const _wsJitteredDelay = Math.round(_wsReconnectDelay * (0.75 + Math.random() * 0.5));
    _wsReconnectTimer = setTimeout(_wsConnect, _wsJitteredDelay);
    /* @__PURE__ */ _olDebug('[WS] Disconnected. Reconnect in', Math.round(_wsJitteredDelay / 1000), 's (attempt', _wsReconnectAttempts + '/' + _WS_MAX_RECONNECT_ATTEMPTS + ')');
}
function _wsHandleMessage(msg) {
    if (!msg || typeof msg !== 'object')
        return;
    const type = msg.type;
    if (!type)
        return;
    if (type === 'connected')
        return;
    if (type === 'pong')
        return;
    if (type === 'market-pulse') {
        if (msg.data) {
            const d = msg.data;
            indicatorsCache = d;
            const w = window;
            if (d.treasuryRate10yr != null) {
                w._treasuryRate10yr = d.treasuryRate10yr;
                // OWNER ruling 2026-10-26: its provenance rides with it ("fred" = read through FRED).
                w._treasuryRate10yrSource = d.treasuryRate10yrSource || null;
            }
            if (typeof renderMarketPulse === 'function')
                renderMarketPulse();
            if (currentView === 'macro') {
                if (w._macroPulseDebounce)
                    clearTimeout(w._macroPulseDebounce);
                w._macroPulseDebounce = setTimeout(function () {
                    if (typeof renderMacroView === 'function') {
                        try {
                            renderMacroView();
                        }
                        catch (_e) { }
                    }
                    else {
                        try {
                            _inlineRenderMacro();
                        }
                        catch (_e) { }
                    }
                }, 30000);
            }
        }
        return;
    }
    if (type === 'ticker-update') {
        const ticker = msg.ticker;
        if (!ticker || !msg.data)
            return;
        if (dataCache[ticker]) {
            const d = dataCache[ticker];
            const summary = msg.data;
            const dPrice = d.price;
            if (summary.price != null && dPrice) {
                dPrice.regularMarketPrice = summary.price;
                dPrice.regularMarketChange = summary.change;
                dPrice.regularMarketChangePercent = summary.changePercent;
                dPrice.regularMarketVolume = summary.volume;
                dPrice.current = summary.price;
                dPrice.change = summary.change;
                dPrice.changePct = summary.changePercent;
                if (summary.volume != null)
                    dPrice.volume = summary.volume;
                if (summary.dayHigh != null) {
                    dPrice.regularMarketDayHigh = summary.dayHigh;
                    dPrice.dayHigh = summary.dayHigh;
                }
                if (summary.dayLow != null) {
                    dPrice.regularMarketDayLow = summary.dayLow;
                    dPrice.dayLow = summary.dayLow;
                }
            }
            d.fetchedAt = summary.fetchedAt || msg.ts;
            if (ticker === activeTicker) {
                _wsUpdateHero(d);
            }
            _wsUpdateTabBadge(ticker, summary);
            const w = window;
            if (currentView === 'portfolio') {
                if (typeof w.renderPortfolio === 'function') {
                    try {
                        w.renderPortfolio();
                    }
                    catch (_e) { }
                }
                else if (typeof w._inlineRenderPortfolio === 'function') {
                    try {
                        w._inlineRenderPortfolio();
                    }
                    catch (_e) { }
                }
            }
            else if (currentView === 'watchlist') {
                if (typeof w.renderWatchlist === 'function') {
                    try {
                        w.renderWatchlist();
                    }
                    catch (_e) { }
                }
                else if (typeof w._inlineRenderWatchlist === 'function') {
                    try {
                        w._inlineRenderWatchlist();
                    }
                    catch (_e) { }
                }
            }
        }
        return;
    }
    if (type === 'phase2-complete') {
        const ticker = msg.ticker;
        if (!ticker)
            return;
        const w = window;
        if (typeof w.phasePollingTimers !== 'undefined' && w.phasePollingTimers && w.phasePollingTimers[ticker]) {
            const _wsPhHandle = w.phasePollingTimers[ticker];
            if (_wsPhHandle && typeof _wsPhHandle.clear === 'function') {
                _wsPhHandle.clear();
            }
            else if (typeof _wsPhHandle === 'number') {
                clearInterval(_wsPhHandle);
            }
            delete w.phasePollingTimers[ticker];
        }
        if (ticker === activeTicker && typeof w.fetchTicker === 'function') {
            // Wave 9 (2026-10-17): gate the refetch like the boot fetch
            // (data-pipeline.ts _olFetchActiveTickerForView). Off a ticker-data view
            // nothing shows the payload, and /api/data can spend vendor quota, so
            // the push only marks the fetch deferred; entering the ticker view fires
            // it (_olOnViewEnteredForActiveTicker). On the ticker view: unchanged.
            // Without the data-pipeline helper loaded, fall back to fetching.
            if (typeof _olViewReadsActiveTicker === 'function' && !_olViewReadsActiveTicker(currentView)) {
                _olActiveTickerFetchDeferred = true;
            }
            else {
                w.fetchTicker(ticker);
            }
        }
        return;
    }
    if (type === 'alert') {
        if (msg.data && typeof showToast === 'function') {
            const alertType = msg.alertType || 'info';
            const data = msg.data;
            const text = data.message || data.title || 'Alert';
            showToast(text, alertType === 'price' ? 'success' : '', 6000);
        }
        return;
    }
}
function _wsUpdateHero(d) {
    const w = window;
    const $id = w.$id;
    if (typeof $id !== 'function')
        return;
    const priceEl = $id('price-hero');
    const changeEl = $id('change-hero');
    const dPrice = d.price;
    if (!priceEl || !dPrice)
        return;
    if (!priceEl.getAttribute('aria-live'))
        priceEl.setAttribute('aria-live', 'polite');
    if (changeEl && !changeEl.getAttribute('aria-live'))
        changeEl.setAttribute('aria-live', 'polite');
    const p = dPrice.regularMarketPrice;
    if (p == null)
        return;
    const prev = priceEl.textContent;
    const newText = '$' + p.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (prev !== newText) {
        if (typeof w._animateNumber === 'function')
            w._animateNumber(priceEl, p, 200, '$', '');
    }
    if (changeEl && dPrice.regularMarketChange != null) {
        const chg = dPrice.regularMarketChange;
        const pct = dPrice.regularMarketChangePercent;
        const sign = chg >= 0 ? '+' : '';
        changeEl.textContent = sign + chg.toFixed(2) + ' (' + sign + (pct || 0).toFixed(2) + '%)';
        changeEl.style.color = chg >= 0 ? 'var(--text-positive)' : 'var(--text-negative)';
    }
    if (typeof w.updateHeroTimestamp === 'function')
        w.updateHeroTimestamp(d);
}
function _wsUpdateTabBadge(ticker, summary) {
    const btns = document.querySelectorAll('.ticker-btn');
    btns.forEach(function (btn) {
        const buttonEl = btn;
        if ((buttonEl.textContent || '').trim().startsWith(ticker)) {
            const badge = buttonEl.querySelector('.tab-chg');
            if (badge && summary.changePercent != null) {
                const pct = summary.changePercent;
                const oldPct = parseFloat((badge.textContent || '').replace(/[^0-9.\-]/g, ''));
                const sign = pct >= 0 ? '+' : '';
                badge.textContent = sign + pct.toFixed(1) + '%';
                badge.style.color = pct >= 0 ? 'var(--text-positive)' : 'var(--text-negative)';
                if (!isNaN(oldPct) && Math.abs(oldPct - Math.abs(pct)) > 0.05) {
                    const w = window;
                    if (typeof w._flashElement === 'function')
                        w._flashElement(badge, pct > oldPct ? 'up' : 'down');
                }
            }
        }
    });
}
setTimeout(function () {
    if (typeof WebSocket !== 'undefined' && SERVER) {
        _wsConnect();
    }
    else {
        _wsPulsePollingFallback = true;
        void _wsPulsePollingFallback;
    }
}, 2000);
//# sourceMappingURL=ws-client.js.map
;
// ═══ welcome-flow.js ═══
;"use strict";
/**
 * welcome-flow.js — Welcome overlay preset selection + live demo +
 * dismissal + Quick Start cards.
 *
 * TS Migration Phase 2 PR 29 (2026-05-04): renamed .js → .ts.
 * Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
 *
 * This file is the SOURCE OF TRUTH; welcome-flow.js is the build
 * artifact produced by `npx tsc -p tsconfig.build.json` (gitignored).
 *
 * Top-level functions stay global so app.js delegated-action handlers
 * (welcome-preset, dismiss-welcome, dismiss-quickstart, etc.) can
 * call them cross-chunk.
 */
function _welcomePreset(tickers) {
    if (!tickers || !Array.isArray(tickers) || tickers.length === 0) {
        if (typeof showToast === 'function')
            showToast('No tickers in this preset — try another or enter your own', 'warning', 3000);
        return;
    }
    PORTFOLIO_TICKERS.length = 0;
    tickers.forEach(function (t) { PORTFOLIO_TICKERS.push(t); });
    window._welcomeTickers = tickers;
    const presetBtns = document.querySelectorAll('#welcome-overlay .welcome-preset-btn');
    presetBtns.forEach(function (btn) {
        const html = btn;
        let btnTickers;
        try {
            btnTickers = JSON.parse(html.dataset.tickers || '[]');
        }
        catch (_e) {
            btnTickers = [];
        }
        if (JSON.stringify(btnTickers) === JSON.stringify(tickers)) {
            html.classList.add('selected');
        }
        else {
            html.classList.remove('selected');
        }
    });
    _renderWelcomeChips();
}
function _renderWelcomeChips() {
    const display = document.getElementById('welcome-selected-display');
    if (!display)
        return;
    const tickers = PORTFOLIO_TICKERS.slice();
    if (tickers.length === 0) {
        display.textContent = '';
        display.classList.remove('visible');
        return;
    }
    display.innerHTML = tickers.map(function (t) {
        return '<span class="welcome-ticker-chip" data-action="welcome-remove-ticker" data-ticker="' + escHtml(t) + '">' + escHtml(t) + ' <span class="chip-x">×</span></span>';
    }).join('');
    display.classList.add('visible');
}
function _showLoadingBridge(ticker) {
    let company = '';
    const w = window;
    if (w.companyDB && w.companyDB[ticker]) {
        company = w.companyDB[ticker].name || w.companyDB[ticker].company || '';
    }
    const el = document.createElement('div');
    el.className = 'wt-loading-bridge';
    el.id = 'wt-loading-bridge';
    el.innerHTML =
        '<div class="wt-loading-ticker">' + escHtml(ticker) + '</div>' +
            (company ? '<div class="wt-loading-company">' + escHtml(company) + '</div>' : '') +
            '<div class="wt-loading-msg">Preparing your research view…</div>' +
            '<div class="wt-loading-bar"><div class="wt-loading-bar-fill"></div></div>';
    document.body.appendChild(el);
    setTimeout(function () { el.classList.add('visible'); }, 10);
    // NL2 (2026-05-07): rotate the loading message every 2.5s so users
    // on slow networks see ongoing forward motion instead of a static
    // "Preparing…" string. Phases mirror the actual init pipeline so
    // the messaging is honest, not theatrical. Cleared by
    // `_dismissLoadingBridge` when the bridge is removed; defensive
    // null-check inside the tick lets the timer fire harmlessly if
    // the element was removed by another path.
    const _msgEl = el.querySelector('.wt-loading-msg');
    const _phases = [
        'Preparing your research view…',
        'Loading market data…',
        'Fetching company filings…',
        'Setting the page…', // #167 B2 VOICE: was 'Almost there — finalizing display…' (toasty)
    ];
    let _phaseIdx = 0;
    const _rotateTimer = setInterval(function () {
        const live = document.getElementById('wt-loading-bridge');
        if (!live || !_msgEl) {
            clearInterval(_rotateTimer);
            return;
        }
        _phaseIdx = (_phaseIdx + 1) % _phases.length;
        _msgEl.textContent = _phases[_phaseIdx];
    }, 2500);
    el._wtRotateTimer = _rotateTimer;
    // #152 boot-stall safety net (2026-06-09): the bridge is removed on init
    // SUCCESS (_dismissLoadingBridge) or init ERROR (the init .catch). If boot
    // instead HANGS — a chunk/fetch promise that neither resolves nor rejects,
    // the intermittent "stuck on Preparing… / hard-refresh-needed" P0 — the
    // bridge would otherwise persist forever with no escape (unlike
    // #loading-overlay, which has a Cancel link). After a generous threshold
    // (normal boot dismisses the bridge in 1-3s; even a slow 2G boot is well
    // under this), surface a one-tap Refresh escape hatch and fire telemetry so
    // the recurrence rate is measurable. Presence-checked (a slow-but-completed
    // boot already removed the bridge → no-op); never auto-reloads (no reload
    // loop, no slow-connection interruption).
    const _watchdog = setTimeout(function () {
        const live = document.getElementById('wt-loading-bridge');
        if (!live)
            return; // boot completed and removed the bridge — nothing to do
        const wmsg = live.querySelector('.wt-loading-msg');
        if (wmsg)
            wmsg.textContent = 'Still preparing — this is taking longer than usual.';
        if (!live.querySelector('.wt-loading-refresh')) {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'wt-loading-refresh';
            btn.textContent = 'Refresh';
            btn.addEventListener('click', function () { location.reload(); });
            live.appendChild(btn);
        }
        try {
            const _w = window;
            if (_w.Sentry && typeof _w.Sentry.captureMessage === 'function') {
                _w.Sentry.captureMessage('boot_loading_bridge_watchdog', { level: 'warning' });
            }
        }
        catch (_e) { /* telemetry is best-effort */ }
    }, 25000);
    el._wtWatchdog = _watchdog;
}
function _dismissLoadingBridge() {
    const el = document.getElementById('wt-loading-bridge');
    if (!el)
        return;
    // NL2: stop the message-rotation timer so it doesn't tick after the
    // element is removed (would race with the parentNode null-check).
    const t = el._wtRotateTimer;
    if (t)
        clearInterval(t);
    // #152: cancel the boot-stall watchdog if the bridge is dismissed normally.
    const wd = el._wtWatchdog;
    if (wd)
        clearTimeout(wd);
    el.classList.add('opacity-0');
    setTimeout(function () { if (el.parentNode)
        el.parentNode.removeChild(el); }, 400);
}
function _startGuidedTour() {
    const welcomeOverlay = document.getElementById('welcome-overlay');
    if (welcomeOverlay && welcomeOverlay.classList.contains('open'))
        return;
    const data = (dataCache[activeTicker] || {});
    const p = (data.price || data);
    const w = window;
    w._tourTickerData = {
        ticker: activeTicker || 'AAPL',
        company: data.company || data.name || activeTicker,
        price: ((p.current || p.c || 0)).toFixed(2),
        change: p.change || p.d || 0,
        changePct: ((p.changePct || p.dp || 0)).toFixed(2),
        marketCap: data.marketCap || '',
        pe: data.pe || '',
    };
    const level = OLStorage.getString('_userLevel', null) || OLStorage.getString('ol_user_level', null) || 'beginner';
    _dismissLoadingBridge();
    setTimeout(function () {
        if (typeof w.Walkthrough !== 'undefined' && w.Walkthrough) {
            if (w.Walkthrough.shouldShow())
                w.Walkthrough.start(level);
        }
        else if (typeof w._loadModule === 'function') {
            w._loadModule('walkthrough').then(function () {
                if (typeof w.Walkthrough !== 'undefined' && w.Walkthrough && w.Walkthrough.shouldShow())
                    w.Walkthrough.start(level);
            }).catch(function () { });
        }
    }, 600);
}
const _initWelcomeDemo = (function () {
    let _bound = false;
    function _escDemo(s) {
        const d = document.createElement('div');
        d.textContent = s;
        return d.innerHTML;
    }
    function _bind() {
        if (_bound)
            return;
        const input = document.getElementById('welcome-demo-ticker');
        const goBtn = document.getElementById('welcome-demo-go');
        const resultEl = document.getElementById('welcome-demo-result');
        if (!input || !goBtn || !resultEl)
            return;
        _bound = true;
        function _demoLookup() {
            const ticker = (input.value || '').trim().toUpperCase().replace(/[^A-Z0-9.\-]/g, '');
            if (!ticker) {
                input.focus();
                return;
            }
            goBtn.disabled = true;
            resultEl.className = 'welcome-demo-result visible';
            resultEl.innerHTML = '<div class="welcome-demo-loading">Fetching data for ' + _escDemo(ticker) + '...</div>';
            const w = window;
            if (!w.OLApi)
                return;
            w.OLApi.getTickerData({ ticker: ticker }, { signal: AbortSignal.timeout(8000) })
                .then(function (d) {
                const p = (d.price || d);
                const price = p.current || p.c || 0;
                const chg = p.change || p.d || 0;
                const pct = p.changePct || p.dp || 0;
                const sign = chg >= 0 ? '+' : '';
                const cls = chg > 0 ? 'pos' : chg < 0 ? 'neg' : 'neu';
                const company = d.company || d.name || (d.profile && d.profile.name) || ticker;
                const pe = d.pe || d.peRatio || p.pe || null;
                const sector = d.sector || (d.profile && d.profile.finnhubIndustry) || (d.profile && d.profile.sector) || '';
                const mktCap = d.marketCap || (d.profile && d.profile.marketCapitalization) || null;
                const summary = d.quickTake || d.briefSummary || (d.overview && d.overview.quickTake) || '';
                let html = '<div class="welcome-demo-header">'
                    + '<div><div class="welcome-demo-ticker">' + _escDemo(ticker) + '</div>'
                    + '<div class="welcome-demo-company">' + _escDemo(company) + '</div></div>'
                    + '<div class="welcome-demo-price-block">'
                    + '<div class="welcome-demo-price">$' + (price ? Number(price).toFixed(2) : '—') + '</div>'
                    + '<div class="welcome-demo-change ' + cls + '">' + sign + Number(chg).toFixed(2) + ' (' + sign + Number(pct).toFixed(2) + '%)</div>'
                    + '</div></div>';
                html += '<div class="welcome-demo-metrics">';
                html += '<div class="welcome-demo-metric"><span class="welcome-demo-metric-label">P/E Ratio</span><span class="welcome-demo-metric-val">' + (pe != null ? Number(pe).toFixed(1) : '—') + '</span></div>';
                html += '<div class="welcome-demo-metric"><span class="welcome-demo-metric-label">Sector</span><span class="welcome-demo-metric-val">' + _escDemo(sector || '—') + '</span></div>';
                let capStr = '—';
                if (mktCap) {
                    const mc = Number(mktCap);
                    capStr = fmtAbbrev(mc); // DS-P2a: canonical $ K/M/B
                }
                html += '<div class="welcome-demo-metric"><span class="welcome-demo-metric-label">Market Cap</span><span class="welcome-demo-metric-val">' + capStr + '</span></div>';
                html += '</div>';
                if (summary) {
                    html += '<div class="welcome-demo-summary">' + _escDemo(typeof summary === 'string' ? summary : '') + '</div>';
                }
                const lvl = document.querySelector('.welcome-level-chip.active')?.dataset;
                const demoLevel = lvl ? lvl.level || 'beginner' : 'beginner';
                const aiExamples = {
                    beginner: { q: 'How does ' + _escDemo(company) + "'s P/E compare with its peers and its own history?", a: 'The AI explains P/E, sector context, and risks in plain English — backed by real SEC filings, not guesswork.' },
                    learner: { q: 'Compare ' + _escDemo(company) + "'s margins to sector peers", a: 'The AI generates peer comparison tables with margin analysis, sourced from 10-year financials in our database.' },
                    expert: { q: 'Summarize risk factors from ' + _escDemo(company) + "'s latest 10-K", a: 'The AI parses SEC filings and highlights key risks, covenant concerns, and concentration exposures — with citations.' },
                };
                const aiEx = aiExamples[demoLevel] || aiExamples.beginner;
                html += '<div class="welcome-demo-ai">';
                html += '<div class="welcome-demo-ai-label">Ask AI anything about ' + _escDemo(ticker) + '</div>';
                html += '<div class="welcome-demo-ai-q">\u201c' + aiEx.q + '\u201d</div>';
                html += '<div class="welcome-demo-ai-a">' + aiEx.a + '</div>';
                html += '<div class="welcome-demo-ai-trust">Every answer cites its sources. No hallucinations.</div>';
                html += '</div>';
                // Option β PR4 (2026-05-13): SaaS-register CTA copy retired
                // per BRAND.md §Voice (banned "Start" + Title Case for button
                // labels). Editorial sentence-case verbs replace the
                // imperative-SaaS register.
                const ctaText = { beginner: 'Begin reading', learner: 'Open a company file', expert: 'Visit the research suite' };
                html += '<div class="welcome-demo-cta" data-action="dismiss-welcome">'
                    + (ctaText[demoLevel] || 'Open a company file') + ' →</div>';
                resultEl.innerHTML = html;
            })
                .catch(function () {
                resultEl.innerHTML = '<div class="welcome-demo-error">Could not find data for \u201c' + _escDemo(ticker) + '\u201d. Try another ticker like AAPL, MSFT, or TSLA.</div>';
            })
                .finally(function () { goBtn.disabled = false; });
        }
        goBtn.addEventListener('click', _demoLookup);
        input.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                _demoLookup();
            }
        });
    }
    document.addEventListener('DOMContentLoaded', _bind);
    return _bind;
})();
void _initWelcomeDemo;
function _dismissWelcome(level, view) {
    const w = window;
    if (typeof w._setUserLevel === 'function' && level)
        w._setUserLevel(level);
    if (view) {
        try {
            OLStorage.setString('ol_default_view', view);
        }
        catch (_e) { }
    }
    if ((!w._welcomeTickers || w._welcomeTickers.length === 0) &&
        (typeof PORTFOLIO_TICKERS === 'undefined' || PORTFOLIO_TICKERS.length === 0)) {
        // F-18 (DESIGN+CHAMP+VOICE quorum 2026-05-21, plan
        // docs/plans/F18_SAMPLE_PORTFOLIO_CTA.md): do NOT silent-inject the
        // 5 default tickers. Set a pending flag instead — the portfolio
        // empty-state renderer reads it and surfaces a transparent CTA
        // banner with removable chips + explicit accept/decline actions.
        // The silent-inject was a day-1 trust collapse the moment a new
        // user noticed "I never said I cared about AAPL" (.docx F-18
        // verbatim). User_trust FOUNDATIONAL overrides any retention
        // delta — telemetry-first, not A/B-gated.
        try {
            OLStorage.setString('ol_sample_portfolio_pending', '1');
        }
        catch (_e) { }
        if (typeof PORTFOLIO_TICKERS !== 'undefined')
            PORTFOLIO_TICKERS.length = 0;
        w._welcomeTickers = [];
    }
    else if (!w._welcomeTickers || w._welcomeTickers.length === 0) {
        w._welcomeTickers = (typeof PORTFOLIO_TICKERS !== 'undefined') ? PORTFOLIO_TICKERS.slice() : [];
    }
    const overlay = document.getElementById('welcome-overlay');
    if (overlay)
        overlay.classList.remove('open');
    OLStorage.setString('onboardingDone', '1');
    OLStorage.setString('ol_welcome_shown', '1');
    try {
        if (!OLStorage.getString('ol_welcome_ts', null)) {
            OLStorage.setString('ol_welcome_ts', String(Date.now()));
        }
    }
    catch (_e) { }
    if (view && typeof setView === 'function') {
        setView(view);
        if (view === 'ticker') {
            setTimeout(function () {
                const inp = document.getElementById('ticker-input');
                if (inp) {
                    inp.focus();
                    inp.select();
                }
            }, 300);
        }
        else {
            setTimeout(function () {
                const btn = document.getElementById('cmd-trigger');
                if (btn) {
                    btn.classList.add('ol-welcome-pulse');
                    setTimeout(function () { btn.classList.remove('ol-welcome-pulse'); }, 4000);
                }
                if (typeof showToast === 'function') {
                    showToast('Tip: press / or click Search to look up any stock.', '', 5000);
                }
            }, 500);
        }
    }
    if (typeof w._maybeShowQuickStart === 'function')
        w._maybeShowQuickStart();
}
function _maybeShowQuickStart() {
    if (OLStorage.getString('ol_quickstart_dismissed', null))
        return;
    const bar = document.getElementById('quickstart-bar');
    if (bar) {
        bar.classList.remove('d-none');
        window._quickstartAutoHide = true;
    }
}
function _dismissQuickStart() {
    const bar = document.getElementById('quickstart-bar');
    if (bar)
        bar.classList.add('d-none');
    OLStorage.setString('ol_quickstart_dismissed', '1');
    window._quickstartAutoHide = false;
}
(function () {
    const visited = OLStorage.getString('ol_learn_visited', null);
    if (!visited) {
        const badge = document.getElementById('learn-badge');
        if (badge)
            badge.classList.add('pulse-active');
    }
})();
void _welcomePreset;
void _showLoadingBridge;
void _startGuidedTour;
void _dismissWelcome;
void _maybeShowQuickStart;
void _dismissQuickStart;
// S6(b) (first-time-user audit, 2026-09-25): may the "Opening a company file?"
// orientation tile hide now? ticker-renderer.ts renderData() used to stamp
// body.has-active-ticker on the FIRST ticker paint, and boot always paints a
// ticker (app-init.ts PORTFOLIO_TICKERS[0] || 'AAPL'), so the tile was hidden
// before a first-timer could read it. Answer true only once this tab has
// rendered TWO different tickers (the user opened a second company file, so
// the orientation did its job). Dismissal (body.ticker-orient-dismissed,
// app-init.ts) is a separate path and unchanged. Lives here, not in
// ticker-renderer.ts, because that file sits at its line budget; exposed on
// window because the two files ship in different bundle IIFEs (app-init vs
// app-tail). ticker-renderer falls back to the old first-paint stamp if this
// is missing, so a load-order slip can never pin the tile open.
function _olOrientTileShouldHide(ticker) {
    const key = 'ol_orient_tickers_seen';
    let seen = [];
    try {
        seen = OLStorage.getSession(key, []);
    }
    catch (_e) {
        seen = [];
    }
    const list = Array.isArray(seen) ? seen.slice() : [];
    const sym = String(ticker || '').trim().toUpperCase();
    if (sym && list.indexOf(sym) === -1) {
        list.push(sym);
        try {
            OLStorage.setSession(key, list);
        }
        catch (_e) { /* private mode: the tile stays until dismissed */ }
    }
    return list.length >= 2;
}
window._olOrientTileShouldHide = _olOrientTileShouldHide;
// 2026-05-28 (OWNER directive — Surface 2 kill): the welcome-overlay
// bootstrap IIFE is RETIRED. The in-app welcome-overlay door-grid
// modal that this IIFE materialized was the post-registration entry
// point; OWNER ratified its replacement with the welcome gallery at
// /welcome (NUS-4.2 welcome-observatory). Surface 1 — the public
// landing.html "Three ways to find your way in" doors — is preserved
// as the anon-cold-entry surface.
//
// Hidden-sibling retirements co-shipped:
//   - templates/dashboard.html tmpl-welcome-overlay block deleted
//   - app-init.ts isFirstVisit materialization → /welcome?observatory=1 redirect
//   - app-renderers.ts welcome-door click handler stubbed (no DOM left)
//   - static/css/dashboard-styles.css door2-focused chrome deleted
//   - routes/routes_auth_fastapi.py OAuth+verify-email redirects → /welcome
//
// Originating session intent (2026-05-08 relocation note kept for git-
// archaeology): the IIFE was relocated here from app-renderers.ts to
// race the bundle-app-tail late-fetchpriority load on slow networks.
// That motivation evaporated when the surface itself was retired —
// there is no longer a tmpl-welcome-overlay to materialize.
//
// The `_fromRecognized` (`?from=doorN` / `?from=hero-*`) and deep-link-
// ticker localStorage seeding lived inside the bootstrap. Those keys
// (onboardingDone, ol_welcome_shown, ol_welcome_entry, ol_user_level,
// skillLevel, ol_welcome_ts) have downstream consumers (achievements.ts
// day-streak, app-init.ts brand-skeleton-remove gate + lapsed-returner
// toast) so the seeding logic is preserved as a no-overlay no-op shim:
// it writes the same keys but never materializes any DOM.
(function _welcomeEntryPathSeed() {
    function _seed() {
        try {
            let done = null;
            try {
                done = OLStorage.getString('onboardingDone', null);
            }
            catch (_e) { }
            if (done)
                return; // returning user — nothing to seed
            const _params = new URLSearchParams(window.location.search);
            const fromParam = _params.get('from');
            // Front-door restoration (OWNER Option A, 2026-06-12): the
            // observatory's anon entry points (Start free chrome CTA +
            // pinned lesson tile) join the recognized list — the successors
            // of the dead landing page's door/hero paths.
            const _fromRecognized = !!fromParam && /^(door[1-3]|hero-(primary|ghost|final|search)|obs-(start|lesson))$/.test(fromParam);
            const _dlTicker = (_params.get('ticker') || '').trim();
            const _isDeepLinkTicker = _params.get('view') === 'ticker' && _dlTicker !== '';
            // NUS retention fix (2026-06-18): a freshly-verified / freshly-authed
            // registrant lands on /welcome?auth=verified (email) or ?auth=success
            // (OAuth) with NO recognized `from=` -- the from=obs-* doors are
            // `ol-anon-only` and hidden the moment the user is authed, and the
            // visible tiles (/?view=news, /?view=macro) carry no door param. So the
            // seed was skipped and ol_user_level was never set, which silently
            // disabled BOTH the guided-tour auto-fire (app-init.ts gates it on
            // ol_user_level==='beginner' at the ticker view) AND the beginner
            // adaptive-simplification (app-init.ts:1557 reads the same key). Treat
            // fresh-auth as a recognized new-user entry and seed the beginner
            // default -- audience_framing: beginner is the safe default; experts flip
            // the level pill in one click. (The deep-link `next` branch that already
            // carried ?walkthrough=1 still fires the explicit tour; this covers the
            // plain /welcome landing the 2026-05-28 Surface-2-kill routes to.)
            const _authParam = _params.get('auth');
            const _isFreshAuth = _authParam === 'verified' || _authParam === 'success';
            if (!_fromRecognized && !_isDeepLinkTicker && !_isFreshAuth) {
                // S6 (first-time-user audit, 2026-09-25): the beginner scaffolding
                // (walkthrough auto-fire + adaptive simplification, both keyed on
                // ol_user_level==='beginner' in app-init.ts) armed ONLY for the
                // recognized entries above. A plain first visit -- typed URL,
                // search-engine landing, a shared link without ?from= -- seeded
                // nothing, so the largest first-time cohort never saw the beginner
                // register. Seed the level alone (not the welcome-shown keys: this is
                // not a door) when there is no level yet and no portfolio saved on
                // this device. Beginner is the safe default for "lifelong students
                // and investors" (docs/BRAND.md); experts flip the pill in one click.
                try {
                    const _hasLevel = !!(OLStorage.getString('ol_user_level', null) || OLStorage.getString('skillLevel', null));
                    const _hasPortfolio = !!OLStorage.getString('portfolio_tickers', null);
                    if (!_hasLevel && !_hasPortfolio) {
                        OLStorage.setString('ol_user_level', 'beginner');
                        OLStorage.setString('skillLevel', 'beginner');
                        const _w0 = window;
                        if (typeof _w0._track === 'function') {
                            _w0._track('skill_level_changed', { from: 'unknown', to: 'beginner', source: 'first_visit_default' });
                        }
                    }
                }
                catch (_e0) { /* never block a first paint on the default seed */ }
                return;
            }
            try {
                OLStorage.setString('onboardingDone', '1');
                OLStorage.setString('ol_welcome_shown', '1');
                OLStorage.setString('ol_welcome_entry', fromParam || (_isFreshAuth ? 'fresh-auth' : 'deeplink-ticker'));
                // P4 #4 (06-11 audit) + OWNER Option A (2026-06-12): the default
                // for UNRECOGNIZED entrants (a friend's ticker deep-link) flips
                // advanced -> beginner. A zero-knowledge first-timer was getting
                // the advanced register product-wide because the beginner entry
                // paths lived on a dead page. The audience is "lifelong students
                // and investors" (audience_framing) — beginner is the safe
                // default; experts flip the level pill in one click.
                const _isAdvanced = fromParam === 'door3' || fromParam === 'hero-search';
                const _level = _isAdvanced ? 'advanced' : 'beginner';
                const _priorLevel = OLStorage.getString('skillLevel', null);
                OLStorage.setString('ol_user_level', _level);
                OLStorage.setString('skillLevel', _level);
                OLStorage.setString('ol_welcome_ts', String(Date.now()));
                // F3.8 Q4 telemetry: every skillLevel write site must emit
                // skill_level_changed so future skill-level re-evaluation has data.
                // This is the welcome-door write site (the topstrip pill is the
                // other, app-init.ts). _track is a script-global from app-init.js
                // exposed on window; guard with typeof since welcome-flow is a
                // standalone IIFE that must not hard-depend on the app bundle
                // (same cross-chunk pattern as tooltip-tour.ts / dom-utils.ts).
                try {
                    const _w = window;
                    if (typeof _w._track === 'function') {
                        _w._track('skill_level_changed', { from: _priorLevel || 'unknown', to: _level, source: 'welcome_door' });
                    }
                }
                catch (_te) { /* never block the entry-path seed on telemetry */ }
            }
            catch (_e) { /* noop */ }
        }
        catch (_e) { /* never block on entry-path seed */ }
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', _seed, { once: true });
    }
    else {
        _seed();
    }
})();
//# sourceMappingURL=welcome-flow.js.map
;
// ═══ brand-v2-status.js ═══
;"use strict";
/* Brand v2 Phase 5b — ChromeB context label + footer source attribution.
 *
 * TS Migration Phase 2 PR 22 (2026-05-04): renamed .js → .ts.
 * Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
 *
 * This file is now the SOURCE OF TRUTH; the sibling brand-v2-status.js
 * is the build artifact produced by `tsc -p tsconfig.build.json`.
 *
 * Two responsibilities:
 *   1. TopStripB context label <- per-view static lookup.
 *   2. The end-of-page footer's source list (#ol-footer-sources) <- the
 *      per-view registry below, a MIRROR of services/data_source_registry.py
 *      (OWNER 2026-09-28). Keys, labels, urls and per-view lists must match
 *      that module exactly; tests/test_data_source_registry_contract.py pins
 *      the parity and the gate that every registered provider has a fetch
 *      path in the tree.
 *
 * OWNER 2026-09-28: the chrome-B status bar (#ol-statusbar-b) and its
 * LIVE / CACHED / STALE state dot are REMOVED. The dot could only ever read
 * LIVE (neither input had a writer) and we have no real-time quotes; the
 * footer now says a static PRICES DELAYED instead. The hand-typed per-view
 * source table (_SOURCE_MAP) it rendered named IEX, EARNINGS WHISPER and
 * FINRA TRACE, none of which the product fetches from. Its 5s sync timer went
 * with it.
 *
 * Settings panel state-refresh helper (_olRefreshSettingsPanel) also
 * lives here — keeps Phase 5b ancillary logic in one place.
 */
(function () {
    'use strict';
    // ── Source registry mirror (services/data_source_registry.py) ──────
    // An empty url renders the label as plain text (no link).
    const _PROVIDERS = {
        'finnhub': { label: 'Finnhub', url: 'https://finnhub.io' },
        'fmp': { label: 'FMP', url: 'https://financialmodelingprep.com' },
        'sec-edgar': { label: 'SEC EDGAR', url: 'https://www.sec.gov/edgar' },
        'fred': { label: 'FRED', url: 'https://fred.stlouisfed.org' },
        'treasury-fiscaldata': { label: 'U.S. Treasury FiscalData', url: 'https://fiscaldata.treasury.gov' },
        'bls': { label: 'BLS', url: 'https://www.bls.gov' },
        'bea': { label: 'BEA', url: 'https://www.bea.gov' },
        'cftc-cot': { label: 'CFTC COT', url: 'https://www.cftc.gov/MarketReports/CommitmentsofTraders' },
        'oxford-ledge': { label: 'Oxford Ledge', url: '' },
    };
    const _FALLBACK_SOURCES = ['finnhub', 'fmp', 'sec-edgar', 'fred'];
    const _VIEW_SOURCES = {
        'macro': ['finnhub', 'fmp', 'sec-edgar', 'fred', 'treasury-fiscaldata', 'bls', 'bea', 'cftc-cot'],
        'news': ['finnhub', 'sec-edgar', 'fred'],
        'ticker': ['fmp', 'finnhub', 'sec-edgar'],
        'portfolio': ['fmp', 'finnhub'],
        'watchlist': ['fmp', 'finnhub'],
        'credit': ['sec-edgar', 'fred'],
        'bdc': ['sec-edgar'],
        'screener': ['fmp', 'sec-edgar'],
        'etf-screener': ['fmp', 'sec-edgar'],
        'fundamentals': ['fmp', 'sec-edgar'],
        'calendar': ['fmp'],
        '13f': ['sec-edgar'],
        'learn': ['oxford-ledge'],
        'usage': ['oxford-ledge'],
        'milestones': ['oxford-ledge'],
        'settings': ['oxford-ledge'],
    };
    // ── Per-view context labels (optional; brief page subject) ─────────
    // 2026-04-26 OWNER feedback: "MARKETS is duplicative in the top bar."
    // The active nav button is already highlighted, so a context label that
    // just repeats the button's text is pure noise. Cleared every entry that
    // duplicates a top-nav button (macro/credit/portfolio/watchlist/screener/
    // learn/news). Kept only entries that ADD information beyond the nav:
    // sub-views (bdc/13f live under Bonds), ticker shows COMPANY NAME via
    // the special-case in _setTopStripBContext, and admin-area sub-views
    // (usage/milestones) sit outside the main nav so they're worth labeling.
    const _CONTEXT_MAP = {
        bdc: 'BDC BROWSER',
        '13f': '13F BROWSER',
        usage: 'USAGE & BILLING',
        milestones: 'ACHIEVEMENTS',
    };
    // Rewrites ONLY the children of #ol-footer-sources (a text-only span; no
    // canvas, widget or observer target lives in it), node for node the shape
    // render_footer_sources_html() ships in dashboard.html: links (or plain
    // labels) separated by ", ".
    function _renderFooterSources(view) {
        const el = document.getElementById('ol-footer-sources');
        if (!el)
            return;
        const keys = _VIEW_SOURCES[view] || _FALLBACK_SOURCES;
        el.textContent = '';
        keys.forEach(function (key, i) {
            const src = _PROVIDERS[key];
            if (!src)
                return;
            if (i > 0)
                el.appendChild(document.createTextNode(', '));
            if (src.url) {
                const a = document.createElement('a');
                a.href = src.url;
                a.target = '_blank';
                a.rel = 'noopener noreferrer';
                a.className = 'disclaimer-link';
                a.textContent = src.label;
                el.appendChild(a);
            }
            else {
                el.appendChild(document.createTextNode(src.label));
            }
        });
    }
    // QA 2026-10-13 P2 (R3): the footer's price token, mirror of
    // services/data_source_registry.footer_price_state. PRICES DELAYED only for
    // a viewer who is shown prices: a session (the ol_csrf_hmac cookie or the
    // resolved user) or the public switch (<meta name="ol-public-vendor-prices">,
    // ssr_assets.dashboard_flag_meta_tags). routes/pages.py renders the same
    // answer server-side; this keeps it true after an in-page sign-in or out.
    const _PRICE_STATE_SHOWN = 'PRICES DELAYED';
    const _PRICE_STATE_WITHHELD = 'PRICES FOR SIGNED-IN USERS';
    function _viewerSeesPrices() {
        try {
            if (document.querySelector('meta[name="ol-public-vendor-prices"]'))
                return true;
            const u = window._olCurrentUser;
            if (u && u.email)
                return true;
            return document.cookie.indexOf('ol_csrf_hmac=') !== -1;
        }
        catch (_e) {
            return true;
        }
    }
    function _renderFooterPriceState() {
        const el = document.getElementById('ol-footer-price-state');
        if (!el)
            return;
        el.textContent = _viewerSeesPrices() ? _PRICE_STATE_SHOWN : _PRICE_STATE_WITHHELD;
    }
    function _setTopStripBContext(view) {
        const el = document.getElementById('ol-topstrip-b-context');
        if (!el)
            return;
        let t;
        if (typeof activeTicker !== 'undefined' && activeTicker && view === 'ticker') {
            const w = window;
            const cache = w.dataCache;
            const profile = cache && cache[activeTicker] && cache[activeTicker].profile;
            const companyName = profile && profile.companyName ? profile.companyName.toUpperCase() : '';
            // #96b (2026-07-19): no dangling separator when the profile isn't
            // cached yet — "SPOT · " read as a broken nav item.
            t = activeTicker.toUpperCase() + (companyName ? ' · ' + companyName : '');
        }
        else {
            // #120/B3 (CHAMP 6.7 DESIGN bridge, 2026-07-26): on the five primary
            // nav views the slot was EMPTY (divider self-collapses). Echo the
            // date — "the page never says Welcome; the date is the greeting"
            // (the observatory's identity) — in the chrome's own mono/uppercase
            // register, deliberately NOT serif (chrome.css: product chrome is
            // dense by design). _CONTEXT_MAP still wins where it adds info.
            t = _CONTEXT_MAP[view] || _topStripDateLabel();
        }
        el.textContent = t;
    }
    function _topStripDateLabel() {
        try {
            return new Date().toLocaleDateString('en-US', {
                weekday: 'long', month: 'long', day: 'numeric',
            }).toUpperCase();
        }
        catch (_e) {
            return '';
        }
    }
    const _w = window;
    // ── Settings panel state refresh ───────────────────────────────────
    // Highlights the active segmented-button per current state. Called
    // when the panel opens AND after each setter fires.
    _w._olRefreshSettingsPanel = function () {
        const theme = document.documentElement.getAttribute('data-theme') || 'dark';
        const density = document.documentElement.getAttribute('data-density') || 'default';
        const chrome = (document.body && document.body.getAttribute('data-chrome') === 'b') ? 'b' : 'legacy';
        let level = 'beginner';
        try {
            level = OLStorage.getString('ol_user_level', null) || 'beginner';
        }
        catch (_) { }
        const pairs = [
            ['set-theme', 'themeValue', theme],
            ['set-density', 'densityValue', density],
            ['set-chrome', 'chromeValue', chrome],
            ['set-user-level', 'levelValue', level],
        ];
        pairs.forEach(function (p) {
            const actionKey = p[0], dsetKey = p[1], current = p[2];
            const btns = document.querySelectorAll('[data-action="' + actionKey + '"]');
            btns.forEach(function (b) {
                const match = b.dataset[dsetKey] === current;
                b.classList.toggle('active', match);
                b.setAttribute('aria-pressed', String(match));
            });
        });
        // Toggle account section visibility based on auth.
        const anonBlk = document.getElementById('ol-settings-account-anon');
        const userBlk = document.getElementById('ol-settings-account-user');
        const nameEl = document.getElementById('ol-settings-account-name');
        const emailEl = document.getElementById('ol-settings-account-email');
        const tierEl = document.getElementById('ol-settings-account-tier');
        const u = (typeof _w._olCurrentUser !== 'undefined') ? _w._olCurrentUser : null;
        if (u && u.email) {
            if (anonBlk)
                anonBlk.classList.add('hidden');
            if (userBlk)
                userBlk.classList.remove('hidden');
            if (nameEl)
                nameEl.textContent = u.username || u.name || u.email.split('@')[0];
            if (emailEl)
                emailEl.textContent = u.email;
            if (tierEl)
                tierEl.textContent = (u.tier || 'free').toUpperCase().replace('_', ' + ');
        }
        else {
            if (anonBlk)
                anonBlk.classList.remove('hidden');
            if (userBlk)
                userBlk.classList.add('hidden');
        }
    };
    // ── Public hooks ───────────────────────────────────────────────────
    // view-router.ts calls this on every view transition.
    _w._olChromeBSyncForView = function (view) {
        // #96b (2026-07-19): the top-strip context is cleared/set on EVERY view,
        // learn included, so a prior ticker label never lingers.
        _setTopStripBContext(view);
        _renderFooterSources(view);
        _renderFooterPriceState();
    };
    // Initial sync after DOM is ready. No timer: nothing here changes except on
    // a view transition, which view-router.ts already reports.
    function _init() {
        const v = (typeof currentView === 'string' && currentView) || 'macro';
        _w._olChromeBSyncForView(v);
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', _init);
    }
    else {
        _init();
    }
})();
//# sourceMappingURL=brand-v2-status.js.map
;
// ═══ wander-banner.js ═══
;"use strict";
/* wander-banner.js — surfaces the "you wandered to: X" affordance
 * after a /wander redirect.
 *
 * TS Migration Phase 2 PR 17 (2026-05-04): renamed .js → .ts.
 * Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
 *
 * This file is now the SOURCE OF TRUTH; the sibling wander-banner.js
 * is the build artifact produced by `npx tsc -p tsconfig.build.json`
 * (gitignored). Self-contained.
 *
 * Phase 1F.5 closing fix (2026-04-30): the cookie hook shipped in
 * routes/misc.py:wander() in 2026-04 but the destination-side banner
 * was never built. Without this the wander affordance teleports the
 * user with no narrative reward — they can't tell they wandered vs.
 * normal navigation.
 *
 * Reads:
 *   - URL flag `?wandered=1` (set by /wander → destination redirect)
 *   - Cookie `ol_wander_label` (set by /wander; max-age 5 min)
 *
 * Renders a small italic banner at the top of the destination page.
 * Strips `?wandered=1` from the URL via replaceState so reloads don't
 * re-trigger. Auto-dismisses after 30 s; user can dismiss via × at any
 * time. Cookie is cleared on dismiss so the next navigation doesn't
 * re-fire.
 *
 * CSP-compliant: external script, no inline handlers, no innerHTML.
 * Loaded by dashboard.html (covers SPA destinations) and the
 * `_render_sp_header` block in ssr_renderer.py (covers SSR
 * destinations like /glossary/, /learn/, /stocks/).
 */
(function () {
    'use strict';
    // Only fire when wandered=1 is in the URL — the cookie alone
    // isn't enough. Without this gate, every page navigation within
    // the 5-min cookie window would re-render the banner.
    const params = new URLSearchParams(window.location.search);
    const wandered = params.get('wandered') === '1';
    // #301 CHAMP 6.7 B2 (cycle 2026-07-26): a recognized observatory door
    // (?from=obs-start on the SPA, ?from=obs-lesson on /learn/) got ZERO
    // visible acknowledgment on arrival — welcome-flow.ts seeds storage from
    // the same param but paints nothing. Reuse this banner (same editorial
    // register) as the crossing's one-line acknowledgment. `from=` is NOT
    // stripped from the URL — welcome-flow.ts reads it too and script order
    // is not guaranteed; re-fire is guarded by sessionStorage instead.
    const _from = params.get('from');
    const obsArrival = !wandered && (_from === 'obs-start' || _from === 'obs-lesson');
    if (!wandered && !obsArrival)
        return;
    if (obsArrival) {
        try {
            // eslint-disable-next-line ol/no-direct-localstorage -- self-contained SSR script (see file header): SP_HEADER surfaces never load storage.js, so OLStorage is not on window here; sessionStorage has no wrapper anyway (auth-handlers.ts:772 precedent) and the try/catch handles private-mode failures.
            if (sessionStorage.getItem('ol_obs_arrival_ack'))
                return;
            // eslint-disable-next-line ol/no-direct-localstorage -- write half of the same self-contained once-guard; best-effort, failure path skips the banner entirely (never nags).
            sessionStorage.setItem('ol_obs_arrival_ack', '1');
        }
        catch (_e) {
            return; // storage unavailable — skip rather than risk re-firing every load
        }
    }
    function readCookie(name) {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? decodeURIComponent(match[2]) : '';
    }
    const label = wandered ? readCookie('ol_wander_label') : '';
    // Strip ?wandered=1 from the URL so reloads/back-navigations don't
    // re-fire the banner. replaceState (not pushState) so we don't
    // pollute browser history. Wander mode only — the obs path leaves
    // `from=` in place (welcome-flow.ts reads it; sessionStorage guards
    // the re-fire instead).
    if (wandered) {
        try {
            params.delete('wandered');
            const newSearch = params.toString();
            const newUrl = window.location.pathname +
                (newSearch ? '?' + newSearch : '') +
                window.location.hash;
            window.history.replaceState({}, '', newUrl);
        }
        catch (_e) { }
    }
    function buildBanner(labelText) {
        const banner = document.createElement('div');
        banner.className = 'ol-wander-banner';
        banner.id = 'ol-wander-banner';
        banner.setAttribute('role', 'status');
        banner.setAttribute('aria-live', 'polite');
        const text = document.createElement('span');
        text.className = 'ol-wander-banner-text';
        // Wander: two phrasings — with-label (rich) and fallback (still
        // editorial). Obs arrival (#301 B2): one line in the same lowercase
        // register acknowledging the crossing from the observatory front door.
        // VOICE rule from the cycle: if either obs string ever reads as a SaaS
        // toast in situ, DROP the obs path — don't reword it toastier.
        if (obsArrival) {
            text.textContent = _from === 'obs-lesson'
                ? 'you followed a lesson in.'
                : 'you stepped onto the ledge.';
        }
        else {
            text.textContent = labelText
                ? 'you wandered to: ' + labelText
                : 'you pulled a thread.';
        }
        banner.appendChild(text);
        const dismissBtn = document.createElement('button');
        dismissBtn.type = 'button';
        dismissBtn.className = 'ol-wander-banner-close';
        dismissBtn.setAttribute('aria-label', 'Dismiss wander notice');
        dismissBtn.textContent = '×'; // multiplication sign as ×
        banner.appendChild(dismissBtn);
        function dismiss() {
            banner.classList.add('ol-wander-banner--dismissed');
            setTimeout(function () {
                if (banner.parentNode)
                    banner.parentNode.removeChild(banner);
            }, 300);
            // Clear the cookie so the next /wander click gets a fresh
            // banner, not a stale relabel. Wander mode only — the obs path
            // never set it.
            if (wandered) {
                document.cookie = 'ol_wander_label=; Max-Age=0; Path=/';
            }
        }
        dismissBtn.addEventListener('click', dismiss);
        // Auto-dismiss at 30 s — generous enough that a slow reader
        // can absorb the banner; short enough that it doesn't linger as
        // chrome on the destination view.
        setTimeout(dismiss, 30000);
        return banner;
    }
    function inject() {
        if (!document.body)
            return;
        // Idempotent — if a previous render is still in the DOM (rare
        // edge case during back-button + replaceState races), don't
        // double-render.
        if (document.getElementById('ol-wander-banner'))
            return;
        document.body.insertBefore(buildBanner(label), document.body.firstChild);
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', inject);
    }
    else {
        inject();
    }
})();
//# sourceMappingURL=wander-banner.js.map
;
// ═══ dormancy-banner.js ═══
;/* SF-RETENTION Phase 3.2 (A12.2) — welcome-back banner dismiss handler.
 *
 * The banner is SSR-injected by routes/pages.py:serve_dashboard when
 * the user's server-side last activity shows >8h dormancy + the
 * ol_dormancy_dismissed cookie is unset. This module wires the
 * "Don't show again" button to:
 *   1. Write ol_dormancy_dismissed=1 with a 365-day max-age. Server
 *      reads this and short-circuits the SSR injection on next load.
 *   2. Hide the banner immediately (visual feedback before the cookie
 *      hits the next request).
 *
 * No telemetry, no fetch — pure cookie + DOM. The banner element
 * MAY be absent (fresh visitor or already-dismissed); fail silent.
 */
(function () {
  'use strict';
  function _onReady() {
    var btn = document.getElementById('ol-dormancy-dismiss');
    if (!btn) return;
    var banner = document.querySelector('.ol-dormancy-banner');
    btn.addEventListener('click', function () {
      try {
        var maxAge = 365 * 24 * 60 * 60;
        // SameSite=Lax + Secure-conditional: only set Secure when on https,
        // otherwise cookie is rejected on http://localhost during dev.
        var secure = (location.protocol === 'https:') ? '; Secure' : '';
        document.cookie =
          'ol_dormancy_dismissed=1; Max-Age=' + maxAge + '; Path=/; SameSite=Lax' + secure;
      } catch (_e) { /* cookie write failed — proceed to hide */ }
      if (banner) {
        banner.classList.add('ol-dormancy-banner-hidden');
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _onReady, { once: true });
  } else {
    _onReady();
  }
})();

;
// ═══ empty-state.js ═══
;"use strict";
// 2026-04-30 evening (auth-panels A5) — single-source-of-truth factory
// for empty-state markup across panels.
//
// TS Migration Phase 2 PR 7 (2026-05-04): renamed .js → .ts.
// Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md (Phase 2 kickoff per
// OWNER Q2=A).
//
// This file is now the SOURCE OF TRUTH; the sibling empty-state.js
// is the build artifact produced by `npx tsc -p tsconfig.build.json`
// (gitignored).
//
// Pre-fix the codebase had 4 disjoint shapes:
//   .ol-empty       (portfolio.js, watchlist.js — canonical)
//   .ol-empty-state (formatting.js emptyState() helper — different)
//   .prac-gate      (practicum-view.js — bespoke for tier gate)
//   .usage-unauth   (milestones-view.js — bespoke for unauth state)
//
// This factory emits canonical .ol-empty markup with optional eyebrow,
// icon, body, and CTA slots.
//
// Usage:
//   document.getElementById('foo').innerHTML = OLEmpty.render({
//     eyebrow: 'TIER REQUIRED',
//     title: 'Portfolio Practicum',
//     body: 'Build a mock portfolio with AI coaching...',
//     cta: { label: 'View Plans', href: '/?upgrade=professional', primary: true },
//   });
(function (global) {
    'use strict';
    function _esc(s) {
        if (s == null)
            return '';
        if (typeof global.escHtml === 'function')
            return global.escHtml(s);
        return String(s)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }
    function render(opts) {
        opts = opts || {};
        const parts = ['<div class="ol-empty">'];
        // Optional eyebrow — caps-mono, gold accent. Used for tier-gate
        // context ("AVAILABLE ON INVESTOR + AI") or section labels
        // ("YOUR WATCHLIST"). When omitted, the title leads.
        if (opts.eyebrow) {
            parts.push('<div class="ol-empty-eyebrow">' + _esc(opts.eyebrow) + '</div>');
        }
        // Optional icon — caller is responsible for the SVG/glyph string;
        // the factory does NOT escape (icons are inline SVG markup that
        // must render as HTML, not text). Caller MUST pass trusted source.
        // Per Brand v2 "no emoji" rule, callers should pass inline SVG.
        if (opts.icon) {
            parts.push('<div class="ol-empty-icon" aria-hidden="true">' + opts.icon + '</div>');
        }
        if (opts.title) {
            parts.push('<div class="ol-empty-title">' + _esc(opts.title) + '</div>');
        }
        if (opts.body) {
            // Body is ALSO not escaped by default — supports inline markup
            // like <strong>, <br>, glossary jargon-links. Callers passing
            // user-controlled strings must escape themselves.
            parts.push('<div class="ol-empty-body">' + opts.body + '</div>');
        }
        if (opts.cta) {
            const c = opts.cta;
            const classes = 'ol-empty-cta' + (c.primary ? ' primary' : '');
            const label = _esc(c.label || '');
            if (c.href) {
                parts.push('<a class="' + classes + '" href="' + _esc(c.href) + '">' + label + '</a>');
            }
            else if (c.action) {
                parts.push('<button class="' + classes + '" data-action="' + _esc(c.action) + '">' + label + '</button>');
            }
        }
        parts.push('</div>');
        return parts.join('');
    }
    global.OLEmpty = { render: render };
}(typeof window !== 'undefined' ? window : globalThis));
//# sourceMappingURL=empty-state.js.map
;
// ═══ _idle_loader.js ═══
;"use strict";
// F-20 Phase 3b (2026-05-21) — deferred-script idle loader.
//
// Per docs/plans/F20_PHASE3_SCOPING.md §3 + Pattern-K artifact
// docs/board/audit/2026-05-21_CHAOS_F20_phase3b_idle_callback.md.
// OWNER-ratified Option A sequential ship (3a → 3b → 3c).
//
// 5 scripts deferred via requestIdleCallback with an explicit
// polyfill (OWNER 2026-05-21 picked explicit polyfill over the
// setTimeout(500) fallback for the 3.6% browser long-tail —
// Safari <15.4 + Firefox <85). Polyfill provides true
// deadline.timeRemaining + didTimeout semantics, not just
// setTimeout-delayed execution.
//
// Pre-Phase-3b these 5 scripts were standalone <script defer> tags
// in dashboard.html. `defer` fires after DOM parse + before
// DOMContentLoaded; this loader fires AFTER bundle-app-init parse +
// AFTER first paint (idle frame), which is a strictly later window.
// Most of the 5 ALREADY self-delayed (dunning-banner: 1.2s,
// mastery-unlock-toast: 1.8s); requestIdleCallback replaces those
// manual setTimeouts with the browser's actual idle-frame
// scheduling.
//
// Cloudflare beacon (line 1963 in dashboard.html) is NOT in this
// loader — 3rd-party analytics is a separate review surface per
// the cookie-banner scope ratified 2026-05-17.
(function () {
    'use strict';
    const w = window;
    // Explicit requestIdleCallback polyfill — provides the canonical
    // deadline API (Math.max(0, 50 - elapsed) for timeRemaining; the
    // 50ms target matches Chrome's idle-frame budget). ~10 lines,
    // zero npm dependency. Same shape as React/Vue polyfills.
    //
    // cancelIdleCallback is shape-only — installed for API completeness
    // but NOT currently exercised. CHAOS sweep 2026-05-21 confirmed:
    // `grep cancelIdleCallback static/js/*.ts` returns 1 hit (this
    // file's polyfill itself); no consumer calls it. If a future
    // consumer DOES cancel a polyfilled rIC, note that the setTimeout
    // cast at L52 produces a `number` reliably in browsers, so
    // clearTimeout(id) works as expected — but the polyfill's
    // signature has not been browser-tested against Safari <15.4's
    // setTimeout return-type quirks. Track-don't-block.
    if (typeof w.requestIdleCallback !== 'function') {
        w.requestIdleCallback = function (cb, opts) {
            const start = Date.now();
            const timeout = (opts && opts.timeout) || 0;
            return setTimeout(function () {
                cb({
                    didTimeout: timeout > 0 && (Date.now() - start) >= timeout,
                    timeRemaining: function () { return Math.max(0, 50 - (Date.now() - start)); }
                });
            }, 1);
        };
        w.cancelIdleCallback = function (id) {
            clearTimeout(id);
        };
    }
    // F-20 Phase 3b + 3c deferred-script set. Order matters only
    // for download priority; runtime ordering is independent (each
    // script runs on its own DCL-or-equivalent trigger).
    //
    // Phase 3c (2026-05-21) added the bottom 2 entries — both safe
    // to defer to idle because their consumers ALREADY use defensive
    // typeof-guards:
    //   - table-sortable.js: callers at features-extra.ts:629 +
    //     peer-view.ts:1045 check `typeof w.OLSortableTable !==
    //     'undefined' && w.OLSortableTable.attach` before calling
    //     attach. If the script is not yet loaded, the sort handler
    //     simply doesn't engage (table renders unsorted; clicks no-op).
    //     50-200ms idle-frame window is the only race surface.
    //   - tier-lock-chip.js: reads window.OL_TIER (set by
    //     bundle-auth-handlers) via a defensive `typeof live ===
    //     'string'` guard at line 62. Falls through to
    //     OL_TIER_FALLBACK → 'free' default if OL_TIER not yet set.
    //     Plan §4 spec'd MutationObserver one-shot; substrate review
    //     showed the existing guards make the simpler rIC approach
    //     equivalent in safety. Pattern-K artifact documents.
    const DEFERRED_SCRIPTS = [
        '/static/js/habit-hook.js',
        '/static/js/dunning-banner.js',
        '/static/js/credit-meter.js',
        '/static/js/mastery-unlock-toast.js',
        '/static/js/notifications-bell.js',
        '/static/js/table-sortable.js', // Phase 3c
        '/static/js/tier-lock-chip.js', // Phase 3c
    ];
    // #65 render-blocking-CSS slice (2026-07-06 OWNER perf analysis): these
    // six stylesheets were <link>ed in dashboard.html and BLOCKED first paint
    // (mastery-dashboard-panel.css led the critical chain) — yet every
    // component they style renders post-idle: the six DEFERRED_SCRIPTS below
    // plus the mastery panel (lazy education chunk, dormant until >=1 quiz
    // attempt). Strict CSP blocks the media="print" onload= trick (inline
    // handler), so the same idle frame injects them as real <link>s.
    // Styles are injected BEFORE the scripts so the CSS request wins the
    // race against component mount (banners also self-delay ~1.2s).
    const DEFERRED_STYLES = [
        '/static/css/mastery-dashboard-panel.css',
        '/static/css/tier-lock-chip.css',
        '/static/css/dunning-banner.css',
        '/static/css/mastery-unlock-toast.css',
        '/static/css/notifications-bell.css',
        '/static/css/dormancy-banner.css',
    ];
    function _injectStyle(href) {
        const l = document.createElement('link');
        l.rel = 'stylesheet';
        l.href = href;
        document.head.appendChild(l);
    }
    function _injectScript(src) {
        // Cache-busting handled by browser (these are first-party
        // /static/js/* paths; Render's deploy invalidates per-file
        // ETag). No version query string needed — keeps the request
        // URL stable across reloads.
        const s = document.createElement('script');
        s.src = src;
        s.defer = true;
        document.body.appendChild(s);
    }
    function _runDeferred() {
        DEFERRED_STYLES.forEach(_injectStyle);
        DEFERRED_SCRIPTS.forEach(_injectScript);
        _preloadEducationChunk();
    }
    // Phase A (2026-06-04, docs/plans/LEARN_LEGACY_FLASH_FIX.md): idle-preload
    // the `education` lazy chunk so its LEARN v3 surfaces (OLLearn.surfaces.*)
    // are registered BEFORE the user opens /?view=learn. Without this the
    // legacy LEARN surface paints first and the chunk swaps the v3 surface in
    // ~171ms later — the "prior version flash on every tab" the OWNER reported
    // (#58/#88/#99 class). Loading it on the same post-first-paint idle frame
    // (deduped by the lazy loader; a no-op when already loaded) closes that gap
    // for the common path. Fully defensive: swallows errors and no-ops when
    // OxfordChunks isn't ready yet — view-router's on-demand loadChunk still
    // covers LEARN entry in that case (just with the flash), so this can only
    // improve, never regress.
    function _preloadEducationChunk() {
        try {
            const _ox = window.OxfordChunks;
            if (_ox && typeof _ox.loadChunk === 'function') {
                const _p = _ox.loadChunk('education');
                if (_p && typeof _p.catch === 'function') {
                    _p.catch(function () { });
                }
                // 2026-06-11 (#36): glossary.js now lives in its own
                // data-only chunk; prefetch it on the same idle frame so
                // GLOSSARY-dependent tooltips are warm before LEARN entry.
                const _g = _ox.loadChunk('glossary-data');
                if (_g && typeof _g.catch === 'function') {
                    _g.catch(function () { });
                }
            }
        }
        catch (_e) { /* defensive — never block idle work */ }
    }
    function _schedule() {
        // 2-second timeout fallback: even if the browser never goes
        // idle (heavy long task on cold-cache desktop), the callback
        // still fires after 2s. Most browsers fire within ~50-200ms
        // post-paint.
        w.requestIdleCallback(_runDeferred, { timeout: 2000 });
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', _schedule);
    }
    else {
        _schedule();
    }
})();
//# sourceMappingURL=_idle_loader.js.map
;